import { Validators, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Component, Injectable, Directive, Input, NgModule, HostListener, EventEmitter, Output, ViewChild, Pipe, ContentChildren } from '@angular/core';
import { first, flatMap, map, takeUntil, tap, skip, catchError } from 'rxjs/operators';
import { of, Subject, fromEvent, BehaviorSubject, forkJoin, EMPTY } from 'rxjs';
import { HttpResponse, HttpHeaders, HttpParams, HttpClientModule } from '@angular/common/http';
import { CommonModule, DecimalPipe as DecimalPipe$1, DatePipe as DatePipe$1, CurrencyPipe as CurrencyPipe$1 } from '@angular/common';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { MatSliderModule } from '@angular/material';
import { RouterModule, NavigationEnd } from '@angular/router';
import { HighlightJsModule, HighlightJsService as HighlightJsService$1 } from 'angular2-highlight-js';
import { ClipboardModule } from 'ngx-clipboard';
import bugsnag from 'bugsnag-js';
import { ios } from 'bowser';
import { PageScrollConfig, PageScrollInstance, NgxPageScrollModule, PageScrollService as PageScrollService$1 } from 'ngx-page-scroll';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
UIFormControl = /** @class */ (function () {
    function UIFormControl(uiFormControl) {
        this.value = null;
        this.validators = [];
        this.asyncValidators = [];
        this.info = null;
        Object.assign(/** @type {?} */ (this), uiFormControl);
    }
    return UIFormControl;
}());

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UIInputControl = /** @class */ (function (_super) {
    __extends(UIInputControl, _super);
    function UIInputControl(uiInputControl) {
        var _this = _super.call(this, uiInputControl) || this;
        _this.type = 'input';
        _this.showPasswordStrength = false;
        _this.defaultFocus = false;
        Object.assign(/** @type {?} */ (_this), uiInputControl);
        return _this;
    }
    return UIInputControl;
}(UIFormControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIFormGroup = /** @class */ (function () {
    function UIFormGroup(uiFormGroup) {
        Object.assign(/** @type {?} */ (this), uiFormGroup);
    }
    return UIFormGroup;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIForgottenPasswordComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Router} router
     * @param {UIFormsService} uiFormsService
     * @param {UIToastService} uiToastService
     * @param {UIAuthService} uiAuthService
     * @param {UISessionService} uiSessionService
     */
    function UIForgottenPasswordComponent(router, uiFormsService, uiToastService, uiAuthService, uiSessionService) {
        this.router = router;
        this.uiFormsService = uiFormsService;
        this.uiToastService = uiToastService;
        this.uiAuthService = uiAuthService;
        this.uiSessionService = uiSessionService;
        this.formInvalid = false;
        this.loading = false;
    }
    /**
     * @return {?}
     */
    UIForgottenPasswordComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.forgottenPasswordFormGroups = this.getForgottenPasswordFormGroups();
    };
    /**
     * Gets Forgotten Password form groups.
     *
     * @returns {UIFormGroup[]}
     */
    /**
     * Gets Forgotten Password form groups.
     *
     * @return {?}
     */
    UIForgottenPasswordComponent.prototype.getForgottenPasswordFormGroups = /**
     * Gets Forgotten Password form groups.
     *
     * @return {?}
     */
    function () {
        return [
            new UIFormGroup({
                name: 'sendResetPasswordLink',
                controls: [
                    new UIInputControl({
                        name: 'email',
                        label: 'Email',
                        placeholder: 'Email',
                        inputType: 'text',
                        validators: [Validators.required, Validators.email],
                        value: this.uiSessionService.getItem('loginEmail'),
                        defaultFocus: true
                    })
                ]
            }),
        ];
    };
    /**
     * Sets form into valid state
     */
    /**
     * Sets form into valid state
     * @return {?}
     */
    UIForgottenPasswordComponent.prototype.setValid = /**
     * Sets form into valid state
     * @return {?}
     */
    function () {
        clearTimeout(this.invalidTimeout);
        this.formInvalid = false;
    };
    /**
     * Shows invalid state.
     */
    /**
     * Shows invalid state.
     * @return {?}
     */
    UIForgottenPasswordComponent.prototype.setInvalid = /**
     * Shows invalid state.
     * @return {?}
     */
    function () {
        var _this = this;
        clearTimeout(this.invalidTimeout);
        this.formInvalid = true;
        this.invalidTimeout = setTimeout(function () {
            _this.formInvalid = false;
        }, 3000);
    };
    /**
     * Handles form events emitted from form.
     *
     * @param event
     */
    /**
     * Handles form events emitted from form.
     *
     * @param {?} event
     * @return {?}
     */
    UIForgottenPasswordComponent.prototype.onFormEvent = /**
     * Handles form events emitted from form.
     *
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var form = event.form;
        /** @type {?} */
        var uiFormEvent = event.event;
        if (uiFormEvent.type === 'submitFailed') {
            this.setInvalid();
        }
        if (uiFormEvent.type === 'keyUp') {
            this.setValid();
            this.uiFormsService.setValidators(form.get(['sendResetPasswordLink', 'email']), this.forgottenPasswordFormGroups[0].controls[0].validators);
            if (uiFormEvent.control.join('.') === 'sendResetPasswordLink.email') {
                this.uiSessionService.setItem('loginEmail', uiFormEvent.value);
            }
        }
    };
    /**
     * Handles form submit.
     *
     * @param {FormGroup} form
     */
    /**
     * Handles form submit.
     *
     * @param {?} form
     * @return {?}
     */
    UIForgottenPasswordComponent.prototype.onSubmit = /**
     * Handles form submit.
     *
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        if (form.valid) {
            this.loading = true;
            this.uiAuthService.sendResetPasswordLink(form.value.sendResetPasswordLink.email).subscribe(function () {
                /** @type {?} */
                var emailControl = form.get(['sendResetPasswordLink', 'email']);
                emailControl.setValue(null);
                emailControl.markAsPristine();
                emailControl.markAsUntouched();
                _this.loading = false;
                _this.uiToastService.success('Check your email for your magic link!');
            });
        }
    };
    UIForgottenPasswordComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-forgotten-password',
                    template: "\n      <!--  TITLE  -->\n\n      <h1>Forgotten your password?</h1>\n\n      <!--  END TITLE  -->\n\n      <!--  INSTRUCTION  -->\n\n      <p>Enter your email address and we'll send you a magic link so you can reset your password.</p>\n\n      <!--  END INSTRUCTION  -->\n\n      <!--  FORM  -->\n\n      <ui-form [uiFormGroups]=\"forgottenPasswordFormGroups\" [style]=\"'plain'\" [autoToast]=\"false\" (formSubmit)=\"onSubmit($event)\" (formEvent)=\"onFormEvent($event)\" #form></ui-form>\n\n      <!--  END FORM  -->\n\n      <!--  SUBMIT BUTTON  -->\n\n      <a class=\"button positive-button block-button\" [ngClass]=\"{'wobble negative-button no-action' : formInvalid}\" [uiLoading]=\"loading\" (click)=\"form.onSubmit()\">\n          {{ formInvalid ? 'Invalid Email Address' : 'Send Reset Link'}}\n      </a>\n\n      <!--  END SUBMIT BUTTON  -->\n\n      <!--  AUTH LINKS  -->\n\n      <div class=\"links-container\">\n          <a [routerLink]=\"['/auth', 'login']\"><i class=\"far fa-arrow-left\"></i>Back to login</a>\n      </div>\n\n      <!--  END AUTH LINKS  -->\n    ",
                    styles: ["\n      :host>h1{text-align:center;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;font-weight:500;letter-spacing:-.04em;font-size:22px;margin-bottom:48px}:host h2{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;text-align:center;margin-top:-44px;margin-bottom:22px;line-height:22px;font-size:16px}:host>p{text-align:center;font-size:12px;margin-bottom:24px;margin-top:-24px;color:#919191}:host>.button{margin:24px 0 0}:host>.links-container{font-size:12px;text-align:center;padding:24px 0}:host>.links-container>a{color:#919191;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s;line-height:32px;display:inline-block;padding:0 16px;border-radius:3px;height:32px}:host>.links-container>a>i{margin-right:8px}:host>.links-container>a:hover{color:#4e4e4e;background:#e9e9e9}@media screen and (max-width:774px){:host>h1{font-size:20px;margin-bottom:36px}:host>h2{font-size:16px;margin-bottom:14px;margin-top:-36px}:host>p{font-size:11px;margin-bottom:24px;margin-top:-20px}:host>.links-container{padding:16px 0}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIForgottenPasswordComponent.ctorParameters = function () { return [
        { type: Router },
        { type: UIFormsService },
        { type: UIToastService },
        { type: UIAuthService },
        { type: UISessionService }
    ]; };
    return UIForgottenPasswordComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIValidators = /** @class */ (function () {
    function UIValidators() {
    }
    /**
     * Validator that checks if value matches another field in form.
     *
     * @param {string[]} fieldPath
     * @param {string} fieldFriendlyName
     *
     * @returns {ValidatorFn | null}
     */
    /**
     * Validator that checks if value matches another field in form.
     *
     *
     * @param {?} fieldPath
     * @param {?} fieldFriendlyName
     * @return {?}
     */
    UIValidators.fieldMatch = /**
     * Validator that checks if value matches another field in form.
     *
     *
     * @param {?} fieldPath
     * @param {?} fieldFriendlyName
     * @return {?}
     */
    function (fieldPath, fieldFriendlyName) {
        /** @type {?} */
        var validator = function (formControl) {
            if (!formControl.parent) {
                return null;
            }
            /** @type {?} */
            var parent = formControl.parent;
            while (typeof (parent.parent) !== 'undefined') {
                parent = parent.parent;
            }
            /** @type {?} */
            var otherControl = parent.get(fieldPath);
            otherControl.valueChanges.pipe(first()).subscribe(function () {
                formControl.updateValueAndValidity();
            });
            if (formControl.value !== otherControl.value) {
                return {
                    fieldmatch: {
                        valid: false,
                        fieldFriendlyName: fieldFriendlyName
                    }
                };
            }
            return null;
        };
        return validator;
    };
    /**
     *
     *
     * @param message
     */
    /**
     *
     *
     * @param {?} message
     * @return {?}
     */
    UIValidators.customMessage = /**
     *
     *
     * @param {?} message
     * @return {?}
     */
    function (message) {
        /** @type {?} */
        var validator = function (formControl) {
            return {
                custom: {
                    message: message
                }
            };
        };
        return validator;
    };
    return UIValidators;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIResetPasswordComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Router} router
     * @param {ActivatedRoute} activatedRoute
     * @param {UIToastService} uiToastService
     * @param {UIFormsService} uiFormsService
     * @param {UIAuthService} uiAuthService
     * @param {UISessionService} uiSessionService
     * @param {UIUserAccountService} uiUserAccountService
     */
    function UIResetPasswordComponent(router, activatedRoute, uiToastService, uiFormsService, uiAuthService, uiSessionService, uiUserAccountService) {
        var _this = this;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.uiToastService = uiToastService;
        this.uiFormsService = uiFormsService;
        this.uiAuthService = uiAuthService;
        this.uiSessionService = uiSessionService;
        this.uiUserAccountService = uiUserAccountService;
        this.resetPasswordFormGroups = this.getResetPasswordFormGroups();
        this.formInvalid = false;
        this.loading = false;
        this.newPassword = '';
        this.confirmPassword = '';
        this.destroyed$ = new Subject();
        this.activatedRoute.queryParams.pipe(takeUntil(this.destroyed$)).subscribe(function (queryParams) {
            if (!queryParams['token'] || !queryParams['email']) {
                _this.router.navigate(['/auth', 'login']).then(function () {
                    setTimeout(function () {
                        _this.uiToastService.error('Your reset password link was invalid.');
                    });
                });
            }
            _this.resetToken = queryParams['token'];
            _this.email = queryParams['email'];
            _this.uiSessionService.setItem('loginEmail', _this.email);
        });
    }
    /**
     * Gets Login form groups.
     *
     * @returns {UIFormGroup[]}
     */
    /**
     * Gets Login form groups.
     *
     * @return {?}
     */
    UIResetPasswordComponent.prototype.getResetPasswordFormGroups = /**
     * Gets Login form groups.
     *
     * @return {?}
     */
    function () {
        return [
            new UIFormGroup({
                name: 'resetPassword',
                controls: [
                    new UIInputControl({
                        name: 'new',
                        label: 'New Password',
                        placeholder: 'New Password',
                        inputType: 'password',
                        validators: [Validators.required, Validators.minLength(6)],
                        value: this.newPassword,
                        showPasswordStrength: true,
                        defaultFocus: true
                    }),
                    new UIInputControl({
                        name: 'confirm',
                        label: 'Confirm Password',
                        placeholder: 'Confirm Password',
                        inputType: 'password',
                        validators: [Validators.required, Validators.minLength(6), UIValidators.fieldMatch(['resetPassword', 'new'], 'New Password')],
                        value: this.confirmPassword
                    })
                ]
            })
        ];
    };
    /**
     * Sets form into valid state
     */
    /**
     * Sets form into valid state
     * @return {?}
     */
    UIResetPasswordComponent.prototype.setValid = /**
     * Sets form into valid state
     * @return {?}
     */
    function () {
        clearTimeout(this.invalidTimeout);
        this.formInvalid = false;
    };
    /**
     * Shows invalid state.
     */
    /**
     * Shows invalid state.
     * @return {?}
     */
    UIResetPasswordComponent.prototype.setInvalid = /**
     * Shows invalid state.
     * @return {?}
     */
    function () {
        var _this = this;
        clearTimeout(this.invalidTimeout);
        this.formInvalid = true;
        this.invalidTimeout = setTimeout(function () {
            _this.formInvalid = false;
        }, 3000);
    };
    /**
     * Handles form events emitted from form.
     *
     * @param event
     */
    /**
     * Handles form events emitted from form.
     *
     * @param {?} event
     * @return {?}
     */
    UIResetPasswordComponent.prototype.onFormEvent = /**
     * Handles form events emitted from form.
     *
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var form = event.form;
        /** @type {?} */
        var uiFormEvent = event.event;
        if (uiFormEvent.type === 'formCreated') {
            this.resetPasswordForm = form;
        }
        if (uiFormEvent.type === 'submitFailed') {
            this.setInvalid();
        }
        if (uiFormEvent.type === 'keyUp') {
            this.setValid();
            this.uiFormsService.setValidators(form.get(['resetPassword', 'new']), this.resetPasswordFormGroups[0].controls[0].validators);
            this.uiFormsService.setValidators(form.get(['resetPassword', 'confirm']), this.resetPasswordFormGroups[0].controls[1].validators);
        }
    };
    /**
     * Handles form submit.
     *
     * @param {FormGroup} form
     */
    /**
     * Handles form submit.
     *
     * @param {?} form
     * @return {?}
     */
    UIResetPasswordComponent.prototype.onSubmit = /**
     * Handles form submit.
     *
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        if (form.valid) {
            /** @type {?} */
            var newPassword_1 = this.resetPasswordForm.value.resetPassword.new;
            /** @type {?} */
            var confirmPassword = this.resetPasswordForm.value.resetPassword.confirm;
            this.loading = true;
            this.uiAuthService.resetPassword(this.email, newPassword_1, confirmPassword, this.resetToken).pipe(flatMap(function (resetSuccess) {
                if (resetSuccess) {
                    return _this.uiAuthService.logIn(_this.email, newPassword_1).pipe(flatMap(function (loginSuccess) {
                        if (loginSuccess) {
                            return _this.uiUserAccountService.getMe().pipe(map(function (meSuccess) {
                                if (meSuccess) {
                                    _this.router.navigateByUrl('/').then(function () {
                                        _this.uiToastService.success('Your password was updated');
                                    });
                                    return meSuccess;
                                }
                            }));
                        }
                        return of(loginSuccess);
                    }));
                }
                return of(resetSuccess);
            })).subscribe();
        }
    };
    /**
     * Destroys component and all active subscriptions.
     */
    /**
     * Destroys component and all active subscriptions.
     * @return {?}
     */
    UIResetPasswordComponent.prototype.ngOnDestroy = /**
     * Destroys component and all active subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
    };
    UIResetPasswordComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-reset-password',
                    template: "\n      <!--  TITLE  -->\n\n      <h1>Reset password for</h1>\n\n      <!--  END TITLE  -->\n\n      <!--  EMAIL LABEL  -->\n\n      <h2 class=\"subtitle acc-hl-col\">{{ email }}</h2>\n\n      <!--  END EMAIL LABEL  -->\n\n      <!--  FORM  -->\n\n      <ui-form [uiFormGroups]=\"resetPasswordFormGroups\" [style]=\"'plain'\" [autoToast]=\"false\" (formSubmit)=\"onSubmit($event)\" (formEvent)=\"onFormEvent($event)\" #form></ui-form>\n\n      <!--  END FORM  -->\n\n      <!--  SUBMIT BUTTON  -->\n\n      <a class=\"button positive-button block-button\" [ngClass]=\"{'wobble negative-button no-action' : formInvalid}\" [uiLoading]=\"loading\" (click)=\"form.onSubmit()\">\n          {{ formInvalid ? 'Invalid Details' : 'Reset Password'}}\n      </a>\n\n      <!--  END SUBMIT BUTTON  -->\n\n      <!--  AUTH LINKS  -->\n\n      <div class=\"links-container\">\n          <a [routerLink]=\"['/auth', 'login']\"><i class=\"far fa-arrow-left\"></i>Back to login</a>\n      </div>\n\n      <!--  END AUTH LINKS  -->\n    ",
                    styles: ["\n      :host>h1{text-align:center;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;font-weight:500;letter-spacing:-.04em;font-size:22px;margin-bottom:48px}:host h2{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;text-align:center;margin-top:-44px;margin-bottom:22px;line-height:22px;font-size:16px}:host>p{text-align:center;font-size:12px;margin-bottom:24px;margin-top:-24px;color:#919191}:host>.button{margin:24px 0 0}:host>.links-container{font-size:12px;text-align:center;padding:24px 0}:host>.links-container>a{color:#919191;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s;line-height:32px;display:inline-block;padding:0 16px;border-radius:3px;height:32px}:host>.links-container>a>i{margin-right:8px}:host>.links-container>a:hover{color:#4e4e4e;background:#e9e9e9}@media screen and (max-width:774px){:host>h1{font-size:20px;margin-bottom:36px}:host>h2{font-size:16px;margin-bottom:14px;margin-top:-36px}:host>p{font-size:11px;margin-bottom:24px;margin-top:-20px}:host>.links-container{padding:16px 0}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIResetPasswordComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: UIToastService },
        { type: UIFormsService },
        { type: UIAuthService },
        { type: UISessionService },
        { type: UIUserAccountService }
    ]; };
    return UIResetPasswordComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILoginComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Router} router
     * @param {UIAuthService} uiAuthService
     * @param {UIFormsService} uiFormsService
     * @param {UISessionService} uiSessionService
     * @param {UIStorageService} uiStorageService
     * @param {UIUserAccountService} uiUserAccountService
     */
    function UILoginComponent(router, uiAuthService, uiFormsService, uiSessionService, uiStorageService, uiUserAccountService) {
        this.router = router;
        this.uiAuthService = uiAuthService;
        this.uiFormsService = uiFormsService;
        this.uiSessionService = uiSessionService;
        this.uiStorageService = uiStorageService;
        this.uiUserAccountService = uiUserAccountService;
        this.loginFormGroups = this.getLoginFormGroups();
        this.formInvalid = false;
        this.loading = false;
    }
    /**
     * Gets Login form groups.
     *
     * @returns {UIFormGroup[]}
     */
    /**
     * Gets Login form groups.
     *
     * @return {?}
     */
    UILoginComponent.prototype.getLoginFormGroups = /**
     * Gets Login form groups.
     *
     * @return {?}
     */
    function () {
        return [
            new UIFormGroup({
                name: 'login',
                controls: [
                    new UIInputControl({
                        name: 'email',
                        label: 'Email',
                        placeholder: 'Email',
                        inputType: 'text',
                        validators: [Validators.required, Validators.email],
                        value: this.uiSessionService.getItem('loginEmail'),
                        defaultFocus: true
                    }),
                    new UIInputControl({
                        name: 'password',
                        label: 'Password',
                        placeholder: 'Password',
                        inputType: 'password',
                        validators: [Validators.required],
                        value: ''
                    })
                ]
            }),
        ];
    };
    /**
     * Sets form into valid state
     */
    /**
     * Sets form into valid state
     * @return {?}
     */
    UILoginComponent.prototype.setValid = /**
     * Sets form into valid state
     * @return {?}
     */
    function () {
        clearTimeout(this.invalidTimeout);
        this.formInvalid = false;
    };
    /**
     * Shows invalid state.
     */
    /**
     * Shows invalid state.
     * @param {?=} invalidateControls
     * @return {?}
     */
    UILoginComponent.prototype.setInvalid = /**
     * Shows invalid state.
     * @param {?=} invalidateControls
     * @return {?}
     */
    function (invalidateControls) {
        var _this = this;
        if (invalidateControls === void 0) { invalidateControls = false; }
        clearTimeout(this.invalidTimeout);
        this.formInvalid = true;
        if (invalidateControls) {
            this.uiFormsService.invalidateControl(this.loginForm.get(['login', 'email']), 'Invalid email or password');
            this.uiFormsService.invalidateControl(this.loginForm.get(['login', 'password']), 'Invalid email or password');
        }
        this.invalidTimeout = setTimeout(function () {
            _this.formInvalid = false;
        }, 3000);
    };
    /**
     * Handles form events emitted from form.
     *
     * @param event
     */
    /**
     * Handles form events emitted from form.
     *
     * @param {?} event
     * @return {?}
     */
    UILoginComponent.prototype.onFormEvent = /**
     * Handles form events emitted from form.
     *
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var form = event.form;
        /** @type {?} */
        var uiFormEvent = event.event;
        if (uiFormEvent.type === 'formCreated') {
            this.loginForm = form;
        }
        if (uiFormEvent.type === 'submitFailed') {
            this.setInvalid();
        }
        if (uiFormEvent.type === 'keyUp') {
            this.setValid();
            this.uiFormsService.setValidators(form.get(['login', 'email']), this.loginFormGroups[0].controls[0].validators);
            this.uiFormsService.setValidators(form.get(['login', 'password']), this.loginFormGroups[0].controls[1].validators);
            if (uiFormEvent.control.join('.') === 'login.email') {
                this.uiSessionService.setItem('loginEmail', uiFormEvent.value);
            }
        }
    };
    /**
     * Handles form submit.
     *
     * @param {FormGroup} form
     */
    /**
     * Handles form submit.
     *
     * @param {?} form
     * @return {?}
     */
    UILoginComponent.prototype.onSubmit = /**
     * Handles form submit.
     *
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        if (form.valid) {
            this.setValid();
            this.loading = true;
            this.uiAuthService.logIn(form.value.login.email, form.value.login.password).pipe(flatMap(function (loginSuccess) {
                if (loginSuccess) {
                    return _this.uiUserAccountService.getMe().pipe(map(function (meSuccess) {
                        if (meSuccess) {
                            _this.router.navigateByUrl('/');
                        }
                        _this.loading = false;
                        _this.setInvalid(true);
                        return false;
                    }));
                }
                _this.loading = false;
                _this.setInvalid(true);
                return of(false);
            })).subscribe();
        }
    };
    /**
     * Enters details for quick login.
     * TODO: Remove before release!
     */
    /**
     * Enters details for quick login.
     * TODO: Remove before release!
     * @return {?}
     */
    UILoginComponent.prototype.onBackdoorLogin = /**
     * Enters details for quick login.
     * TODO: Remove before release!
     * @return {?}
     */
    function () {
        this.loginForm.get('login.email').setValue('spd@clickdealer.co.uk');
        this.loginForm.get('login.password').setValue('Steve123');
    };
    UILoginComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-login',
                    template: "\n      <!--  TITLE  -->\n\n      <h1 (click)=\"onBackdoorLogin()\">Click Dealer Login</h1>\n\n      <!--  END TITLE  -->\n\n      <!--  FORM  -->\n\n      <ui-form [uiFormGroups]=\"loginFormGroups\" [style]=\"'plain'\" [autoToast]=\"false\" (formSubmit)=\"onSubmit($event)\" (formEvent)=\"onFormEvent($event)\" #form></ui-form>\n\n      <!--  END FORM  -->\n\n      <!--  SUBMIT BUTTON  -->\n\n      <a class=\"button positive-button block-button\" [ngClass]=\"{'wobble negative-button no-action' : formInvalid}\" [uiLoading]=\"loading\" (click)=\"form.onSubmit()\">\n          {{ formInvalid ? 'Invalid Details' : 'Log In'}}\n      </a>\n\n      <!--  END SUBMIT BUTTON  -->\n\n      <!--  AUTH LINKS  -->\n\n      <div class=\"links-container\">\n          <a [routerLink]=\"['/auth', 'forgotten-password']\">Forgotten your password?</a>\n      </div>\n\n      <!--  END AUTH LINKS  -->\n    ",
                    styles: ["\n      :host>h1{text-align:center;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;font-weight:500;letter-spacing:-.04em;font-size:22px;margin-bottom:48px}:host h2{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;text-align:center;margin-top:-44px;margin-bottom:22px;line-height:22px;font-size:16px}:host>p{text-align:center;font-size:12px;margin-bottom:24px;margin-top:-24px;color:#919191}:host>.button{margin:24px 0 0}:host>.links-container{font-size:12px;text-align:center;padding:24px 0}:host>.links-container>a{color:#919191;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s;line-height:32px;display:inline-block;padding:0 16px;border-radius:3px;height:32px}:host>.links-container>a>i{margin-right:8px}:host>.links-container>a:hover{color:#4e4e4e;background:#e9e9e9}@media screen and (max-width:774px){:host>h1{font-size:20px;margin-bottom:36px}:host>h2{font-size:16px;margin-bottom:14px;margin-top:-36px}:host>p{font-size:11px;margin-bottom:24px;margin-top:-20px}:host>.links-container{padding:16px 0}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UILoginComponent.ctorParameters = function () { return [
        { type: Router },
        { type: UIAuthService },
        { type: UIFormsService },
        { type: UISessionService },
        { type: UIStorageService },
        { type: UIUserAccountService }
    ]; };
    return UILoginComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIAuthComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIThemeService} uiThemeService
     * @param {UISessionService} uiSessionService
     * @param {UIStorageService} uiStorageService
     */
    function UIAuthComponent(uiThemeService, uiSessionService, uiStorageService) {
        var _this = this;
        this.uiThemeService = uiThemeService;
        this.uiSessionService = uiSessionService;
        this.uiStorageService = uiStorageService;
        this.uiApp = this.uiSessionService.getItem('uiApp');
        this.destroyed$ = new Subject();
        this.uiSessionService.getSubject('uiApp').pipe(takeUntil(this.destroyed$)).subscribe(function (uiApp) {
            _this.uiApp = uiApp;
        });
        this.uiThemeService.setFromColor('orange').subscribe();
        this.uiStorageService.removeItem('token');
        this.uiSessionService.removeItems(['me']);
    }
    /**
     * Lifecycle hook: destroys component and all active subscriptions.
     */
    /**
     * Lifecycle hook: destroys component and all active subscriptions.
     * @return {?}
     */
    UIAuthComponent.prototype.ngOnDestroy = /**
     * Lifecycle hook: destroys component and all active subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
    };
    UIAuthComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-auth',
                    template: "\n      <!--  OVERLAY  -->\n\n      <div class=\"auth-overlay head-bg\"></div>\n\n      <!--  END OVERLAY  -->\n\n      <!--  FRAME  -->\n\n      <div class=\"auth-frame\">\n\n          <div class=\"auth-frame-inner acc-hl-bt\">\n\n              <!--  LOGOS  -->\n\n              <div class=\"logos\">\n                  <div class=\"bg-blue\"><i class=\"icon-click-dealer\"></i></div>\n                  <div class=\"bg-orange\"><i class=\"icon-click-dealer\"></i></div>\n                  <div class=\"bg-pink\"><i class=\"icon-click-dealer\"></i></div>\n                  <div class=\"bg-teal\"><i class=\"icon-click-dealer\"></i></div>\n                  <div class=\"bg-yellow\"><i class=\"icon-click-dealer\"></i></div>\n              </div>\n\n              <!--  END LOGOS  -->\n\n              <!--  ROUTER OUTLET  -->\n\n              <router-outlet></router-outlet>\n\n              <!--  END ROUTER OUTLET  -->\n\n          </div>\n\n          <!--  FOOTER  -->\n\n          <ul class=\"auth-frame-footer\">\n              <li><a class=\"pri-fg-col\" href=\"tel:01782478220\">01782 478220</a></li>\n              <li><a class=\"pri-fg-col\" href=\"mailto:help@clickdealer.co.uk\">help@clickdealer.co.uk</a></li>\n          </ul>\n\n          <!--  END FOOTER  -->\n\n      </div>\n\n      <!--  END FRAME  -->\n\n      <!--  TOAST  -->\n\n      <ui-toast [position]=\"'on-bottom'\"></ui-toast>\n\n      <!--  END TOAST  -->\n    ",
                    styles: ["\n      :host .auth-overlay{position:fixed;top:0;left:0;right:0;bottom:0}:host .auth-frame{width:360px;height:446px;position:absolute;top:50%;left:50%;margin:-223px 0 0 -180px;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s}:host .auth-frame .auth-frame-inner{background:#FFF;overflow:auto;border-radius:3px;-webkit-box-shadow:0 2px 3px rgba(0,0,0,.3);box-shadow:0 2px 3px rgba(0,0,0,.3);padding:49px 56px 8px;border-top:5px solid transparent}:host .auth-frame .auth-frame-inner .logos{text-align:center}:host .auth-frame .auth-frame-inner .logos>div{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:22px;width:22px;text-align:center;margin:0 4px 16px;border-radius:100%;color:#FFF;position:relative}:host .auth-frame .auth-frame-inner .logos>div>i{height:22px;line-height:22px;width:22px;font-size:14px}:host .auth-frame .auth-frame-footer{font-size:12px;text-align:center;height:64px}:host .auth-frame .auth-frame-footer>li{display:inline-block;margin:0 16px;line-height:64px}:host .auth-frame .auth-frame-footer>li>a{font-weight:400;opacity:.4;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s}:host .auth-frame .auth-frame-footer>li>a:hover{opacity:1}@media screen and (max-width:774px){:host .auth-frame{width:300px;height:360px;margin:-180px 0 0 -150px}:host .auth-frame .auth-frame-inner{padding:32px 32px 8px}:host .auth-frame .auth-frame-inner .logos>div{height:20px;width:20px;margin:0 4px 8px}:host .auth-frame .auth-frame-inner .logos>div>i{height:20px;line-height:20px;width:20px;font-size:12px}:host .auth-frame .auth-frame-footer{height:48px}:host .auth-frame .auth-frame-footer>li{line-height:48px}}@media screen and (min-width:775px) and (max-height:466px),screen and (max-width:774px) and (max-height:380px){:host .auth-frame{top:10px;margin-top:0}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIAuthComponent.ctorParameters = function () { return [
        { type: UIThemeService },
        { type: UISessionService },
        { type: UIStorageService }
    ]; };
    return UIAuthComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIRestOptions = /** @class */ (function () {
    function UIRestOptions(uiRestOptions) {
        this.include = [];
        this.requiresAuthorization = true;
        this.returnRawResponse = false;
        Object.assign(/** @type {?} */ (this), uiRestOptions);
    }
    return UIRestOptions;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIAuthService$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Router} router
     * @param {UIRestService} uiRestService
     * @param {UIStorageService} uiStorageService
     * @param {UIToastService} uiToastService
     * @param {UISessionService} uiSessionService
     */
    function UIAuthService(router, uiRestService, uiStorageService, uiToastService, uiSessionService) {
        this.router = router;
        this.uiRestService = uiRestService;
        this.uiStorageService = uiStorageService;
        this.uiToastService = uiToastService;
        this.uiSessionService = uiSessionService;
        this.uiApp = this.uiSessionService.getItem('uiApp');
    }
    /**
     * Logs in.
     *
     * @param {string} email
     * @param {string} password
     * @param {string} successToast
     *
     * @return {Observable<boolean>}
     */
    /**
     * Logs in.
     *
     *
     * @param {?} email
     * @param {?} password
     * @param {?=} successToast
     * @return {?}
     */
    UIAuthService.prototype.logIn = /**
     * Logs in.
     *
     *
     * @param {?} email
     * @param {?} password
     * @param {?=} successToast
     * @return {?}
     */
    function (email, password, successToast) {
        var _this = this;
        if (successToast === void 0) { successToast = null; }
        /** @type {?} */
        var body = {
            email: email,
            password: password
        };
        if (this.uiApp.audience === 'consumer') {
            body.audience = 'consumer';
        }
        /** @type {?} */
        var options = new UIRestOptions({
            requiresAuthorization: false,
            returnRawResponse: true
        });
        return this.uiRestService.post(['auth', 'login'], body, options).pipe(map(function (response) {
            if (response.ok) {
                _this.uiStorageService.setItem('token', response.body.access_token);
                return true;
            }
            return false;
        }));
    };
    /**
     * Removes token in storage, local email value and navigates to login screen.
     *
     * @return {Observable<boolean>}
     */
    /**
     * Removes token in storage, local email value and navigates to login screen.
     *
     * @return {?}
     */
    UIAuthService.prototype.logOut = /**
     * Removes token in storage, local email value and navigates to login screen.
     *
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var options = new UIRestOptions({
            requiresAuthorization: false,
            returnRawResponse: true
        });
        return this.uiRestService.post(['auth', 'logout'], null, options).pipe(map(function (response) {
            _this.uiSessionService.removeAll();
            _this.uiStorageService.removeItem('token');
            _this.router.navigate(['/auth', 'login']).then(function () {
                _this.uiToastService.success('You have been logged out');
            });
            return response.ok;
        }));
    };
    /**
     * Sends forgotten password email to user.
     *
     * @param {string} email
     *
     * @return {Observable<boolean>}
     */
    /**
     * Sends forgotten password email to user.
     *
     *
     * @param {?} email
     * @return {?}
     */
    UIAuthService.prototype.sendResetPasswordLink = /**
     * Sends forgotten password email to user.
     *
     *
     * @param {?} email
     * @return {?}
     */
    function (email) {
        /** @type {?} */
        var body = {
            email: email
        };
        if (this.uiApp.audience === 'consumer') {
            body.audience = 'consumer';
        }
        /** @type {?} */
        var options = new UIRestOptions({
            returnRawResponse: true,
            requiresAuthorization: false
        });
        return this.uiRestService.post(['auth', 'forgot-password'], body, options).pipe(map(function () {
            return true;
        }));
    };
    /**
     * Resets password to new one set by user.
     *
     * @param {string} email
     * @param {string} newPassword
     * @param {string} confirmPassword
     * @param {string} token
     *
     * @return {Observable<boolean>}
     */
    /**
     * Resets password to new one set by user.
     *
     *
     * @param {?} email
     * @param {?} newPassword
     * @param {?} confirmPassword
     * @param {?} token
     * @return {?}
     */
    UIAuthService.prototype.resetPassword = /**
     * Resets password to new one set by user.
     *
     *
     * @param {?} email
     * @param {?} newPassword
     * @param {?} confirmPassword
     * @param {?} token
     * @return {?}
     */
    function (email, newPassword, confirmPassword, token) {
        /** @type {?} */
        var body = {
            email: email,
            password: newPassword,
            password_confirmation: confirmPassword,
            token: token
        };
        /** @type {?} */
        var options = new UIRestOptions({
            returnRawResponse: true,
            requiresAuthorization: false
        });
        return this.uiRestService.post((['auth', 'reset-password']), body, options).pipe(map(function (response) {
            return response.ok;
        }));
    };
    /**
     * Verifies if reset token is valid.
     *
     * @param {string} email
     * @param {string} token
     *
     * @return {Observable<boolean>}
     */
    /**
     * Verifies if reset token is valid.
     *
     *
     * @param {?} email
     * @param {?} token
     * @return {?}
     */
    UIAuthService.prototype.verifyPasswordResetToken = /**
     * Verifies if reset token is valid.
     *
     *
     * @param {?} email
     * @param {?} token
     * @return {?}
     */
    function (email, token) {
        /** @type {?} */
        var body = {
            email: email,
            token: token
        };
        if (this.uiApp.audience === 'consumer') {
            body.audience = 'consumer';
        }
        /** @type {?} */
        var options = new UIRestOptions({
            returnRawResponse: true,
            requiresAuthorization: false
        });
        return this.uiRestService.post((['auth', 'verify-password-reset-token']), body, options).pipe(map(function (response) {
            return response.ok;
        }));
    };
    UIAuthService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIAuthService.ctorParameters = function () { return [
        { type: Router },
        { type: UIRestService },
        { type: UIStorageService },
        { type: UIToastService },
        { type: UISessionService }
    ]; };
    return UIAuthService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIAuthGuard = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param router
     * @param {UIStorageService} uiStorageService
     */
    function UIAuthGuard(router, uiStorageService) {
        this.router = router;
        this.uiStorageService = uiStorageService;
    }
    /**
     * Checks for token and navigates to login screen if not present.
     */
    /**
     * Checks for token and navigates to login screen if not present.
     * @return {?}
     */
    UIAuthGuard.prototype.canActivate = /**
     * Checks for token and navigates to login screen if not present.
     * @return {?}
     */
    function () {
        if (!this.uiStorageService.getItem('token')) {
            this.router.navigate(['/auth/login']);
            return false;
        }
        return true;
    };
    UIAuthGuard.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIAuthGuard.ctorParameters = function () { return [
        { type: Router },
        { type: UIStorageService }
    ]; };
    return UIAuthGuard;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIResetPasswordResolver = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Router} router
     * @param {UIAuthService} uiAuthService
     * @param {UIToastService} uiToastService
     */
    function UIResetPasswordResolver(router, uiAuthService, uiToastService) {
        this.router = router;
        this.uiAuthService = uiAuthService;
        this.uiToastService = uiToastService;
    }
    /**
     * Checks for token and navigates to forgotten password screen if not present.
     */
    /**
     * Checks for token and navigates to forgotten password screen if not present.
     * @param {?} activatedRouteSnapshot
     * @return {?}
     */
    UIResetPasswordResolver.prototype.resolve = /**
     * Checks for token and navigates to forgotten password screen if not present.
     * @param {?} activatedRouteSnapshot
     * @return {?}
     */
    function (activatedRouteSnapshot) {
        var _this = this;
        /** @type {?} */
        var email = activatedRouteSnapshot.queryParams['email'];
        /** @type {?} */
        var token = activatedRouteSnapshot.queryParams['token'];
        if (!email || !token) {
            this.redirectToForgottenPassword();
            return false;
        }
        return this.uiAuthService.verifyPasswordResetToken(email, token).pipe(map(function (success) {
            if (!success) {
                _this.router.navigateByUrl('/auth/forgotten-password').then(function () {
                    _this.uiToastService.error('Your reset link was invalid, please request another.');
                });
            }
            return success;
        }));
    };
    /**
     * Redirects to forgotten password and shows error toast.
     */
    /**
     * Redirects to forgotten password and shows error toast.
     * @return {?}
     */
    UIResetPasswordResolver.prototype.redirectToForgottenPassword = /**
     * Redirects to forgotten password and shows error toast.
     * @return {?}
     */
    function () {
        var _this = this;
        this.router.navigateByUrl('/auth/forgotten-password').then(function () {
            _this.uiToastService.error('Your reset link was invalid, please request another.');
        });
    };
    UIResetPasswordResolver.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIResetPasswordResolver.ctorParameters = function () { return [
        { type: Router },
        { type: UIAuthService },
        { type: UIToastService }
    ]; };
    return UIResetPasswordResolver;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIAuthInterceptor = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIStorageService} uiStorageService
     */
    function UIAuthInterceptor(uiStorageService) {
        this.uiStorageService = uiStorageService;
    }
    /**
     * Intercepts all responses to update stored token, should it be present.
     *
     * @param {HttpRequest<any>} httpRequest
     * @param {HttpHandler} httpHandler
     *
     * @return {Observable<HttpEvent<any>>}
     */
    /**
     * Intercepts all responses to update stored token, should it be present.
     *
     *
     * @param {?} httpRequest
     * @param {?} httpHandler
     * @return {?}
     */
    UIAuthInterceptor.prototype.intercept = /**
     * Intercepts all responses to update stored token, should it be present.
     *
     *
     * @param {?} httpRequest
     * @param {?} httpHandler
     * @return {?}
     */
    function (httpRequest, httpHandler) {
        var _this = this;
        return httpHandler.handle(httpRequest).pipe(tap(function (httpEvent) {
            if (httpEvent instanceof HttpResponse) {
                /** @type {?} */
                var newToken = httpEvent.headers.get('Authorization');
                if (newToken) {
                    _this.uiStorageService.setItem('token', newToken.replace('Bearer ', ''));
                }
            }
        }));
    };
    UIAuthInterceptor.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIAuthInterceptor.ctorParameters = function () { return [
        { type: UIStorageService }
    ]; };
    return UIAuthInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIUser = /** @class */ (function () {
    function UIUser(uiUser) {
        this["full_name"] = uiUser.first_name + " " + uiUser.last_name;
        Object.assign(/** @type {?} */ (this), uiUser);
    }
    return UIUser;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILoadingDirective = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {ElementRef} elementRef
     * @param {Renderer2} renderer
     */
    function UILoadingDirective(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    /**
     * Lifecycle hook: Detect change in loading state.
     *
     * @param {SimpleChanges} simpleChanges
     */
    /**
     * Lifecycle hook: Detect change in loading state.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    UILoadingDirective.prototype.ngOnChanges = /**
     * Lifecycle hook: Detect change in loading state.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    function (simpleChanges) {
        var _this = this;
        if (simpleChanges['uiLoading']) {
            setTimeout(function () {
                /** @type {?} */
                var current = simpleChanges['uiLoading'].currentValue;
                /** @type {?} */
                var previous = simpleChanges['uiLoading'].previousValue;
                if (current && !previous) {
                    _this.renderer.addClass(_this.elementRef.nativeElement, 'loading');
                    /** @type {?} */
                    var currentPositionStyle = (/** @type {?} */ (window)).getComputedStyle(_this.elementRef.nativeElement).position;
                    if (currentPositionStyle !== 'absolute' && currentPositionStyle !== 'fixed') {
                        _this.renderer.addClass(_this.elementRef.nativeElement, 'loading-relative');
                    }
                }
                else {
                    // Loading stopped. Hide spinner.
                    // Loading stopped. Hide spinner.
                    _this.renderer.removeClass(_this.elementRef.nativeElement, 'loading');
                    _this.renderer.removeClass(_this.elementRef.nativeElement, 'loading-relative');
                }
            });
        }
    };
    UILoadingDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[uiLoading]'
                },] },
    ];
    /** @nocollapse */
    UILoadingDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    UILoadingDirective.propDecorators = {
        uiLoading: [{ type: Input }]
    };
    return UILoadingDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILoadingModule = /** @class */ (function () {
    function UILoadingModule() {
    }
    UILoadingModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UILoadingDirective
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UILoadingDirective
                    ]
                },] },
    ];
    return UILoadingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIToastComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIToastService} uiToastService
     * @param {UISessionService} uiSessionService
     * @param {UIResponsiveService} uiResponsiveService
     */
    function UIToastComponent(uiToastService, uiSessionService, uiResponsiveService) {
        this.uiToastService = uiToastService;
        this.uiSessionService = uiSessionService;
        this.uiResponsiveService = uiResponsiveService;
        this.position = 'default';
        this.toastState = 'idle';
        this.uiLayoutConfig = this.uiSessionService.getItem('uiLayoutConfig');
        this.destroyed$ = new Subject();
    }
    /**
     * Subscribe to toasts and hasKeyFunctions
     */
    /**
     * Subscribe to toasts and hasKeyFunctions
     * @return {?}
     */
    UIToastComponent.prototype.ngOnInit = /**
     * Subscribe to toasts and hasKeyFunctions
     * @return {?}
     */
    function () {
        var _this = this;
        this.uiToastService.uiToast$.pipe(takeUntil(this.destroyed$)).subscribe(function (toast) {
            if (toast) {
                _this.toast = toast;
                _this.cssClasses = _this.getCSSClasses();
                if (_this.toast.state === 'ready') {
                    if (_this.position === 'on-bottom') {
                        _this.toastState = 'on-bottom';
                    }
                    else {
                        _this.toastState = _this.uiResponsiveService.screenIsGTE('sm3') ? 'on-right' : 'on-bottom';
                    }
                }
                if (_this.toast.state === 'removing') {
                    _this.toastState = 'idle';
                }
            }
            else {
                _this.toastState = 'idle';
            }
        });
        this.uiSessionService.getSubject('uiLayoutConfig').pipe(takeUntil(this.destroyed$)).subscribe(function (uiLayoutConfig) {
            _this.uiLayoutConfig = uiLayoutConfig;
        });
    };
    /**
     * Trigger removal of current toast.
     */
    /**
     * Trigger removal of current toast.
     * @return {?}
     */
    UIToastComponent.prototype.onRemove = /**
     * Trigger removal of current toast.
     * @return {?}
     */
    function () {
        this.toastState = 'idle';
    };
    /**
     * Destroy toast after animation finishes.
     *
     * @param animationEvent
     */
    /**
     * Destroy toast after animation finishes.
     *
     * @param {?} animationEvent
     * @return {?}
     */
    UIToastComponent.prototype.onAnimationEnd = /**
     * Destroy toast after animation finishes.
     *
     * @param {?} animationEvent
     * @return {?}
     */
    function (animationEvent) {
        if (animationEvent.toState === 'idle') {
            this.uiToastService.destroy();
        }
    };
    /**
     * Builds CSS Classes for toasts
     *
     * @returns any
     */
    /**
     * Builds CSS Classes for toasts
     *
     * @return {?} any
     */
    UIToastComponent.prototype.getCSSClasses = /**
     * Builds CSS Classes for toasts
     *
     * @return {?} any
     */
    function () {
        if (this.toast.type === 'success') {
            return {
                div: 'pos-bg',
                p: 'pos-alt-col',
                i: 'pos-alt-col pos-mix-hov-bg'
            };
        }
        if (this.toast.type === 'warning') {
            return {
                div: 'warn-bg',
                p: 'warn-alt-col',
                i: 'warn-alt-col warn-mix-hov-bg'
            };
        }
        if (this.toast.type === 'error') {
            return {
                div: 'neg-bg',
                p: 'neg-alt-col',
                i: 'neg-alt-col neg-mix-hov-bg'
            };
        }
        return {
            div: 'pri-bg',
            p: 'pri-alt-col',
            i: 'pri-alt-col pri-mix-hov-bg'
        };
    };
    /**
     * Moves toast appropriately on screen resize
     */
    /**
     * Moves toast appropriately on screen resize
     * @return {?}
     */
    UIToastComponent.prototype.onResize = /**
     * Moves toast appropriately on screen resize
     * @return {?}
     */
    function () {
        if (this.toastState !== 'idle') {
            if (this.position === 'on-bottom') {
                this.toastState = 'on-bottom';
            }
            else {
                this.toastState = this.uiResponsiveService.screenIsGTE('sm3') ? 'on-right' : 'on-bottom';
            }
        }
    };
    /**
     * Destroys component and any active subscriptions
     */
    /**
     * Destroys component and any active subscriptions
     * @return {?}
     */
    UIToastComponent.prototype.ngOnDestroy = /**
     * Destroys component and any active subscriptions
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
    };
    UIToastComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-toast',
                    template: "\n      <!--  TOAST CONTAINER  -->\n\n      <div class=\"toast-container\" [ngClass]=\"toastState\" [class.has-key-functions]=\"uiLayoutConfig?.hasKeyFunctions\" [class.always-on-bottom]=\"position === 'on-bottom'\" [@toast]=\"toastState\" (@toast.done)=\"onAnimationEnd($event)\">\n\n          <!--  TOAST  -->\n\n          <div *ngIf=\"toast\" class=\"toast\" [ngClass]=\"cssClasses.div\">\n\n              <!--  MESSAGE  -->\n\n              <p [ngClass]=\"cssClasses.p\">{{ toast.message }}</p>\n\n              <!--  END MESSAGE  -->\n\n              <!--  CLOSE BUTTON  -->\n\n              <i class=\"far fa-times icon-button\" [ngClass]=\"cssClasses.i\" (click)=\"onRemove()\"></i>\n\n              <!--  END CLOSE BUTTON  -->\n\n          </div>\n\n          <!--  END TOAST  -->\n\n      </div>\n\n      <!--  END TOAST CONTAINER  -->\n    ",
                    styles: ["\n      :host .toast-container{position:fixed;z-index:30000;bottom:0;right:0;overflow:hidden;width:0;height:0;-webkit-transition:bottom .2s ease-in-out 0s;-o-transition:bottom .2s ease-in-out 0s;transition:bottom .2s ease-in-out 0s}:host .toast-container .toast{width:304px;height:56px;overflow:hidden;border-radius:3px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 8px 0 0;background:#222;color:#FFF}:host .toast-container .toast p{line-height:1.4em;margin:0;color:#FFF;font-size:13px;padding:16px 16px 16px 20px}:host .toast-container .toast .fa-times{-ms-flex-negative:0;flex-shrink:0;opacity:.5;color:#FFF}:host .toast-container .toast .fa-times:hover{opacity:1;background:#4e4e4e}:host .toast-container.always-on-bottom{left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around}@media screen and (max-width:774px){:host .toast-container.has-key-functions{bottom:58px}}@media screen and (max-width:574px){:host .toast-container{left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around}}\n    "],
                    animations: [
                        trigger('toast', [
                            state('on-right', style({
                                width: '336px',
                                height: '88px',
                                padding: '16px'
                            })),
                            transition('idle => on-right', animate('0.2s ease-in-out', keyframes([
                                style({
                                    width: '0',
                                    height: '88px',
                                    padding: '16px 0'
                                }),
                                style({
                                    width: '336px',
                                    height: '88px',
                                    padding: '16px'
                                })
                            ]))),
                            transition('on-right => idle', animate('0.2s ease-in-out', keyframes([
                                style({
                                    width: '336px',
                                    height: '88px',
                                    padding: '16px'
                                }),
                                style({
                                    width: '0',
                                    height: '88px',
                                    padding: '16px 0'
                                })
                            ]))),
                            state('on-bottom', style({
                                width: '100%',
                                height: '72px',
                                padding: '8px'
                            })),
                            transition('idle => on-bottom', animate('0.2s ease-in-out', keyframes([
                                style({
                                    width: '100%',
                                    height: '0',
                                    padding: '0'
                                }),
                                style({
                                    width: '100%',
                                    height: '72px',
                                    padding: '8px 0'
                                })
                            ]))),
                            transition('on-bottom => idle', animate('0.2s ease-in-out', keyframes([
                                style({
                                    width: '100%',
                                    height: '72px',
                                    padding: '8px 0'
                                }),
                                style({
                                    width: '100%',
                                    height: '0',
                                    padding: '0'
                                })
                            ]))),
                        ])
                    ]
                },] },
    ];
    /** @nocollapse */
    UIToastComponent.ctorParameters = function () { return [
        { type: UIToastService },
        { type: UISessionService },
        { type: UIResponsiveService }
    ]; };
    UIToastComponent.propDecorators = {
        position: [{ type: Input }],
        onResize: [{ type: HostListener, args: ['window:resize',] }]
    };
    return UIToastComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIToastModule = /** @class */ (function () {
    function UIToastModule() {
    }
    UIToastModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIToastComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UIToastComponent
                    ]
                },] },
    ];
    return UIToastModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UITooltip = /** @class */ (function () {
    function UITooltip(uiTooltip) {
        this.trigger = 'hover';
        this.placement = 'top';
        this.offset = 8;
        this.delay = 400;
        this.size = 'normal';
        Object.assign(/** @type {?} */ (this), uiTooltip);
    }
    return UITooltip;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UITooltipDirective = /** @class */ (function () {
    function UITooltipDirective(elementRef) {
        this.elementRef = elementRef;
        this.tooltipDestroyed$ = new Subject();
        this.enabled = true;
        this.timeout = null;
    }
    /**
     * Set defaults from model if not set
     */
    /**
     * Set defaults from model if not set
     * @return {?}
     */
    UITooltipDirective.prototype.ngOnInit = /**
     * Set defaults from model if not set
     * @return {?}
     */
    function () {
        this.uiTooltipConfig = Object.assign(new UITooltip(), this.uiTooltipConfig);
    };
    /**
     * Handles changes to config.
     *
     * @param {SimpleChanges} simpleChanges
     */
    /**
     * Handles changes to config.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    UITooltipDirective.prototype.ngOnChanges = /**
     * Handles changes to config.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    function (simpleChanges) {
        if (simpleChanges['uiTooltipConfig']) {
            this.uiTooltipConfig = Object.assign(new UITooltip(), this.uiTooltipConfig);
        }
    };
    /**
     * Disable tooltip if user is actively using a touch device and
     * trigger is set to hover
     */
    /**
     * Disable tooltip if user is actively using a touch device and
     * trigger is set to hover
     * @return {?}
     */
    UITooltipDirective.prototype.onTouchStart = /**
     * Disable tooltip if user is actively using a touch device and
     * trigger is set to hover
     * @return {?}
     */
    function () {
        this.enabled = this.uiTooltipConfig.trigger !== 'hover';
    };
    /**
     * Initialise tooltip element if trigger is set to hover
     */
    /**
     * Initialise tooltip element if trigger is set to hover
     * @return {?}
     */
    UITooltipDirective.prototype.onMouseEnter = /**
     * Initialise tooltip element if trigger is set to hover
     * @return {?}
     */
    function () {
        if (this.uiTooltipConfig.trigger === 'hover') {
            this.initTooltip();
        }
    };
    /**
     * Initialise tooltip element if trigger is set to click
     */
    /**
     * Initialise tooltip element if trigger is set to click
     * @return {?}
     */
    UITooltipDirective.prototype.onClick = /**
     * Initialise tooltip element if trigger is set to click
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.uiTooltipConfig.trigger === 'click') {
            if (this.enabled && this.uiTooltipText && this.element) {
                this.destroyElement();
                return;
            }
            this.initTooltip();
            fromEvent(document, 'click').pipe(skip(1)).pipe(takeUntil(this.tooltipDestroyed$)).subscribe(function (event) {
                if (!_this.elementRef.nativeElement.contains(event.target)) {
                    _this.destroyElement();
                }
            });
            return;
        }
        this.destroyElement();
    };
    /**
     * Initialise tooltip element
     */
    /**
     * Initialise tooltip element
     * @return {?}
     */
    UITooltipDirective.prototype.initTooltip = /**
     * Initialise tooltip element
     * @return {?}
     */
    function () {
        if (this.enabled && this.uiTooltipText) {
            if (typeof (this.uiTooltipText) === 'string') {
                this.uiTooltipText = [this.uiTooltipText];
            }
            this.position = this.elementRef.nativeElement.getBoundingClientRect();
            document.body.appendChild(this.getTooltipElement());
            this.setPosition();
        }
    };
    /**
     * Create and return tooltip element
     */
    /**
     * Create and return tooltip element
     * @return {?}
     */
    UITooltipDirective.prototype.getTooltipElement = /**
     * Create and return tooltip element
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.element) {
            this.element.parentNode.removeChild(this.element);
            this.element = null;
        }
        this.element = document.createElement('span');
        this.element.className += 'tooltip position-' + this.uiTooltipConfig.placement;
        this.element.className += ((this.uiTooltipConfig.size !== 'normal') ? (' ' + this.uiTooltipConfig.size) : '');
        this.element.appendChild(this.getTooltipContent());
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
            _this.element.className += ' show';
        }, this.uiTooltipConfig.delay);
        return this.element;
    };
    /**
     * Builds tooltip content into either a simple string or,
     * when required, an unordered list of strings.
     *
     * @returns {Node}
     */
    /**
     * Builds tooltip content into either a simple string or,
     * when required, an unordered list of strings.
     *
     * @return {?}
     */
    UITooltipDirective.prototype.getTooltipContent = /**
     * Builds tooltip content into either a simple string or,
     * when required, an unordered list of strings.
     *
     * @return {?}
     */
    function () {
        if (this.uiTooltipText.length === 1) {
            /** @type {?} */
            var span = document.createElement('span');
            span.textContent = this.uiTooltipText[0];
            return span;
        }
        /** @type {?} */
        var list = document.createElement('ul');
        for (var _i = 0, _a = this.uiTooltipText; _i < _a.length; _i++) {
            var item = _a[_i];
            /** @type {?} */
            var li = document.createElement('li');
            li.textContent = item;
            list.appendChild(li);
        }
        return list;
    };
    /**
     * Add necessary placement classes and set inline styling for position on screen
     */
    /**
     * Add necessary placement classes and set inline styling for position on screen
     * @return {?}
     */
    UITooltipDirective.prototype.setPosition = /**
     * Add necessary placement classes and set inline styling for position on screen
     * @return {?}
     */
    function () {
        /** @type {?} */
        var elementHeight = this.elementRef.nativeElement.offsetHeight;
        /** @type {?} */
        var elementWidth = this.elementRef.nativeElement.offsetWidth;
        /** @type {?} */
        var tooltipHeight = this.element.clientHeight;
        /** @type {?} */
        var tooltipWidth = this.element.offsetWidth;
        /** @type {?} */
        var commonLeft = this.position.left + elementWidth / 2 - tooltipWidth / 2 + 'px';
        /** @type {?} */
        var commonTop = this.position.top + elementHeight / 2 - this.element.clientHeight / 2 + 'px';
        if (this.uiTooltipConfig.placement === 'top') {
            this.element.style.top = this.position.top - (tooltipHeight + this.uiTooltipConfig.offset) + 'px';
            this.element.style.left = commonLeft;
        }
        if (this.uiTooltipConfig.placement === 'bottom') {
            this.element.style.top = this.position.top + elementHeight + this.uiTooltipConfig.offset + 'px';
            this.element.style.left = commonLeft;
        }
        if (this.uiTooltipConfig.placement === 'left') {
            this.element.style.left = this.position.left - tooltipWidth - this.uiTooltipConfig.offset + 'px';
            this.element.style.top = commonTop;
        }
        if (this.uiTooltipConfig.placement === 'right') {
            this.element.style.left = this.position.left + elementWidth + this.uiTooltipConfig.offset + 'px';
            this.element.style.top = commonTop;
        }
    };
    /**
     * Destroy element if trigger is set to hover
     */
    /**
     * Destroy element if trigger is set to hover
     * @return {?}
     */
    UITooltipDirective.prototype.onMouseLeave = /**
     * Destroy element if trigger is set to hover
     * @return {?}
     */
    function () {
        if (this.uiTooltipConfig.trigger === 'hover') {
            this.destroyElement();
        }
    };
    /**
     * Destroy tooltip element, no longer needed
     */
    /**
     * Destroy tooltip element, no longer needed
     * @return {?}
     */
    UITooltipDirective.prototype.destroyElement = /**
     * Destroy tooltip element, no longer needed
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.enabled && this.uiTooltipText && this.element) {
            clearTimeout(this.timeout);
            this.element.className = this.element.className.replace('show', '');
            this.timeout = setTimeout(function () {
                _this.element.parentNode.removeChild(_this.element);
                _this.element = null;
                _this.tooltipDestroyed$.next(true);
            }, 200);
        }
    };
    /**
     * Make sure tooltip element is no longer present when
     * trigger element is destroyed
     */
    /**
     * Make sure tooltip element is no longer present when
     * trigger element is destroyed
     * @return {?}
     */
    UITooltipDirective.prototype.ngOnDestroy = /**
     * Make sure tooltip element is no longer present when
     * trigger element is destroyed
     * @return {?}
     */
    function () {
        this.destroyElement();
    };
    UITooltipDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[uiTooltipText]'
                },] },
    ];
    /** @nocollapse */
    UITooltipDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    UITooltipDirective.propDecorators = {
        uiTooltipText: [{ type: Input }],
        uiTooltipConfig: [{ type: Input }],
        onTouchStart: [{ type: HostListener, args: ['window:touchstart',] }],
        onMouseEnter: [{ type: HostListener, args: ['mouseenter',] }],
        onClick: [{ type: HostListener, args: ['click',] }],
        onMouseLeave: [{ type: HostListener, args: ['mouseleave',] }]
    };
    return UITooltipDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UITooltipModule = /** @class */ (function () {
    function UITooltipModule() {
    }
    UITooltipModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UITooltipDirective
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UITooltipDirective
                    ]
                },] },
    ];
    return UITooltipModule;
}());

var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UIMultiControl = /** @class */ (function (_super) {
    __extends$1(UIMultiControl, _super);
    function UIMultiControl(uiMultiControl) {
        var _this = _super.call(this, uiMultiControl) || this;
        _this.type = 'multi';
        _this.orientation = 'vertical';
        Object.assign(/** @type {?} */ (_this), uiMultiControl);
        return _this;
    }
    return UIMultiControl;
}(UIFormControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIFormComponent = /** @class */ (function () {
    /**
     * Construct component with dependencies.
     *
     * @param {FormBuilder} formBuilder
     * @param {UIToastService} uiToastService
     * @param {UIHelperService} uiHelperService
     * @param {UIFormsService} uiFormsService
     */
    function UIFormComponent(formBuilder, uiToastService, uiHelperService, uiFormsService, uiScrollService) {
        this.formBuilder = formBuilder;
        this.uiToastService = uiToastService;
        this.uiHelperService = uiHelperService;
        this.uiFormsService = uiFormsService;
        this.uiScrollService = uiScrollService;
        this.submitText = 'Submit';
        this.showSubmit = true;
        this.inlineSubmit = false;
        this.submitTheme = 'positive';
        this.submitting = false;
        this.style = 'default';
        this.autoToast = true;
        this.formSubmit = new EventEmitter();
        this.formEvent = new EventEmitter();
        this.form = new FormGroup({});
    }
    /**
     * Lifecycle hook: Initialise form from Input data. Loop through and create angular
     * data driven form.
     */
    /**
     * Lifecycle hook: Initialise form from Input data. Loop through and create angular
     * data driven form.
     * @return {?}
     */
    UIFormComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Initialise form from Input data. Loop through and create angular
     * data driven form.
     * @return {?}
     */
    function () {
        var _this = this;
        this.form = this.formBuilder.group({});
        this.uiFormGroups.forEach(function (uiFormGroup) {
            /** @type {?} */
            var formGroup = _this.formBuilder.group({});
            _this.form.addControl(uiFormGroup.name, _this.addControls(formGroup, uiFormGroup, uiFormGroup.controls));
        });
        this.formEvent.emit({ form: this.form, event: { type: 'formCreated' } });
    };
    /**
     * Adds controls to form group or control. Called recursively when UIMultiControl is used.
     *
     * @param {FormGroup} formGroup
     * @param {UIFormGroup | UIFormControl} uiFormGroup
     * @param {UIFormControl[]} controls
     * @returns {FormGroup}
     */
    /**
     * Adds controls to form group or control. Called recursively when UIMultiControl is used.
     *
     * @param {?} formGroup
     * @param {?} uiFormGroup
     * @param {?} controls
     * @return {?}
     */
    UIFormComponent.prototype.addControls = /**
     * Adds controls to form group or control. Called recursively when UIMultiControl is used.
     *
     * @param {?} formGroup
     * @param {?} uiFormGroup
     * @param {?} controls
     * @return {?}
     */
    function (formGroup, uiFormGroup, controls) {
        var _this = this;
        controls.forEach(function (uiFormControl) {
            /**
                         * Check id has not been previously set (probably by parent multi control).
                         */
            if (!uiFormControl.id) {
                uiFormControl.id = uiFormControl.name + '_' + _this.uiHelperService.generateRandomString(20);
            }
            /**
                         * Check for instance of UIMultiControl. If matches, set first item id to match and build child controls.
                         */
            if (uiFormControl instanceof UIMultiControl) {
                /** @type {?} */
                var multiFormGroup = _this.formBuilder.group({});
                uiFormControl.items[0].id = uiFormControl.id;
                formGroup.addControl(uiFormControl.name, _this.addControls(multiFormGroup, uiFormControl, uiFormControl.items));
            }
            else {
                formGroup.addControl(uiFormControl.name, new FormControl(uiFormControl.value, uiFormControl.validators, uiFormControl.asyncValidators));
            }
        });
        return formGroup;
    };
    /**
     * Submit event when form is submitted. Will show validation of it doesn't pass.
     * Upon passing validation, form state will be emitted to parent via Output().
     */
    /**
     * Submit event when form is submitted. Will show validation of it doesn't pass.
     * Upon passing validation, form state will be emitted to parent via Output().
     * @return {?}
     */
    UIFormComponent.prototype.onSubmit = /**
     * Submit event when form is submitted. Will show validation of it doesn't pass.
     * Upon passing validation, form state will be emitted to parent via Output().
     * @return {?}
     */
    function () {
        if (this.form.invalid) {
            this.uiFormsService.forceValidate(this.form);
            this.formEvent.emit({ form: this.form, event: { type: 'submitFailed' } });
            if (this.autoToast) {
                this.uiScrollService.smoothScrollTo('.control.ng-invalid');
                this.uiToastService.error('Please check the form for errors');
            }
            return;
        }
        this.formSubmit.emit(this.form);
    };
    /**
     * Checks if form control passes validation, returns pass state. Checks one level
     * into multi control.
     *
     * @param {UIFormGroup} uiFormGroup
     * @param {UIFormControl} uiFormControl
     * @returns {boolean}
     */
    /**
     * Checks if form control passes validation, returns pass state. Checks one level
     * into multi control.
     *
     * @param {?} uiFormGroup
     * @param {?} uiFormControl
     * @return {?}
     */
    UIFormComponent.prototype.isInvalid = /**
     * Checks if form control passes validation, returns pass state. Checks one level
     * into multi control.
     *
     * @param {?} uiFormGroup
     * @param {?} uiFormControl
     * @return {?}
     */
    function (uiFormGroup, uiFormControl) {
        if (uiFormControl instanceof UIMultiControl) {
            for (var _i = 0, _a = uiFormControl.items; _i < _a.length; _i++) {
                var item = _a[_i];
                /** @type {?} */
                var childControl = this.form.get(uiFormGroup.name).get(uiFormControl.name).get(item.name);
                if (item.validators.length && this.uiFormsService.isInvalid(childControl)) {
                    return true;
                }
            }
        }
        /** @type {?} */
        var formGroup = this.form.controls[uiFormGroup.name];
        return uiFormControl.validators.length && this.uiFormsService.isInvalid(formGroup.controls[uiFormControl.name]);
    };
    /**
     * Gets the reasons that a control has not passed validation, returns as array.
     * Doesn't need to get reasons for children of multi control, as they
     * are handled at lower level.
     *
     * @param {UIFormGroup} uiFormGroup
     * @param {UIFormControl} uiFormControl
     * @returns {string[]}
     */
    /**
     * Gets the reasons that a control has not passed validation, returns as array.
     * Doesn't need to get reasons for children of multi control, as they
     * are handled at lower level.
     *
     * @param {?} uiFormGroup
     * @param {?} uiFormControl
     * @return {?}
     */
    UIFormComponent.prototype.getInvalidReasons = /**
     * Gets the reasons that a control has not passed validation, returns as array.
     * Doesn't need to get reasons for children of multi control, as they
     * are handled at lower level.
     *
     * @param {?} uiFormGroup
     * @param {?} uiFormControl
     * @return {?}
     */
    function (uiFormGroup, uiFormControl) {
        /** @type {?} */
        var formGroup = this.form.controls[uiFormGroup.name];
        return this.uiFormsService.getInvalidReasons(formGroup.controls[uiFormControl.name]);
    };
    /**
     * Handles output of chile event.
     *
     * @param {UIFormGroup} uiFormGroup
     * @param event
     */
    /**
     * Handles output of chile event.
     *
     * @param {?} uiFormGroup
     * @param {?} event
     * @return {?}
     */
    UIFormComponent.prototype.onChildEvent = /**
     * Handles output of chile event.
     *
     * @param {?} uiFormGroup
     * @param {?} event
     * @return {?}
     */
    function (uiFormGroup, event) {
        event.control.splice(0, 0, uiFormGroup.name);
        this.formEvent.emit({ form: this.form, event: event });
    };
    UIFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-form',
                    template: "\n      <!-- FORM  -->\n\n      <form [formGroup]=\"form\" (submit)=\"onSubmit()\" novalidate>\n\n          <!--  FULL FORM  -->\n\n          <div *ngIf=\"style === 'default'\">\n\n              <!--  FORM GROUP LOOP  -->\n\n              <section *ngFor=\"let uiFormGroup of uiFormGroups; let isLast = last\" class=\"written-content\">\n\n                  <!--  FORM GROUP HEADING  -->\n\n                  <h3 *ngIf=\"uiFormGroup.heading\">{{uiFormGroup.heading}}</h3>\n                  <p *ngIf=\"uiFormGroup.description\" class=\"sub-heading\">{{uiFormGroup.description}}</p>\n\n                  <!--  END FORM GROUP HEADING  -->\n\n                  <!--  FORM GROUP CONTENT  -->\n\n                  <div class=\"form-group\">\n\n                      <!--  FORM CONTROL LOOP  -->\n\n                      <div *ngFor=\"let uiFormControl of uiFormGroup.controls\" class=\"row\">\n\n                          <!--  FORM CONTROL LABEL  -->\n\n                          <div class=\"label-container col-sm1-30 col-sm3-8 col-md2-8 col-md3-7 col-lg2-6\">\n\n                              <!--  LABEL  -->\n\n                              <label [for]=\"uiFormControl.id\" [class.neg-col]=\"isInvalid(uiFormGroup, uiFormControl)\">{{uiFormControl.label}}</label>\n\n                              <!--  END LABEL  -->\n\n                              <!--  DESCRIPTION  -->\n\n                              <p *ngIf=\"uiFormControl.description\" class=\"description\">\n                                  <small>{{ uiFormControl.description }}</small>\n                              </p>\n\n                              <!--  END DESCRIPTION  -->\n\n                          </div>\n\n                          <!-- END FORM CONTROL LABEL  -->\n\n                          <!--  FORM CONTROL CONTAINER  -->\n\n                          <div class=\"control-container col-sm1-30 col-sm3-22 col-md2-19 col-md3-17 col-lg2-14\">\n\n                              <!--  CONTROL SELECTOR  -->\n\n                              <ui-control-selector\n                                  [form]=\"form.controls[uiFormGroup.name]\"\n                                  [uiFormControl]=\"uiFormControl\"\n                                  [isInvalid]=\"isInvalid(uiFormGroup, uiFormControl)\"\n                                  [invalidReasons]=\"getInvalidReasons(uiFormGroup, uiFormControl)\"\n                                  (onEvent)=\"onChildEvent(uiFormGroup, $event)\">\n                              </ui-control-selector>\n\n                              <!-- END CONTROL SELECTOR  -->\n\n                              <!--  INFO ICON  -->\n\n                              <i *ngIf=\"uiFormControl.info\" class=\"far fa-info-circle icon-button pri-hl-col\" [uiTooltipText]=\"uiFormControl.info\" [uiTooltipConfig]=\"{placement: 'left'}\"></i>\n\n                              <!-- END INFO ICON  -->\n\n                          </div>\n\n                          <!--  END FORM CONTROL CONTAINER  -->\n\n                      </div>\n\n                      <!--  END FORM CONTROL LOOP  -->\n\n                      <!--  INLINE SUBMIT BUTTON  -->\n\n                      <div *ngIf=\"showSubmit && inlineSubmit && isLast\" class=\"row\">\n                          <div class=\"control-container col-sm1-30 col-sm3-22 col-sm3-offset-8 col-md2-19 col-md2-offset-8 col-md3-17 col-md3-offset-7 col-lg2-14 col-lg2-offset-6\">\n                              <a class=\"button\" [ngClass]=\"submitTheme + '-button'\" [uiLoading]=\"submitting\" (click)=\"onSubmit()\">{{ submitText }}</a>\n                          </div>\n                      </div>\n\n                      <!--  END INLINE SUBMIT BUTTON  -->\n\n                  </div>\n\n                  <!--  END FORM GROUP CONTENT  -->\n\n              </section>\n\n              <!--  END FORM GROUP LOOP  -->\n\n              <!--  HIDDEN SUBMIT BUTTON  -->\n\n              <button class=\"hidden\">Submit</button>\n\n              <!-- END HIDDEN SUBMIT BUTTON  -->\n\n              <!--  VISIBLE SUBMIT BUTTON  -->\n\n              <div *ngIf=\"showSubmit && !inlineSubmit\" class=\"row\">\n                  <div class=\"col-sm1-30 align-right\">\n                      <a class=\"button\" [ngClass]=\"submitTheme + '-button'\" [uiLoading]=\"submitting\" (click)=\"onSubmit()\">{{ submitText }}</a>\n                  </div>\n              </div>\n\n              <!-- END VISIBLE SUBMIT BUTTON  -->\n\n          </div>\n\n          <!--  END FULL FORM  -->\n\n          <!--  CONTROLS ONLY  -->\n\n          <div *ngIf=\"style === 'plain'\" class=\"plain\">\n\n              <!--  FORM GROUP LOOP  -->\n\n              <div *ngFor=\"let uiFormGroup of uiFormGroups\" class=\"plain-group-container\">\n\n                  <!--  FORM CONTROL LOOP  -->\n\n                  <div *ngFor=\"let uiFormControl of uiFormGroup.controls\" class=\"plain-control-container\">\n\n                      <!--  CONTROL SELECTOR  -->\n\n                      <ui-control-selector\n                          [form]=\"form.controls[uiFormGroup.name]\"\n                          [uiFormControl]=\"uiFormControl\"\n                          [isInvalid]=\"isInvalid(uiFormGroup, uiFormControl)\"\n                          [invalidReasons]=\"getInvalidReasons(uiFormGroup, uiFormControl)\"\n                          (onEvent)=\"onChildEvent(uiFormGroup, $event)\">\n                      </ui-control-selector>\n\n                      <!-- END CONTROL SELECTOR  -->\n\n                  </div>\n\n                  <!--  END FORM CONTROL LOOP  -->\n\n              </div>\n\n              <!--  END FORM GROUP LOOP  -->\n\n              <!--  HIDDEN SUBMIT BUTTON  -->\n\n              <button class=\"hidden\">Submit</button>\n\n              <!-- END HIDDEN SUBMIT BUTTON  -->\n\n          </div>\n\n          <!--  END CONTROLS ONLY  -->\n\n      </form>\n\n      <!--  END FORM  -->\n    ",
                    styles: ["\n      :host form .form-group{display:block;background:#f2f2f2;border-radius:3px;margin-bottom:24px}:host form .form-group .row{border-bottom:1px solid #d3d3d3}:host form .form-group .row>div{padding:16px 24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}:host form .form-group .row>div>.icon-button{margin-left:8px;color:#222}:host form .form-group .row>div>.icon-button:hover{background:#dedede;color:#222}:host form .form-group .row>div.label-container{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}:host form .form-group .row>div.label-container>label{text-transform:uppercase;color:#646464;font-size:12px;font-weight:500;-ms-flex-negative:0;flex-shrink:0;line-height:1.5em;margin:8px 0 0;-webkit-transition:color .1s ease-in-out 0s;-o-transition:color .1s ease-in-out 0s;transition:color .1s ease-in-out 0s}:host form .form-group .row>div.label-container>.description{color:#a7a7a7;font-size:11px;margin-bottom:8px}:host form .form-group .row:nth-child(even){background:#f8f8f8}:host form .form-group .row:last-child{border-radius:0 0 3px 3px;border-bottom:0}:host form>.plain>.plain-group-container>.plain-control-container{margin-bottom:4px}:host form>.plain>.plain-group-container>.plain-control-container:last-child{margin-bottom:0}@media screen and (max-width:574px){:host form .form-group{margin-bottom:16px}:host form .form-group .row{position:relative}:host form .form-group .row>div{padding:16px}:host form .form-group .row>div>.icon-button{position:absolute;right:8px;top:8px}:host form .form-group .row>div.label-container{padding-bottom:0;margin-bottom:-8px}:host form .form-group .row>div.label-container>label{margin:0}:host form .form-group .row>div.label-container>.description{margin-bottom:4px}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIFormComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: UIToastService },
        { type: UIHelperService },
        { type: UIFormsService },
        { type: UIScrollService }
    ]; };
    UIFormComponent.propDecorators = {
        uiFormGroups: [{ type: Input }],
        submitText: [{ type: Input }],
        showSubmit: [{ type: Input }],
        inlineSubmit: [{ type: Input }],
        submitTheme: [{ type: Input }],
        submitting: [{ type: Input }],
        style: [{ type: Input }],
        autoToast: [{ type: Input }],
        formSubmit: [{ type: Output }],
        formEvent: [{ type: Output }]
    };
    return UIFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIControlSelectorComponent = /** @class */ (function () {
    function UIControlSelectorComponent() {
        this.isInvalid = false;
        this.invalidReasons = [];
        this.onEvent = new EventEmitter();
    }
    /**
     * Handles output emit of child events.
     *
     * @param event
     */
    /**
     * Handles output emit of child events.
     *
     * @param {?} event
     * @return {?}
     */
    UIControlSelectorComponent.prototype.onChildEvent = /**
     * Handles output emit of child events.
     *
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.onEvent.emit(event);
    };
    UIControlSelectorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-control-selector',
                    template: "\n      <!--  CHECKBOX  -->\n\n      <ui-checkbox-control\n          *ngIf=\"uiFormControl.type === 'checkbox'\"\n          [id]=\"uiFormControl.id\"\n          [form]=\"form\"\n          [name]=\"uiFormControl.name\"\n          [text]=\"uiFormControl.text\"\n          [isInvalid]=\"uiFormControl.validators.length && isInvalid\"\n          [invalidReasons]=\"invalidReasons\"\n          (onEvent)=\"onChildEvent($event)\">\n      </ui-checkbox-control>\n\n      <!--  END CHECKBOX  -->\n\n      <!--  INPUT  -->\n\n      <ui-input-control\n          *ngIf=\"uiFormControl.type === 'input'\"\n          [id]=\"uiFormControl.id\"\n          [form]=\"form\"\n          [name]=\"uiFormControl.name\"\n          [placeholder]=\"uiFormControl.placeholder\"\n          [inputType]=\"uiFormControl.inputType\"\n          [prefixes]=\"uiFormControl.prefixes\"\n          [suffixes]=\"uiFormControl.suffixes\"\n          [hasValidators]=\"uiFormControl.validators.length\"\n          [isInvalid]=\"isInvalid\"\n          [invalidReasons]=\"invalidReasons\"\n          [showPasswordStrength]=\"uiFormControl.showPasswordStrength\"\n          [isDefaultFocus]=\"uiFormControl.defaultFocus\"\n          (onEvent)=\"onChildEvent($event)\">\n      </ui-input-control>\n\n      <!--  END INPUT  -->\n\n      <!--  TEXTAREA  -->\n\n      <ui-textarea-control\n          *ngIf=\"uiFormControl.type === 'textarea'\"\n          [id]=\"uiFormControl.id\"\n          [form]=\"form\"\n          [name]=\"uiFormControl.name\"\n          [placeholder]=\"uiFormControl.placeholder\"\n          [prefixes]=\"uiFormControl.prefixes\"\n          [suffixes]=\"uiFormControl.suffixes\"\n          [hasValidators]=\"uiFormControl.validators.length\"\n          [isInvalid]=\"isInvalid\"\n          [invalidReasons]=\"invalidReasons\"\n          [isDefaultFocus]=\"uiFormControl.defaultFocus\"\n          [rows]=\"uiFormControl.rows\">\n      </ui-textarea-control>\n\n      <!--  END TEXTAREA  -->\n\n      <!--  SLIDER  -->\n\n      <ui-slider-control\n          *ngIf=\"uiFormControl.type === 'range'\"\n          [id]=\"uiFormControl.id\"\n          [form]=\"form\"\n          [name]=\"uiFormControl.name\"\n          [min]=\"uiFormControl.min\"\n          [max]=\"uiFormControl.max\"\n          [step]=\"uiFormControl.step\"\n          [invert]=\"uiFormControl.invert\"\n          [thumbLabel]=\"uiFormControl.thumbLabel\"\n          [tickInterval]=\"uiFormControl.tickInterval\"\n          [textInput]=\"uiFormControl.textInput\"\n          [prefixes]=\"uiFormControl.prefixes\"\n          [suffixes]=\"uiFormControl.suffixes\"\n          [isDefaultFocus]=\"uiFormControl.defaultFocus\">\n      </ui-slider-control>\n\n      <!-- END SLIDER  -->\n\n      <!--  SELECT  -->\n\n      <ui-select-control\n          *ngIf=\"uiFormControl.type === 'select'\"\n          [id]=\"uiFormControl.id\"\n          [form]=\"form\"\n          [name]=\"uiFormControl.name\"\n          [options]=\"uiFormControl.options\"\n          [prefixes]=\"uiFormControl.prefixes\"\n          [suffixes]=\"uiFormControl.suffixes\"\n          [hasValidators]=\"uiFormControl.validators.length\"\n          [isInvalid]=\"isInvalid\"\n          [invalidReasons]=\"invalidReasons\"\n          (onEvent)=\"onChildEvent($event)\">\n      </ui-select-control>\n\n      <!--  END SELECT  -->\n\n      <!--  MULTI  -->\n\n      <ui-multi-control\n          *ngIf=\"uiFormControl.type === 'multi'\"\n          [form]=\"form\"\n          [uiFormControl]=\"uiFormControl\"\n          [items]=\"uiFormControl.items\"\n          (onEvent)=\"onChildEvent($event)\">\n      </ui-multi-control>\n\n      <!--  END MULTI  -->\n    ",
                    styles: ["\n      :host{width:100%;display:block}\n    "]
                },] },
    ];
    UIControlSelectorComponent.propDecorators = {
        form: [{ type: Input }],
        uiFormControl: [{ type: Input }],
        isInvalid: [{ type: Input }],
        invalidReasons: [{ type: Input }],
        onEvent: [{ type: Output }]
    };
    return UIControlSelectorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UICheckboxControlComponent = /** @class */ (function () {
    function UICheckboxControlComponent() {
        this.onEvent = new EventEmitter();
        this.textParts = [];
    }
    /**
     * Lifecycle hook: Creates text parts
     */
    /**
     * Lifecycle hook: Creates text parts
     * @return {?}
     */
    UICheckboxControlComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Creates text parts
     * @return {?}
     */
    function () {
        this.textParts = this.text ? this.text.split('|') : [];
    };
    /**
     * Checks is control is checked.
     *
     * @returns {boolean}
     */
    /**
     * Checks is control is checked.
     *
     * @return {?}
     */
    UICheckboxControlComponent.prototype.isChecked = /**
     * Checks is control is checked.
     *
     * @return {?}
     */
    function () {
        return this.form.controls[this.name].value === true;
    };
    /**
     * Checks if control value is indeterminate.
     *
     * @returns {boolean}
     */
    /**
     * Checks if control value is indeterminate.
     *
     * @return {?}
     */
    UICheckboxControlComponent.prototype.isIndeterminate = /**
     * Checks if control value is indeterminate.
     *
     * @return {?}
     */
    function () {
        return this.form.controls[this.name].value === null;
    };
    /**
     * Checks if label part contains * to indicate CTA status.
     *
     * @param {string} textPart
     * @returns {boolean}
     */
    /**
     * Checks if label part contains * to indicate CTA status.
     *
     * @param {?} textPart
     * @return {?}
     */
    UICheckboxControlComponent.prototype.isCta = /**
     * Checks if label part contains * to indicate CTA status.
     *
     * @param {?} textPart
     * @return {?}
     */
    function (textPart) {
        return textPart.indexOf('*') !== -1;
    };
    /**
     * Gets CTA text from label part.
     *
     * @param {string} textPart
     * @returns {string}
     */
    /**
     * Gets CTA text from label part.
     *
     * @param {?} textPart
     * @return {?}
     */
    UICheckboxControlComponent.prototype.getCtaText = /**
     * Gets CTA text from label part.
     *
     * @param {?} textPart
     * @return {?}
     */
    function (textPart) {
        return textPart.split('*')[0];
    };
    /**
     * Handles when CTA text part is triggered.
     *
     * @param {any} event
     * @param {string} textPart
     */
    /**
     * Handles when CTA text part is triggered.
     *
     * @param {?} event
     * @param {?} textPart
     * @return {?}
     */
    UICheckboxControlComponent.prototype.onCtaClick = /**
     * Handles when CTA text part is triggered.
     *
     * @param {?} event
     * @param {?} textPart
     * @return {?}
     */
    function (event, textPart) {
        event.preventDefault();
        /** @type {?} */
        var formEvent = {
            control: [this.name],
            type: 'cta',
            value: textPart.split('*')[1]
        };
        this.onEvent.emit(formEvent);
    };
    /**
     * Handles value change of checkbox.
     *
     * @param event
     */
    /**
     * Handles value change of checkbox.
     *
     * @param {?} event
     * @return {?}
     */
    UICheckboxControlComponent.prototype.onCheckChange = /**
     * Handles value change of checkbox.
     *
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var formEvent = {
            control: [this.name],
            type: 'change',
            value: event.target.checked
        };
        this.onEvent.emit(formEvent);
    };
    UICheckboxControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-checkbox-control',
                    template: "\n      <!--  CHECKBOX CONTROL  -->\n\n      <div [formGroup]=\"form\" class=\"control\" [class.is-invalid]=\"isInvalid\">\n\n          <!--  HIDDEN INPUT  -->\n\n          <input [id]=\"id\" type=\"checkbox\" [formControlName]=\"name\" (change)=\"onCheckChange($event)\"/>\n\n          <!--  END HIDDEN INPUT  -->\n\n          <!--  LABEL  -->\n\n          <label [for]=\"id\">\n\n              <!--  CHECKBOX CONTAINER  -->\n\n              <span class=\"checkbox-container\" [ngClass]=\"{'acc-hl-bg acc-hl-bd' : isChecked()}\" [class.neg-bd]=\"isInvalid\"></span>\n\n              <!--  END CHECKBOX CONTAINER  -->\n\n              <!--  CHECKBOX TICK  -->\n\n              <i class=\"far fa-check\"></i>\n\n              <!--  END CHECKBOX TICK  -->\n\n              <!--  INDETERMINATE DASH  -->\n\n              <span *ngIf=\"isIndeterminate()\" class=\"indeterminate\"></span>\n\n              <!--  END INDETERMINATE DASH  -->\n\n              <span class=\"text\">\n\n                  <!--  TEXT PARTS LOOP  -->\n\n                  <ng-template ngFor let-textPart [ngForOf]=\"textParts\">\n\n                      <!--  CTA  -->\n\n                      <a *ngIf=\"isCta(textPart)\" class=\"pri-hl-col\" (click)=\"onCtaClick($event, textPart)\">{{ getCtaText(textPart) }}</a>\n\n                      <!--  END CTA  -->\n\n                      <!--  PLAIN TEXT  -->\n\n                      <span *ngIf=\"!isCta(textPart)\">{{ textPart }}</span>\n\n                      <!--  END PLAIN TEXT  -->\n\n                  </ng-template>\n\n                  <!--  END TEXT PARTS LOOP  -->\n\n              </span>\n\n          </label>\n\n          <!-- END CHECKBOX LABEL  -->\n\n      </div>\n\n      <!--  END CHECKBOX CONTROL  -->\n    ",
                    styles: ["\n      :host>div input[type=checkbox]{display:none}:host>div input[type=checkbox]~label{color:#4e4e4e;position:relative;padding-left:20px;font-size:0;margin:6px 0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;display:inline-block;min-height:20px}:host>div input[type=checkbox]~label .text{padding-left:12px;display:inline-block;font-size:13px;line-height:1.5em;-webkit-transition:all .1s ease-in-out 0s;-o-transition:all .1s ease-in-out 0s;transition:all .1s ease-in-out 0s}:host>div input[type=checkbox]~label .checkbox-container{content:'';width:20px;height:20px;background:#FFF;border:1px solid #d3d3d3;border-radius:3px;position:absolute;left:0;z-index:0;-webkit-transition:all .1s ease-in-out 0s;-o-transition:all .1s ease-in-out 0s;transition:all .1s ease-in-out 0s}:host>div input[type=checkbox]~label .fa-check{left:0;top:0;width:20px;height:20px;line-height:20px;text-align:center;position:absolute;z-index:1;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);color:#FFF;-webkit-transition:all .1s ease-in-out 0s;-o-transition:all .1s ease-in-out 0s;transition:all .1s ease-in-out 0s;font-size:13px}:host>div input[type=checkbox]~label .indeterminate{left:4.8px;top:10px;width:10.4px;height:2px;margin-top:-1px;position:absolute;z-index:1;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);background:#d3d3d3;-webkit-transition:all .1s ease-in-out 0s;-o-transition:all .1s ease-in-out 0s;transition:all .1s ease-in-out 0s}:host>div input[type=checkbox]:checked~label .checkbox-container{background:#222;border-color:#222}:host>div input[type=checkbox]:checked~label .fa-check{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1)}:host>div input[type=checkbox]:checked~label .indeterminate{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0)}\n    "]
                },] },
    ];
    UICheckboxControlComponent.propDecorators = {
        form: [{ type: Input }],
        id: [{ type: Input }],
        name: [{ type: Input }],
        text: [{ type: Input }],
        isInvalid: [{ type: Input }],
        invalidReasons: [{ type: Input }],
        onEvent: [{ type: Output }]
    };
    return UICheckboxControlComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIInputControlComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Renderer2} renderer
     * @param {UIFormsService} uiFormsService
     */
    function UIInputControlComponent(renderer, uiFormsService) {
        this.renderer = renderer;
        this.uiFormsService = uiFormsService;
        this.onEvent = new EventEmitter();
        this.isInFocus = false;
    }
    /**
     * Lifecycle hook: Sets affixes.
     */
    /**
     * Lifecycle hook: Sets affixes.
     * @return {?}
     */
    UIInputControlComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Sets affixes.
     * @return {?}
     */
    function () {
        this.controlPrefixes = this.uiFormsService.getAffixes(this.prefixes);
        this.controlSuffixes = this.uiFormsService.getAffixes(this.suffixes);
        this.hasPasswordStrength = this.inputType === 'password' && this.showPasswordStrength;
        this.passwordStrength = this.getPasswordStrength();
    };
    /**
     * Lifecycle hook: Focuses on element if set as default focus.
     */
    /**
     * Lifecycle hook: Focuses on element if set as default focus.
     * @return {?}
     */
    UIInputControlComponent.prototype.ngAfterViewInit = /**
     * Lifecycle hook: Focuses on element if set as default focus.
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.isDefaultFocus) {
            setTimeout(function () {
                _this.renderer.selectRootElement('#' + _this.id).focus();
            });
        }
    };
    /**
     * Handles key press event.
     *
     * @param event
     */
    /**
     * Handles key press event.
     *
     * @param {?} event
     * @return {?}
     */
    UIInputControlComponent.prototype.onKeyUp = /**
     * Handles key press event.
     *
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.key !== 'Enter') {
            /** @type {?} */
            var value = event.target['value'];
            /** @type {?} */
            var formEvent = {
                control: [this.name],
                type: 'keyUp',
                value: value
            };
            this.onEvent.emit(formEvent);
            this.passwordStrength = this.getPasswordStrength(value);
        }
    };
    /**
     * Handles input change.
     *
     * @param event
     */
    /**
     * Handles input change.
     *
     * @param {?} event
     * @return {?}
     */
    UIInputControlComponent.prototype.onChange = /**
     * Handles input change.
     *
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var value = event.target['value'];
        /** @type {?} */
        var formEvent = {
            control: [this.name],
            type: 'change',
            value: value
        };
        this.onEvent.emit(formEvent);
        this.passwordStrength = this.getPasswordStrength(value);
    };
    /**
     * Gets password strength if enabled.
     *
     * @param password
     */
    /**
     * Gets password strength if enabled.
     *
     * @param {?=} password
     * @return {?}
     */
    UIInputControlComponent.prototype.getPasswordStrength = /**
     * Gets password strength if enabled.
     *
     * @param {?=} password
     * @return {?}
     */
    function (password) {
        if (password === void 0) { password = ''; }
        if (!this.hasPasswordStrength) {
            return null;
        }
        /** @type {?} */
        var rules = 'A good password should be at least 8 characters long and contain at least one uppercase letter, one lowercase letter and one number.';
        /** @type {?} */
        var score = 0;
        if (password.length >= 8) {
            score += 1;
        }
        if (new RegExp('[A-Z]').test(password)) {
            score += 1;
        }
        if (new RegExp('[a-z]').test(password)) {
            score += 1;
        }
        if (new RegExp('[0-9]').test(password)) {
            score += 1;
        }
        if (score < 3) {
            return {
                containerClass: 'neg-bg neg-bd',
                iconClass: 'fas fa-frown neg-fg-col',
                tooltipText: 'Poor password! ' + rules
            };
        }
        if (score < 4) {
            return {
                containerClass: 'warn-bg warn-bd',
                iconClass: 'fas fa-meh warn-fg-col',
                tooltipText: 'OK password! ' + rules
            };
        }
        return {
            containerClass: 'pos-bg pos-bd',
            iconClass: 'fas fa-grin pos-fg-col',
            tooltipText: 'Good job! Your password is strong!'
        };
    };
    UIInputControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-input-control',
                    template: "\n      <!--  INPUT CONTROL  -->\n\n      <div class=\"input-group control\"\n           [class.has-validators]=\"hasValidators\"\n           [class.has-password-strength]=\"passwordStrength\"\n           [class.is-invalid]=\"isInvalid\"\n           [class.focus]=\"isInFocus\"\n           [class.has-suffixes]=\"controlSuffixes.length > 0\"\n           [formGroup]=\"form\">\n\n          <!--  PREFIXES  -->\n\n          <ng-template ngFor let-prefix [ngForOf]=\"controlPrefixes\">\n\n              <span class=\"prefix\" [ngClass]=\"{'is-link pri-bg pri-fg-col pri-mix-hov-bg pri-bd pri-mix-hov-bd' : prefix.event}\">\n                  <i *ngIf=\"prefix.icon\" [ngClass]=\"prefix.icon\"></i>\n                  {{ prefix.text }}\n              </span>\n\n          </ng-template>\n\n\n          <!--  END PREFIXES  -->\n\n          <!--  CONTROL  -->\n\n          <div>\n              <input [id]=\"id\"\n                     [type]=\"inputType\"\n                     [formControlName]=\"name\"\n                     [attr.placeholder]=\"placeholder ? placeholder : null\"\n                     (change)=\"onChange($event)\"\n                     (keyup)=\"onKeyUp($event)\"\n                     (focus)=\"isInFocus = true\"\n                     (blur)=\"isInFocus = false\"/>\n          </div>\n\n          <!--  END CONTROL  -->\n\n          <!--  SUFFIXES  -->\n\n          <ng-template ngFor let-suffix [ngForOf]=\"controlSuffixes\" let-i=\"index\">\n\n              <span class=\"suffix\" [class.last-child]=\"i === controlSuffixes.length - 1\" [ngClass]=\"{'is-link pri-bg pri-fg-col pri-mix-hov-bg pri-bd pri-mix-hov-bd' : suffix.event}\">\n                  <i *ngIf=\"suffix.icon\" [ngClass]=\"suffix.icon\"></i>\n                  {{ suffix.text }}\n              </span>\n\n          </ng-template>\n\n          <!-- END SUFFIXES  -->\n\n          <!--  PASSWORD STRENGTH  -->\n\n          <span *ngIf=\"passwordStrength\"\n                class=\"password-strength\"\n                [ngClass]=\"passwordStrength.containerClass\"\n                [uiTooltipText]=\"passwordStrength.tooltipText\">\n              <i [ngClass]=\"passwordStrength.iconClass\"></i>\n          </span>\n\n          <!--  END PASSWORD STRENGTH  -->\n\n          <!-- VALIDATION INDICATOR  -->\n\n          <span *ngIf=\"hasValidators\" class=\"invalid-indicator neg-bg neg-mix-hov-bg\" [uiTooltipText]=\"invalidReasons.length > 0 ? invalidReasons : 'Invalid Value'\">\n      \t\t<i class=\"fas fa-exclamation-circle neg-fg-col\"></i>\n      \t</span>\n\n          <!--  END VALIDATION INDICATOR  -->\n\n      </div>\n\n      <!--  END INPUT CONTROL  -->\n    ",
                    styles: ["\n      .mx-border-left{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}.mx-border-right{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}.mx-no-border-right{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host{width:100%;display:block}:host div.input-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;border-radius:3px;position:relative}:host div.input-group>div>input,:host div.input-group>div>select,:host div.input-group>div>textarea,:host div.input-group>span{border:1px solid #d3d3d3;border-right:none;display:inline-block;line-height:30px;padding:0 8px;font-size:13px}:host div.input-group>div{-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}:host div.input-group>div>input,:host div.input-group>div>select,:host div.input-group>div>textarea{font-family:Roboto,Trebuchet,Arial,sans-serif;color:#4e4e4e;background:#FFF;width:100%;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;height:32px}:host div.input-group>div>input::-webkit-input-placeholder,:host div.input-group>div>select::-webkit-input-placeholder,:host div.input-group>div>textarea::-webkit-input-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div>input::-moz-placeholder,:host div.input-group>div>select::-moz-placeholder,:host div.input-group>div>textarea::-moz-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div>input:-ms-input-placeholder,:host div.input-group>div>select:-ms-input-placeholder,:host div.input-group>div>textarea:-ms-input-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div:first-child>input,:host div.input-group>div:first-child>select,:host div.input-group>div:first-child>textarea{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}:host div.input-group>div:last-child>input,:host div.input-group>div:last-child>select,:host div.input-group>div:last-child>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group>span{background:#f8f8f8;-ms-flex-negative:1;flex-shrink:1;font-size:12px;text-align:center;font-weight:500;white-space:nowrap;color:#4e4e4e;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s}:host div.input-group>span:first-child{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}:host div.input-group>span:last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group::before{content:'';position:absolute;pointer-events:none;display:block;border:1px solid #919191;border-radius:3px;top:0;left:0;bottom:0;right:0;opacity:0;-webkit-transition:opacity .2s linear 0s;-o-transition:opacity .2s linear 0s;transition:opacity .2s linear 0s;z-index:1}:host div.input-group.has-password-strength>span.suffix.last-child,:host div.input-group.has-validators>span.suffix.last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength>span.invalid-indicator,:host div.input-group.has-password-strength>span.password-strength,:host div.input-group.has-validators>span.invalid-indicator,:host div.input-group.has-validators>span.password-strength{background:#222;color:#FFF;border-radius:0 3px 3px 0;overflow:hidden;padding:0;-webkit-transition:all .1s ease-in-out 0s;-o-transition:all .1s ease-in-out 0s;transition:all .1s ease-in-out 0s;-ms-flex-negative:0;flex-shrink:0;font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;opacity:0;width:0;border:none}:host div.input-group.has-password-strength>span.password-strength,:host div.input-group.has-validators>span.password-strength{opacity:1;width:32px}:host div.input-group.has-validators:not(.has-suffixes)>div>input,:host div.input-group.has-validators:not(.has-suffixes)>div>select,:host div.input-group.has-validators:not(.has-suffixes)>div>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>input,:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>select,:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>textarea{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-validators.is-invalid>span:nth-last-child(2){border-radius:0;border-right-width:0}:host div.input-group.has-validators.is-invalid>span.invalid-indicator{width:32px;opacity:1}:host div.input-group.has-validators.is-invalid>span.password-strength{width:0;opacity:0}:host div.input-group.has-password-strength:not(.has-suffixes)>div>input,:host div.input-group.has-password-strength:not(.has-suffixes)>div>select,:host div.input-group.has-password-strength:not(.has-suffixes)>div>textarea{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-password-strength.has-suffixes>span.suffix.last-child{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>input,:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>select,:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength.ng-untouched.ng-pristine.has-suffixes>span.suffix.last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength.ng-untouched.ng-pristine>span.password-strength{width:0;border-left-width:0;opacity:0}:host div.input-group.focus::before{opacity:1}:host div.input-group.focus.has-validators.is-invalid::before{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;right:32px}:host div.input-group.focus.has-password-strength:not(.ng-pristine)::before{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;right:32px}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIInputControlComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: UIFormsService }
    ]; };
    UIInputControlComponent.propDecorators = {
        form: [{ type: Input }],
        id: [{ type: Input }],
        name: [{ type: Input }],
        inputType: [{ type: Input }],
        placeholder: [{ type: Input }],
        prefixes: [{ type: Input }],
        suffixes: [{ type: Input }],
        hasValidators: [{ type: Input }],
        isInvalid: [{ type: Input }],
        invalidReasons: [{ type: Input }],
        showPasswordStrength: [{ type: Input }],
        isDefaultFocus: [{ type: Input }],
        onEvent: [{ type: Output }],
        inputControl: [{ type: ViewChild, args: ['inputControl',] }]
    };
    return UIInputControlComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UITextareaControlComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Renderer2} renderer
     * @param {UIFormsService} uiFormsService
     */
    function UITextareaControlComponent(renderer, uiFormsService) {
        this.renderer = renderer;
        this.uiFormsService = uiFormsService;
        this.onEvent = new EventEmitter();
        this.isInFocus = false;
    }
    /**
     * Lifecycle hook: Sets affixes.
     */
    /**
     * Lifecycle hook: Sets affixes.
     * @return {?}
     */
    UITextareaControlComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Sets affixes.
     * @return {?}
     */
    function () {
        this.controlPrefixes = this.uiFormsService.getAffixes(this.prefixes);
        this.controlSuffixes = this.uiFormsService.getAffixes(this.suffixes);
    };
    /**
     * Lifecycle hook: Focuses on element if set as default focus.
     */
    /**
     * Lifecycle hook: Focuses on element if set as default focus.
     * @return {?}
     */
    UITextareaControlComponent.prototype.ngAfterViewInit = /**
     * Lifecycle hook: Focuses on element if set as default focus.
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.isDefaultFocus) {
            setTimeout(function () {
                _this.renderer.selectRootElement('#' + _this.id).focus();
            });
        }
    };
    /**
     * Handles change event.
     */
    /**
     * Handles change event.
     * @param {?} event
     * @return {?}
     */
    UITextareaControlComponent.prototype.onChange = /**
     * Handles change event.
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var formEvent = {
            control: [this.name],
            type: 'change',
            value: event.target.value
        };
        this.onEvent.emit(formEvent);
    };
    UITextareaControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-textarea-control',
                    template: "\n      <!--  INPUT CONTROL  -->\n\n      <div class=\"input-group control\"\n           [class.has-validators]=\"hasValidators\"\n           [class.is-invalid]=\"isInvalid\"\n           [class.focus]=\"isInFocus\"\n           [class.has-suffixes]=\"controlSuffixes.length > 0\"\n           [formGroup]=\"form\">\n\n          <!--  PREFIXES  -->\n\n          <ng-template ngFor let-prefix [ngForOf]=\"controlPrefixes\">\n\n              <span class=\"prefix\" [ngClass]=\"{'is-link acc-bg acc-fg-col acc-mix-hov-bg acc-bd acc-mix-hov-bd' : prefix.event}\">\n                  <i *ngIf=\"prefix.icon\" [ngClass]=\"prefix.icon\"></i>\n                  {{ prefix.text }}\n              </span>\n\n          </ng-template>\n\n\n          <!--  END PREFIXES  -->\n\n          <!--  CONTROL  -->\n\n          <div>\n              <textarea [id]=\"id\" [formControlName]=\"name\" [attr.placeholder]=\"placeholder ? placeholder : null\" [rows]=\"rows\" (change)=\"onChange($event)\" (focus)=\"isInFocus = true\" (blur)=\"isInFocus = false\"></textarea>\n          </div>\n\n          <!--  END CONTROL  -->\n\n          <!--  SUFFIXES  -->\n\n          <ng-template ngFor let-suffix [ngForOf]=\"controlSuffixes\" let-i=\"index\">\n\n              <span class=\"suffix\" [class.last-child]=\"i === controlSuffixes.length - 1\" [ngClass]=\"{'is-link acc-bg acc-fg-col acc-mix-hov-bg acc-bd acc-mix-hov-bd' : suffix.event}\">\n                  <i *ngIf=\"suffix.icon\" [ngClass]=\"suffix.icon\"></i>\n                  {{ suffix.text }}\n              </span>\n\n          </ng-template>\n\n          <!-- END SUFFIXES  -->\n\n          <!-- VALIDATION INDICATOR  -->\n\n          <span *ngIf=\"hasValidators\" class=\"invalid-indicator neg-bg neg-mix-hov-bg\" [uiTooltipText]=\"invalidReasons\">\n      \t\t<i class=\"fas fa-exclamation-circle neg-fg-col\"></i>\n      \t</span>\n\n          <!--  END VALIDATION INDICATOR  -->\n\n      </div>\n\n      <!--  END INPUT CONTROL  -->\n    ",
                    styles: ["\n      .mx-border-left{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}.mx-border-right{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}.mx-no-border-right{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host{width:100%;display:block}:host div.input-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;border-radius:3px;position:relative}:host div.input-group>div>input,:host div.input-group>div>select,:host div.input-group>div>textarea,:host div.input-group>span{border:1px solid #d3d3d3;border-right:none;display:inline-block;line-height:30px;padding:0 8px;font-size:13px}:host div.input-group>div{-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}:host div.input-group>div>input,:host div.input-group>div>select,:host div.input-group>div>textarea{font-family:Roboto,Trebuchet,Arial,sans-serif;color:#4e4e4e;background:#FFF;width:100%;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;height:32px}:host div.input-group>div>input::-webkit-input-placeholder,:host div.input-group>div>select::-webkit-input-placeholder,:host div.input-group>div>textarea::-webkit-input-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div>input::-moz-placeholder,:host div.input-group>div>select::-moz-placeholder,:host div.input-group>div>textarea::-moz-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div>input:-ms-input-placeholder,:host div.input-group>div>select:-ms-input-placeholder,:host div.input-group>div>textarea:-ms-input-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div:first-child>input,:host div.input-group>div:first-child>select,:host div.input-group>div:first-child>textarea{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}:host div.input-group>div:last-child>input,:host div.input-group>div:last-child>select,:host div.input-group>div:last-child>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group>span{background:#f8f8f8;-ms-flex-negative:1;flex-shrink:1;font-size:12px;text-align:center;font-weight:500;white-space:nowrap;color:#4e4e4e;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s}:host div.input-group>span:first-child{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}:host div.input-group>span:last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group::before{content:'';position:absolute;pointer-events:none;display:block;border:1px solid #919191;border-radius:3px;top:0;left:0;bottom:0;right:0;opacity:0;-webkit-transition:opacity .2s linear 0s;-o-transition:opacity .2s linear 0s;transition:opacity .2s linear 0s;z-index:1}:host div.input-group.has-password-strength>span.suffix.last-child,:host div.input-group.has-validators>span.suffix.last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength>span.invalid-indicator,:host div.input-group.has-password-strength>span.password-strength,:host div.input-group.has-validators>span.invalid-indicator,:host div.input-group.has-validators>span.password-strength{background:#222;color:#FFF;border-radius:0 3px 3px 0;overflow:hidden;padding:0;-webkit-transition:all .1s ease-in-out 0s;-o-transition:all .1s ease-in-out 0s;transition:all .1s ease-in-out 0s;-ms-flex-negative:0;flex-shrink:0;font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;opacity:0;width:0;border:none}:host div.input-group.has-password-strength>span.password-strength,:host div.input-group.has-validators>span.password-strength{opacity:1;width:32px}:host div.input-group.has-validators:not(.has-suffixes)>div>input,:host div.input-group.has-validators:not(.has-suffixes)>div>select,:host div.input-group.has-validators:not(.has-suffixes)>div>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>input,:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>select,:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>textarea{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-validators.is-invalid>span:nth-last-child(2){border-radius:0;border-right-width:0}:host div.input-group.has-validators.is-invalid>span.invalid-indicator{width:32px;opacity:1}:host div.input-group.has-validators.is-invalid>span.password-strength{width:0;opacity:0}:host div.input-group.has-password-strength:not(.has-suffixes)>div>input,:host div.input-group.has-password-strength:not(.has-suffixes)>div>select,:host div.input-group.has-password-strength:not(.has-suffixes)>div>textarea{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-password-strength.has-suffixes>span.suffix.last-child{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>input,:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>select,:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength.ng-untouched.ng-pristine.has-suffixes>span.suffix.last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength.ng-untouched.ng-pristine>span.password-strength{width:0;border-left-width:0;opacity:0}:host div.input-group.focus::before{opacity:1}:host div.input-group.focus.has-validators.is-invalid::before{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;right:32px}:host div.input-group.focus.has-password-strength:not(.ng-pristine)::before{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;right:32px}:host>div.input-group>div>textarea{padding-top:5px;line-height:1.5em;height:auto;display:block;resize:vertical}\n    "]
                },] },
    ];
    /** @nocollapse */
    UITextareaControlComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: UIFormsService }
    ]; };
    UITextareaControlComponent.propDecorators = {
        form: [{ type: Input }],
        id: [{ type: Input }],
        name: [{ type: Input }],
        placeholder: [{ type: Input }],
        prefixes: [{ type: Input }],
        suffixes: [{ type: Input }],
        hasValidators: [{ type: Input }],
        isInvalid: [{ type: Input }],
        invalidReasons: [{ type: Input }],
        rows: [{ type: Input }],
        isDefaultFocus: [{ type: Input }],
        onEvent: [{ type: Output }]
    };
    return UITextareaControlComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISelectControlComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIFormsService} uiFormsService
     */
    function UISelectControlComponent(uiFormsService) {
        this.uiFormsService = uiFormsService;
        this.onEvent = new EventEmitter();
        this.isInFocus = false;
    }
    /**
     * Lifecycle hook: Sets affixes.
     */
    /**
     * Lifecycle hook: Sets affixes.
     * @return {?}
     */
    UISelectControlComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Sets affixes.
     * @return {?}
     */
    function () {
        this.controlPrefixes = this.uiFormsService.getAffixes(this.prefixes);
        this.controlSuffixes = this.uiFormsService.getAffixes(this.suffixes);
    };
    /**
     * Handles change event.
     */
    /**
     * Handles change event.
     * @param {?} event
     * @return {?}
     */
    UISelectControlComponent.prototype.onChange = /**
     * Handles change event.
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var formEvent = {
            control: [this.name],
            type: 'change',
            value: event.target.value
        };
        this.onEvent.emit(formEvent);
    };
    UISelectControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-select-control',
                    template: "\n      <!--  SELECT CONTROL  -->\n\n      <div class=\"input-group control\"\n           [class.has-validators]=\"hasValidators\"\n           [class.is-invalid]=\"isInvalid\"\n           [class.focus]=\"isInFocus\"\n           [class.has-suffixes]=\"controlSuffixes.length > 0\"\n           [formGroup]=\"form\">\n\n          <!--  PREFIXES  -->\n\n          <ng-template ngFor let-prefix let-i=\"index\" [ngForOf]=\"controlPrefixes\">\n\n              <span class=\"prefix\" [ngClass]=\"{'is-link pri-bg pri-fg-col pri-mix-hov-bg pri-bd pri-mix-hov-bd' : prefix.event}\">\n                  <i *ngIf=\"prefix.icon\" [ngClass]=\"prefix.icon\"></i>\n                  {{ prefix.text }}\n              </span>\n\n          </ng-template>\n\n          <!--  END PREFIXES  -->\n\n          <!--  CONTROL  -->\n\n          <div>\n              <select class=\"control\" [id]=\"id\" [formControlName]=\"name\" (change)=\"onChange($event)\" (focus)=\"isInFocus = true\" (blur)=\"isInFocus = false\">\n                  <option *ngFor=\"let option of options\" [value]=\"option.value\">{{option.name}}</option>\n              </select>\n              <i class=\"fas fa-chevron-down acc-hl-bef-col\"></i>\n          </div>\n\n          <!--  END CONTROL   -->\n\n          <!--  SUFFIXES  -->\n\n          <ng-template ngFor let-suffix let-i=\"index\" [ngForOf]=\"controlSuffixes\">\n\n              <span class=\"suffix\" [class.last-child]=\"i === controlSuffixes.length - 1\" [ngClass]=\"{'is-link pri-bg pri-fg-col pri-mix-hov-bg pri-bd pri-mix-hov-bd' : suffix.event}\">\n                  <i *ngIf=\"suffix.icon\" [ngClass]=\"suffix.icon\"></i>\n                  {{ suffix.text }}\n              </span>\n\n          </ng-template>\n\n          <!-- END SUFFIXES  -->\n\n          <!--  VALIDATION INDICATOR  -->\n\n          <span *ngIf=\"hasValidators\" class=\"invalid-indicator neg-bg neg-mix-hov-bg\" [uiTooltipText]=\"invalidReasons\">\n      \t\t<i class=\"fas fa-exclamation-circle\"></i>\n      \t</span>\n\n          <!--  END VALIDATION INDICATOR  -->\n\n      </div>\n\n      <!-- END SELECT CONTROL  -->\n    ",
                    styles: ["\n      .mx-border-left{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}.mx-border-right{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}.mx-no-border-right{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host{width:100%;display:block}:host div.input-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;border-radius:3px;position:relative}:host div.input-group>div>input,:host div.input-group>div>select,:host div.input-group>div>textarea,:host div.input-group>span{border:1px solid #d3d3d3;border-right:none;display:inline-block;line-height:30px;padding:0 8px;font-size:13px}:host div.input-group>div{-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}:host div.input-group>div>input,:host div.input-group>div>select,:host div.input-group>div>textarea{font-family:Roboto,Trebuchet,Arial,sans-serif;color:#4e4e4e;background:#FFF;width:100%;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;height:32px}:host div.input-group>div>input::-webkit-input-placeholder,:host div.input-group>div>select::-webkit-input-placeholder,:host div.input-group>div>textarea::-webkit-input-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div>input::-moz-placeholder,:host div.input-group>div>select::-moz-placeholder,:host div.input-group>div>textarea::-moz-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div>input:-ms-input-placeholder,:host div.input-group>div>select:-ms-input-placeholder,:host div.input-group>div>textarea:-ms-input-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div:first-child>input,:host div.input-group>div:first-child>select,:host div.input-group>div:first-child>textarea{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}:host div.input-group>div:last-child>input,:host div.input-group>div:last-child>select,:host div.input-group>div:last-child>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group>span{background:#f8f8f8;-ms-flex-negative:1;flex-shrink:1;font-size:12px;text-align:center;font-weight:500;white-space:nowrap;color:#4e4e4e;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s}:host div.input-group>span:first-child{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}:host div.input-group>span:last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group::before{content:'';position:absolute;pointer-events:none;display:block;border:1px solid #919191;border-radius:3px;top:0;left:0;bottom:0;right:0;opacity:0;-webkit-transition:opacity .2s linear 0s;-o-transition:opacity .2s linear 0s;transition:opacity .2s linear 0s;z-index:1}:host div.input-group.has-password-strength>span.suffix.last-child,:host div.input-group.has-validators>span.suffix.last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength>span.invalid-indicator,:host div.input-group.has-password-strength>span.password-strength,:host div.input-group.has-validators>span.invalid-indicator,:host div.input-group.has-validators>span.password-strength{background:#222;color:#FFF;border-radius:0 3px 3px 0;overflow:hidden;padding:0;-webkit-transition:all .1s ease-in-out 0s;-o-transition:all .1s ease-in-out 0s;transition:all .1s ease-in-out 0s;-ms-flex-negative:0;flex-shrink:0;font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;opacity:0;width:0;border:none}:host div.input-group.has-password-strength>span.password-strength,:host div.input-group.has-validators>span.password-strength{opacity:1;width:32px}:host div.input-group.has-validators:not(.has-suffixes)>div>input,:host div.input-group.has-validators:not(.has-suffixes)>div>select,:host div.input-group.has-validators:not(.has-suffixes)>div>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>input,:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>select,:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>textarea{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-validators.is-invalid>span:nth-last-child(2){border-radius:0;border-right-width:0}:host div.input-group.has-validators.is-invalid>span.invalid-indicator{width:32px;opacity:1}:host div.input-group.has-validators.is-invalid>span.password-strength{width:0;opacity:0}:host div.input-group.has-password-strength:not(.has-suffixes)>div>input,:host div.input-group.has-password-strength:not(.has-suffixes)>div>select,:host div.input-group.has-password-strength:not(.has-suffixes)>div>textarea{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-password-strength.has-suffixes>span.suffix.last-child{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>input,:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>select,:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength.ng-untouched.ng-pristine.has-suffixes>span.suffix.last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength.ng-untouched.ng-pristine>span.password-strength{width:0;border-left-width:0;opacity:0}:host div.input-group.focus::before{opacity:1}:host div.input-group.focus.has-validators.is-invalid::before{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;right:32px}:host div.input-group.focus.has-password-strength:not(.ng-pristine)::before{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;right:32px}:host>div.input-group>div{position:relative}:host>div.input-group>div>.fa-chevron-down{height:12px;width:12px;font-size:12px;line-height:12px;position:absolute;right:10px;top:10px;pointer-events:none}:host>div.input-group>div>select{padding-right:32px;-webkit-appearance:none;-moz-appearance:none}:host>div.input-group>div>select::-ms-expand{display:none}\n    "]
                },] },
    ];
    /** @nocollapse */
    UISelectControlComponent.ctorParameters = function () { return [
        { type: UIFormsService }
    ]; };
    UISelectControlComponent.propDecorators = {
        form: [{ type: Input }],
        id: [{ type: Input }],
        name: [{ type: Input }],
        options: [{ type: Input }],
        prefixes: [{ type: Input }],
        suffixes: [{ type: Input }],
        hasValidators: [{ type: Input }],
        isInvalid: [{ type: Input }],
        invalidReasons: [{ type: Input }],
        onEvent: [{ type: Output }]
    };
    return UISelectControlComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISliderControlComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Renderer2} renderer
     * @param {UIFormsService} uiFormsService
     */
    function UISliderControlComponent(renderer, uiFormsService) {
        this.renderer = renderer;
        this.uiFormsService = uiFormsService;
        this.isInFocus = false;
    }
    /**
     * Assigns this.formControl for easy access and triggers
     * initial sync between slider and input.
     * Sets affixes.
     */
    /**
     * Assigns this.formControl for easy access and triggers
     * initial sync between slider and input.
     * Sets affixes.
     * @return {?}
     */
    UISliderControlComponent.prototype.ngOnInit = /**
     * Assigns this.formControl for easy access and triggers
     * initial sync between slider and input.
     * Sets affixes.
     * @return {?}
     */
    function () {
        this.controlPrefixes = this.uiFormsService.getAffixes(this.prefixes);
        this.controlSuffixes = this.uiFormsService.getAffixes(this.suffixes);
        this.formControl = this.form.controls[this.name];
        this.onTextInput();
    };
    /**
     * Lifecycle hook: Focuses on element if set as default focus.
     */
    /**
     * Lifecycle hook: Focuses on element if set as default focus.
     * @return {?}
     */
    UISliderControlComponent.prototype.ngAfterViewInit = /**
     * Lifecycle hook: Focuses on element if set as default focus.
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.isDefaultFocus && this.textInput) {
            setTimeout(function () {
                _this.renderer.selectRootElement('#' + _this.id).focus();
            });
        }
    };
    /**
     * Synchronises input control value with slider value
     *
     * @param {MatSliderChange} matSliderChange
     */
    /**
     * Synchronises input control value with slider value
     *
     * @param {?} matSliderChange
     * @return {?}
     */
    UISliderControlComponent.prototype.onSliderInput = /**
     * Synchronises input control value with slider value
     *
     * @param {?} matSliderChange
     * @return {?}
     */
    function (matSliderChange) {
        this.formControl.setValue(matSliderChange.value);
    };
    /**
     * Synchronises slider value with input control value
     */
    /**
     * Synchronises slider value with input control value
     * @return {?}
     */
    UISliderControlComponent.prototype.onTextInput = /**
     * Synchronises slider value with input control value
     * @return {?}
     */
    function () {
        this.sliderValue = this.formControl.value;
    };
    UISliderControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-slider-control',
                    template: "\n      <div class=\"row\">\n\n          <!--  SLIDER CONTROL  -->\n\n          <div class=\"slider-container col-sm1-30\" [ngClass]=\"{'col-sm3-16 has-text-input' : textInput}\">\n\n              <!--  MATERIAL SLIDER CONTROL  -->\n\n              <mat-slider [value]=\"sliderValue\"\n                          [min]=\"min\"\n                          [max]=\"max\"\n                          [step]=\"step\"\n                          [invert]=\"invert\"\n                          [thumbLabel]=\"thumbLabel\"\n                          [tickInterval]=\"tickInterval\"\n                          (input)=\"onSliderInput($event)\">\n              </mat-slider>\n\n              <!-- END MATERIAL SLIDER CONTROL  -->\n\n          </div>\n\n          <!-- END SLIDER CONTROL  -->\n\n          <!-- DIRECT INPUT CONTROL  -->\n\n          <div class=\"slider-input-container col-sm1-30 col-sm3-14\" [class.hidden]=\"!textInput\">\n              <div class=\"input-group control\"\n                   [class.focus]=\"isInFocus\"\n                   [class.has-suffixes]=\"controlSuffixes.length > 0\"\n                   [formGroup]=\"form\">\n\n                  <!--  PREFIXES  -->\n\n                  <ng-template ngFor let-prefix [ngForOf]=\"controlPrefixes\">\n\n                      <span class=\"prefix\" [ngClass]=\"{'is-link pri-bg pri-mix-hov-bg pri-bd pri-mix-hov-bd' : prefix.event}\">\n                          <i *ngIf=\"prefix.icon\" [ngClass]=\"prefix.icon\"></i>\n                          {{ prefix.text }}\n                      </span>\n\n                  </ng-template>\n\n                  <!--  END PREFIXES  -->\n\n                  <!--  INPUT  -->\n\n                  <div>\n                      <input type=\"number\"\n                             [id]=\"id\"\n                             [formControlName]=\"name\"\n                             [min]=\"min\"\n                             [max]=\"max\"\n                             [step]=\"step\"\n                             (input)=\"onTextInput()\"\n                             (focus)=\"isInFocus = true\"\n                             (blur)=\"isInFocus = false\"/>\n                  </div>\n\n                  <!--  END INPUT -->\n\n                  <!--  SUFFIXES  -->\n\n                  <ng-template ngFor let-suffix [ngForOf]=\"controlSuffixes\">\n\n                      <span class=\"suffix\" [class.last-child]=\"i === controlSuffixes.length - 1\" [ngClass]=\"{'is-link pri-bg pri-fg-col pri-mix-hov-bg pri-bd pri-mix-hov-bd' : suffix.event}\">\n                          <i *ngIf=\"suffix.icon\" [ngClass]=\"suffix.icon\"></i>\n                          {{ suffix.text }}\n                      </span>\n\n                  </ng-template>\n\n                  <!-- END SUFFIXES  -->\n\n              </div>\n          </div>\n\n          <!-- END DIRECT INPUT CONTROL  -->\n\n      </div>\n    ",
                    styles: ["\n      .mx-border-left{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}.mx-border-right{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}.mx-no-border-right{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host{width:100%;display:block}:host div.input-group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;border-radius:3px;position:relative}:host div.input-group>div>input,:host div.input-group>div>select,:host div.input-group>div>textarea,:host div.input-group>span{border:1px solid #d3d3d3;border-right:none;display:inline-block;line-height:30px;padding:0 8px;font-size:13px}:host div.input-group>div{-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}:host div.input-group>div>input,:host div.input-group>div>select,:host div.input-group>div>textarea{font-family:Roboto,Trebuchet,Arial,sans-serif;color:#4e4e4e;background:#FFF;width:100%;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;height:32px}:host div.input-group>div>input::-webkit-input-placeholder,:host div.input-group>div>select::-webkit-input-placeholder,:host div.input-group>div>textarea::-webkit-input-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div>input::-moz-placeholder,:host div.input-group>div>select::-moz-placeholder,:host div.input-group>div>textarea::-moz-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div>input:-ms-input-placeholder,:host div.input-group>div>select:-ms-input-placeholder,:host div.input-group>div>textarea:-ms-input-placeholder{color:#a7a7a7;text-transform:none}:host div.input-group>div:first-child>input,:host div.input-group>div:first-child>select,:host div.input-group>div:first-child>textarea{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}:host div.input-group>div:last-child>input,:host div.input-group>div:last-child>select,:host div.input-group>div:last-child>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group>span{background:#f8f8f8;-ms-flex-negative:1;flex-shrink:1;font-size:12px;text-align:center;font-weight:500;white-space:nowrap;color:#4e4e4e;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s}:host div.input-group>span:first-child{border-left:1px solid #d3d3d3;border-top-left-radius:3px;border-bottom-left-radius:3px}:host div.input-group>span:last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group::before{content:'';position:absolute;pointer-events:none;display:block;border:1px solid #919191;border-radius:3px;top:0;left:0;bottom:0;right:0;opacity:0;-webkit-transition:opacity .2s linear 0s;-o-transition:opacity .2s linear 0s;transition:opacity .2s linear 0s;z-index:1}:host div.input-group.has-password-strength>span.suffix.last-child,:host div.input-group.has-validators>span.suffix.last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength>span.invalid-indicator,:host div.input-group.has-password-strength>span.password-strength,:host div.input-group.has-validators>span.invalid-indicator,:host div.input-group.has-validators>span.password-strength{background:#222;color:#FFF;border-radius:0 3px 3px 0;overflow:hidden;padding:0;-webkit-transition:all .1s ease-in-out 0s;-o-transition:all .1s ease-in-out 0s;transition:all .1s ease-in-out 0s;-ms-flex-negative:0;flex-shrink:0;font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;opacity:0;width:0;border:none}:host div.input-group.has-password-strength>span.password-strength,:host div.input-group.has-validators>span.password-strength{opacity:1;width:32px}:host div.input-group.has-validators:not(.has-suffixes)>div>input,:host div.input-group.has-validators:not(.has-suffixes)>div>select,:host div.input-group.has-validators:not(.has-suffixes)>div>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>input,:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>select,:host div.input-group.has-validators.is-invalid:not(.has-suffixes)>div>textarea{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-validators.is-invalid>span:nth-last-child(2){border-radius:0;border-right-width:0}:host div.input-group.has-validators.is-invalid>span.invalid-indicator{width:32px;opacity:1}:host div.input-group.has-validators.is-invalid>span.password-strength{width:0;opacity:0}:host div.input-group.has-password-strength:not(.has-suffixes)>div>input,:host div.input-group.has-password-strength:not(.has-suffixes)>div>select,:host div.input-group.has-password-strength:not(.has-suffixes)>div>textarea{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-password-strength.has-suffixes>span.suffix.last-child{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>input,:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>select,:host div.input-group.has-password-strength.ng-untouched.ng-pristine:not(.has-suffixes)>div>textarea{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength.ng-untouched.ng-pristine.has-suffixes>span.suffix.last-child{border-right:1px solid #d3d3d3;border-top-right-radius:3px;border-bottom-right-radius:3px}:host div.input-group.has-password-strength.ng-untouched.ng-pristine>span.password-strength{width:0;border-left-width:0;opacity:0}:host div.input-group.focus::before{opacity:1}:host div.input-group.focus.has-validators.is-invalid::before{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;right:32px}:host div.input-group.focus.has-password-strength:not(.ng-pristine)::before{border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;right:32px}@import url(https://unpkg.com/@angular/material/prebuilt-themes/indigo-pink.css);:host ::ng-deep{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}:host ::ng-deep .slider-container .mat-slider.mat-slider-horizontal{width:100%;padding:0;height:32px}:host ::ng-deep .slider-container .mat-slider.mat-slider-horizontal .mat-slider-wrapper{left:0;right:0;height:8px;top:12px}:host ::ng-deep .slider-container .mat-slider.mat-slider-horizontal .mat-slider-wrapper .mat-slider-track-wrapper{height:8px;border-radius:4px;overflow:hidden}:host ::ng-deep .slider-container .mat-slider.mat-slider-horizontal .mat-slider-wrapper .mat-slider-track-wrapper .mat-slider-track-background{height:8px;background:#d3d3d3}:host ::ng-deep .slider-container .mat-slider.mat-slider-horizontal .mat-slider-wrapper .mat-slider-track-wrapper .mat-slider-track-fill{background:#222;height:8px}:host ::ng-deep .slider-container .mat-slider.mat-slider-horizontal .mat-slider-wrapper .mat-slider-ticks{display:none}:host ::ng-deep .slider-container .mat-slider.mat-slider-horizontal .mat-slider-wrapper::after{display:none}:host ::ng-deep .slider-container .mat-slider.mat-slider-horizontal .mat-slider-thumb-container .mat-slider-thumb{height:20px;width:20px;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);border:7px solid #222;background:#FFF;bottom:-10px;right:-10px}:host ::ng-deep .slider-container .mat-slider.mat-slider-horizontal .mat-slider-thumb-container .mat-slider-thumb-label{background:#222;color:#FFF;width:36px;height:36px;right:-18px;top:-48px;font-size:13px}:host ::ng-deep .slider-container .mat-slider.mat-slider-horizontal.cdk-focused.mat-slider-thumb-label-showing .mat-slider-thumb{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1)}:host ::ng-deep .slider-container.has-text-input{padding-right:16px}:host ::ng-deep .slider-input-container{padding-left:16px}:host ::ng-deep .slider-input-container .input-group{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}:host ::ng-deep .slider-input-container .input-group>div{-ms-flex-negative:1;flex-shrink:1}@media screen and (max-width:574px){:host .slider-container.has-text-input{padding-right:0;padding-bottom:8px}:host .slider-input-container{padding-left:0}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UISliderControlComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: UIFormsService }
    ]; };
    UISliderControlComponent.propDecorators = {
        form: [{ type: Input }],
        id: [{ type: Input }],
        name: [{ type: Input }],
        min: [{ type: Input }],
        max: [{ type: Input }],
        step: [{ type: Input }],
        invert: [{ type: Input }],
        thumbLabel: [{ type: Input }],
        tickInterval: [{ type: Input }],
        textInput: [{ type: Input }],
        prefixes: [{ type: Input }],
        suffixes: [{ type: Input }],
        isDefaultFocus: [{ type: Input }]
    };
    return UISliderControlComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIMultiControlComponent = /** @class */ (function () {
    function UIMultiControlComponent(uiFormsService) {
        this.uiFormsService = uiFormsService;
        this.onEvent = new EventEmitter();
    }
    /**
     * Checks if form control passes validation, returns pass state.
     *
     * @param {UIFormGroup} uiFormGroup
     * @param {UIFormControl} uiFormControl
     * @returns {boolean}
     */
    /**
     * Checks if form control passes validation, returns pass state.
     *
     * @param {?} uiFormGroup
     * @param {?} uiFormControl
     * @return {?}
     */
    UIMultiControlComponent.prototype.isInvalid = /**
     * Checks if form control passes validation, returns pass state.
     *
     * @param {?} uiFormGroup
     * @param {?} uiFormControl
     * @return {?}
     */
    function (uiFormGroup, uiFormControl) {
        /** @type {?} */
        var formControl = this.form.get(this.uiFormControl.name).get(uiFormControl.name);
        return uiFormControl.validators.length && this.uiFormsService.isInvalid(formControl);
    };
    /**
     * Gets the reasons that a control has not passed validation, returns as array.
     *
     * @param {UIFormGroup} uiFormGroup
     * @param {UIFormControl} uiFormControl
     * @returns {string[]}
     */
    /**
     * Gets the reasons that a control has not passed validation, returns as array.
     *
     * @param {?} uiFormGroup
     * @param {?} uiFormControl
     * @return {?}
     */
    UIMultiControlComponent.prototype.getInvalidReasons = /**
     * Gets the reasons that a control has not passed validation, returns as array.
     *
     * @param {?} uiFormGroup
     * @param {?} uiFormControl
     * @return {?}
     */
    function (uiFormGroup, uiFormControl) {
        /** @type {?} */
        var formControl = this.form.get(this.uiFormControl.name).get(uiFormControl.name);
        return this.uiFormsService.getInvalidReasons(formControl);
    };
    /**
     * Handles output emit of child event.
     *
     * @param {UIFormEvent} event
     */
    /**
     * Handles output emit of child event.
     *
     * @param {?} event
     * @return {?}
     */
    UIMultiControlComponent.prototype.onChildEvent = /**
     * Handles output emit of child event.
     *
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.control.splice(0, 0, this.uiFormControl.name);
        this.onEvent.emit(event);
    };
    UIMultiControlComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-multi-control',
                    template: "\n      <!--  MULTI CONTROL  -->\n\n      <div [formGroup]=\"form\">\n\n          <div class=\"multi-control-container\" [formGroup]=\"form.controls[uiFormControl.name]\" [ngClass]=\"uiFormControl.orientation\">\n\n              <!-- CONTROL LOOP  -->\n\n              <div *ngFor=\"let item of items\" class=\"child-control-container\">\n\n                  <!--  CONTROL SELECTOR  -->\n\n                  <ui-control-selector\n                      [form]=\"form.controls[uiFormControl.name]\"\n                      [uiFormControl]=\"item\"\n                      [isInvalid]=\"isInvalid(form.controls[uiFormControl.name], item)\"\n                      [invalidReasons]=\"getInvalidReasons(form.controls[uiFormControl.name], item)\"\n                      (onEvent)=\"onChildEvent($event)\">\n                  </ui-control-selector>\n\n                  <!--  END CONTROL LOOP  -->\n\n              </div>\n\n              <!--  END CONTROL LOOP  -->\n\n          </div>\n\n      </div>\n\n      <!--  END MULTI CONTROL  -->\n    ",
                    styles: ["\n      :host .multi-control-container.vertical .child-control-container{margin-bottom:8px}:host .multi-control-container.vertical .child-control-container:last-child{margin-bottom:0}:host .multi-control-container.horizontal{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}:host .multi-control-container.horizontal .child-control-container{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin-right:8px}:host .multi-control-container.horizontal .child-control-container:last-child{margin-right:0}@media screen and (max-width:574px){:host .multi-control-container.horizontal{-ms-flex-wrap:wrap;flex-wrap:wrap}:host .multi-control-container.horizontal .child-control-container{width:calc(50% - 8px)}:host .multi-control-container.horizontal .child-control-container:last-child{margin-right:8px}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIMultiControlComponent.ctorParameters = function () { return [
        { type: UIFormsService }
    ]; };
    UIMultiControlComponent.propDecorators = {
        form: [{ type: Input }],
        uiFormControl: [{ type: Input }],
        items: [{ type: Input }],
        onEvent: [{ type: Output }]
    };
    return UIMultiControlComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIFormsModule = /** @class */ (function () {
    function UIFormsModule() {
    }
    UIFormsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIFormComponent,
                        UIControlSelectorComponent,
                        UICheckboxControlComponent,
                        UIInputControlComponent,
                        UITextareaControlComponent,
                        UISelectControlComponent,
                        UISliderControlComponent,
                        UIMultiControlComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        MatSliderModule,
                        UITooltipModule,
                        UILoadingModule
                    ],
                    exports: [
                        ReactiveFormsModule,
                        MatSliderModule,
                        UIFormComponent,
                        UIControlSelectorComponent,
                        UICheckboxControlComponent,
                        UIInputControlComponent,
                        UITextareaControlComponent,
                        UISelectControlComponent,
                        UISliderControlComponent,
                        UIMultiControlComponent
                    ]
                },] },
    ];
    return UIFormsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIFormsService$1 = /** @class */ (function () {
    function UIFormsService() {
    }
    /**
     * Marks all invalid form controls in all nested groups as dirty
     * to trigger validation visibility
     *
     * @param {FormGroup} formGroup
     */
    /**
     * Marks all invalid form controls in all nested groups as dirty
     * to trigger validation visibility
     *
     * @param {?} formGroup
     * @return {?}
     */
    UIFormsService.prototype.forceValidate = /**
     * Marks all invalid form controls in all nested groups as dirty
     * to trigger validation visibility
     *
     * @param {?} formGroup
     * @return {?}
     */
    function (formGroup) {
        var _this = this;
        /** @type {?} */
        var controls = Object.keys(formGroup.controls).map(function (key) {
            return formGroup.controls[key];
        });
        controls.forEach(function (child) {
            if (child instanceof FormGroup) {
                _this.forceValidate(child);
                return;
            }
            if (child instanceof FormControl && child.invalid) {
                child.markAsDirty();
                return;
            }
        });
    };
    /**
     * Checks if the control is (dirty or touched) and invalid. Done to ensure
     * that invalid fields are not displayed on a pristine form
     *
     * @param {AbstractControl} formControl
     * @returns {boolean}
     */
    /**
     * Checks if the control is (dirty or touched) and invalid. Done to ensure
     * that invalid fields are not displayed on a pristine form
     *
     * @param {?} formControl
     * @return {?}
     */
    UIFormsService.prototype.isInvalid = /**
     * Checks if the control is (dirty or touched) and invalid. Done to ensure
     * that invalid fields are not displayed on a pristine form
     *
     * @param {?} formControl
     * @return {?}
     */
    function (formControl) {
        return ((formControl.dirty || formControl.touched) && formControl.invalid);
    };
    /**
     * Returns an array of all reasons why a field is invalid
     *
     * @param {AbstractControl} formControl
     * @returns {string[]}
     */
    /**
     * Returns an array of all reasons why a field is invalid
     *
     * @param {?} formControl
     * @return {?}
     */
    UIFormsService.prototype.getInvalidReasons = /**
     * Returns an array of all reasons why a field is invalid
     *
     * @param {?} formControl
     * @return {?}
     */
    function (formControl) {
        /** @type {?} */
        var reasons = [];
        if (this.isInvalid(formControl)) {
            if (formControl.hasError('required')) {
                reasons.push('Value cannot be empty');
            }
            if (formControl.hasError('requiredtrue')) {
                reasons.push('Value must be true');
            }
            if (formControl.hasError('email')) {
                reasons.push('Value must be a valid email address');
            }
            if (formControl.hasError('pattern')) {
                reasons.push('Value does not match the required format');
            }
            if (formControl.hasError('min')) {
                reasons.push('Value cannot be lower than ' + formControl.errors["min"].min);
            }
            if (formControl.hasError('max')) {
                reasons.push('Value cannot be higher than ' + formControl.errors["max"].max);
            }
            if (formControl.hasError('minlength')) {
                reasons.push('Value cannot be shorter than ' + formControl.errors["minlength"].requiredLength + ' characters');
            }
            if (formControl.hasError('maxlength')) {
                reasons.push('Value cannot be longer than ' + formControl.errors["maxlength"].requiredLength + ' characters');
            }
            if (formControl.hasError('fieldmatch')) {
                reasons.push('Value does not match the ' + formControl.errors["fieldmatch"].fieldFriendlyName + ' field');
            }
            if (formControl.hasError('custom') && formControl.errors["custom"].message) {
                reasons.push(formControl.errors["custom"].message);
            }
        }
        return reasons;
    };
    /**
     * Finds any control inside a UIFormGroup, regardless of level of depth.
     *
     * @param {UIFormGroup[]} uiFormGroups
     * @param {string[]} identifier
     *
     * @returns UIFormControl
     */
    /**
     * Finds any control inside a UIFormGroup, regardless of level of depth.
     *
     *
     * @param {?} uiFormGroups
     * @param {?} identifier
     * @return {?} UIFormControl
     */
    UIFormsService.prototype.findControl = /**
     * Finds any control inside a UIFormGroup, regardless of level of depth.
     *
     *
     * @param {?} uiFormGroups
     * @param {?} identifier
     * @return {?} UIFormControl
     */
    function (uiFormGroups, identifier) {
        return uiFormGroups.find(function (uiFormGroup) {
            return uiFormGroup.name === identifier[0];
        }).controls.find(function (uiFormControl) {
            return uiFormControl.name === identifier[1];
        });
    };
    /**
     * Builds and returns array of UIAffix objects
     *
     * @param {string[]} affixes
     *
     * @returns {UIAffix[]}
     */
    /**
     * Builds and returns array of UIAffix objects
     *
     *
     * @param {?} affixes
     * @return {?}
     */
    UIFormsService.prototype.getAffixes = /**
     * Builds and returns array of UIAffix objects
     *
     *
     * @param {?} affixes
     * @return {?}
     */
    function (affixes) {
        if (!affixes) {
            return [];
        }
        return affixes.map(function (affix) {
            /** @type {?} */
            var parts = affix.split('|');
            if (parts[0] === '*') {
                if (parts[1].startsWith('i.')) {
                    return {
                        icon: parts[1].replace('i.', ''),
                        event: parts[2]
                    };
                }
                return {
                    text: parts[1],
                    event: parts[2]
                };
            }
            if (parts[0].startsWith('i.')) {
                return {
                    icon: parts[0].replace('i.', '')
                };
            }
            return {
                text: parts[0]
            };
        });
    };
    /**
     * Invalidates a control with an optional message
     *
     * @param {AbstractControl} formControl
     * @param {string} message
     */
    /**
     * Invalidates a control with an optional message
     *
     * @param {?} formControl
     * @param {?=} message
     * @return {?}
     */
    UIFormsService.prototype.invalidateControl = /**
     * Invalidates a control with an optional message
     *
     * @param {?} formControl
     * @param {?=} message
     * @return {?}
     */
    function (formControl, message) {
        if (message === void 0) { message = null; }
        formControl.setValidators(UIValidators.customMessage(message));
        formControl.markAsDirty();
        formControl.updateValueAndValidity();
    };
    /**
     * Sets validators on control and updates validity.
     *
     * @param {AbstractControl} formControl
     * @param {ValidatorFn[]} validators
     */
    /**
     * Sets validators on control and updates validity.
     *
     * @param {?} formControl
     * @param {?} validators
     * @return {?}
     */
    UIFormsService.prototype.setValidators = /**
     * Sets validators on control and updates validity.
     *
     * @param {?} formControl
     * @param {?} validators
     * @return {?}
     */
    function (formControl, validators) {
        formControl.clearValidators();
        formControl.setValidators(validators);
        formControl.updateValueAndValidity();
    };
    UIFormsService.decorators = [
        { type: Injectable },
    ];
    return UIFormsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIAuthModule = /** @class */ (function () {
    function UIAuthModule() {
    }
    UIAuthModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIForgottenPasswordComponent,
                        UIResetPasswordComponent,
                        UILoginComponent,
                        UIAuthComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        UILoadingModule,
                        UIToastModule,
                        UIFormsModule
                    ],
                    providers: [
                        UIFormsService$1
                    ],
                    exports: [
                        UIForgottenPasswordComponent,
                        UIResetPasswordComponent,
                        UILoginComponent,
                        UIAuthComponent
                    ]
                },] },
    ];
    return UIAuthModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UITabBar = /** @class */ (function () {
    function UITabBar(uiTabBar) {
        this.routeTabs = false;
        this.checkTabs = false;
        this.baseTheme = 'white';
        this.align = 'left';
        this.contained = false;
        this.containerBaseTheme = 'light';
        this.modalTabs = false;
        Object.assign(/** @type {?} */ (this), uiTabBar);
    }
    return UITabBar;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UICodePanelComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIHttpService} uiHttpService
     * @param {DomSanitizer} domSanitizer
     * @param {ElementRef} elementRef
     * @param {HighlightJsService} highlightJsService
     * @param {UIScriptLoaderService} uiScriptLoaderService
     * @param {UIToastService} uiToastService
     * @param {UIHelperService} uiHelperService
     */
    function UICodePanelComponent(uiHttpService, domSanitizer, elementRef, highlightJsService, uiScriptLoaderService, uiToastService, uiHelperService) {
        this.uiHttpService = uiHttpService;
        this.domSanitizer = domSanitizer;
        this.elementRef = elementRef;
        this.highlightJsService = highlightJsService;
        this.uiScriptLoaderService = uiScriptLoaderService;
        this.uiToastService = uiToastService;
        this.uiHelperService = uiHelperService;
        this.panelContent = [];
        this.rawPanelContent = [];
        this.selectedTab = 0;
        this.codeBlocks = null;
    }
    /**
     * Lifecycle hook: Sets tab bar config & loads scripts needed for code panels.
     */
    /**
     * Lifecycle hook: Sets tab bar config & loads scripts needed for code panels.
     * @return {?}
     */
    UICodePanelComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Sets tab bar config & loads scripts needed for code panels.
     * @return {?}
     */
    function () {
        var _this = this;
        this.tabBarConfig = this.getTabBarConfig();
        this.uiScriptLoaderService.load('highlightjs', 'highlightjs_typescript').then(function () {
            _this.codeBlocks = _this.elementRef.nativeElement.querySelectorAll('code');
            _this.panels.forEach(function (item, index) {
                _this.getContent(item.path, index);
            });
        }).catch(function (error) {
            console.log(error);
        });
    };
    /**
     * Gets tab bar config.
     *
     * @returns {UITabBar}
     */
    /**
     * Gets tab bar config.
     *
     * @return {?}
     */
    UICodePanelComponent.prototype.getTabBarConfig = /**
     * Gets tab bar config.
     *
     * @return {?}
     */
    function () {
        return new UITabBar({
            baseTheme: 'dark',
            contained: true,
            tabs: this.panels.map(function (panel) {
                return { name: panel.name };
            })
        });
    };
    /**
     * Gets content from snippet and runs it through highlight js.
     *
     * @param {string} src
     * @param {number} index
     */
    /**
     * Gets content from snippet and runs it through highlight js.
     *
     * @param {?} src
     * @param {?} index
     * @return {?}
     */
    UICodePanelComponent.prototype.getContent = /**
     * Gets content from snippet and runs it through highlight js.
     *
     * @param {?} src
     * @param {?} index
     * @return {?}
     */
    function (src, index) {
        var _this = this;
        this.uiHttpService.get(src, { responseType: 'text' }).pipe(first()).subscribe(function (response) {
            _this.panelContent[index] = _this.domSanitizer.bypassSecurityTrustHtml(_this.uiHelperService.escapeHTML(response));
            _this.rawPanelContent[index] = response;
            setTimeout(function () {
                _this.highlightJsService.highlight(_this.codeBlocks[index]);
                _this.codeBlocks[index].classList.remove('loading');
            });
        });
    };
    /**
     * Notifies user of copy success.
     */
    /**
     * Notifies user of copy success.
     * @return {?}
     */
    UICodePanelComponent.prototype.onCopySuccess = /**
     * Notifies user of copy success.
     * @return {?}
     */
    function () {
        this.uiToastService.info('Copied to clipboard!');
    };
    UICodePanelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-code-panel',
                    template: "\n      <!--  CODE PANEL  -->\n\n      <div class=\"panel panel-dark code-panel\">\n\n          <!--  TAB BAR  -->\n\n          <ui-tab-bar [uiTabBar]=\"tabBarConfig\" (change)=\"selectedTab = $event\"></ui-tab-bar>\n\n          <!--  END TAB BAR  -->\n\n          <!--  PANEL LOOP  -->\n\n          <div *ngFor=\"let panel of panels; let index = index\" class=\"tab-content\" [class.hidden]=\"selectedTab !== index\">\n\n              <!--  SNIPPET CONTENT  -->\n\n              <pre><code class=\"loading\" [ngClass]=\"panel.type\" [innerHtml]=\"panelContent[index]\"></code></pre>\n\n              <!--  END SNIPPET  -->\n\n              <!--  COPY TO CLIPBOARD BUTTON  -->\n\n              <a class=\"button small-button accent-button\" ngxClipboard [cbContent]=\"rawPanelContent[index]\" (cbOnSuccess)=\"onCopySuccess()\">Copy</a>\n\n              <!--  END COPY TO CLIPBOARD BUTTON  -->\n\n          </div>\n\n          <!--  END PANEL LOOP  -->\n\n      </div>\n\n      <!--  END CODE PANEL  -->\n    ",
                    styles: ["\n      @import url(https://cdnjs.cloudflare.com/ajax/libs/highlight.js/9.12.0/styles/monokai-sublime.min.css);@font-face{font-family:'Fira Mono';font-style:normal;font-weight:400;src:local('Fira Mono Regular'),local('FiraMono-Regular'),url(https://fonts.gstatic.com/s/firamono/v6/N0bX2SlFPv1weGeLZDtgJv7X.ttf) format('truetype')}:host .code-panel{padding:0}:host .code-panel .tab-content{padding:0;position:relative}:host .code-panel .tab-content pre code{padding:32px;-moz-tab-size:32px;-o-tab-size:32px;tab-size:32px;line-height:1.7em;opacity:1;-webkit-transition:opacity .2s linear 0s;-o-transition:opacity .2s linear 0s;transition:opacity .2s linear 0s;font-size:12px;font-family:'Fira Mono',Consolas,'Courier New',serif;border-radius:0 0 3px 3px}:host .code-panel .tab-content pre code.hljs{background:#262626}:host .code-panel .tab-content pre code.loading{opacity:0}:host .code-panel .tab-content .button{position:absolute;right:32px;top:32px;opacity:0;-webkit-transition-property:background,opacity;-o-transition-property:background,opacity;transition-property:background,opacity}:host .code-panel .tab-content:hover .button{opacity:1}@media screen and (max-width:1174px){:host .code-panel .tab-content pre code{padding:24px}:host .code-panel .tab-content .button{top:24px;right:24px}}@media screen and (max-width:774px){:host .code-panel .tab-content pre code{padding:16px}:host .code-panel .tab-content .button{top:16px;right:16px}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UICodePanelComponent.ctorParameters = function () { return [
        { type: UIHttpService },
        { type: DomSanitizer },
        { type: ElementRef },
        { type: HighlightJsService },
        { type: UIScriptLoaderService },
        { type: UIToastService },
        { type: UIHelperService }
    ]; };
    UICodePanelComponent.propDecorators = {
        panels: [{ type: Input }]
    };
    return UICodePanelComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UICodePanel = /** @class */ (function () {
    function UICodePanel(uiCodePanel) {
        Object.assign(/** @type {?} */ (this), uiCodePanel);
    }
    return UICodePanel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIPopoverComponent = /** @class */ (function () {
    function UIPopoverComponent() {
    }
    /**
     * Lifecycle hook: Builds offsets.
     */
    /**
     * Lifecycle hook: Builds offsets.
     * @return {?}
     */
    UIPopoverComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Builds offsets.
     * @return {?}
     */
    function () {
        this.setOffsets();
    };
    /**
     * Lifecycle hook: re-builds offsets on change.
     *
     * @param {SimpleChanges} simpleChanges
     */
    /**
     * Lifecycle hook: re-builds offsets on change.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    UIPopoverComponent.prototype.ngOnChanges = /**
     * Lifecycle hook: re-builds offsets on change.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    function (simpleChanges) {
        if (!simpleChanges['uiPopover'].firstChange && simpleChanges['uiPopover'].previousValue.offset !== simpleChanges['uiPopover'].currentValue.offset) {
            this.setOffsets();
        }
    };
    /**
     * Sets offset values.
     */
    /**
     * Sets offset values.
     * @return {?}
     */
    UIPopoverComponent.prototype.setOffsets = /**
     * Sets offset values.
     * @return {?}
     */
    function () {
        this.offset = {
            right: (this.uiPopover.face === 'bottom' || this.uiPopover.face === 'top') && this.uiPopover.position === 'right' ? -this.uiPopover.offset + 'px' : null,
            left: (this.uiPopover.face === 'bottom' || this.uiPopover.face === 'top') && this.uiPopover.position === 'left' ? this.uiPopover.offset + 'px' : null,
            bottom: (this.uiPopover.face === 'left' || this.uiPopover.face === 'right') && this.uiPopover.position === 'bottom' ? -this.uiPopover.offset + 'px' : null,
            top: (this.uiPopover.face === 'left' || this.uiPopover.face === 'right') && this.uiPopover.position === 'top' ? this.uiPopover.offset + 'px' : null
        };
    };
    UIPopoverComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-popover',
                    template: "\n      <!--  POPOVER  -->\n\n      <div class=\"popover\"\n           [class.show]=\"uiPopover.show\"\n           [class.has-arrow]=\"uiPopover.hasArrow\"\n           [ngClass]=\"['face-' + uiPopover.face, 'pos-' + uiPopover.position]\"\n           [style.right]=\"offset.right\"\n           [style.left]=\"offset.left\"\n           [style.top]=\"offset.top\"\n           [style.bottom]=\"offset.bottom\">\n\n          <!--  POPOVER INNER  -->\n\n          <div class=\"inner\"\n               [style.min-width]=\"(uiPopover.minWidth) ? uiPopover.minWidth + 'px' : null\"\n               [style.max-width]=\"(uiPopover.maxWidth) ? uiPopover.maxWidth + 'px' : null\"\n               [style.min-height]=\"(uiPopover.minHeight) ? uiPopover.minHeight + 'px' : null\"\n               [style.max-height]=\"(uiPopover.maxHeight) ? uiPopover.maxHeight + 'px' : null\">\n\n              <!--  POPOVER CONTENT CONTAINER  -->\n\n              <ng-content></ng-content>\n\n              <!--  END POPOVER CONTENT CONTAINER  -->\n\n          </div>\n\n          <!--  END POPOVER INNER  -->\n\n      </div>\n\n      <!--  END POPOVER  -->\n    ",
                    styles: ["\n      :host .popover{position:absolute;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);-webkit-transition:-webkit-transform .2s ease-in-out 0s;-o-transition:transform .2s ease-in-out 0s;transition:transform .2s ease-in-out 0s;transition:transform .2s ease-in-out 0s,-webkit-transform .2s ease-in-out 0s;z-index:30000}:host .popover>.inner{background:#FFF;border:1px solid #bdbdbd;-webkit-box-shadow:0 3px 7px rgba(0,0,0,.1);box-shadow:0 3px 7px rgba(0,0,0,.1);min-width:30px;min-height:30px;position:relative;overflow:auto;border-radius:3px}:host .popover::before{content:'';border-left:1px solid #bdbdbd;border-top:1px solid #bdbdbd;height:8px;width:8px;background:#FFF;position:absolute;border-bottom-right-radius:8px;z-index:1;display:none}:host .popover.show{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);-webkit-transition:-webkit-transform .2s ease-in-out 0s;-o-transition:transform .2s ease-in-out 0s;transition:transform .2s ease-in-out 0s;transition:transform .2s ease-in-out 0s,-webkit-transform .2s ease-in-out 0s}:host .popover.face-bottom{padding-top:2px;top:100%}:host .popover.face-bottom::before{-webkit-transform:translateX(-50%) rotate(45deg);-ms-transform:translateX(-50%) rotate(45deg);transform:translateX(-50%) rotate(45deg);top:5px}:host .popover.face-bottom.pos-left{left:0;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}:host .popover.face-bottom.pos-left::before{left:18px}:host .popover.face-bottom.pos-center{left:50%;-webkit-transform:translateX(-50%) scale(0);-ms-transform:translateX(-50%) scale(0);transform:translateX(-50%) scale(0);-webkit-transform-origin:50% 0;-ms-transform-origin:50% 0;transform-origin:50% 0}:host .popover.face-bottom.pos-center.show{-webkit-transform:translateX(-50%) scale(1);-ms-transform:translateX(-50%) scale(1);transform:translateX(-50%) scale(1)}:host .popover.face-bottom.pos-center::before{left:50%}:host .popover.face-bottom.pos-right{right:0;-webkit-transform-origin:100% 0;-ms-transform-origin:100% 0;transform-origin:100% 0}:host .popover.face-bottom.pos-right::before{right:18px;-webkit-transform:translateX(50%) rotate(45deg);-ms-transform:translateX(50%) rotate(45deg);transform:translateX(50%) rotate(45deg)}:host .popover.face-top{bottom:100%;padding-bottom:2px}:host .popover.face-top::before{-webkit-transform:translateX(-50%) rotate(225deg);-ms-transform:translateX(-50%) rotate(225deg);transform:translateX(-50%) rotate(225deg);bottom:5px}:host .popover.face-top.pos-left{left:0;-webkit-transform-origin:0 100%;-ms-transform-origin:0 100%;transform-origin:0 100%}:host .popover.face-top.pos-left::before{left:18px}:host .popover.face-top.pos-center{left:50%;-webkit-transform:translateX(-50%) scale(0);-ms-transform:translateX(-50%) scale(0);transform:translateX(-50%) scale(0);-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;transform-origin:50% 100%}:host .popover.face-top.pos-center.show{-webkit-transform:translateX(-50%) scale(1);-ms-transform:translateX(-50%) scale(1);transform:translateX(-50%) scale(1)}:host .popover.face-top.pos-center::before{left:50%}:host .popover.face-top.pos-right{right:0;-webkit-transform-origin:100% 100%;-ms-transform-origin:100% 100%;transform-origin:100% 100%}:host .popover.face-top.pos-right::before{right:18px;-webkit-transform:translateX(50%) rotate(225deg);-ms-transform:translateX(50%) rotate(225deg);transform:translateX(50%) rotate(225deg)}:host .popover.face-left{right:100%;padding-right:2px}:host .popover.face-left::before{-webkit-transform:translateY(-50%) rotate(135deg);-ms-transform:translateY(-50%) rotate(135deg);transform:translateY(-50%) rotate(135deg);right:5px}:host .popover.face-left.pos-top{top:0;-webkit-transform-origin:100% 0;-ms-transform-origin:100% 0;transform-origin:100% 0}:host .popover.face-left.pos-top::before{top:18px}:host .popover.face-left.pos-middle{top:50%;-webkit-transform:translateY(-50%) scale(0);-ms-transform:translateY(-50%) scale(0);transform:translateY(-50%) scale(0);-webkit-transform-origin:100% 50%;-ms-transform-origin:100% 50%;transform-origin:100% 50%}:host .popover.face-left.pos-middle.show{-webkit-transform:translateY(-50%) scale(1);-ms-transform:translateY(-50%) scale(1);transform:translateY(-50%) scale(1)}:host .popover.face-left.pos-middle::before{top:50%}:host .popover.face-left.pos-bottom{bottom:0;-webkit-transform-origin:100% 100%;-ms-transform-origin:100% 100%;transform-origin:100% 100%}:host .popover.face-left.pos-bottom::before{bottom:18px;-webkit-transform:translateY(50%) rotate(135deg);-ms-transform:translateY(50%) rotate(135deg);transform:translateY(50%) rotate(135deg)}:host .popover.face-right{left:100%;padding-left:2px}:host .popover.face-right::before{-webkit-transform:translateY(-50%) rotate(315deg);-ms-transform:translateY(-50%) rotate(315deg);transform:translateY(-50%) rotate(315deg);left:5px}:host .popover.face-right.pos-top{top:0;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}:host .popover.face-right.pos-top::before{top:18px}:host .popover.face-right.pos-middle{top:50%;-webkit-transform:translateY(-50%) scale(0);-ms-transform:translateY(-50%) scale(0);transform:translateY(-50%) scale(0);-webkit-transform-origin:0 50%;-ms-transform-origin:0 50%;transform-origin:0 50%}:host .popover.face-right.pos-middle.show{-webkit-transform:translateY(-50%) scale(1);-ms-transform:translateY(-50%) scale(1);transform:translateY(-50%) scale(1)}:host .popover.face-right.pos-middle::before{top:50%}:host .popover.face-right.pos-bottom{bottom:0;-webkit-transform-origin:0 100%;-ms-transform-origin:0 100%;transform-origin:0 100%}:host .popover.face-right.pos-bottom::before{bottom:18px;-webkit-transform:translateY(50%) rotate(315deg);-ms-transform:translateY(50%) rotate(315deg);transform:translateY(50%) rotate(315deg)}:host .popover.has-arrow::before{display:block}:host .popover.has-arrow.face-bottom{padding-top:9px}:host .popover.has-arrow.face-top{padding-bottom:9px}:host .popover.has-arrow.face-left{padding-right:9px}:host .popover.has-arrow.face-right{padding-left:9px}\n    "]
                },] },
    ];
    UIPopoverComponent.propDecorators = {
        uiPopover: [{ type: Input }]
    };
    return UIPopoverComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIPopoverModule = /** @class */ (function () {
    function UIPopoverModule() {
    }
    UIPopoverModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIPopoverComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UIPopoverComponent
                    ]
                },] },
    ];
    return UIPopoverModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIPopover = /** @class */ (function () {
    function UIPopover(uiPopover) {
        this.show = false;
        this.hasArrow = true;
        this.offset = 0;
        Object.assign(/** @type {?} */ (this), uiPopover);
    }
    return UIPopover;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UITabBarComponent = /** @class */ (function () {
    /**
     * Constructs component and injects dependencies
     *
     * @param {Router} router
     * @param {ActivatedRoute} activatedRoute
     * @param {ElementRef} elementRef
     * @param {UIHelperService} uiHelperService
     */
    function UITabBarComponent(router, activatedRoute, elementRef, uiHelperService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.elementRef = elementRef;
        this.uiHelperService = uiHelperService;
        this.change = new EventEmitter();
        this.tabHash = this.uiHelperService.generateRandomString(20);
        this.tabBarCssClass = '';
        this.selectedTabIndex = 0;
        this.highlightWidth = 0;
        this.highlightLeft = 0;
        this.highlightStatic = true;
        this.totalTabsWidth = 0;
        this.viewInitialised = false;
        this.checkStateTimeout = null;
        this.secondaryTabsPopover = new UIPopover({
            face: 'bottom',
            position: 'right',
            minWidth: 160,
            maxHeight: 220,
            hasArrow: false
        });
        this.popoverExists = false;
        this.popoverDestroyed$ = new Subject();
        this.destroyed$ = new Subject();
    }
    /**
     * Lifecycle hook: Sets up tabBarCssClass and creates listener for route tabs.
     */
    /**
     * Lifecycle hook: Sets up tabBarCssClass and creates listener for route tabs.
     * @return {?}
     */
    UITabBarComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Sets up tabBarCssClass and creates listener for route tabs.
     * @return {?}
     */
    function () {
        var _this = this;
        this.tabBarCssClass = this.getCssClass();
        if (this.uiTabBar.routeTabs) {
            this.router.events.pipe(takeUntil(this.destroyed$)).subscribe(function (event) {
                if (event instanceof NavigationEnd) {
                    if (_this.uiTabBar.modalTabs) {
                        _this.showModalRouteTab();
                    }
                    else {
                        _this.showRouteTab();
                    }
                }
            });
        }
    };
    /**
     * Builds string to be used as CSS class for the tab bar.
     *
     * @returns {string}
     */
    /**
     * Builds string to be used as CSS class for the tab bar.
     *
     * @return {?}
     */
    UITabBarComponent.prototype.getCssClass = /**
     * Builds string to be used as CSS class for the tab bar.
     *
     * @return {?}
     */
    function () {
        /** @type {?} */
        var classes = [];
        if (this.uiTabBar.baseTheme !== null) {
            classes.push('base-' + this.uiTabBar.baseTheme);
        }
        if (this.uiTabBar.contained === true) {
            classes.push('contained');
        }
        if (this.uiTabBar.contained === true) {
            classes.push('container-' + ((this.uiTabBar.baseTheme === 'dark') ? 'dark' : this.uiTabBar.containerBaseTheme));
        }
        if (this.uiTabBar.checkTabs === true) {
            classes.push('check-tabs');
        }
        switch (this.uiTabBar.align) {
            case 'left':
                classes.push('align-left');
                break;
            case 'center':
                classes.push('align-center');
                break;
            case 'right':
                classes.push('align-right');
                break;
        }
        return classes.join(' ');
    };
    /**
     * Lifecycle hook: Waits for component to render, then activates transition.
     */
    /**
     * Lifecycle hook: Waits for component to render, then activates transition.
     * @return {?}
     */
    UITabBarComponent.prototype.ngAfterContentInit = /**
     * Lifecycle hook: Waits for component to render, then activates transition.
     * @return {?}
     */
    function () {
        var _this = this;
        this.initTabs();
        setTimeout(function () {
            _this.highlightStatic = false;
        }, 200);
        this.viewInitialised = true;
    };
    /**
     * Subscribes to changes to the tabs being passed in. Calls function to initialise tabs
     * if it detects a change.
     *
     * @param {SimpleChanges} simpleChanges
     */
    /**
     * Subscribes to changes to the tabs being passed in. Calls function to initialise tabs
     * if it detects a change.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    UITabBarComponent.prototype.ngOnChanges = /**
     * Subscribes to changes to the tabs being passed in. Calls function to initialise tabs
     * if it detects a change.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    function (simpleChanges) {
        /** @type {?} */
        var current = simpleChanges["currentValue"];
        /** @type {?} */
        var previous = simpleChanges["previousValue"];
        if (current && previous) {
            if (this.viewInitialised && !this.uiHelperService.arraysMatch(current.tabs, previous.tabs)) {
                this.initTabs();
            }
        }
    };
    /**
     * Resets primary / secondary tabs. Calls function to check primary / secondary state.
     */
    /**
     * Resets primary / secondary tabs. Calls function to check primary / secondary state.
     * @return {?}
     */
    UITabBarComponent.prototype.initTabs = /**
     * Resets primary / secondary tabs. Calls function to check primary / secondary state.
     * @return {?}
     */
    function () {
        var _this = this;
        this.primaryTabs = this.uiTabBar.tabs;
        this.secondaryTabs = [];
        setTimeout(function () {
            _this.populateTabsAdditional();
            if (_this.uiTabBar.routeTabs && !_this.uiTabBar.modalTabs) {
                _this.showRouteTab();
                return;
            }
            if (_this.uiTabBar.routeTabs && _this.uiTabBar.modalTabs) {
                _this.showModalRouteTab();
                return;
            }
            _this.onTabClick(_this.uiTabBar.tabs[0], false);
        });
    };
    /**
     * Adds additional info to tabs within the tab bar, to be used later to determine position and state.
     */
    /**
     * Adds additional info to tabs within the tab bar, to be used later to determine position and state.
     * @return {?}
     */
    UITabBarComponent.prototype.populateTabsAdditional = /**
     * Adds additional info to tabs within the tab bar, to be used later to determine position and state.
     * @return {?}
     */
    function () {
        var _this = this;
        this.totalTabsWidth = 0;
        /** @type {?} */
        var tabElements = this.elementRef.nativeElement.querySelectorAll('.primary-tab');
        tabElements.forEach(function (tab, index) {
            /** @type {?} */
            var tabElement = tab.parentElement;
            /** @type {?} */
            var tabInstance = _this.uiTabBar.tabs[index];
            tabInstance.width = tabElement.offsetWidth;
            tabInstance.index = index;
            tabInstance.active = tab.classList.contains('active');
            _this.totalTabsWidth += tabElement.offsetWidth;
        });
    };
    /**
     * Called when tabs are route tabs. Used to move the highlight item to the correct position.
     */
    /**
     * Called when tabs are route tabs. Used to move the highlight item to the correct position.
     * @return {?}
     */
    UITabBarComponent.prototype.showRouteTab = /**
     * Called when tabs are route tabs. Used to move the highlight item to the correct position.
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout(function () {
            _this.uiTabBar.tabs.forEach(function (tab, index) {
                /** @type {?} */
                var tabElement = _this.elementRef.nativeElement.querySelector('#' + _this.tabHash + '_tab_' + tab.index);
                tab.active = tabElement.classList.contains('active');
                if (tab.active) {
                    _this.selectedTabIndex = index;
                }
            });
            _this.checkState();
        });
    };
    /**
     * @return {?}
     */
    UITabBarComponent.prototype.showModalRouteTab = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.uiTabBar.tabs.forEach(function (tab, index) {
            tab.active = _this.router.url.indexOf("(modal:dialog/" + tab.path.join('/') + ")") !== -1;
            if (tab.active) {
                _this.selectedTabIndex = index;
            }
        });
        this.checkState();
    };
    /**
     * Handles output event and is used to move highlight item into the correct position
     *
     * @param {UITab} tabToShow
     * @param {boolean} userClick
     */
    /**
     * Handles output event and is used to move highlight item into the correct position
     *
     * @param {?} tabToShow
     * @param {?=} userClick
     * @return {?}
     */
    UITabBarComponent.prototype.onTabClick = /**
     * Handles output event and is used to move highlight item into the correct position
     *
     * @param {?} tabToShow
     * @param {?=} userClick
     * @return {?}
     */
    function (tabToShow, userClick) {
        var _this = this;
        if (userClick === void 0) { userClick = true; }
        this.setHideMore();
        this.uiTabBar.tabs.forEach(function (tab) {
            tab.active = (tab === tabToShow);
            if (tab.active) {
                _this.selectedTabIndex = tab.index;
            }
        });
        if (userClick && tabToShow.click) {
            tabToShow.click();
        }
        this.change.emit(tabToShow.index);
        this.checkState();
    };
    /**
     * Handles when route modal tab is clicked.
     *
     * @param {UITab} tabToShow
     */
    /**
     * Handles when route modal tab is clicked.
     *
     * @param {?} tabToShow
     * @return {?}
     */
    UITabBarComponent.prototype.onModalRouteTabClick = /**
     * Handles when route modal tab is clicked.
     *
     * @param {?} tabToShow
     * @return {?}
     */
    function (tabToShow) {
        var _this = this;
        this.uiTabBar.tabs.forEach(function (tab) {
            tab.active = (tab === tabToShow);
            if (tab.active) {
                _this.selectedTabIndex = tab.index;
            }
        });
        this.router.navigate([{ outlets: { 'modal': ['dialog'].concat(tabToShow.path) } }]);
    };
    /**
     * Determines whether tabs should be added to primary or secondary tabs.
     * Triggered by window:resize event.
     *
     * @param event
     */
    /**
     * Determines whether tabs should be added to primary or secondary tabs.
     * Triggered by window:resize event.
     *
     * @param {?=} event
     * @return {?}
     */
    UITabBarComponent.prototype.checkState = /**
     * Determines whether tabs should be added to primary or secondary tabs.
     * Triggered by window:resize event.
     *
     * @param {?=} event
     * @return {?}
     */
    function (event) {
        var _this = this;
        clearTimeout(this.checkStateTimeout);
        this.checkStateTimeout = setTimeout(function () {
            /** @type {?} */
            var containerWidth = _this.containerElement.nativeElement.offsetWidth;
            if (_this.totalTabsWidth <= containerWidth) {
                _this.primaryTabs = _this.uiTabBar.tabs;
                _this.secondaryTabs = [];
            }
            else {
                _this.primaryTabs = [];
                _this.secondaryTabs = [];
                /** @type {?} */
                var primaryWidthTotal_1 = 0;
                /** @type {?} */
                var primaryFull_1 = false;
                /** @type {?} */
                var secondaryStartIndex_1 = -1;
                _this.uiTabBar.tabs.forEach(function (tab, index) {
                    if (!primaryFull_1 && ((primaryWidthTotal_1 + tab.width) <= (containerWidth - 90))) {
                        primaryWidthTotal_1 += tab.width;
                        _this.primaryTabs.push(tab);
                    }
                    else {
                        if (!primaryFull_1) {
                            secondaryStartIndex_1 = index;
                            primaryFull_1 = true;
                        }
                        _this.secondaryTabs.push(tab);
                    }
                });
                setTimeout(function () {
                    if (_this.primaryTabs.length > 1 && _this.selectedTabIndex >= secondaryStartIndex_1) {
                        /** @type {?} */
                        var lastInPrimary = _this.primaryTabs[_this.primaryTabs.length - 1];
                        /** @type {?} */
                        var activeInSecondary = _this.secondaryTabs.find(function (tab) {
                            return tab.active === true;
                        });
                        _this.primaryTabs.splice(_this.primaryTabs.length - 1, 1);
                        _this.secondaryTabs.splice(_this.secondaryTabs.indexOf(activeInSecondary), 1);
                        _this.primaryTabs.push(activeInSecondary);
                        _this.secondaryTabs.splice(0, 0, lastInPrimary);
                        /** @type {?} */
                        var totalPrimaryTabsWidth = _this.primaryTabs.reduce(function (total, tab) {
                            return total + tab.width;
                        }, 0);
                        while (_this.primaryTabs.length > 2 && totalPrimaryTabsWidth > (containerWidth - 90)) {
                            /** @type {?} */
                            var penultimateInPrimary = _this.primaryTabs[_this.primaryTabs.length - 2];
                            _this.primaryTabs.splice(_this.primaryTabs.length - 2, 1);
                            _this.secondaryTabs.splice(0, 0, penultimateInPrimary);
                            totalPrimaryTabsWidth = _this.primaryTabs.reduce(function (total, tab) {
                                return total + tab.width;
                            }, 0);
                        }
                    }
                });
            }
            setTimeout(function () {
                /** @type {?} */
                var activeTab = _this.elementRef.nativeElement.querySelector('.primary-tabs a.active');
                _this.highlightWidth = activeTab.offsetWidth;
                _this.highlightLeft = activeTab.offsetLeft;
            });
        }, typeof (event) !== 'undefined' ? 20 : 0);
    };
    /**
     * Toggles visible state of secondary tabs popover.
     */
    /**
     * Toggles visible state of secondary tabs popover.
     * @return {?}
     */
    UITabBarComponent.prototype.onMoreClick = /**
     * Toggles visible state of secondary tabs popover.
     * @return {?}
     */
    function () {
        if (this.popoverExists) {
            this.setHideMore();
            return;
        }
        this.setShowMore();
    };
    /**
     * Shows secondary tabs popover
     */
    /**
     * Shows secondary tabs popover
     * @return {?}
     */
    UITabBarComponent.prototype.setShowMore = /**
     * Shows secondary tabs popover
     * @return {?}
     */
    function () {
        var _this = this;
        clearTimeout(this.popoverTimeout);
        this.popoverExists = true;
        this.popoverDestroyed$.next(false);
        this.popoverTimeout = setTimeout(function () {
            _this.secondaryTabsPopover.show = true;
        });
        // Popover exists and is visible, register listener to hide it when user clicks elsewhere.
        fromEvent(document, 'click').pipe(skip(1)).pipe(takeUntil(this.popoverDestroyed$)).subscribe(function (event) {
            if (!_this.elementRef.nativeElement.contains(event.target)) {
                _this.setHideMore();
            }
        });
    };
    /**
     * Hides secondary tabs popover
     */
    /**
     * Hides secondary tabs popover
     * @return {?}
     */
    UITabBarComponent.prototype.setHideMore = /**
     * Hides secondary tabs popover
     * @return {?}
     */
    function () {
        var _this = this;
        clearTimeout(this.popoverTimeout);
        this.secondaryTabsPopover.show = false;
        this.popoverTimeout = setTimeout(function () {
            _this.popoverExists = false;
            _this.popoverDestroyed$.next(true);
        }, 200);
    };
    /**
     * Lifecycle: Destroys any active click listeners or subscriptions
     */
    /**
     * Lifecycle: Destroys any active click listeners or subscriptions
     * @return {?}
     */
    UITabBarComponent.prototype.ngOnDestroy = /**
     * Lifecycle: Destroys any active click listeners or subscriptions
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
        this.popoverDestroyed$.next(true);
    };
    UITabBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-tab-bar',
                    template: "\n      <!-- TAB BAR  -->\n\n      <div class=\"tab-bar\" [ngClass]=\"tabBarCssClass\">\n          <ul #container class=\"primary-tabs\" [class.justify]=\"secondaryTabs?.length > 0\">\n\n              <!--  PRIMARY TABS  -->\n\n              <li *ngFor=\"let t of primaryTabs\">\n\n                  <!--  NON-ROUTE TAB  -->\n\n                  <a #tab\n                     *ngIf=\"!uiTabBar.routeTabs\"\n                     [attr.id]=\"tabHash + '_tab_' + t.index\"\n                     class=\"tab primary-tab\"\n                     [class.active]=\"selectedTabIndex === t.index\"\n                     (click)=\"onTabClick(t)\">\n                      <i class=\"far fa-check pos-bg pos-fg-col\"></i>\n                      <span class=\"text\">{{ t.name }}</span>\n                  </a>\n\n                  <!--  END NON-ROUTE TAB  -->\n\n                  <!-- ROUTE TAB - NON MODAL  -->\n\n                  <a #tab\n                     *ngIf=\"uiTabBar.routeTabs && !uiTabBar.modalTabs\"\n                     [attr.id]=\"tabHash + '_tab_' + t.index\"\n                     class=\"tab primary-tab\"\n                     [routerLink]=\"[t.path]\"\n                     routerLinkActive=\"active\">\n                      <span class=\"text\">{{ t.name }}</span>\n                  </a>\n\n                  <!--  END ROUTE TAB - NON MODAL  -->\n\n                  <!-- ROUTE TAB - MODAL  -->\n\n                  <a #tab\n                     *ngIf=\"uiTabBar.routeTabs && uiTabBar.modalTabs\"\n                     [attr.id]=\"tabHash + '_tab_' + t.index\"\n                     class=\"tab primary-tab\"\n                     [class.active]=\"selectedTabIndex === t.index\"\n                     (click)=\"onModalRouteTabClick(t)\">\n                      <span class=\"text\">{{ t.name }}</span>\n                  </a>\n\n                  <!--  END ROUTE TAB - MODAL  -->\n\n              </li>\n\n              <!-- END PRIMARY TABS  -->\n\n              <!--  SECONDARY TABS  -->\n\n              <li *ngIf=\"secondaryTabs?.length > 0\" class=\"more-tab\">\n\n                  <!--  MORE TAB  -->\n\n                  <a [class.expanded]=\"secondaryTabsPopover.show\"\n                     (click)=\"onMoreClick()\">\n                      <span class=\"text\">More <i class=\"fas fa-chevron-down\"></i></span>\n                  </a>\n\n                  <!--  END MORE TAB  -->\n\n                  <!--  SECONDARY TABS POPOVER  -->\n\n                  <ui-popover *ngIf=\"popoverExists\" [uiPopover]=\"secondaryTabsPopover\">\n\n                      <!--  SECONDARY ITEMS  -->\n\n                      <ul class=\"link-list secondary-tabs\">\n                          <li *ngFor=\"let t of secondaryTabs\">\n\n                              <!--  NON-ROUTE TAB  -->\n\n                              <a #tab\n                                 *ngIf=\"!uiTabBar.routeTabs\"\n                                 [attr.id]=\"tabHash + '_tab_' + t.index\"\n                                 class=\"tab\"\n                                 [class.active]=\"selectedTabIndex === t.index\"\n                                 (click)=\"onTabClick(t)\">\n                                  <span class=\"text\">{{ t.name }}</span>\n                              </a>\n\n                              <!--  END NON-ROUTE TAB  -->\n\n                              <!--  ROUTE TAB  -->\n\n                              <a #tab\n                                 *ngIf=\"uiTabBar.routeTabs\"\n                                 [attr.id]=\"tabHash + '_tab_' + t.index\"\n                                 class=\"tab\"\n                                 (click)=\"setHideMore()\"\n                                 [routerLink]=\"[t.path]\"\n                                 routerLinkActive=\"active\">\n                                  <span class=\"text\">{{ t.name }}</span>\n                              </a>\n\n                              <!-- END ROUTE TAB  -->\n\n                          </li>\n                      </ul>\n\n                      <!-- END SECONDARY ITEMS  -->\n\n                  </ui-popover>\n\n                  <!--  END SECONDARY TABS POPOVER  -->\n\n              </li>\n\n              <!--  END SECONDARY TABS  -->\n\n              <!--  HIGHLIGHT TAB  -->\n\n              <li class=\"highlight acc-hl-bg\"\n                  [class.static]=\"highlightStatic\"\n                  [style.left]=\"highlightLeft + 'px'\"\n                  [style.width]=\"highlightWidth + 'px'\">\n              </li>\n\n              <!--  END HIGHLIGHT TAB  -->\n\n          </ul>\n      </div>\n\n      <!--  END TAB BAR  -->\n    ",
                    styles: ["\n      :host .tab-bar{border-radius:3px 3px 0 0}:host .tab-bar>ul{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;position:relative}:host .tab-bar>ul>li{margin-bottom:-5px}:host .tab-bar>ul>li>a{text-transform:uppercase;border-bottom:5px solid #f2f2f2;line-height:32px;display:block;height:37px;font-size:12px;color:#919191;padding:0 16px;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;cursor:pointer;font-weight:500;position:relative;text-align:center;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s;border-radius:3px 3px 0 0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host .tab-bar>ul>li>a.active,:host .tab-bar>ul>li>a:hover{color:#4e4e4e;background:#f2f2f2}:host .tab-bar>ul>li>a>i{display:none}:host .tab-bar>ul>li.highlight{display:block;position:absolute;height:5px;background:#222;bottom:0;border-bottom:none;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s}:host .tab-bar>ul>li.highlight.static{-webkit-transition:none;-o-transition:none;transition:none}:host .tab-bar>ul>li.more-tab{position:relative}:host .tab-bar>ul>li.more-tab>a>span>.fa-chevron-down{font-size:10px;margin-left:10px}:host .tab-bar>ul>li.more-tab>a.expanded{color:#4e4e4e;background:#f2f2f2}:host .tab-bar>ul>li.more-tab .popover.face-bottom.pos-right::before{right:21px}:host .tab-bar>ul.justify{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important;border-bottom:5px solid #f2f2f2}:host .tab-bar.base-light>ul>li>a{border-bottom-color:#dedede}:host .tab-bar.base-light>ul>li>a.active,:host .tab-bar.base-light>ul>li>a:hover{background:#FFF}:host .tab-bar.base-light>ul.justify{border-bottom-color:#dedede}:host .tab-bar.base-dark>ul>li>a{color:#a7a7a7;border-bottom-color:#4e4e4e}:host .tab-bar.base-dark>ul>li>a.active,:host .tab-bar.base-dark>ul>li>a:hover{background:#4e4e4e;color:#FFF}:host .tab-bar.base-dark>ul>li.more-tab>a.expanded{color:#FFF}:host .tab-bar.base-dark>ul.justify{border-bottom-color:#4e4e4e}:host .tab-bar.align-left>ul{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}:host .tab-bar.align-right>ul{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}:host .tab-bar.align-center>ul{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}:host .tab-bar.check-tabs>ul>li:not(.more-tab)>a{padding-left:40px}:host .tab-bar.check-tabs>ul>li:not(.more-tab)>a::before,:host .tab-bar.check-tabs>ul>li:not(.more-tab)>a>i{display:inline-block;position:absolute;left:12px;top:8px;height:16px;width:16px;line-height:16px;text-align:center;border-radius:2px}:host .tab-bar.check-tabs>ul>li:not(.more-tab)>a::before{content:'';background:#FFF;border:1px solid #dedede;opacity:1;-webkit-transition:all .1s linear 0s;-o-transition:all .1s linear 0s;transition:all .1s linear 0s}:host .tab-bar.check-tabs>ul>li:not(.more-tab)>a>i{-webkit-transition:all .1s linear 0s;-o-transition:all .1s linear 0s;transition:all .1s linear 0s;font-size:0;opacity:0}:host .tab-bar.check-tabs>ul>li:not(.more-tab)>a.active>i{opacity:1;font-size:12px}:host .tab-bar.check-tabs>ul>li:not(.more-tab)>a.active::before{opacity:0}:host .tab-bar.check-tabs.base-dark>ul>li:not(.more-tab)>a::before{background:#383838;border-color:#383838}:host .tab-bar.contained{border-bottom:5px solid #e9e9e9;background:#FFF;padding:0 24px}:host .tab-bar.contained>ul{border-bottom:5px solid transparent}:host .tab-bar.contained>ul>li{padding-right:24px;margin-bottom:-10px}:host .tab-bar.contained>ul>li>a{padding:0;line-height:39.5px;height:42px;border-bottom-color:transparent}:host .tab-bar.contained>ul>li>a.active,:host .tab-bar.contained>ul>li>a:hover{background:0 0}:host .tab-bar.contained>ul>li>a:hover{border-bottom-color:#bdbdbd}:host .tab-bar.contained>ul>li.more-tab>a.expanded{border-bottom-color:#bdbdbd}:host .tab-bar.contained>ul>li:nth-last-child(2){padding-right:0}:host .tab-bar.contained>ul.justify{border-bottom:5px solid transparent}:host .tab-bar.contained.base-light{border-bottom-color:#dedede;background:#f2f2f2}:host .tab-bar.contained.base-light>ul>li>a{background:0 0}:host .tab-bar.contained.base-dark{border-bottom-color:#4e4e4e;background:#2d2d2d}:host .tab-bar.contained.base-dark>ul>li>a{background:#2d2d2d;border-bottom-color:#4e4e4e}:host .tab-bar.contained.check-tabs>ul>li:not(.more-tab)>a{padding-left:24px}:host .tab-bar.contained.check-tabs>ul>li:not(.more-tab)>a::before,:host .tab-bar.contained.check-tabs>ul>li:not(.more-tab)>a>i{left:0;top:10.5px}:host .tab-bar.contained.container-white{background:#FFF}:host .tab-bar.contained.container-light{background:#f2f2f2}:host .tab-bar.contained.container-dark{background:#2d2d2d}\n    "]
                },] },
    ];
    /** @nocollapse */
    UITabBarComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: ElementRef },
        { type: UIHelperService }
    ]; };
    UITabBarComponent.propDecorators = {
        uiTabBar: [{ type: Input }],
        change: [{ type: Output }],
        containerElement: [{ type: ViewChild, args: ['container',] }],
        checkState: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
    };
    return UITabBarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UITabBarModule = /** @class */ (function () {
    function UITabBarModule() {
    }
    UITabBarModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UITabBarComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        UIPopoverModule
                    ],
                    providers: [],
                    exports: [
                        UITabBarComponent
                    ]
                },] },
    ];
    return UITabBarModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UICodePanelModule = /** @class */ (function () {
    function UICodePanelModule() {
    }
    /**
     * @return {?}
     */
    UICodePanelModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: UICodePanelModule,
            providers: [
                HighlightJsService$1
            ]
        };
    };
    UICodePanelModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UICodePanelComponent
                    ],
                    imports: [
                        CommonModule,
                        ClipboardModule,
                        HighlightJsModule,
                        UITabBarModule
                    ],
                    providers: [],
                    exports: [
                        UICodePanelComponent
                    ]
                },] },
    ];
    return UICodePanelModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIHttpErrorComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     * Subscribes to route param changes.
     *
     * @param {ActivatedRoute} activatedRoute
     * @param {UISessionService} uiSessionService
     * @param {UIToastService} uiToastService
     * @param {UICookieStorageService} uiStorageService
     */
    function UIHttpErrorComponent(activatedRoute, uiSessionService, uiToastService, uiStorageService) {
        var _this = this;
        this.activatedRoute = activatedRoute;
        this.uiSessionService = uiSessionService;
        this.uiToastService = uiToastService;
        this.uiStorageService = uiStorageService;
        this.uiApp = this.uiSessionService.getItem('uiApp');
        this.logged = false;
        this.destroyed$ = new Subject();
        this.activatedRoute.params.pipe(takeUntil(this.destroyed$)).subscribe(function (params) {
            /** @type {?} */
            var statusCode = parseInt(params['status']);
            _this.currentError = _this.getError(statusCode);
            if (_this.currentError.log === 'always') {
                _this.onLog();
            }
        });
        this.uiSessionService.getSubject('uiApp').pipe(takeUntil(this.destroyed$)).subscribe(function (uiApp) {
            _this.uiApp = uiApp;
        });
    }
    /**
     * Gets current error based on status from route param.
     *
     * @param {string} status
     * @returns {UIError}
     */
    /**
     * Gets current error based on status from route param.
     *
     * @param {?} status
     * @return {?}
     */
    UIHttpErrorComponent.prototype.getError = /**
     * Gets current error based on status from route param.
     *
     * @param {?} status
     * @return {?}
     */
    function (status) {
        switch (status) {
            case 401:
                return {
                    status: status,
                    title: 'Unauthorised',
                    message: ['You\'re not authorised to view this resource.'],
                    log: 'ask',
                    showReload: false
                };
            case 403:
                return {
                    status: status,
                    title: 'Forbidden',
                    message: ['Access to that resource is not allowed.'],
                    log: 'ask',
                    showReload: false
                };
            case 404:
                return {
                    status: status,
                    title: 'Not Found',
                    message: ['The requested resource was not found.'],
                    log: 'ask',
                    showReload: false
                };
            case 429:
            case 502:
                return {
                    status: status,
                    title: 'High Traffic',
                    message: ['This app is currently experiencing a high amount of traffic, please try again later.', 'We apologise for any inconvenience and we hope to be back up and running as soon as possible.'],
                    log: 'always',
                    showReload: true
                };
            case 503:
                return {
                    status: status,
                    title: 'Under Maintenance',
                    message: ['This app is currently under maintenance.', 'We apologise for any inconvenience and we hope to be back up and running as soon as possible.'],
                    log: 'always',
                    showReload: true
                };
            default:
                return {
                    status: status,
                    title: 'Something went wrong',
                    message: ['We\'re sorry, there was a problem with our service.', 'We have automatically sent an error report so that we can investigate. Apologies for any inconvenience.'],
                    log: 'always',
                    showReload: true
                };
        }
    };
    /**
     * Checks if body is scrolling.
     *
     * @returns {boolean}
     */
    /**
     * Checks if body is scrolling.
     *
     * @return {?}
     */
    UIHttpErrorComponent.prototype.isBodyScrolling = /**
     * Checks if body is scrolling.
     *
     * @return {?}
     */
    function () {
        return this.errorBody.nativeElement.scrollHeight > this.errorBody.nativeElement.clientHeight;
    };
    /**
     * Logs error to bugsnag.
     */
    /**
     * Logs error to bugsnag.
     * @return {?}
     */
    UIHttpErrorComponent.prototype.onLog = /**
     * Logs error to bugsnag.
     * @return {?}
     */
    function () {
        try {
            if (this.uiApp.environment.bugsnagKey) {
                /** @type {?} */
                var bugsnagClient = bugsnag({
                    apiKey: this.uiApp.environment.bugsnagKey,
                    releaseStage: this.uiApp.environment.name,
                    appVersion: this.uiApp.environment.name
                });
                /** @type {?} */
                var subdomain = this.uiApp.environment.subDomain;
                /** @type {?} */
                var me = this.uiSessionService.getItem('me') || null;
                /** @type {?} */
                var dealer = this.uiSessionService.getItem('dealer') || null;
                /** @type {?} */
                var token = this.uiStorageService.getItem('token') || null;
                /** @type {?} */
                var httpErrorResponse = this.uiSessionService.getItem('httpErrorResponse') || null;
                /** @type {?} */
                var httpErrorLocation = this.uiSessionService.getItem('httpErrorLocation') || null;
                /** @type {?} */
                var httpErrorRequest = this.uiSessionService.getItem('httpErrorRequest') || null;
                this.uiSessionService.removeItems(['httpErrorResponse', 'httpErrorLocation', 'httpErrorRequest']);
                /** @type {?} */
                var body = {
                    status: this.currentError.status,
                    subdomain: subdomain,
                    user: me,
                    dealer: dealer,
                    token: token,
                    cookiesSupported: this.uiStorageService.supportsCS,
                    localStorageSupported: this.uiStorageService.supportsLS,
                    httpErrorResponse: httpErrorResponse,
                    httpErrorLocation: httpErrorLocation,
                    httpErrorRequest: httpErrorRequest
                };
                bugsnagClient.notify(new Error('Handled error: ' + this.currentError.title), { metaData: body });
                this.logged = true;
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    /**
     * Reloads current location.
     */
    /**
     * Reloads current location.
     * @return {?}
     */
    UIHttpErrorComponent.prototype.onReload = /**
     * Reloads current location.
     * @return {?}
     */
    function () {
        location.reload();
    };
    /**
     * Destroys component and any active subscriptions.
     */
    /**
     * Destroys component and any active subscriptions.
     * @return {?}
     */
    UIHttpErrorComponent.prototype.ngOnDestroy = /**
     * Destroys component and any active subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
    };
    UIHttpErrorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-http-error',
                    template: "\n      <!--  OVERLAY  -->\n\n      <div class=\"error-overlay\"></div>\n\n      <!--  END OVERLAY  -->\n\n      <!--  ERROR FRAME  -->\n\n      <div class=\"error-frame\">\n\n          <!--  ERROR HEADER  -->\n\n          <div class=\"error-frame-header\">\n              <h2>{{currentError.title}}</h2>\n          </div>\n\n          <!-- END ERROR HEADER  -->\n\n          <!--  ERROR BODY  -->\n\n          <div #errorBody class=\"error-frame-body written-content\" [class.is-scrolling]=\"isBodyScrolling()\" [class.has-footer]=\"currentError.showReload || (currentError.log === 'ask' && uiApp)\">\n\n              <!--  ERROR MESSAGES LOOP  -->\n\n              <p *ngFor=\"let message of currentError.message; let index = index\">\n                  <strong *ngIf=\"index === 0\">{{message}}</strong>\n                  <span *ngIf=\"index !== 0\">{{message}}</span>\n              </p>\n\n              <!--  END ERROR MESSAGES LOOP  -->\n\n              <!--  REPORT MESSAGE  -->\n\n              <p *ngIf=\"currentError.log === 'ask' && uiApp\">If you believe this to be incorrect please report the issue by clicking below and we'll look into it.</p>\n\n              <!--  END REPORT MESSAGE  -->\n\n          </div>\n\n          <!--  END ERROR BODY  -->\n\n          <!--  ERROR FOOTER  -->\n\n          <div *ngIf=\"currentError.showReload || (currentError.log === 'ask' && uiApp)\" class=\"error-frame-footer\">\n\n              <!--  RELOAD BUTTON  -->\n\n              <a *ngIf=\"currentError.showReload\" class=\"button primary-button\" (click)=\"onReload()\">Reload Page</a>\n\n              <!--  END RELOAD BUTTON  -->\n\n              <!--  REPORT BUTTON  -->\n\n              <a *ngIf=\"currentError.log === 'ask' && uiApp && !logged\" class=\"button primary-button\" (click)=\"onLog()\">Send Report</a>\n\n              <!--  END REPORT BUTTON  -->\n\n              <!--  REPORTED MESSAGE  -->\n\n              <div *ngIf=\"currentError.log === 'ask' && uiApp && logged\" class=\"icon-status\"><i class=\"far fa-check pos-bg pos-fg-col\"></i> Thanks for sending your report!</div>\n\n              <!--  END REPORTED MESSAGE  -->\n\n          </div>\n\n          <!--  END ERROR FOOTER  -->\n\n      </div>\n\n      <!--  END ERROR FRAME  -->\n    ",
                    styles: ["\n      :host .error-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:#d3d3d3;z-index:99999999}:host .error-frame{position:fixed;background:#FFF;z-index:100000000;top:50%;left:50%;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.3);box-shadow:0 1px 3px rgba(0,0,0,.3);width:calc(100% - 64px);max-width:510px;border-radius:3px;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;opacity:1;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}:host .error-frame .error-frame-header{padding:16px 24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}:host .error-frame .error-frame-header h2{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;line-height:32px}:host .error-frame .error-frame-body{padding:0 24px 24px;max-height:calc(100vh - 128px);overflow-y:auto}:host .error-frame .error-frame-body.is-scrolling{border-top:5px solid #f2f2f2;padding-top:24px;max-height:calc(100vh - 133px)}:host .error-frame .error-frame-body.has-footer{padding-bottom:0;max-height:calc(100vh - 192px)}:host .error-frame .error-frame-body.has-footer.is-scrolling{border-bottom:5px solid #f2f2f2;padding-bottom:24px;max-height:calc(100vh - 197px)}:host .error-frame .error-frame-footer{font-size:0;height:64px;padding:16px 24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}:host .error-frame .error-frame-footer>*{margin:0 8px}:host .error-frame .error-frame-footer>:first-child{margin-left:0}:host .error-frame .error-frame-footer>:last-child{margin-right:0}@media screen and (max-width:574px){:host .error-frame{width:calc(100% - 48px)}:host .error-frame .error-frame-header{padding:8px 16px}:host .error-frame .error-frame-header h2{font-size:16px}:host .error-frame .error-frame-body{padding:0 16px 16px;max-height:calc(100vh - 96px)}:host .error-frame .error-frame-body.is-scrolling{padding-top:16px;max-height:calc(100vh - 101px)}:host .error-frame .error-frame-body.has-footer{max-height:calc(100vh - 160px)}:host .error-frame .error-frame-body.has-footer.is-scrolling{max-height:calc(100vh - 165px)}:host .error-frame .error-frame-footer{padding:16px}}@media screen and (max-width:374px){:host .error-frame{width:calc(100% - 16px)}:host .error-frame .error-frame-body{max-height:calc(100vh - 64px)}:host .error-frame .error-frame-body.is-scrolling{max-height:calc(100vh - 69px)}:host .error-frame .error-frame-body.has-footer{max-height:calc(100vh - 128px)}:host .error-frame .error-frame-body.has-footer.is-scrolling{max-height:calc(100vh - 133px)}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIHttpErrorComponent.ctorParameters = function () { return [
        { type: ActivatedRoute },
        { type: UISessionService },
        { type: UIToastService },
        { type: UIStorageService }
    ]; };
    UIHttpErrorComponent.propDecorators = {
        errorBody: [{ type: ViewChild, args: ['errorBody',] }],
        isBodyScrolling: [{ type: HostListener, args: ['window:resize',] }]
    };
    return UIHttpErrorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIFooterComponent = /** @class */ (function () {
    function UIFooterComponent() {
    }
    /**
     * Handles link button click.
     *
     * @param {UIActionLinkButton} uiActionLinkButton
     */
    /**
     * Handles link button click.
     *
     * @param {?} uiActionLinkButton
     * @return {?}
     */
    UIFooterComponent.prototype.onLinkButtonClick = /**
     * Handles link button click.
     *
     * @param {?} uiActionLinkButton
     * @return {?}
     */
    function (uiActionLinkButton) {
        uiActionLinkButton.click(uiActionLinkButton);
    };
    UIFooterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-footer',
                    template: "\n      <!--  FOOTER  -->\n\n      <div *ngIf=\"links\" class=\"footer\">\n\n          <ul>\n\n              <!--  LINK LOOP  -->\n\n              <li *ngFor=\"let link of links\">\n\n                  <!--  ANCHOR LINK  -->\n\n                  <a *ngIf=\"link.type === 'anchorLink'\" [attr.href]=\"link.href\" [attr.target]=\"link.target\">{{ link.text }}</a>\n\n                  <!--  END ANCHOR LINK  -->\n\n                  <!--  LINK BUTTON  -->\n\n                  <a *ngIf=\"link.type === 'linkButton'\" (click)=\"onLinkButtonClick(link)\">{{ link.text }}</a>\n\n                  <!--  END LINK BUTTON -->\n\n                  <!--  ROUTER LINK -->\n\n                  <a *ngIf=\"link.type === 'routerLink'\" [routerLink]=\"link.navigateTo\" [routerLinkActive]=\"'active'\">{{ link.text }}</a>\n\n                  <!--  END ROUTER LINK -->\n\n              </li>\n\n              <!--  END LINK LOOP  -->\n\n          </ul>\n\n      </div>\n\n      <!--  END FOOTER  -->\n    ",
                    styles: ["\n      :host .footer{height:58px;border-top:5px solid #f2f2f2;margin:0 32px}:host .footer>ul{display:-webkit-box;display:-ms-flexbox;display:flex;height:48px;font-size:11px}:host .footer>ul>li{line-height:48px;margin:0 12px}:host .footer>ul>li>a{color:#bdbdbd;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s}:host .footer>ul>li>a.active,:host .footer>ul>li>a:hover{color:#4e4e4e}:host .footer>ul>li:first-child{margin-left:0}:host .footer>ul>li:last-child{margin-right:0}@media screen and (max-width:1174px){:host .footer{margin:0 24px}}@media screen and (max-width:774px){:host .footer{margin:0 16px}:host .footer>ul{font-size:10px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}\n    "]
                },] },
    ];
    UIFooterComponent.propDecorators = {
        links: [{ type: Input }]
    };
    return UIFooterComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIErrorComponent = /** @class */ (function () {
    function UIErrorComponent() {
    }
    /**
     * Checks if body is scrolling.
     *
     * @returns {boolean}
     */
    /**
     * Checks if body is scrolling.
     *
     * @return {?}
     */
    UIErrorComponent.prototype.isBodyScrolling = /**
     * Checks if body is scrolling.
     *
     * @return {?}
     */
    function () {
        return this.errorBody.nativeElement.scrollHeight > this.errorBody.nativeElement.clientHeight;
    };
    /**
     * Reloads currently active route.
     */
    /**
     * Reloads currently active route.
     * @return {?}
     */
    UIErrorComponent.prototype.onReload = /**
     * Reloads currently active route.
     * @return {?}
     */
    function () {
        location.reload();
    };
    UIErrorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-error',
                    template: "\n      <!--  ERROR OVERLAY  -->\n\n      <div class=\"error-overlay\"></div>\n\n      <!-- END ERROR OVERLAY  -->\n\n      <!--  ERROR FRAME  -->\n\n      <div class=\"error-frame\">\n\n          <!--  ERROR HEADER  -->\n\n          <div class=\"error-frame-header\">\n              <h2>Something went wrong</h2>\n          </div>\n\n          <!--  END ERROR HEADER  -->\n\n          <!--  ERROR BODY  -->\n\n          <div #errorBody class=\"error-frame-body has-footer written-content\" [class.is-scrolling]=\"isBodyScrolling()\">\n\n              <!--  MESSAGES  -->\n\n              <p><strong>We're sorry, there was a problem with our service.</strong></p>\n              <p>We have automatically sent an error report so that we can investigate. Apologies for any inconvenience.</p>\n\n              <!--  END MESSAGES  -->\n\n          </div>\n\n          <!--  END ERROR BODY  -->\n\n          <!--  ERROR FOOTER  -->\n\n          <div class=\"error-frame-footer\">\n\n              <!--  RELOAD BUTTON  -->\n\n              <a class=\"button primary-button\" (click)=\"onReload()\">Reload Page</a>\n\n              <!--  END RELOAD BUTTON  -->\n\n          </div>\n\n          <!--  END ERROR FOOTER  -->\n      </div>\n\n      <!--  END ERROR FRAME  -->\n    ",
                    styles: ["\n      :host .error-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:#d3d3d3;z-index:99999999}:host .error-frame{position:fixed;background:#FFF;z-index:100000000;top:50%;left:50%;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.3);box-shadow:0 1px 3px rgba(0,0,0,.3);width:calc(100% - 64px);max-width:510px;border-radius:3px;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;opacity:1;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}:host .error-frame .error-frame-header{padding:16px 24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}:host .error-frame .error-frame-header h2{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;line-height:32px}:host .error-frame .error-frame-body{padding:0 24px 24px;max-height:calc(100vh - 128px);overflow-y:auto}:host .error-frame .error-frame-body.is-scrolling{border-top:5px solid #f2f2f2;padding-top:24px;max-height:calc(100vh - 133px)}:host .error-frame .error-frame-body.has-footer{padding-bottom:0;max-height:calc(100vh - 192px)}:host .error-frame .error-frame-body.has-footer.is-scrolling{border-bottom:5px solid #f2f2f2;padding-bottom:24px;max-height:calc(100vh - 197px)}:host .error-frame .error-frame-footer{font-size:0;height:64px;padding:16px 24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}:host .error-frame .error-frame-footer>*{margin:0 8px}:host .error-frame .error-frame-footer>:first-child{margin-left:0}:host .error-frame .error-frame-footer>:last-child{margin-right:0}@media screen and (max-width:574px){:host .error-frame{width:calc(100% - 48px)}:host .error-frame .error-frame-header{padding:8px 16px}:host .error-frame .error-frame-header h2{font-size:16px}:host .error-frame .error-frame-body{padding:0 16px 16px;max-height:calc(100vh - 96px)}:host .error-frame .error-frame-body.is-scrolling{padding-top:16px;max-height:calc(100vh - 101px)}:host .error-frame .error-frame-body.has-footer{max-height:calc(100vh - 160px)}:host .error-frame .error-frame-body.has-footer.is-scrolling{max-height:calc(100vh - 165px)}:host .error-frame .error-frame-footer{padding:16px}}@media screen and (max-width:374px){:host .error-frame{width:calc(100% - 16px)}:host .error-frame .error-frame-body{max-height:calc(100vh - 64px)}:host .error-frame .error-frame-body.is-scrolling{max-height:calc(100vh - 69px)}:host .error-frame .error-frame-body.has-footer{max-height:calc(100vh - 128px)}:host .error-frame .error-frame-body.has-footer.is-scrolling{max-height:calc(100vh - 133px)}}:host .overlay{z-index:100000001}:host .error-frame{z-index:100000002}\n    "]
                },] },
    ];
    UIErrorComponent.propDecorators = {
        errorBody: [{ type: ViewChild, args: ['errorBody',] }],
        isBodyScrolling: [{ type: HostListener, args: ['window:resize',] }]
    };
    return UIErrorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIStartComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Router} router
     * @param {ActivatedRoute} activatedRoute
     * @param {UIStorageService} uiStorageService
     */
    function UIStartComponent(router, activatedRoute, uiStorageService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.uiStorageService = uiStorageService;
        this.destroyed$ = new Subject();
    }
    /**
     * Lifecycle hook: Subscribes to router params and handles sso and redirect.
     */
    /**
     * Lifecycle hook: Subscribes to router params and handles sso and redirect.
     * @return {?}
     */
    UIStartComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Subscribes to router params and handles sso and redirect.
     * @return {?}
     */
    function () {
        var _this = this;
        this.activatedRoute.queryParams.pipe(takeUntil(this.destroyed$)).subscribe(function (queryParams) {
            if (queryParams['token']) {
                _this.uiStorageService.setItem('token', queryParams['token']);
            }
            if (queryParams['redirect']) {
                _this.router.navigate([queryParams['redirect']]);
            }
        });
    };
    /**
     * Lifecycle hook: Destroys any open subscriptions.
     */
    /**
     * Lifecycle hook: Destroys any open subscriptions.
     * @return {?}
     */
    UIStartComponent.prototype.ngOnDestroy = /**
     * Lifecycle hook: Destroys any open subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
    };
    UIStartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-start-component',
                    template: ''
                },] },
    ];
    /** @nocollapse */
    UIStartComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: UIStorageService }
    ]; };
    return UIStartComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UINavComponent = /** @class */ (function () {
    /**
     * Constructs component and injects dependencies.
     *
     * @param {Router} router
     * @param {UIModalService} uiModalService
     * @param {UISessionService} uiSessionService
     * @param {UIResponsiveService} uiResponsiveService
     * @param {UILayoutConfigService} uiLayoutConfigService
     * @param {UIThemeService} uiThemeService
     */
    function UINavComponent(router, uiModalService, uiSessionService, uiResponsiveService, uiLayoutConfigService, uiThemeService) {
        var _this = this;
        this.router = router;
        this.uiModalService = uiModalService;
        this.uiSessionService = uiSessionService;
        this.uiResponsiveService = uiResponsiveService;
        this.uiLayoutConfigService = uiLayoutConfigService;
        this.uiThemeService = uiThemeService;
        this.uiApp = this.uiSessionService.getItem('uiApp');
        this.uiAppModule = this.uiSessionService.getItem('uiAppModule');
        this.me = this.uiSessionService.getItem('me');
        this.logoFailedToLoad = false;
        this.totalBadge = this.getTotalBadge();
        this.uiLayoutConfig = this.uiSessionService.getItem('uiLayoutConfig');
        this.destroyed$ = new Subject();
        this.setTooltipConfig();
        this.uiSessionService.getSubject('uiApp').pipe(takeUntil(this.destroyed$)).subscribe(function (uiApp) {
            _this.uiApp = uiApp;
            _this.totalBadge = _this.getTotalBadge();
        });
        this.uiSessionService.getSubject('uiAppModule').pipe(takeUntil(this.destroyed$)).subscribe(function (uiAppModule) {
            _this.uiAppModule = uiAppModule;
            _this.checkForExpandedNavItems();
        });
        this.uiSessionService.getSubject('title').pipe(takeUntil(this.destroyed$)).subscribe(function (title) {
            _this.viewTitle = title;
        });
        this.uiSessionService.getSubject('me').pipe(takeUntil(this.destroyed$)).subscribe(function (me) {
            _this.me = me;
        });
        this.uiSessionService.getSubject('uiLayoutConfig').pipe(takeUntil(this.destroyed$)).subscribe(function (uiLayoutConfig) {
            _this.uiLayoutConfig = uiLayoutConfig;
        });
    }
    /**
     * Checks items for active children, then expands parent automatically.
     */
    /**
     * Checks items for active children, then expands parent automatically.
     * @return {?}
     */
    UINavComponent.prototype.checkForExpandedNavItems = /**
     * Checks items for active children, then expands parent automatically.
     * @return {?}
     */
    function () {
        for (var _i = 0, _a = this.getItemsWithChildren(); _i < _a.length; _i++) {
            var navItem = _a[_i];
            for (var _b = 0, _c = navItem.children; _b < _c.length; _b++) {
                var subNavItem = _c[_b];
                if (this.router.isActive('/' + this.uiAppModule.path + '/' + navItem.path + '/' + subNavItem.path, false)) {
                    navItem.expanded = true;
                    return;
                }
            }
        }
    };
    /**
     * Filters out only the uiSideNavItems with children
     *
     * @returns {UINavItem[]}
     */
    /**
     * Filters out only the uiSideNavItems with children
     *
     * @return {?}
     */
    UINavComponent.prototype.getItemsWithChildren = /**
     * Filters out only the uiSideNavItems with children
     *
     * @return {?}
     */
    function () {
        return this.uiAppModule.navItems.filter(function (navItem) {
            return navItem.children;
        });
    };
    /**
     * Sets the tooltip uiAppModule for the main nav uiSideNavItems. Watches for screen size
     * changes to determine the tooltip position.
     */
    /**
     * Sets the tooltip uiAppModule for the main nav uiSideNavItems. Watches for screen size
     * changes to determine the tooltip position.
     * @return {?}
     */
    UINavComponent.prototype.setTooltipConfig = /**
     * Sets the tooltip uiAppModule for the main nav uiSideNavItems. Watches for screen size
     * changes to determine the tooltip position.
     * @return {?}
     */
    function () {
        /** @type {?} */
        var placement = 'right';
        if (this.uiApp.navPosition === 'top' && this.uiResponsiveService.screenIsGTE('md3') ||
            this.uiResponsiveService.screenIs(['md1', 'md2'])) {
            placement = 'bottom';
        }
        this.mainNavTooltip = new UITooltip({
            placement: placement,
            offset: 18,
            size: 'large'
        });
    };
    /**
     * @return {?}
     */
    UINavComponent.prototype.getTotalBadge = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var itemsWithBadges = this.uiApp.mainNavItems.filter(function (uiMainMavItem) {
            return !!uiMainMavItem.badge;
        });
        if (itemsWithBadges.length < 1) {
            return { exists: false };
        }
        /** @type {?} */
        var badgeTheme = itemsWithBadges[0].badge.theme;
        /** @type {?} */
        var totalValue = itemsWithBadges.map(function (uiMainNavItem) {
            return uiMainNavItem.badge.value;
        }).reduce(function (accumulated, current) {
            return accumulated + current;
        });
        return {
            exists: true,
            cssClass: this.uiThemeService.buildCssClass(badgeTheme, 'bg') + ' ' + this.uiThemeService.buildCssClass(badgeTheme, 'col', 'fg'),
            value: totalValue
        };
    };
    /**
     * Called when key main nav item is clicked. Event should determine which
     * item was clicked.
     *
     * @param {string} event
     */
    /**
     * Called when key main nav item is clicked. Event should determine which
     * item was clicked.
     *
     * @param {?} event
     * @return {?}
     */
    UINavComponent.prototype.onKeyNavItemClick = /**
     * Called when key main nav item is clicked. Event should determine which
     * item was clicked.
     *
     * @param {?} event
     * @return {?}
     */
    function (event) {
        switch (event) {
            case 'switch-modules':
                this.uiModalService.show(['module-switcher'], null, false);
                break;
            case 'search':
                this.uiModalService.show(['search'], null, false);
                break;
            case 'user-account':
                this.uiModalService.show(['user-account', 'user-account'], null, false);
                break;
        }
    };
    /**
     * Called when main nav item is clicked. Event should determine which
     * item was clicked.
     *
     * @param {UIMainNavItem} uiMainNavItem
     */
    /**
     * Called when main nav item is clicked. Event should determine which
     * item was clicked.
     *
     * @param {?} uiMainNavItem
     * @return {?}
     */
    UINavComponent.prototype.onMainNavItemClick = /**
     * Called when main nav item is clicked. Event should determine which
     * item was clicked.
     *
     * @param {?} uiMainNavItem
     * @return {?}
     */
    function (uiMainNavItem) {
        uiMainNavItem.click();
    };
    /**
     * Shows dealer switcher modal.
     */
    /**
     * Shows dealer switcher modal.
     * @return {?}
     */
    UINavComponent.prototype.onSwitchDealerClick = /**
     * Shows dealer switcher modal.
     * @return {?}
     */
    function () {
        this.uiModalService.show(['user-account', 'dealer-switcher'], null, false);
    };
    /**
     * Shows menu on smaller screens.
     */
    /**
     * Shows menu on smaller screens.
     * @return {?}
     */
    UINavComponent.prototype.onExpandNav = /**
     * Shows menu on smaller screens.
     * @return {?}
     */
    function () {
        this.uiLayoutConfigService.setProperty('navExpanded', true);
    };
    /**
     * @return {?}
     */
    UINavComponent.prototype.onCollapseNav = /**
     * @return {?}
     */
    function () {
        this.uiLayoutConfigService.setProperty('navExpanded', false);
    };
    /**
     * Called when component is destroyed. Invalidates all open subscriptions.
     */
    /**
     * Called when component is destroyed. Invalidates all open subscriptions.
     * @return {?}
     */
    UINavComponent.prototype.ngOnDestroy = /**
     * Called when component is destroyed. Invalidates all open subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
    };
    UINavComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-nav',
                    template: "\n      <!--  TITLE BAR  -->\n\n      <div class=\"title-bar head-bg\">\n\n          <!--  BACK ICON  -->\n\n          <a *ngIf=\"uiLayoutConfig.hasViewTakeover && !!uiLayoutConfig.viewTakeoverBackPath\" class=\"icon-button head-fg-col head-mix-hov-bg\" [routerLink]=\"uiLayoutConfig.viewTakeoverBackPath\">\n              <i class=\"fas fa-arrow-left\"></i>\n          </a>\n\n          <!--  END BURGER ICON  -->\n\n          <!--  BURGER ICON  -->\n\n          <a class=\"icon-button head-fg-col head-mix-hov-bg\" (click)=\"onExpandNav()\">\n              <i class=\"fas fa-bars\"></i>\n              <span *ngIf=\"totalBadge.exists\" class=\"badge\" [ngClass]=\"totalBadge.cssClass\">{{ totalBadge.value | uiMaxNumber:99 }}</span>\n          </a>\n\n          <!--  END BURGER ICON  -->\n\n          <!--  TITLE  -->\n\n          <h2 class=\"view-title head-fg-col\">{{ viewTitle }}</h2>\n\n          <!--  END TITLE  -->\n\n      </div>\n\n      <!--  END TITLE BAR  -->\n\n      <!--  NAV CONTAINER  -->\n\n      <div class=\"nav-container\"\n           [class.expanded]=\"!!uiLayoutConfig.navExpanded\"\n           [class.top-nav]=\"uiApp.navPosition === 'top'\"\n           [class.consumer]=\"uiApp.audience === 'consumer'\"\n           [class.has-module-nav]=\"uiAppModule.hasModuleNav && uiLayoutConfig?.hasViewTakeover !== true\">\n\n          <!--  MAIN NAV  -->\n\n          <div class=\"main-nav head-bg\">\n              <nav>\n                  <ul>\n\n                      <!--  HOME ICON  -->\n\n                      <li *ngIf=\"uiApp.audience !== 'consumer'\" class=\"home\">\n                          <a class=\"icon-button acc-bg acc-hov-bg acc-fg-col\"\n                             [routerLink]=\"['/']\"\n                             [uiTooltipText]=\"'Home'\"\n                             [uiTooltipConfig]=\"mainNavTooltip\"\n                             (click)=\"onCollapseNav()\">\n                              <i class=\"icon-click-dealer\"></i>\n                          </a>\n                      </li>\n\n                      <!-- END HOME ICON  -->\n\n                      <!--  LOGO  -->\n\n                      <li *ngIf=\"uiApp.audience === 'consumer'\" class=\"logo\" [class.failed-to-load]=\"logoFailedToLoad || !uiApp.logoUrl\">\n                          <a class=\"head-fg-col\"\n                             [routerLink]=\"['/' + uiAppModule?.path]\"\n                             [uiTooltipText]=\"'Home'\"\n                             [uiTooltipConfig]=\"mainNavTooltip\"\n                             (click)=\"onCollapseNav()\">\n                              <img *ngIf=\"uiApp.logoUrl\" [src]=\"uiApp.logoUrl\" [alt]=\"uiApp.name\" (error)=\"logoFailedToLoad = true\">\n                              <span class=\"collection-name\">{{ uiApp.name }}</span>\n                              <span class=\"collection-acronym pri-bg pri-fg-col\" [class.trio]=\"uiApp.acronym.length === 3\">{{uiApp.acronym}}</span>\n                          </a>\n                      </li>\n\n                      <!--  END LOGO  -->\n\n                      <!--  SPACER - KEY ICONS WITH MENU ITEMS  -->\n\n                      <li *ngIf=\"uiApp.keyItemsPosition === 'withMenuItems'\" class=\"spacer\"></li>\n\n                      <!--  END SPACER - KEY ICONS WITH MENU ITEMS  -->\n\n                      <!--  MODULE SWITCHER  -->\n\n                      <li *ngIf=\"uiApp.showModuleSwitcher\">\n                          <a class=\"icon-button head-mix-hov-bg\"\n                             [uiTooltipText]=\"'Go to...'\"\n                             [uiTooltipConfig]=\"mainNavTooltip\"\n                             (click)=\"onKeyNavItemClick('switch-modules')\">\n                              <i class=\"fas fa-th head-fg-col\"></i>\n                          </a>\n                      </li>\n\n                      <!--  END MODULE SWITCHER  -->\n\n                      <!--  SEARCH  -->\n\n                      <li *ngIf=\"uiApp.showSearch\">\n                          <a class=\"icon-button head-mix-hov-bg\"\n                             [uiTooltipText]=\"'Search'\"\n                             [uiTooltipConfig]=\"mainNavTooltip\"\n                             (click)=\"onKeyNavItemClick('search')\">\n                              <i class=\"fas fa-search head-fg-col\"></i>\n                          </a>\n                      </li>\n\n                      <!--  END SEARCH  -->\n\n                      <!--  SPACER - KEY ICONS FIRST  -->\n\n                      <li *ngIf=\"uiApp.keyItemsPosition === 'default'\" class=\"spacer\"></li>\n\n                      <!--  END SPACER - KEY ICONS FIRST  -->\n\n\n                      <!--  ICONS LOOP  -->\n\n                      <li *ngFor=\"let mainNavItem of uiApp.mainNavItems\">\n                          <a class=\"icon-button head-mix-hov-bg\"\n                             [class.has-badge]=\"!!mainNavItem.badge\"\n                             [uiTooltipText]=\"mainNavItem.tooltipText\"\n                             [uiTooltipConfig]=\"mainNavTooltip\"\n                             (click)=\"onMainNavItemClick(mainNavItem)\">\n                              <i class=\"head-fg-col\" [ngClass]=\"mainNavItem.icon\"></i>\n                              <span *ngIf=\"mainNavItem.badge\"\n                                    class=\"badge\"\n                                    [ngClass]=\"[uiThemeService.buildCssClass(mainNavItem.badge.theme, 'bg'), uiThemeService.buildCssClass(mainNavItem.badge.theme, 'col', 'fg')]\">\n                                  {{ mainNavItem.badge.value | uiMaxNumber:99 }}\n                              </span>\n                          </a>\n                      </li>\n\n                      <!--  END ICONS LOOP  -->\n\n                      <!--  DEALER SWITCHER  -->\n\n                      <li *ngIf=\"uiApp.audience !== 'consumer' && me && me.multi_dealer\" class=\"dealer-switcher hidden-sm1 hidden-sm2 hidden-sm3\">\n                          <a class=\"head-mix-hov-bg\"\n                             [uiTooltipText]=\"'Switch Dealer...'\"\n                             [uiTooltipConfig]=\"mainNavTooltip\"\n                             (click)=\"onSwitchDealerClick()\">\n                              <i class=\"fas fa-building head-fg-col\"></i>\n                              <span class=\"head-fg-col\">{{ me.current_dealer.brand_name }}</span>\n                          </a>\n                      </li>\n\n                      <li *ngIf=\"uiApp.audience !== 'consumer' && me && me.multi_dealer\" class=\"visible-sm1 visible-sm2 visible-sm3\">\n                          <a class=\"icon-button head-mix-hov-bg\"\n                             [uiTooltipText]=\"'Switch Dealer...'\"\n                             [uiTooltipConfig]=\"mainNavTooltip\"\n                             (click)=\"onSwitchDealerClick()\">\n                              <i class=\"fas fa-building head-fg-col\"></i>\n                          </a>\n                      </li>\n\n                      <!--  END DEALER SWITCHER  -->\n\n                      <!--  USER ACCOUNT  -->\n\n                      <li *ngIf=\"uiApp.showUserAccount && me\">\n\n                          <!--  ACCOUNT ICON  -->\n\n                          <a *ngIf=\"!me.avatar_path\" class=\"icon-button head-mix-hov-bg\"\n                             [uiTooltipText]=\"'Account'\"\n                             [uiTooltipConfig]=\"mainNavTooltip\"\n                             (click)=\"onKeyNavItemClick('user-account')\">\n                              <i class=\"fas fa-user head-fg-col\"></i>\n                          </a>\n\n                          <!--  END ACCOUNT ICON  -->\n\n                          <!--  USER AVATAR  -->\n\n                          <a *ngIf=\"!!me.avatar_path\" class=\"avatar\"\n                             [uiTooltipText]=\"'Account'\"\n                             [uiTooltipConfig]=\"mainNavTooltip\"\n                             (click)=\"onKeyNavItemClick('user-account')\">\n                              <img [src]=\"me.avatar_path\" [alt]=\"me.full_name\">\n                          </a>\n\n                          <!-- END USER AVATAR  -->\n\n                      </li>\n\n                      <!--  END USER ACCOUNT  -->\n\n                  </ul>\n              </nav>\n          </div>\n\n          <!--  END MAIN NAV  -->\n\n          <!--  MODULE NAV  -->\n\n          <div *ngIf=\"uiAppModule?.hasModuleNav && uiLayoutConfig?.hasViewTakeover !== true\" class=\"module-nav\">\n\n              <!--  MODULE NAV HEADING  -->\n\n              <div class=\"module-nav-header\">\n                  <h1>{{uiAppModule?.name}}</h1>\n                  <a class=\"icon-button\" (click)=\"onCollapseNav()\">\n                      <i class=\"far fa-times\"></i>\n                  </a>\n              </div>\n\n              <!--  END MODULE NAV HEADING  -->\n\n              <!--  MODULE NAV ITEMS  -->\n\n              <nav *ngIf=\"uiAppModule?.navItems !== null && uiAppModule?.navItems.length > 0\">\n\n                  <ui-nav-list [navItems]=\"uiAppModule?.navItems\" [parentPath]=\"uiAppModule?.path\" (navigation)=\"onCollapseNav()\"></ui-nav-list>\n\n              </nav>\n\n              <!--  END MODULE NAV ITEMS  -->\n\n          </div>\n\n          <!--  END MODULE NAV  -->\n\n      </div>\n\n      <!--  END NAV CONTAINER  -->\n\n      <!--  OVERLAY  -->\n\n      <div class=\"overlay\" [class.show]=\"!!uiLayoutConfig.navExpanded\" (click)=\"onCollapseNav()\"></div>\n\n      <!--  END OVERLAY  -->\n    ",
                    styles: ["\n      .mx-top-nav .main-nav{bottom:auto;right:0;width:auto;height:48px}.mx-top-nav .main-nav>nav>ul{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:auto;top:8px;bottom:8px;left:16px;right:16px}.mx-top-nav .main-nav>nav>ul>li{margin-bottom:0;margin-right:16px}.mx-top-nav .main-nav>nav>ul>li:first-child,.mx-top-nav .main-nav>nav>ul>li:nth-child(2){margin-bottom:0}.mx-top-nav .main-nav>nav>ul>li:last-child{margin-right:0}.mx-top-nav .main-nav>nav>ul>li.separator{margin-right:0;margin-top:0;margin-left:-8px}.mx-top-nav .main-nav>nav>ul>li.separator::after{height:16px;width:1px;margin:8px 16px}.mx-top-nav .module-nav{top:48px;left:0}.mx-top-nav.consumer .main-nav{height:64px}.mx-top-nav.consumer .main-nav>nav>ul>li>a.icon-button{width:41.6px;height:41.6px;font-size:20.8px;padding:10.4px}.mx-top-nav.consumer .main-nav:not(.has-module-nav) .module-nav{display:none}.mx-top-nav.consumer .module-nav{top:64px}.mx-badge{position:absolute;top:-2px;right:-2px}:host .title-bar{display:none}:host .nav-container .main-nav{display:block;position:fixed;background:#222;top:0;left:0;bottom:0;right:auto;width:48px;padding:8px;z-index:8000;height:auto}:host .nav-container .main-nav>nav>ul{width:32px;position:absolute;top:21px;bottom:21px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}:host .nav-container .main-nav>nav>ul>li{margin-bottom:8px}:host .nav-container .main-nav>nav>ul>li>a{color:#FFF;position:relative}:host .nav-container .main-nav>nav>ul>li>a>i{opacity:.7}:host .nav-container .main-nav>nav>ul>li>a>.badge{position:absolute;top:-2px;right:-2px}:host .nav-container .main-nav>nav>ul>li>a:hover{background:#4e4e4e}:host .nav-container .main-nav>nav>ul>li>a:hover>i{opacity:1}:host .nav-container .main-nav>nav>ul>li>a.avatar{position:relative;height:32px;width:32px;opacity:1;border-radius:100%;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}:host .nav-container .main-nav>nav>ul>li>a.avatar>img{height:32px;width:32px;-o-object-fit:cover;object-fit:cover;-webkit-transition:opacity .2s linear 0s;-o-transition:opacity .2s linear 0s;transition:opacity .2s linear 0s}:host .nav-container .main-nav>nav>ul>li>a.avatar:hover>img{opacity:.9}:host .nav-container .main-nav>nav>ul>li.home{margin-bottom:24px}:host .nav-container .main-nav>nav>ul>li.home>a{padding:5.6px;background:#FFF;color:#222}:host .nav-container .main-nav>nav>ul>li.home>a>i{opacity:1;width:20.8px;height:20.8px;line-height:20.8px;font-size:20.8px}:host .nav-container .main-nav>nav>ul>li:last-child{margin-bottom:0}:host .nav-container .main-nav>nav>ul>li.separator{margin-bottom:0;margin-top:-8px}:host .nav-container .main-nav>nav>ul>li.separator::after{content:'';display:block;height:1px;width:16px;margin:16px 8px;background:#383838}:host .nav-container .main-nav>nav>ul>li.spacer{-ms-flex-preferred-size:100%;flex-basis:100%}:host .nav-container .main-nav>nav>ul>li.logo{padding-left:16px}:host .nav-container .main-nav>nav>ul>li.logo>a{display:inline-block}:host .nav-container .main-nav>nav>ul>li.logo>a>img{max-height:40px;max-width:300px}:host .nav-container .main-nav>nav>ul>li.logo>a>span{display:none;font-size:20px;white-space:nowrap;font-weight:500}:host .nav-container .main-nav>nav>ul>li.logo>a:hover{background:0 0}:host .nav-container .main-nav>nav>ul>li.logo.failed-to-load>a>img{display:none}:host .nav-container .main-nav>nav>ul>li.logo.failed-to-load>a>span.collection-name{display:inline-block}:host .nav-container .main-nav>nav>ul>li.dealer-switcher{height:32px}:host .nav-container .main-nav>nav>ul>li.dealer-switcher>a{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:32px;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;padding:0 16px;border-radius:16px;opacity:.7}:host .nav-container .main-nav>nav>ul>li.dealer-switcher>a>span{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;font-size:13px;display:inline-block;max-width:150px}:host .nav-container .main-nav>nav>ul>li.dealer-switcher>a>i{font-size:16px;margin-right:16px;opacity:1}:host .nav-container .main-nav>nav>ul>li.dealer-switcher>a:hover{opacity:1}:host .nav-container .module-nav{position:fixed;z-index:8000;top:0;left:48px;bottom:0;width:240px;background:#f2f2f2;overflow:auto;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host .nav-container .module-nav .module-nav-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}:host .nav-container .module-nav .module-nav-header>h1{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-weight:500;letter-spacing:-.04em;font-size:20px;height:74px;line-height:64px;padding:5px 32px}:host .nav-container .module-nav .module-nav-header>.icon-button{display:none}@media screen and (min-width:1175px){:host .nav-container.top-nav .main-nav{bottom:auto;right:0;width:auto;height:48px}:host .nav-container.top-nav .main-nav>nav>ul{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:auto;top:8px;bottom:8px;left:16px;right:16px}:host .nav-container.top-nav .main-nav>nav>ul>li{margin-bottom:0;margin-right:16px}:host .nav-container.top-nav .main-nav>nav>ul>li:first-child,:host .nav-container.top-nav .main-nav>nav>ul>li:nth-child(2){margin-bottom:0}:host .nav-container.top-nav .main-nav>nav>ul>li:last-child{margin-right:0}:host .nav-container.top-nav .main-nav>nav>ul>li.separator{margin-right:0;margin-top:0;margin-left:-8px}:host .nav-container.top-nav .main-nav>nav>ul>li.separator::after{height:16px;width:1px;margin:8px 16px}:host .nav-container.top-nav .module-nav{top:48px;left:0}:host .nav-container.top-nav.consumer .main-nav{height:64px}:host .nav-container.top-nav.consumer .main-nav>nav>ul>li>a.icon-button{width:41.6px;height:41.6px;font-size:20.8px;padding:10.4px}:host .nav-container.top-nav.consumer .main-nav:not(.has-module-nav) .module-nav{display:none}:host .nav-container.top-nav.consumer .module-nav{top:64px}}@media screen and (max-width:1174px) and (min-width:775px){:host .nav-container .main-nav{bottom:auto;right:0;width:auto;height:48px}:host .nav-container .main-nav>nav>ul{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:auto;top:8px;bottom:8px;left:16px;right:16px}:host .nav-container .main-nav>nav>ul>li{margin-bottom:0;margin-right:16px}:host .nav-container .main-nav>nav>ul>li:first-child,:host .nav-container .main-nav>nav>ul>li:nth-child(2){margin-bottom:0}:host .nav-container .main-nav>nav>ul>li:last-child{margin-right:0}:host .nav-container .main-nav>nav>ul>li.separator{margin-right:0;margin-top:0;margin-left:-8px}:host .nav-container .main-nav>nav>ul>li.separator::after{height:16px;width:1px;margin:8px 16px}:host .nav-container .module-nav{top:48px;left:0}:host .nav-container.consumer .main-nav{height:64px}:host .nav-container.consumer .main-nav>nav>ul>li>a.icon-button{width:41.6px;height:41.6px;font-size:20.8px;padding:10.4px}:host .nav-container.consumer .main-nav:not(.has-module-nav) .module-nav{display:none}:host .nav-container.consumer .module-nav{top:64px}}@media screen and (max-width:1174px){:host .nav-container .main-nav>nav>ul>li.logo{padding-left:8px}:host .nav-container .main-nav>nav>ul>li.logo>a>span{font-size:18px}:host .nav-container .module-nav{top:48px;width:192px;left:0}:host .nav-container .module-nav .module-nav-header>h1{font-size:16px;height:58px;line-height:48px;padding:5px 24px}}@media screen and (max-width:774px){:host .title-bar{display:-webkit-box;display:-ms-flexbox;display:flex;height:53px;position:fixed;background:#222;top:0;left:0;right:0;padding:8px;z-index:8000;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:5px solid #f2f2f2}:host .title-bar .icon-button{position:relative;color:#FFF}:host .title-bar .icon-button>i{opacity:.7}:host .title-bar .icon-button>.badge{position:absolute;top:-2px;right:-2px}:host .title-bar .icon-button:hover{background:#4e4e4e}:host .title-bar .icon-button:hover>i{opacity:1}:host .title-bar>.view-title{color:#FFF;display:block;font-size:16px;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;margin-left:8px}:host .nav-container{position:fixed;top:0;left:-320px;bottom:0;z-index:9001;width:320px;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s}:host .nav-container .main-nav{position:absolute;background:#dedede!important}:host .nav-container .main-nav>nav>ul{top:8px;bottom:8px;left:8px;right:8px}:host .nav-container .main-nav>nav>ul>li{margin-right:0}:host .nav-container .main-nav>nav>ul>li>a>i{color:#222;opacity:.8}:host .nav-container .main-nav>nav>ul>li:first-child{margin-bottom:14px}:host .nav-container .main-nav>nav>ul>li:first-child>a{background:#222}:host .nav-container .main-nav>nav>ul>li:first-child>a>i{color:#FFF}:host .nav-container .main-nav>nav>ul>li:not(:first-child)>a>i{color:#222!important}:host .nav-container .main-nav>nav>ul>li:not(:first-child)>a:hover{background:#c8c8c8!important}:host .nav-container .main-nav>nav>ul>li.logo{padding-left:0}:host .nav-container .main-nav>nav>ul>li.logo>a{position:relative;width:32px;background:0 0}:host .nav-container .main-nav>nav>ul>li.logo>a>img{display:none}:host .nav-container .main-nav>nav>ul>li.logo>a>span.collection-acronym{display:inline-block;line-height:32px;text-align:center;border-radius:100%;width:32px;height:32px;font-size:12px;text-transform:uppercase}:host .nav-container .main-nav>nav>ul>li.logo>a>span.collection-acronym.trio{font-size:10px}:host .nav-container .main-nav>nav>ul>li.logo.failed-to-load>a>span.collection-name{display:none}:host .nav-container .module-nav{position:absolute;top:0;left:48px;width:272px}:host .nav-container .module-nav .module-nav-header{padding-top:0;padding-bottom:0;height:48px}:host .nav-container .module-nav .module-nav-header>.icon-button{display:inline-block;margin:5px 8px 5px 0}:host .nav-container .module-nav .module-nav-header>.icon-button:hover{background:#dedede}:host .nav-container.expanded{left:0}:host .nav-container:not(.has-module-nav){width:48px}:host .overlay{position:fixed;background:#000;opacity:0;top:100%;right:0;bottom:0;left:0;z-index:8999;display:block;-webkit-transition:opacity .2s linear 0s,top 0s linear .2s;-o-transition:opacity .2s linear 0s,top 0s linear .2s;transition:opacity .2s linear 0s,top 0s linear .2s;cursor:pointer}:host .overlay.show{top:0;opacity:.6;-webkit-transition:opacity .2s linear 0s,top 0s linear 0s;-o-transition:opacity .2s linear 0s,top 0s linear 0s;transition:opacity .2s linear 0s,top 0s linear 0s}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UINavComponent.ctorParameters = function () { return [
        { type: Router },
        { type: UIModalService },
        { type: UISessionService },
        { type: UIResponsiveService },
        { type: UILayoutConfigService },
        { type: UIThemeService }
    ]; };
    UINavComponent.propDecorators = {
        setTooltipConfig: [{ type: HostListener, args: ['window:resize',] }]
    };
    return UINavComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIAppModuleSwitcherModalComponent = /** @class */ (function () {
    function UIAppModuleSwitcherModalComponent(router, uiSessionService, uiModalService) {
        this.router = router;
        this.uiSessionService = uiSessionService;
        this.uiModalService = uiModalService;
        this.modules = this.uiSessionService.getItem('uiApp').modules;
        this.constructModal();
    }
    /**
     * @return {?}
     */
    UIAppModuleSwitcherModalComponent.prototype.constructModal = /**
     * @return {?}
     */
    function () {
        this.uiModalService.setConfig({
            title: 'Go to...',
            position: 'left',
            width: 'sm1',
            baseTheme: 'light',
            actions: []
        });
    };
    /**
     * @param {?} uiAppModule
     * @return {?}
     */
    UIAppModuleSwitcherModalComponent.prototype.onClick = /**
     * @param {?} uiAppModule
     * @return {?}
     */
    function (uiAppModule) {
        var _this = this;
        this.router.navigate([uiAppModule.path]).then(function () {
            _this.uiModalService.close();
        });
    };
    UIAppModuleSwitcherModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-module-switcher-modal',
                    template: "\n      <!--  NAV LIST  -->\n\n      <ul class=\"nav-list\">\n\n          <!--  MODULE LOOP  -->\n\n          <li *ngFor=\"let module of modules\">\n\n              <!--  MODULE LINK  -->\n\n              <a (click)=\"onClick(module)\">\n\n                  <!--  ICON  -->\n\n                  <i *ngIf=\"!!module.icon\" class=\"fa-fw fa-sm\" [ngClass]=\"[module.icon, 'bg-' + module.theme]\"></i>\n\n                  <!--  END ICON  -->\n\n                  <!--  MODULE NAME  -->\n\n                  {{ module.name }}\n\n                  <!--  END MODULE NAME  -->\n              </a>\n\n              <!--  END MODULE LINK  -->\n\n          </li>\n\n          <!--  END MODULE LOOP  -->\n\n      </ul>\n\n      <!--  END NAV LIST  -->\n    "
                },] },
    ];
    /** @nocollapse */
    UIAppModuleSwitcherModalComponent.ctorParameters = function () { return [
        { type: Router },
        { type: UISessionService },
        { type: UIModalService }
    ]; };
    return UIAppModuleSwitcherModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIModal = /** @class */ (function () {
    function UIModal(uiModal) {
        this.show = false;
        this.position = 'center';
        this.width = 'sm1';
        this.height = 'content';
        this.canDismiss = true;
        this.actions = [];
        this.actionsPosition = 'right';
        this.baseTheme = 'white';
        this.opaque = false;
        this.tabs = [];
        if (uiModal) {
            // Ensure developer hasn't instantiated class with show set to true.
            // This is the job of the UIModalComponent to ensure transition.
            uiModal.show = false;
        }
        Object.assign(/** @type {?} */ (this), uiModal);
    }
    UIModal.leftStyle = {
        top: 0,
        bottom: 0,
        left: 0
    };
    return UIModal;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISearchModalComponent = /** @class */ (function () {
    function UISearchModalComponent(uiModalService) {
        this.uiModalService = uiModalService;
        this.constructModal();
    }
    /**
     * @return {?}
     */
    UISearchModalComponent.prototype.constructModal = /**
     * @return {?}
     */
    function () {
        this.uiModalService.setConfig(new UIModal({
            title: 'Search everything',
            position: 'left',
            width: 'sm2'
        }));
    };
    UISearchModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-search-modal',
                    template: "\n      SEARCH HERE...\n    ",
                    styles: ["\n\n    "]
                },] },
    ];
    /** @nocollapse */
    UISearchModalComponent.ctorParameters = function () { return [
        { type: UIModalService }
    ]; };
    return UISearchModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIModalComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIModalService} uiModalService
     * @param {Router} router
     */
    function UIModalComponent(uiModalService, router) {
        var _this = this;
        this.uiModalService = uiModalService;
        this.router = router;
        this.modalState = 'idle';
        this.destroyed$ = new Subject();
        this.uiModal = Object.assign(new UIModal(), this.uiModalService.uiModal);
        if (this.uiModal.tabs.length) {
            this.uiTabBar = new UITabBar({ tabs: this.uiModal.tabs, contained: true, containerBaseTheme: (this.uiModal.baseTheme === 'white') ? 'light' : 'white' });
        }
        this.uiModalService.uiModal$.pipe(takeUntil(this.destroyed$)).subscribe(function (uiModal) {
            _this.uiModal = uiModal;
            _this.handleAnimationState();
            if (_this.uiModal.tabs.length) {
                _this.uiTabBar = new UITabBar({
                    tabs: _this.uiModal.tabs, routeTabs: !!_this.uiModal.tabs[0].path, modalTabs: true, contained: true, containerBaseTheme: (_this.uiModal.baseTheme === 'white') ? 'light' : 'white'
                });
            }
        });
    }
    /**
     * Shows modal.
     */
    /**
     * Shows modal.
     * @return {?}
     */
    UIModalComponent.prototype.ngOnInit = /**
     * Shows modal.
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout(function () {
            _this.uiModalService.setShow(true);
        });
    };
    /**
     * Puts modal into correct animation state.
     */
    /**
     * Puts modal into correct animation state.
     * @return {?}
     */
    UIModalComponent.prototype.handleAnimationState = /**
     * Puts modal into correct animation state.
     * @return {?}
     */
    function () {
        if (!this.uiModal.show) {
            this.modalState = 'idle';
            return;
        }
        if (this.uiModal.position === 'center' && this.uiModal.height === 'full') {
            this.modalState = 'centerFullHeight';
            return;
        }
        this.modalState = this.uiModal.position;
    };
    /**
     * Handles close of modal.
     */
    /**
     * Handles close of modal.
     * @return {?}
     */
    UIModalComponent.prototype.onClose = /**
     * Handles close of modal.
     * @return {?}
     */
    function () {
        if (this.uiModal.canDismiss) {
            this.uiModalService.setShow(false);
        }
    };
    /**
     * Handles action click.
     *
     * @param {UIActionButton} uiActionButton
     */
    /**
     * Handles action click.
     *
     * @param {?} uiActionButton
     * @return {?}
     */
    UIModalComponent.prototype.onClick = /**
     * Handles action click.
     *
     * @param {?} uiActionButton
     * @return {?}
     */
    function (uiActionButton) {
        uiActionButton.working = uiActionButton.showWorking;
        uiActionButton.click(uiActionButton);
    };
    /**
     * Handles router button click by navigating and then closing modal.
     *
     * @param {string[]} navigateTo
     */
    /**
     * Handles router button click by navigating and then closing modal.
     *
     * @param {?} navigateTo
     * @return {?}
     */
    UIModalComponent.prototype.onRouterButtonClick = /**
     * Handles router button click by navigating and then closing modal.
     *
     * @param {?} navigateTo
     * @return {?}
     */
    function (navigateTo) {
        var _this = this;
        this.router.navigate(navigateTo).then(function () {
            _this.uiModalService.setShow(false);
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    UIModalComponent.prototype.onAnimationEnd = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.fromState !== 'void' && event.toState === 'idle') {
            this.uiModalService.destroy();
        }
    };
    /**
     * Checks if body is scrolling.
     *
     * @returns {boolean}
     */
    /**
     * Checks if body is scrolling.
     *
     * @return {?}
     */
    UIModalComponent.prototype.isBodyScrolling = /**
     * Checks if body is scrolling.
     *
     * @return {?}
     */
    function () {
        return this.modalBody.nativeElement.scrollHeight > this.modalBody.nativeElement.clientHeight;
    };
    /**
     * Lifecycle hook: destroys component and any active subscriptions.
     */
    /**
     * Lifecycle hook: destroys component and any active subscriptions.
     * @return {?}
     */
    UIModalComponent.prototype.ngOnDestroy = /**
     * Lifecycle hook: destroys component and any active subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
    };
    UIModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-modal',
                    template: "\n      <!--  OVERLAY  -->\n\n      <div class=\"overlay\" [class.show]=\"uiModal.show\" [class.can-dismiss]=\"uiModal.canDismiss\" [class.opaque]=\"uiModal.opaque\" (click)=\"onClose()\"></div>\n\n      <!--  END OVERLAY  -->\n\n      <!--  MODAL  -->\n\n      <div class=\"modal\"\n           [class.has-footer]=\"uiModal.actions.length\"\n           [class.has-tabs]=\"uiTabBar\"\n           [class.light-body]=\"uiModal.baseTheme === 'light'\"\n           [ngClass]=\"'width-' + uiModal.width + ' position-' + uiModal.position + ' height-' + uiModal.height\"\n           [@modal]=\"modalState\"\n           (@modal.done)=\"onAnimationEnd($event)\">\n\n          <!--  MODAL HEADER  -->\n\n          <div class=\"modal-header\" [class.can-dismiss]=\"uiModal.canDismiss\">\n\n              <!--  TITLE  -->\n\n              <h2>{{ uiModal.title }}</h2>\n\n              <!--  END TITLE  -->\n\n              <!--  DISMISS BUTTON  -->\n\n              <a class=\"icon-button\" (click)=\"onClose()\">\n                  <i class=\"far fa-times\"></i>\n              </a>\n\n              <!--  END DISMISS BUTTON  -->\n\n          </div>\n\n          <!--  END MODAL HEADER  -->\n\n          <!--  TABS  -->\n\n          <div *ngIf=\"uiTabBar\" class=\"modal-tabs\">\n              <ui-tab-bar [uiTabBar]=\"uiTabBar\"></ui-tab-bar>\n          </div>\n\n          <!--  END TABS  -->\n\n          <!--  MODAL BODY  -->\n\n          <div #modalBody id=\"modalBody\" class=\"modal-body\">\n              <router-outlet></router-outlet>\n          </div>\n\n          <!--  END MODAL BODY  -->\n\n          <!--  MODAL FOOTER  -->\n\n          <div *ngIf=\"uiModal.actions.length\" class=\"modal-footer\" [ngClass]=\"'actions-position-' + uiModal.actionsPosition\">\n\n              <!--  MODAL ACTION LOOP  -->\n\n              <ng-template ngFor [ngForOf]=\"uiModal.actions\" let-action>\n\n                  <!--  BUTTON  -->\n\n                  <a *ngIf=\"action.type === 'button'\" class=\"button\" [ngClass]=\"action.theme + '-button'\" [uiLoading]=\"action.showWorking && action.working\" (click)=\"onClick(action)\"> {{ action.text }} </a>\n\n                  <!--  END BUTTON  -->\n\n                  <!--  ANCHOR BUTTON  -->\n\n                  <a *ngIf=\"action.type === 'anchorButton'\" class=\"button\" [ngClass]=\"action.theme + '-button'\" [attr.href]=\"action.href\" [attr.target]=\"action.target\">{{ action.text }}</a>\n\n                  <!--  END ANCHOR BUTTON  -->\n\n                  <!--  ROUTER BUTTON  -->\n\n                  <a *ngIf=\"action.type === 'routerButton'\" class=\"button\" [ngClass]=\"action.theme + '-button'\" (click)=\"onRouterButtonClick(action.navigateTo)\">{{ action.text }}</a>\n\n                  <!--  END ROUTER BUTTON  -->\n\n              </ng-template>\n\n              <!--  END MODAL ACTION LOOP  -->\n\n          </div>\n\n          <!--  END MODAL FOOTER  -->\n\n      </div>\n\n      <!--  END MODAL  -->\n    ",
                    styles: ["\n      :host .overlay{position:fixed;background:#000;opacity:0;top:100%;right:0;bottom:0;left:0;z-index:10000;display:block;-webkit-transition:opacity .2s linear 0s,top 0s linear .2s;-o-transition:opacity .2s linear 0s,top 0s linear .2s;transition:opacity .2s linear 0s,top 0s linear .2s}:host .overlay.opaque{background:#d3d3d3}:host .overlay.show{top:0;opacity:.6;-webkit-transition:opacity .2s linear 0s,top 0s linear 0s;-o-transition:opacity .2s linear 0s,top 0s linear 0s;transition:opacity .2s linear 0s,top 0s linear 0s}:host .overlay.show.opaque{opacity:1;-webkit-transition:none;-o-transition:none;transition:none}:host .overlay.can-dismiss{cursor:pointer}:host .modal{position:fixed;background:#FFF;z-index:10001;padding-top:64px;-webkit-font-smoothing:antialiased;opacity:0}:host .modal .modal-header{position:absolute;top:0;left:0;right:0;padding:16px 24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}:host .modal .modal-header h2{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;line-height:32px;padding-right:16px}:host .modal .modal-header .icon-button{display:none}:host .modal .modal-header.can-dismiss{padding-right:16px}:host .modal .modal-header.can-dismiss .icon-button{display:inline-block;-ms-flex-negative:0;flex-shrink:0}:host .modal .modal-body{padding:24px;overflow-y:auto;-webkit-overflow-scrolling:touch;position:relative;min-height:1px;border-top:5px solid #f2f2f2}:host .modal .modal-tabs{position:absolute;left:0;right:0;top:64px}:host .modal .modal-footer{position:absolute;bottom:0;left:0;right:0;font-size:0;height:69px;padding:16px 24px;display:-webkit-box;display:-ms-flexbox;display:flex;border-top:5px solid #f2f2f2}:host .modal .modal-footer>*{margin:0 8px}:host .modal .modal-footer>:first-child{margin-left:0}:host .modal .modal-footer>:last-child{margin-right:0}:host .modal .modal-footer.actions-position-right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}:host .modal .modal-footer.actions-position-left{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}:host .modal .modal-footer.actions-position-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}:host .modal .modal-footer.actions-position-justify{-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch}:host .modal .modal-footer.actions-position-justify>*{-ms-flex-preferred-size:calc(100% - 16px);flex-basis:calc(100% - 16px)}:host .modal .modal-footer.actions-position-justify>:first-child{-ms-flex-preferred-size:calc(100% - 8px);flex-basis:calc(100% - 8px)}:host .modal .modal-footer.actions-position-justify>:last-child{-ms-flex-preferred-size:calc(100% - 8px);flex-basis:calc(100% - 8px)}:host .modal .modal-footer.actions-position-justify>:only-child{-ms-flex-preferred-size:100%;flex-basis:100%}:host .modal.has-tabs{padding-top:106px}:host .modal.has-tabs .modal-body{border-top:0}:host .modal.has-footer{padding-bottom:69px}:host .modal.light-body .modal-body{background:#f2f2f2;border-top-color:#e9e9e9}:host .modal.light-body .modal-footer{border-top-color:#e9e9e9}:host .modal.position-center{width:calc(100% - 48px);border-radius:3px}:host .modal.position-center .modal-body{max-height:calc(100vh - 112px);border-radius:0 0 30px 30px}:host .modal.position-center.has-tabs .modal-body{max-height:calc(100vh - 154px)}:host .modal.position-center.has-footer .modal-body{max-height:calc(100vh - 181px);border-radius:0}:host .modal.position-center.has-tabs.has-footer .modal-body{max-height:calc(100vh - 223px)}:host .modal.position-center.height-full{margin:24px 0}:host .modal.position-center.width-sm1{max-width:326px}:host .modal.position-center.width-sm2{max-width:526px}:host .modal.position-center.width-sm3{max-width:726px}:host .modal.position-center.width-md1{max-width:926px}:host .modal.position-center.width-md2{max-width:1126px}:host .modal.position-center.width-md3{max-width:1326px}:host .modal.position-center.width-lg1{max-width:1526px}:host .modal.position-center.width-lg2{max-width:1726px}:host .modal.position-center.height-full .modal-body,:host .modal.position-left .modal-body,:host .modal.position-right .modal-body{position:absolute;top:64px;left:0;right:0;bottom:0}:host .modal.position-center.height-full.has-tabs .modal-body,:host .modal.position-left.has-tabs .modal-body,:host .modal.position-right.has-tabs .modal-body{top:106px}:host .modal.position-center.height-full.has-footer .modal-body,:host .modal.position-left.has-footer .modal-body,:host .modal.position-right.has-footer .modal-body{bottom:69px}:host .modal.position-left{width:100%}:host .modal.position-left.width-sm1{max-width:320px}:host .modal.position-left.width-sm2{max-width:574px}:host .modal.position-left.width-sm3{max-width:774px}:host .modal.position-left.width-md1{max-width:974px}:host .modal.position-left.width-md2{max-width:1174px}:host .modal.position-left.width-md3{max-width:1374px}:host .modal.position-left.width-lg1{max-width:1574px}:host .modal.position-left.width-lg2{max-width:1774px}:host .modal.position-right{width:100%}:host .modal.position-right.width-sm1{max-width:320px}:host .modal.position-right.width-sm2{max-width:574px}:host .modal.position-right.width-sm3{max-width:774px}:host .modal.position-right.width-md1{max-width:974px}:host .modal.position-right.width-md2{max-width:1174px}:host .modal.position-right.width-md3{max-width:1374px}:host .modal.position-right.width-lg1{max-width:1574px}:host .modal.position-right.width-lg2{max-width:1774px}@media screen and (max-width:774px){:host .modal{padding-top:48px}:host .modal .modal-header{padding:8px 16px}:host .modal .modal-header h2{font-size:16px}:host .modal .modal-header.can-dismiss{padding-right:8px}:host .modal .modal-tabs{top:48px}:host .modal .modal-body{padding:16px}:host .modal .modal-footer{padding:16px}:host .modal.has-tabs{padding-top:90px}:host .modal.position-center{width:calc(100% - 32px)}:host .modal.position-center .modal-body{max-height:calc(100vh - 80px)}:host .modal.position-center.has-tabs .modal-body{max-height:calc(100vh - 122px)}:host .modal.position-center.has-footer .modal-body{max-height:calc(100vh - 149px)}:host .modal.position-center.has-tabs.has-footer .modal-body{max-height:calc(100vh - 191px)}:host .modal.position-center.height-full{margin:16px 0}:host .modal.position-center.height-full .modal-body,:host .modal.position-left .modal-body,:host .modal.position-right .modal-body{top:48px}:host .modal.position-center.height-full.has-tabs .modal-body,:host .modal.position-left.has-tabs .modal-body,:host .modal.position-right.has-tabs .modal-body{top:90px}}@media screen and (max-width:574px){:host .modal.position-center{width:calc(100% - 16px)}:host .modal.position-center .modal-body{max-height:calc(100vh - 64px)}:host .modal.position-center.has-tabs .modal-body{max-height:calc(100vh - 106px)}:host .modal.position-center.has-footer .modal-body{max-height:calc(100vh - 133px)}:host .modal.position-center.has-tabs.has-footer .modal-body{max-height:calc(100vh - 175px)}:host .modal.position-center.height-full{margin:8px 0}}\n    "],
                    animations: [
                        trigger('modal', [
                            //  LEFT STATE
                            state('left', style({
                                left: 0,
                                top: 0,
                                bottom: 0,
                                transform: 'translateX(0)',
                                opacity: 1
                            })),
                            //  LEFT TRANSITION IN
                            transition('idle => left', animate('0.2s ease-in-out', keyframes([
                                style({
                                    left: 0,
                                    top: 0,
                                    bottom: 0,
                                    transform: 'translateX(-100%)',
                                    offset: 0,
                                    opacity: 1
                                }),
                                style({
                                    transform: 'translateX(0)',
                                    offset: 1,
                                    opacity: 1
                                })
                            ]))),
                            //  LEFT TRANSITION OUT
                            transition('left => idle', animate('0.2s ease-in-out', keyframes([
                                style({
                                    left: 0,
                                    top: 0,
                                    bottom: 0,
                                    transform: 'translateX(0)',
                                    offset: 0,
                                    opacity: 1
                                }),
                                style({
                                    transform: 'translateX(-100%)',
                                    offset: 1,
                                    opacity: 1
                                })
                            ]))),
                            //  RIGHT STATE
                            state('right', style({
                                right: 0,
                                top: 0,
                                bottom: 0,
                                transform: 'translateX(0)',
                                opacity: 1
                            })),
                            //  RIGHT TRANSITION IN
                            transition('idle => right', animate('0.2s ease-in-out', keyframes([
                                style({
                                    right: 0,
                                    top: 0,
                                    bottom: 0,
                                    transform: 'translateX(100%)',
                                    offset: 0,
                                    opacity: 1
                                }),
                                style({
                                    transform: 'translateX(0)',
                                    offset: 1,
                                    opacity: 1
                                })
                            ]))),
                            //  RIGHT TRANSITION OUT
                            transition('right => idle', animate('0.2s ease-in-out', keyframes([
                                style({
                                    right: 0,
                                    top: 0,
                                    bottom: 0,
                                    transform: 'translateX(0)',
                                    offset: 0,
                                    opacity: 1
                                }),
                                style({
                                    transform: 'translateX(100%)',
                                    offset: 1,
                                    opacity: 1
                                })
                            ]))),
                            //  CENTER STATE
                            state('center', style({
                                left: '50%',
                                top: '50%',
                                transform: 'translate(-50%, -50%) translate3d( 0, 0, 0)',
                                marginTop: 0,
                                opacity: 1
                            })),
                            //  CENTER TRANSITION IN
                            transition('idle => center', animate('0.2s ease-in-out', keyframes([
                                style({
                                    left: '50%',
                                    top: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    opacity: 0,
                                    marginTop: '16px',
                                    offset: 0
                                }),
                                style({
                                    transform: 'translate(-50%, -50%)',
                                    opacity: 1,
                                    marginTop: 0,
                                    offset: 1
                                })
                            ]))),
                            //  CENTER TRANSITION OUT
                            transition('center => idle', animate('0.2s ease-in-out', keyframes([
                                style({
                                    left: '50%',
                                    top: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    opacity: 1,
                                    marginTop: 0,
                                    offset: 0
                                }),
                                style({
                                    transform: 'translate(-50%, -50%)',
                                    opacity: 0,
                                    marginTop: '-16px',
                                    offset: 1
                                })
                            ]))),
                            //  CENTER FULL HEIGHT STATE
                            state('centerFullHeight', style({
                                left: '50%',
                                top: 0,
                                bottom: 0,
                                transform: 'translate(-50%, 0)',
                                opacity: 1
                            })),
                            //  CENTER FULL HEIGHT TRANSITION IN
                            transition('idle => centerFullHeight', animate('0.2s ease-in-out', keyframes([
                                style({
                                    left: '50%',
                                    top: 0,
                                    bottom: 0,
                                    transform: 'translate(-50%, 16px)',
                                    opacity: 0,
                                    offset: 0
                                }),
                                style({
                                    transform: 'translate(-50%, 0)',
                                    opacity: 1,
                                    offset: 1
                                })
                            ]))),
                            //  CENTER FULL HEIGHT TRANSITION OUT
                            transition('centerFullHeight => idle', animate('0.2s ease-in-out', keyframes([
                                style({
                                    left: '50%',
                                    top: 0,
                                    bottom: 0,
                                    transform: 'translate(-50%, 0)',
                                    opacity: 1,
                                    offset: 0
                                }),
                                style({
                                    transform: 'translate(-50%, -16px)',
                                    opacity: 0,
                                    offset: 1
                                })
                            ])))
                        ])
                    ]
                },] },
    ];
    /** @nocollapse */
    UIModalComponent.ctorParameters = function () { return [
        { type: UIModalService },
        { type: Router }
    ]; };
    UIModalComponent.propDecorators = {
        modalBody: [{ type: ViewChild, args: ['modalBody',] }],
        isBodyScrolling: [{ type: HostListener, args: ['window:resize',] }]
    };
    return UIModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
UIAction = /** @class */ (function () {
    function UIAction() {
    }
    return UIAction;
}());

var __extends$2 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UIActionAnchorButton = /** @class */ (function (_super) {
    __extends$2(UIActionAnchorButton, _super);
    function UIActionAnchorButton(uiActionAnchorButton) {
        var _this = _super.call(this) || this;
        _this.type = 'anchorButton';
        Object.assign(/** @type {?} */ (_this), uiActionAnchorButton);
        return _this;
    }
    return UIActionAnchorButton;
}(UIAction));

var __extends$3 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UIActionRouterButton = /** @class */ (function (_super) {
    __extends$3(UIActionRouterButton, _super);
    function UIActionRouterButton(uiActionRouterButton) {
        var _this = _super.call(this) || this;
        _this.type = 'routerLink';
        Object.assign(/** @type {?} */ (_this), uiActionRouterButton);
        return _this;
    }
    return UIActionRouterButton;
}(UIAction));

var __extends$4 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UIActionAnchorLink = /** @class */ (function (_super) {
    __extends$4(UIActionAnchorLink, _super);
    function UIActionAnchorLink(uiActionAnchorLink) {
        var _this = _super.call(this) || this;
        _this.type = 'anchorLink';
        Object.assign(_this, uiActionAnchorLink);
        return _this;
    }
    return UIActionAnchorLink;
}(UIAction));

var __extends$5 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UIActionLinkButton = /** @class */ (function (_super) {
    __extends$5(UIActionLinkButton, _super);
    function UIActionLinkButton(uiActionLinkButton) {
        var _this = _super.call(this) || this;
        _this.type = 'linkButton';
        Object.assign(_this, uiActionLinkButton);
        return _this;
    }
    /**
     * @param {?} uiActionLinkButton
     * @return {?}
     */
    UIActionLinkButton.prototype.click = /**
     * @param {?} uiActionLinkButton
     * @return {?}
     */
    function (uiActionLinkButton) {
    };
    return UIActionLinkButton;
}(UIAction));

var __extends$6 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UIActionRouterLink = /** @class */ (function (_super) {
    __extends$6(UIActionRouterLink, _super);
    function UIActionRouterLink(uiActionRouterLink) {
        var _this = _super.call(this) || this;
        _this.type = 'routerLink';
        Object.assign(_this, uiActionRouterLink);
        return _this;
    }
    return UIActionRouterLink;
}(UIAction));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILayoutConfig = /** @class */ (function () {
    function UILayoutConfig(uiLayoutConfig) {
        this.hasKeyFunctions = false;
        this.baseTheme = 'white';
        this.hasModuleNav = true;
        this.navExpanded = false;
        this.hasViewHeader = true;
        this.hasViewTakeover = false;
        Object.assign(/** @type {?} */ (this), uiLayoutConfig);
    }
    return UILayoutConfig;
}());

var __extends$7 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UIActionButton = /** @class */ (function (_super) {
    __extends$7(UIActionButton, _super);
    function UIActionButton(uiActionButton) {
        var _this = _super.call(this) || this;
        _this.type = 'button';
        _this.showWorking = false;
        _this.working = false;
        Object.assign(/** @type {?} */ (_this), uiActionButton);
        return _this;
    }
    /**
     * @param {?} uiActionButton
     * @return {?}
     */
    UIActionButton.prototype.click = /**
     * @param {?} uiActionButton
     * @return {?}
     */
    function (uiActionButton) {
    };
    return UIActionButton;
}(UIAction));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIMainNavItem = /** @class */ (function () {
    function UIMainNavItem(uiMainNavItem) {
        if (!uiMainNavItem.tooltipText) {
            uiMainNavItem.tooltipText = uiMainNavItem.name;
        }
        Object.assign(/** @type {?} */ (this), uiMainNavItem);
    }
    /**
     * @return {?}
     */
    UIMainNavItem.prototype.click = /**
     * @return {?}
     */
    function () {
    };
    return UIMainNavItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIAppModule = /** @class */ (function () {
    function UIAppModule(uiAppModule) {
        this.hasModuleNav = true;
        Object.assign(/** @type {?} */ (this), uiAppModule);
    }
    return UIAppModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIDataItem = /** @class */ (function () {
    function UIDataItem() {
    }
    return UIDataItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UINavItem = /** @class */ (function () {
    function UINavItem(uiNavItem) {
        Object.assign(/** @type {?} */ (this), uiNavItem);
    }
    return UINavItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIFooter = /** @class */ (function () {
    function UIFooter(uiFooter) {
        this.links = [];
        Object.assign(/** @type {?} */ (this), uiFooter);
    }
    return UIFooter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UICache = /** @class */ (function () {
    function UICache() {
    }
    return UICache;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIError = /** @class */ (function () {
    function UIError() {
    }
    return UIError;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIBadge = /** @class */ (function () {
    function UIBadge(uiBadge) {
        this.theme = 'negative';
        Object.assign(/** @type {?} */ (this), uiBadge);
    }
    return UIBadge;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIApp = /** @class */ (function () {
    function UIApp(uiApp) {
        this.mainNavItems = [];
        this.showModuleSwitcher = false;
        this.showSearch = false;
        this.showUserAccount = false;
        this.keyItemsPosition = 'default';
        this.audience = 'dealer';
        this.navPosition = 'default';
        /**
                 * Force nav position to top for consumer facing apps.
                 */
        if (uiApp.audience === 'consumer') {
            uiApp.navPosition = 'top';
        }
        Object.assign(/** @type {?} */ (this), uiApp);
    }
    return UIApp;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UICookieStorageService$1 = /** @class */ (function () {
    function UICookieStorageService() {
    }
    /**
     * Set cookie item with key, value and expiry days. Default expiry set to 1 year.
     *
     * @param {string} key
     * @param {string} value
     * @param {number} expiryDays
     */
    /**
     * Set cookie item with key, value and expiry days. Default expiry set to 1 year.
     *
     * @param {?} key
     * @param {?} value
     * @param {?=} expiryDays
     * @return {?}
     */
    UICookieStorageService.prototype.setItem = /**
     * Set cookie item with key, value and expiry days. Default expiry set to 1 year.
     *
     * @param {?} key
     * @param {?} value
     * @param {?=} expiryDays
     * @return {?}
     */
    function (key, value, expiryDays) {
        if (expiryDays === void 0) { expiryDays = 365; }
        /** @type {?} */
        var d = new Date();
        d.setTime(d.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
        /** @type {?} */
        var expires = 'expires=' + d.toUTCString();
        document.cookie = key + '=' + value + ';' + expires + ';path=/';
    };
    /**
     * Gets cookie item from key.
     *
     * @param {string} key
     * @returns {string}
     */
    /**
     * Gets cookie item from key.
     *
     * @param {?} key
     * @return {?}
     */
    UICookieStorageService.prototype.getItem = /**
     * Gets cookie item from key.
     *
     * @param {?} key
     * @return {?}
     */
    function (key) {
        /** @type {?} */
        var name = key + '=';
        /** @type {?} */
        var decodedCookie = decodeURIComponent(document.cookie);
        /** @type {?} */
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            /** @type {?} */
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };
    /**
     * Removes cookie item with key.
     *
     * @param {string} key
     */
    /**
     * Removes cookie item with key.
     *
     * @param {?} key
     * @return {?}
     */
    UICookieStorageService.prototype.removeItem = /**
     * Removes cookie item with key.
     *
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this.setItem(key, '', -1);
    };
    UICookieStorageService.decorators = [
        { type: Injectable },
    ];
    return UICookieStorageService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UINotificationsService = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UISessionService} uiSessionService
     * @param {UINavigationService} uiNavigationService
     */
    function UINotificationsService(uiSessionService, uiNavigationService) {
        var _this = this;
        this.uiSessionService = uiSessionService;
        this.uiNavigationService = uiNavigationService;
        this.uiApp = this.uiSessionService.getItem('uiApp');
        this.uiSessionService.getSubject('uiApp').subscribe(function (uiApp) {
            _this.uiApp = uiApp;
        });
    }
    /**
     * Sets Main mav item badge.
     *
     * @param {string} name
     * @param {UIBadge} badge
     */
    /**
     * Sets Main mav item badge.
     *
     * @param {?} name
     * @param {?} badge
     * @return {?}
     */
    UINotificationsService.prototype.setBadge = /**
     * Sets Main mav item badge.
     *
     * @param {?} name
     * @param {?} badge
     * @return {?}
     */
    function (name, badge) {
        /** @type {?} */
        var mainNavItem = this.uiNavigationService.getMainNavItem(name);
        if (mainNavItem) {
            mainNavItem.badge = badge;
            this.uiSessionService.setItem('uiApp', this.uiApp);
        }
    };
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    UINotificationsService.prototype.setBadgeValue = /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (name, value) {
        /** @type {?} */
        var mainNavItem = this.uiNavigationService.getMainNavItem(name);
        if (mainNavItem) {
            if (!mainNavItem.badge) {
                mainNavItem.badge = new UIBadge({ value: value });
            }
            mainNavItem.badge.value = value;
            this.uiSessionService.setItem('uiApp', this.uiApp);
        }
    };
    /**
     * @param {?} name
     * @return {?}
     */
    UINotificationsService.prototype.removeBadge = /**
     * @param {?} name
     * @return {?}
     */
    function (name) {
        /** @type {?} */
        var mainNavItem = this.uiNavigationService.getMainNavItem(name);
        if (mainNavItem) {
            delete mainNavItem['badge'];
            this.uiSessionService.setItem('uiApp', this.uiApp);
        }
    };
    UINotificationsService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UINotificationsService.ctorParameters = function () { return [
        { type: UISessionService },
        { type: UINavigationService }
    ]; };
    return UINotificationsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILocalStorageService$1 = /** @class */ (function () {
    function UILocalStorageService() {
    }
    /**
     * Sets item with key and value.
     *
     * @param {string} key
     * @param {string} value
     */
    /**
     * Sets item with key and value.
     *
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    UILocalStorageService.prototype.setItem = /**
     * Sets item with key and value.
     *
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        localStorage.setItem(key, value);
    };
    /**
     * Gets item from key.
     *
     * @param {string} key
     * @returns {string}
     */
    /**
     * Gets item from key.
     *
     * @param {?} key
     * @return {?}
     */
    UILocalStorageService.prototype.getItem = /**
     * Gets item from key.
     *
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return localStorage.getItem(key);
    };
    /**
     * Removes item with key.
     *
     * @param {string} key
     */
    /**
     * Removes item with key.
     *
     * @param {?} key
     * @return {?}
     */
    UILocalStorageService.prototype.removeItem = /**
     * Removes item with key.
     *
     * @param {?} key
     * @return {?}
     */
    function (key) {
        localStorage.removeItem(key);
    };
    UILocalStorageService.decorators = [
        { type: Injectable },
    ];
    return UILocalStorageService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var ScriptStore = [
    {
        name: 'highlightjs',
        src: '//cdnjs.cloudflare.com/ajax/libs/highlight.js/9.5.0/highlight.min.js'
    },
    {
        name: 'highlightjs_typescript',
        src: '//cdnjs.cloudflare.com/ajax/libs/highlight.js/9.4.0/languages/typescript.min.js'
    },
    {
        name: 'hammerjs',
        src: 'https://cdnjs.cloudflare.com/ajax/libs/hammer.js/2.0.8/hammer.min.js'
    }
];
var UIScriptLoaderService$1 = /** @class */ (function () {
    function UIScriptLoaderService() {
        var _this = this;
        this.scripts = {};
        ScriptStore.forEach(function (script) {
            _this.scripts[script.name] = {
                loaded: false,
                src: script.src
            };
        });
    }
    /**
     * @param {...?} scripts
     * @return {?}
     */
    UIScriptLoaderService.prototype.load = /**
     * @param {...?} scripts
     * @return {?}
     */
    function () {
        var _this = this;
        var scripts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            scripts[_i] = arguments[_i];
        }
        /** @type {?} */
        var promises = [];
        scripts.forEach(function (script) {
            promises.push(_this.loadScript(script));
        });
        return Promise.all(promises);
    };
    /**
     * @param {?} name
     * @return {?}
     */
    UIScriptLoaderService.prototype.loadScript = /**
     * @param {?} name
     * @return {?}
     */
    function (name) {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.scripts[name].loaded) {
                resolve({ script: name, loaded: true, status: 'Already Loaded' });
            }
            else {
                /** @type {?} */
                var script_1 = document.createElement('script');
                script_1.type = 'text/javascript';
                script_1.src = _this.scripts[name].src;
                if (script_1.readyState) {
                    // IE
                    // IE
                    script_1.onreadystatechange = function () {
                        if (script_1.readyState === 'loaded' || script_1.readyState === 'complete') {
                            script_1.onreadystatechange = null;
                            _this.scripts[name].loaded = true;
                            resolve({ script: name, loaded: true, status: 'Loaded' });
                        }
                    };
                }
                else {
                    // Decent browsers
                    // Decent browsers
                    script_1.onload = function () {
                        _this.scripts[name].loaded = true;
                        resolve({ script: name, loaded: true, status: 'Loaded' });
                    };
                }
                script_1.onerror = function (error) { return resolve({ script: name, loaded: false, status: 'Loaded' }); };
                document.getElementsByTagName('head')[0].appendChild(script_1);
            }
        });
    };
    UIScriptLoaderService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIScriptLoaderService.ctorParameters = function () { return []; };
    return UIScriptLoaderService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILayoutConfigService$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UISessionService} uiSessionService
     */
    function UILayoutConfigService(uiSessionService) {
        var _this = this;
        this.uiSessionService = uiSessionService;
        this.uiLayoutConfig = new UILayoutConfig({});
        this.uiSessionService.setItem('uiLayoutConfig', this.uiLayoutConfig);
        this.uiSessionService.getSubject('uiLayoutConfig').subscribe(function (uiLayoutConfig) {
            _this.uiLayoutConfig = uiLayoutConfig;
        });
    }
    /**
     * Sets layout config properties and updates session object.
     *
     * @param {string | string[]} properties
     * @param {any | any[]} values
     */
    /**
     * Sets layout config properties and updates session object.
     *
     * @param {?} properties
     * @param {?} values
     * @return {?}
     */
    UILayoutConfigService.prototype.setProperty = /**
     * Sets layout config properties and updates session object.
     *
     * @param {?} properties
     * @param {?} values
     * @return {?}
     */
    function (properties, values) {
        if (typeof (properties) === 'string') {
            properties = [properties];
            values = [values];
        }
        if (properties.length !== values.length) {
            console.warn('Number of properties does not match number of values');
            return;
        }
        for (var i = 0; i < properties.length; i++) {
            this.uiLayoutConfig[properties[i]] = values[i];
        }
        this.uiSessionService.setItem('uiLayoutConfig', this.uiLayoutConfig);
    };
    UILayoutConfigService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UILayoutConfigService.ctorParameters = function () { return [
        { type: UISessionService }
    ]; };
    return UILayoutConfigService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var ScreenSizes = {
    sm1: { min: 0, max: 374 },
    sm2: { min: 375, max: 574 },
    sm3: { min: 575, max: 774 },
    md1: { min: 775, max: 974 },
    md2: { min: 975, max: 1174 },
    md3: { min: 1175, max: 1374 },
    lg1: { min: 1375, max: 1574 },
    lg2: { min: 1575, max: 1774 },
    lg3: { min: 1775, max: 999999 },
};
var UIResponsiveService$1 = /** @class */ (function () {
    function UIResponsiveService() {
    }
    /**
     * Accepts screen size key and returns whether the screen currently matches that size
     *
     * @param {string | string[]} checkSize
     * @returns {boolean}
     */
    /**
     * Accepts screen size key and returns whether the screen currently matches that size
     *
     * @param {?} checkSize
     * @return {?}
     */
    UIResponsiveService.prototype.screenIs = /**
     * Accepts screen size key and returns whether the screen currently matches that size
     *
     * @param {?} checkSize
     * @return {?}
     */
    function (checkSize) {
        if (typeof (checkSize) === 'string') {
            checkSize = [checkSize];
        }
        for (var _i = 0, checkSize_1 = checkSize; _i < checkSize_1.length; _i++) {
            var size = checkSize_1[_i];
            this.validateScreenSize(size);
            /** @type {?} */
            var windowWidth = window.innerWidth;
            if (windowWidth >= ScreenSizes[size].min && windowWidth < ScreenSizes[size].max) {
                return true;
            }
        }
        return false;
    };
    /**
     * Accepts screen size key and returns whether the screen is currently less than,
     * or equal to it
     *
     * @param {string} checkSize
     *
     * @returns {boolean}
     *
     * @throws {Error}
     */
    /**
     * Accepts screen size key and returns whether the screen is currently less than,
     * or equal to it
     *
     *
     *
     * @throws {Error}
     * @param {?} checkSize
     * @return {?}
     */
    UIResponsiveService.prototype.screenIsLTE = /**
     * Accepts screen size key and returns whether the screen is currently less than,
     * or equal to it
     *
     *
     *
     * @throws {Error}
     * @param {?} checkSize
     * @return {?}
     */
    function (checkSize) {
        this.validateScreenSize(checkSize);
        /** @type {?} */
        var windowWidth = window.innerWidth;
        return windowWidth < ScreenSizes[checkSize].max;
    };
    /**
     * Accepts screen size key and returns whether the screen is currently less than it
     *
     * @param {string} checkSize
     *
     * @returns {boolean}
     *
     * @throws {Error}
     */
    /**
     * Accepts screen size key and returns whether the screen is currently less than it
     *
     *
     *
     * @throws {Error}
     * @param {?} checkSize
     * @return {?}
     */
    UIResponsiveService.prototype.screenIsLT = /**
     * Accepts screen size key and returns whether the screen is currently less than it
     *
     *
     *
     * @throws {Error}
     * @param {?} checkSize
     * @return {?}
     */
    function (checkSize) {
        this.validateScreenSize(checkSize);
        /** @type {?} */
        var windowWidth = window.innerWidth;
        return windowWidth < ScreenSizes[checkSize].min;
    };
    /**
     * Accepts screen size key and returns whether the screen is currently greater than,
     * or equal to it
     *
     * @param {string} checkSize
     *
     * @returns {boolean}
     *
     * @throws {Error}
     */
    /**
     * Accepts screen size key and returns whether the screen is currently greater than,
     * or equal to it
     *
     *
     *
     * @throws {Error}
     * @param {?} checkSize
     * @return {?}
     */
    UIResponsiveService.prototype.screenIsGTE = /**
     * Accepts screen size key and returns whether the screen is currently greater than,
     * or equal to it
     *
     *
     *
     * @throws {Error}
     * @param {?} checkSize
     * @return {?}
     */
    function (checkSize) {
        this.validateScreenSize(checkSize);
        /** @type {?} */
        var windowWidth = window.innerWidth;
        return windowWidth >= ScreenSizes[checkSize].min;
    };
    /**
     * Accepts screen size key and returns whether the screen is currently greater than it
     *
     * @param {string} checkSize
     *
     * @returns {boolean}
     *
     * @throws {Error}
     */
    /**
     * Accepts screen size key and returns whether the screen is currently greater than it
     *
     *
     *
     * @throws {Error}
     * @param {?} checkSize
     * @return {?}
     */
    UIResponsiveService.prototype.screenIsGT = /**
     * Accepts screen size key and returns whether the screen is currently greater than it
     *
     *
     *
     * @throws {Error}
     * @param {?} checkSize
     * @return {?}
     */
    function (checkSize) {
        this.validateScreenSize(checkSize);
        /** @type {?} */
        var windowWidth = window.innerWidth;
        return windowWidth > ScreenSizes[checkSize].max;
    };
    /**
     * Gets the current screen size
     *
     * @returns {string}
     */
    /**
     * Gets the current screen size
     *
     * @return {?}
     */
    UIResponsiveService.prototype.getScreenSize = /**
     * Gets the current screen size
     *
     * @return {?}
     */
    function () {
        /** @type {?} */
        var returnValue = '';
        for (var key in ScreenSizes) {
            if (this.screenIs(key.toString())) {
                returnValue = key.toString();
            }
        }
        return returnValue;
    };
    /**
     * Checks if passes size is a valid key
     *
     * @param checkSize
     *
     * @throws {Error}
     */
    /**
     * Checks if passes size is a valid key
     *
     * @throws {Error}
     * @param {?} checkSize
     *
     * @return {?}
     */
    UIResponsiveService.prototype.validateScreenSize = /**
     * Checks if passes size is a valid key
     *
     * @throws {Error}
     * @param {?} checkSize
     *
     * @return {?}
     */
    function (checkSize) {
        if (!ScreenSizes[checkSize]) {
            throw new Error('Invalid size');
        }
    };
    UIResponsiveService.decorators = [
        { type: Injectable },
    ];
    return UIResponsiveService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UINavigationService$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UISessionService} uiSessionService
     */
    function UINavigationService(uiSessionService) {
        var _this = this;
        this.uiSessionService = uiSessionService;
        this.uiApp = this.uiSessionService.getItem('uiApp');
        this.uiSessionService.getSubject('uiApp').subscribe(function (uiApp) {
            _this.uiApp = uiApp;
        });
    }
    /**
     * Gets main nav item by name.
     *
     * @param {string} name
     *
     * @return {UIMainNavItem}
     */
    /**
     * Gets main nav item by name.
     *
     *
     * @param {?} name
     * @return {?}
     */
    UINavigationService.prototype.getMainNavItem = /**
     * Gets main nav item by name.
     *
     *
     * @param {?} name
     * @return {?}
     */
    function (name) {
        /** @type {?} */
        var mainNavItem = this.uiApp.mainNavItems.find(function (uiMainNavItem) {
            return uiMainNavItem.name === name;
        });
        if (!mainNavItem) {
            console.warn("No main nav item found with the name of: " + name);
            return;
        }
        return mainNavItem;
    };
    UINavigationService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UINavigationService.ctorParameters = function () { return [
        { type: UISessionService }
    ]; };
    return UINavigationService;
}());

var __extends$8 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @template T
 */
var /**
 * @template T
 */
UICacheSubject = /** @class */ (function (_super) {
    __extends$8(UICacheSubject, _super);
    function UICacheSubject(value) {
        if (value === void 0) { value = undefined; }
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    /**
     * @return {?}
     */
    UICacheSubject.prototype.getValue = /**
     * @return {?}
     */
    function () {
        return this.value;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    UICacheSubject.prototype.next = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        _super.prototype.next.call(this, value);
    };
    return UICacheSubject;
}(Subject));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISessionService$1 = /** @class */ (function () {
    /**
     * IMPORTANT! Do not pass anything into this constructor. It will break error handling.
     */
    function UISessionService() {
        this.cache = {};
    }
    /**
     * Checks if an item exists.
     *
     * @param {string} key
     *
     * @returns {boolean}
     */
    /**
     * Checks if an item exists.
     *
     *
     * @param {?} key
     * @return {?}
     */
    UISessionService.prototype.itemExists = /**
     * Checks if an item exists.
     *
     *
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return !!this.cache[key];
    };
    /**
     * Sets item into cache storage.
     *
     * @param {string} key
     *
     * @param value
     */
    /**
     * Sets item into cache storage.
     *
     *
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    UISessionService.prototype.setItem = /**
     * Sets item into cache storage.
     *
     *
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        if (!this.cache[key]) {
            this.cache[key] = new UICacheSubject(value);
            return;
        }
        this.cache[key].next(value);
    };
    /**
     * Gets item from cache storage.
     *
     * @param {string} key
     *
     * @returns {any}
     */
    /**
     * Gets item from cache storage.
     *
     *
     * @param {?} key
     * @return {?}
     */
    UISessionService.prototype.getItem = /**
     * Gets item from cache storage.
     *
     *
     * @param {?} key
     * @return {?}
     */
    function (key) {
        if (this.cache[key]) {
            return this.cache[key].getValue();
        }
        return undefined;
    };
    /**
     * Gets subject-wrapped item in cache storage.
     *
     * @param {string} key
     *
     * @returns {UICacheSubject<any>}
     */
    /**
     * Gets subject-wrapped item in cache storage.
     *
     *
     * @param {?} key
     * @return {?}
     */
    UISessionService.prototype.getSubject = /**
     * Gets subject-wrapped item in cache storage.
     *
     *
     * @param {?} key
     * @return {?}
     */
    function (key) {
        if (!this.cache[key]) {
            return this.cache[key] = new UICacheSubject();
        }
        return this.cache[key];
    };
    /**
     * Removes item from cache storage.
     *
     * @param {string} key
     */
    /**
     * Removes item from cache storage.
     *
     * @param {?} key
     * @return {?}
     */
    UISessionService.prototype.removeItem = /**
     * Removes item from cache storage.
     *
     * @param {?} key
     * @return {?}
     */
    function (key) {
        if (this.cache[key]) {
            this.cache[key].next(null);
            delete this.cache[key];
        }
    };
    /**
     * Removes multiple items from session storage.
     *
     * @param {string[]} keys
     */
    /**
     * Removes multiple items from session storage.
     *
     * @param {?} keys
     * @return {?}
     */
    UISessionService.prototype.removeItems = /**
     * Removes multiple items from session storage.
     *
     * @param {?} keys
     * @return {?}
     */
    function (keys) {
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            this.removeItem(key);
        }
    };
    /**
     * Clears all session data.
     */
    /**
     * Clears all session data.
     * @return {?}
     */
    UISessionService.prototype.removeAll = /**
     * Clears all session data.
     * @return {?}
     */
    function () {
        this.cache = {};
    };
    UISessionService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UISessionService.ctorParameters = function () { return []; };
    return UISessionService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIStorageService$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UICookieStorageService} uiCookieStorageService
     * @param {UILocalStorageService} uiLocalStorageService
     * @param {UISessionService} uiSessionService
     */
    function UIStorageService(uiCookieStorageService, uiLocalStorageService, uiSessionService) {
        this.uiCookieStorageService = uiCookieStorageService;
        this.uiLocalStorageService = uiLocalStorageService;
        this.uiSessionService = uiSessionService;
        this.supportsLS = this.supportsLocalStorage();
        this.supportsCS = this.supportsCookieStorage();
    }
    /**
     * Sets either cookie or local storage item with key and value.
     *
     * @param {string} key
     * @param {string} value
     */
    /**
     * Sets either cookie or local storage item with key and value.
     *
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    UIStorageService.prototype.setItem = /**
     * Sets either cookie or local storage item with key and value.
     *
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        if (this.supportsLS) {
            return this.uiLocalStorageService.setItem(key, value);
        }
        if (this.supportsCS) {
            return this.uiCookieStorageService.setItem(key, value);
        }
        this.uiSessionService.setItem(key, value);
    };
    /**
     * Gets item from cookie or local storage.
     *
     * @param {string} key
     * @returns {string}
     */
    /**
     * Gets item from cookie or local storage.
     *
     * @param {?} key
     * @return {?}
     */
    UIStorageService.prototype.getItem = /**
     * Gets item from cookie or local storage.
     *
     * @param {?} key
     * @return {?}
     */
    function (key) {
        if (this.supportsLS) {
            return this.uiLocalStorageService.getItem(key);
        }
        if (this.supportsCS) {
            return this.uiCookieStorageService.getItem(key);
        }
        return this.uiSessionService.getItem(key);
    };
    /**
     * Removes item from cookie or local storage.
     *
     * @param {string} key
     */
    /**
     * Removes item from cookie or local storage.
     *
     * @param {?} key
     * @return {?}
     */
    UIStorageService.prototype.removeItem = /**
     * Removes item from cookie or local storage.
     *
     * @param {?} key
     * @return {?}
     */
    function (key) {
        if (this.supportsLS) {
            return this.uiLocalStorageService.removeItem(key);
        }
        if (this.supportsCS) {
            return this.uiCookieStorageService.removeItem(key);
        }
        this.uiSessionService.removeItem(key);
    };
    /**
     * Checks if local storage is supported.
     *
     * @returns {boolean}
     */
    /**
     * Checks if local storage is supported.
     *
     * @return {?}
     */
    UIStorageService.prototype.supportsLocalStorage = /**
     * Checks if local storage is supported.
     *
     * @return {?}
     */
    function () {
        try {
            localStorage.setItem('test', 'test');
            localStorage.removeItem('test');
            return true;
        }
        catch (e) {
            return false;
        }
    };
    /**
     * Checks if cookie storage is supported.
     *
     * @returns {boolean}
     */
    /**
     * Checks if cookie storage is supported.
     *
     * @return {?}
     */
    UIStorageService.prototype.supportsCookieStorage = /**
     * Checks if cookie storage is supported.
     *
     * @return {?}
     */
    function () {
        if (navigator.cookieEnabled) {
            return true;
        }
        document.cookie = 'testCookie=1';
        /** @type {?} */
        var result = document.cookie.indexOf('testCookie=') !== -1;
        document.cookie = 'testCookie=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
        return result;
    };
    UIStorageService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIStorageService.ctorParameters = function () { return [
        { type: UICookieStorageService },
        { type: UILocalStorageService },
        { type: UISessionService }
    ]; };
    return UIStorageService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIHelperService$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {DomSanitizer} domSanitizer
     */
    function UIHelperService(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    /**
     * Checks if a string contains any instances of the contents of an array of search terms
     *
     * @param {string} string
     * @param {string[]} searchTerms
     * @returns {boolean}
     */
    /**
     * Checks if a string contains any instances of the contents of an array of search terms
     *
     * @param {?} string
     * @param {?} searchTerms
     * @return {?}
     */
    UIHelperService.prototype.stringContainsAny = /**
     * Checks if a string contains any instances of the contents of an array of search terms
     *
     * @param {?} string
     * @param {?} searchTerms
     * @return {?}
     */
    function (string, searchTerms) {
        for (var _i = 0, searchTerms_1 = searchTerms; _i < searchTerms_1.length; _i++) {
            var a = searchTerms_1[_i];
            if (string.indexOf(a) !== -1) {
                return true;
            }
        }
        return false;
    };
    /**
     * Replaces HTML tag open / closures with HTML encoded values
     *
     * @param {string} html
     * @returns {string}
     */
    /**
     * Replaces HTML tag open / closures with HTML encoded values
     *
     * @param {?} html
     * @return {?}
     */
    UIHelperService.prototype.escapeHTML = /**
     * Replaces HTML tag open / closures with HTML encoded values
     *
     * @param {?} html
     * @return {?}
     */
    function (html) {
        html = html.replace(new RegExp('<', 'g'), '&lt;');
        html = html.replace(new RegExp('>', 'g'), '&gt;');
        return html;
    };
    /**
     * Generates a random string to the required length
     *
     * @param {number} length
     * @returns {string}
     */
    /**
     * Generates a random string to the required length
     *
     * @param {?} length
     * @return {?}
     */
    UIHelperService.prototype.generateRandomString = /**
     * Generates a random string to the required length
     *
     * @param {?} length
     * @return {?}
     */
    function (length) {
        /** @type {?} */
        var possible = 'abcdefghijklmnopqrstuvwxyz0123456789';
        /** @type {?} */
        var possibleFirst = 'abcdefghijklmnopqrstuvwxyz';
        /** @type {?} */
        var randomString = possibleFirst.charAt(Math.floor(Math.random() * possibleFirst.length));
        for (var i = 0; i < length - 1; i++) {
            randomString += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return randomString;
    };
    /**
     * Creates an acronym from a string.
     *
     * @param {string} stringToAcronymise
     * @param {number} maxLength
     * @returns {string}
     */
    /**
     * Creates an acronym from a string.
     *
     * @param {?} stringToAcronymise
     * @param {?} maxLength
     * @return {?}
     */
    UIHelperService.prototype.acronymise = /**
     * Creates an acronym from a string.
     *
     * @param {?} stringToAcronymise
     * @param {?} maxLength
     * @return {?}
     */
    function (stringToAcronymise, maxLength) {
        /** @type {?} */
        var parts = stringToAcronymise.split(' ').map(function (part) {
            return part.substr(0, 1);
        }).filter(function (character) {
            return character.match(/[a-z]/i);
        });
        return parts.join('').substr(0, maxLength).toUpperCase();
    };
    /**
     * Copies objects
     *
     * @param object
     * @returns {any}
     */
    /**
     * Copies objects
     *
     * @param {?} object
     * @return {?}
     */
    UIHelperService.prototype.copy = /**
     * Copies objects
     *
     * @param {?} object
     * @return {?}
     */
    function (object) {
        return JSON.parse(JSON.stringify(object));
    };
    /**
     * Checks if the values of two arrays match each other
     *
     * @param {any[]} a1
     * @param {any[]} a2
     * @returns {boolean}
     */
    /**
     * Checks if the values of two arrays match each other
     *
     * @param {?} a1
     * @param {?} a2
     * @return {?}
     */
    UIHelperService.prototype.arraysMatch = /**
     * Checks if the values of two arrays match each other
     *
     * @param {?} a1
     * @param {?} a2
     * @return {?}
     */
    function (a1, a2) {
        if (typeof (a1) === 'undefined' && typeof (a2) === 'undefined') {
            return true;
        }
        else if (typeof (a1) !== typeof (a2)) {
            return false;
        }
        else if (a1.length !== a2.length) {
            return false;
        }
        else {
            return JSON.stringify(a1) === JSON.stringify(a2);
        }
    };
    /**
     * Filters all duplicates out of array.
     *
     * @param {any[]} array
     *
     * @returns {any[]}
     */
    /**
     * Filters all duplicates out of array.
     *
     *
     * @param {?} array
     * @return {?}
     */
    UIHelperService.prototype.getDistinctArray = /**
     * Filters all duplicates out of array.
     *
     *
     * @param {?} array
     * @return {?}
     */
    function (array) {
        /** @type {?} */
        var distinctItems = [];
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var item = array_1[_i];
            if (distinctItems.indexOf(item) === -1) {
                distinctItems.push(item);
            }
        }
        return distinctItems;
    };
    /**
     * Builds common separated address from array of strings
     *
     * @param {string[]} lines
     * @param {boolean} break_line
     *
     * @returns {string}
     */
    /**
     * Builds common separated address from array of strings
     *
     *
     * @param {?} lines
     * @param {?=} break_line
     * @return {?}
     */
    UIHelperService.prototype.buildAddress = /**
     * Builds common separated address from array of strings
     *
     *
     * @param {?} lines
     * @param {?=} break_line
     * @return {?}
     */
    function (lines, break_line) {
        if (break_line === void 0) { break_line = false; }
        /** @type {?} */
        var address = '';
        /** @type {?} */
        var br = (break_line) ? '<br>' : '';
        for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
            var l = lines_1[_i];
            if (l !== '' && l !== null) {
                address += (address !== '') ? ', ' + br + l : l;
            }
        }
        return address;
    };
    /**
     * Builds map links.
     *
     * @param {String} location
     * @param {boolean} embed
     *
     * @returns {SafeResourceUrl}
     */
    /**
     * Builds map links.
     *
     *
     * @param {?} location
     * @param {?} embed
     * @return {?}
     */
    UIHelperService.prototype.getMapLink = /**
     * Builds map links.
     *
     *
     * @param {?} location
     * @param {?} embed
     * @return {?}
     */
    function (location, embed) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl('https://maps.google.co.uk/maps?q=' + location.replace(/ /g, '+') + ((embed) ? '&output=embed' : ''));
    };
    UIHelperService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIHelperService.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    return UIHelperService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIScrollService$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies. Configures PageScrollService.
     *
     * @param {PageScrollService} pageScrollService
     * @param {UIResponsiveService} uiResponsiveService
     * @param {UISessionService} uiSessionService
     * @param {Router} router
     */
    function UIScrollService(pageScrollService, uiResponsiveService, uiSessionService, router) {
        var _this = this;
        this.pageScrollService = pageScrollService;
        this.uiResponsiveService = uiResponsiveService;
        this.uiSessionService = uiSessionService;
        this.router = router;
        this.sizeBasis = 32;
        this.modalOpen = false;
        PageScrollConfig.defaultScrollOffset = 0;
        PageScrollConfig.defaultDuration = 300;
        PageScrollConfig.defaultEasingLogic = {
            ease: function (t, b, c, d) {
                // easeInOutExpo easing
                if (t === 0) {
                    return b;
                }
                if (t === d) {
                    return b + c;
                }
                if ((t /= d / 2) < 1) {
                    return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
                }
                return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
            }
        };
        this.router.events.subscribe(function (routerEvent) {
            if (routerEvent instanceof NavigationEnd) {
                /** @type {?} */
                var modalExists = routerEvent.urlAfterRedirects.indexOf('(modal:') !== -1;
                if (!modalExists) {
                    if (_this.modalOpen) {
                        _this.modalOpen = false;
                    }
                    else {
                        _this.scrollTop();
                    }
                    _this.unlock();
                }
                else {
                    if (_this.modalOpen) {
                        /** @type {?} */
                        var modalBody = document.querySelector('#modalBody');
                        modalBody.scrollTop = 0;
                    }
                    _this.modalOpen = true;
                }
            }
        });
    }
    /**
     *
     *
     */
    /**
     *
     *
     * @return {?}
     */
    UIScrollService.prototype.scrollTop = /**
     *
     *
     * @return {?}
     */
    function () {
        window.scrollTo(0, 0);
    };
    /**
     * Scrolls the view to the section related to the clicked item.
     *
     * @param {string} target
     * @param {number} offset
     */
    /**
     * Scrolls the view to the section related to the clicked item.
     *
     * @param {?} target
     * @param {?=} offset
     * @return {?}
     */
    UIScrollService.prototype.smoothScrollTo = /**
     * Scrolls the view to the section related to the clicked item.
     *
     * @param {?} target
     * @param {?=} offset
     * @return {?}
     */
    function (target, offset) {
        if (offset === void 0) { offset = this.getScrollOffset(); }
        /** @type {?} */
        var pageScrollInstance = PageScrollInstance.newInstance({
            document: document,
            scrollTarget: target,
            pageScrollOffset: offset
        });
        this.pageScrollService.start(pageScrollInstance);
    };
    /**
     * Scrolls the modal body to the requested section.
     * #
     * @param {string} target
     * @param {number} offset
     */
    /**
     * Scrolls the modal body to the requested section.
     * #
     * @param {?} target
     * @param {?=} offset
     * @return {?}
     */
    UIScrollService.prototype.smoothScrollModalTo = /**
     * Scrolls the modal body to the requested section.
     * #
     * @param {?} target
     * @param {?=} offset
     * @return {?}
     */
    function (target, offset) {
        if (offset === void 0) { offset = this.getModalScrollOffset(); }
        /** @type {?} */
        var pageScrollInstance = PageScrollInstance.newInstance({
            document: document,
            scrollTarget: target,
            pageScrollOffset: offset,
            scrollingViews: [document.querySelector('#modalBody')]
        });
        this.pageScrollService.start(pageScrollInstance);
    };
    /**
     * Returns scroll offset.
     *
     * @returns {number}
     */
    /**
     * Returns scroll offset.
     *
     * @return {?}
     */
    UIScrollService.prototype.getScrollOffset = /**
     * Returns scroll offset.
     *
     * @return {?}
     */
    function () {
        /**
                 * Has top nav
                 */
        if (this.uiSessionService.getItem('uiApp').navPosition === 'top') {
            /**
                         * Also has consumer audience
                         */
            if (this.uiSessionService.getItem('uiApp').audience === 'consumer') {
                if (this.uiResponsiveService.screenIsGTE('md3')) {
                    return this.sizeBasis * 5 + 10;
                }
                if (this.uiResponsiveService.screenIsGTE('md1')) {
                    return this.sizeBasis * 4.25 + 10;
                }
                return this.sizeBasis * 2 + 5;
            }
            if (this.uiResponsiveService.screenIsGTE('md3')) {
                return this.sizeBasis * 4.5 + 10;
            }
            if (this.uiResponsiveService.screenIsGTE('md1')) {
                return this.sizeBasis * 3.75 + 10;
            }
            return this.sizeBasis * 2 + 5;
        }
        return this.sizeBasis * 3 + 10;
    };
    /**
     * Returns scroll offset.
     *
     * @returns {number}
     */
    /**
     * Returns scroll offset.
     *
     * @return {?}
     */
    UIScrollService.prototype.getModalScrollOffset = /**
     * Returns scroll offset.
     *
     * @return {?}
     */
    function () {
        if (this.uiResponsiveService.screenIsGTE('sm3')) {
            return this.sizeBasis * 0.75;
        }
        return this.sizeBasis * 0.5;
    };
    /**
     * Locks scrolling, but maintains scroll position.
     *
     * @param {number} offset
     * @param {number} cssDelay
     */
    /**
     * Locks scrolling, but maintains scroll position.
     *
     * @param {?=} offset
     * @param {?=} cssDelay
     * @return {?}
     */
    UIScrollService.prototype.lock = /**
     * Locks scrolling, but maintains scroll position.
     *
     * @param {?=} offset
     * @param {?=} cssDelay
     * @return {?}
     */
    function (offset, cssDelay) {
        if (offset === void 0) { offset = 0; }
        if (cssDelay === void 0) { cssDelay = 0; }
        if (!ios) {
            document.body.style.top = -offset + 'px';
        }
        setTimeout(function () {
            document.body.classList.add('scroll-lock');
        }, cssDelay);
    };
    /**
     * Unlocks scrolling and resets scroll position to previous.
     *
     * @param {number} offset
     */
    /**
     * Unlocks scrolling and resets scroll position to previous.
     *
     * @param {?=} offset
     * @return {?}
     */
    UIScrollService.prototype.unlock = /**
     * Unlocks scrolling and resets scroll position to previous.
     *
     * @param {?=} offset
     * @return {?}
     */
    function (offset) {
        if (offset === void 0) { offset = 0; }
        if (document.body.classList.contains('scroll-lock')) {
            document.body.classList.remove('scroll-lock');
            window.scrollTo(0, offset);
            if (!ios) {
                document.body.style.top = '0';
            }
        }
    };
    UIScrollService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIScrollService.ctorParameters = function () { return [
        { type: PageScrollService },
        { type: UIResponsiveService },
        { type: UISessionService },
        { type: Router }
    ]; };
    return UIScrollService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIModalService$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Router} router
     * @param {UIScrollService} uiScrollService
     */
    function UIModalService(router, uiScrollService) {
        var _this = this;
        this.router = router;
        this.uiScrollService = uiScrollService;
        this.uiModal$ = new Subject();
        this.bodyScrollTop = 0;
        this.router.events.subscribe(function (routerEvent) {
            if (routerEvent instanceof NavigationEnd) {
                /** @type {?} */
                var modalExists = routerEvent.urlAfterRedirects.indexOf('(modal:') !== -1;
                if (!modalExists) {
                    _this.uiModal = null;
                    _this.uiModal$.next(null);
                }
            }
        });
    }
    /**
     * Initialises modal config.
     *
     * @param {(string | number)[]} route
     * @param data
     * @param {boolean} showInUrlBar
     */
    /**
     * Initialises modal config.
     *
     * @param {?} route
     * @param {?=} data
     * @param {?=} showInUrlBar
     * @return {?}
     */
    UIModalService.prototype.show = /**
     * Initialises modal config.
     *
     * @param {?} route
     * @param {?=} data
     * @param {?=} showInUrlBar
     * @return {?}
     */
    function (route, data, showInUrlBar) {
        if (data === void 0) { data = null; }
        if (showInUrlBar === void 0) { showInUrlBar = true; }
        if (this.uiModal) {
            this.nextModal = {
                route: route,
                data: data,
                showInUrlBar: showInUrlBar
            };
            this.close();
        }
        else {
            this.nextModal = null;
            this.navigate(route, data, showInUrlBar);
        }
    };
    /**
     * Navigates to modal route.
     *
     * @param {(string | number)[]} route
     * @param data
     * @param {boolean} showInUrlBar
     */
    /**
     * Navigates to modal route.
     *
     * @param {?} route
     * @param {?=} data
     * @param {?=} showInUrlBar
     * @return {?}
     */
    UIModalService.prototype.navigate = /**
     * Navigates to modal route.
     *
     * @param {?} route
     * @param {?=} data
     * @param {?=} showInUrlBar
     * @return {?}
     */
    function (route, data, showInUrlBar) {
        if (data === void 0) { data = null; }
        if (showInUrlBar === void 0) { showInUrlBar = true; }
        this.data = data;
        if (route[0].toString().startsWith('/')) {
            route[0] = route[0].toString().substring(1);
        }
        this.router.navigate([{ outlets: { 'modal': 'dialog/' + route.join('/') } }], { skipLocationChange: data ? true : !showInUrlBar });
    };
    /**
     * Sets config.
     *
     * @param {UIModal} uiModal
     */
    /**
     * Sets config.
     *
     * @param {?} uiModal
     * @return {?}
     */
    UIModalService.prototype.setConfig = /**
     * Sets config.
     *
     * @param {?} uiModal
     * @return {?}
     */
    function (uiModal) {
        this.uiModal = Object.assign(new UIModal(), uiModal);
        this.uiModal$.next(this.uiModal);
    };
    /**
     * Sets show state.
     *
     * @param {boolean} show
     */
    /**
     * Sets show state.
     *
     * @param {?} show
     * @return {?}
     */
    UIModalService.prototype.setShow = /**
     * Sets show state.
     *
     * @param {?} show
     * @return {?}
     */
    function (show) {
        if (this.uiModal) {
            this.uiModal.show = show;
            this.uiModal$.next(this.uiModal);
            if (show) {
                this.bodyScrollTop = window.pageYOffset;
                this.uiScrollService.lock(this.bodyScrollTop, 200);
            }
            else {
                this.uiScrollService.unlock(this.bodyScrollTop);
            }
        }
    };
    /**
     * Closes modal.
     */
    /**
     * Closes modal.
     * @return {?}
     */
    UIModalService.prototype.close = /**
     * Closes modal.
     * @return {?}
     */
    function () {
        this.setShow(false);
    };
    /**
     * Destroys modal.
     */
    /**
     * Destroys modal.
     * @return {?}
     */
    UIModalService.prototype.destroy = /**
     * Destroys modal.
     * @return {?}
     */
    function () {
        var _this = this;
        this.router.navigate([{ outlets: { 'modal': null } }]).then(function () {
            _this.uiModal = null;
            _this.uiModal$.next(null);
            if (_this.nextModal) {
                _this.navigate(_this.nextModal.route, _this.nextModal.data, _this.nextModal.showInUrlBar);
                _this.nextModal = null;
            }
        });
    };
    UIModalService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIModalService.ctorParameters = function () { return [
        { type: Router },
        { type: UIScrollService }
    ]; };
    return UIModalService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIToast = /** @class */ (function () {
    function UIToast(uiToast) {
        this.state = 'ready';
        Object.assign(/** @type {?} */ (this), uiToast);
    }
    return UIToast;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIToastService$1 = /** @class */ (function () {
    function UIToastService() {
        this.uiToast$ = new BehaviorSubject(null);
        this.duration = 6000;
        this.maxLength = 60;
    }
    /**
     * Success uiToast
     *
     * @param message
     */
    /**
     * Success uiToast
     *
     * @param {?} message
     * @return {?}
     */
    UIToastService.prototype.success = /**
     * Success uiToast
     *
     * @param {?} message
     * @return {?}
     */
    function (message) {
        this.show(new UIToast({
            message: message,
            type: 'success'
        }));
    };
    /**
     * Error uiToast
     *
     * @param message
     */
    /**
     * Error uiToast
     *
     * @param {?} message
     * @return {?}
     */
    UIToastService.prototype.error = /**
     * Error uiToast
     *
     * @param {?} message
     * @return {?}
     */
    function (message) {
        this.show(new UIToast({
            message: message,
            type: 'error'
        }));
    };
    /**
     * Warning uiToast
     *
     * @param message
     */
    /**
     * Warning uiToast
     *
     * @param {?} message
     * @return {?}
     */
    UIToastService.prototype.warning = /**
     * Warning uiToast
     *
     * @param {?} message
     * @return {?}
     */
    function (message) {
        this.show(new UIToast({
            message: message,
            type: 'warning'
        }));
    };
    /**
     * Information uiToast
     *
     * @param message
     */
    /**
     * Information uiToast
     *
     * @param {?} message
     * @return {?}
     */
    UIToastService.prototype.info = /**
     * Information uiToast
     *
     * @param {?} message
     * @return {?}
     */
    function (message) {
        this.show(new UIToast({
            message: message,
            type: 'info'
        }));
    };
    /**
     * Show the uiToast
     *
     * @param uiToast
     */
    /**
     * Show the uiToast
     *
     * @param {?} uiToast
     * @return {?}
     */
    UIToastService.prototype.show = /**
     * Show the uiToast
     *
     * @param {?} uiToast
     * @return {?}
     */
    function (uiToast) {
        var _this = this;
        // Force next tick to account for toasts shown after navigation has completed.
        setTimeout(function () {
            if (uiToast.message.length > 60) {
                console.warn("Toast message exceeded maximum of " + _this.maxLength + " characters. Message was trimmed.");
                uiToast.message = uiToast.message.substring(0, _this.maxLength - 3) + '...';
            }
            uiToast = new UIToast(uiToast);
            if (_this.uiToast$.getValue()) {
                _this.nextToast = uiToast;
                _this.remove();
                return;
            }
            _this.uiToast$.next(uiToast);
            _this.removeTimeout = setTimeout(function () {
                _this.remove();
            }, _this.duration);
        });
    };
    /**
     * Remove the uiToast by changing state
     */
    /**
     * Remove the uiToast by changing state
     * @return {?}
     */
    UIToastService.prototype.remove = /**
     * Remove the uiToast by changing state
     * @return {?}
     */
    function () {
        /** @type {?} */
        var currentToast = this.uiToast$.getValue();
        if (!!currentToast) {
            currentToast.state = 'removing';
            this.uiToast$.next(currentToast);
            clearTimeout(this.removeTimeout);
        }
    };
    /**
     * Destroys the uiToast
     */
    /**
     * Destroys the uiToast
     * @return {?}
     */
    UIToastService.prototype.destroy = /**
     * Destroys the uiToast
     * @return {?}
     */
    function () {
        this.uiToast$.next(null);
        clearTimeout(this.removeTimeout);
        if (this.nextToast) {
            this.show(this.nextToast);
            this.nextToast = null;
        }
    };
    UIToastService.decorators = [
        { type: Injectable },
    ];
    return UIToastService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIThemeService$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIHttpService} uiHttpService
     * @param {UISessionService} uiSessionService
     * @param {DomSanitizer} domSanitizer
     */
    function UIThemeService(uiHttpService, uiSessionService, domSanitizer) {
        this.uiHttpService = uiHttpService;
        this.uiSessionService = uiSessionService;
        this.domSanitizer = domSanitizer;
    }
    /**
     * Sets theme based on fixed theme color.
     *
     * @param {string} color
     *
     * @returns {Observable<any>}
     */
    /**
     * Sets theme based on fixed theme color.
     *
     *
     * @param {?} color
     * @return {?}
     */
    UIThemeService.prototype.setFromColor = /**
     * Sets theme based on fixed theme color.
     *
     *
     * @param {?} color
     * @return {?}
     */
    function (color) {
        /** @type {?} */
        var faviconPath = "/assets/images/favicons/favicon-" + color + ".png";
        /** @type {?} */
        var cssPath = "/assets/css/theme-cd-" + color + ".min.css";
        return forkJoin(this.setFavicon(faviconPath), this.setCSS(cssPath));
    };
    /**
     * Sets theme from branding object.
     *
     * @param branding
     *
     * @returns {Observable<any>}
     */
    /**
     * Sets theme from branding object.
     *
     * @param {?} branding
     *
     * @return {?}
     */
    UIThemeService.prototype.setFromBranding = /**
     * Sets theme from branding object.
     *
     * @param {?} branding
     *
     * @return {?}
     */
    function (branding) {
        if (!branding || (Array.isArray(branding) && branding.length < 1)) {
            return of(false);
        }
        /** @type {?} */
        var uiApp = this.uiSessionService.getItem('uiApp');
        /** @type {?} */
        var assetsToFetch = [];
        if (branding.logo_on_header) {
            uiApp.logoUrl = this.buildAssetPath(uiApp.environment.assetsUrl, branding.logo_on_header);
            this.uiSessionService.setItem('uiApp', uiApp);
        }
        if (branding.favicon_path) {
            assetsToFetch.push(this.setFavicon(this.buildAssetPath(uiApp.environment.assetsUrl, branding.favicon_path)));
        }
        if (branding.css_path) {
            assetsToFetch.push(this.setCSS(this.buildAssetPath(uiApp.environment.assetsUrl, branding.css_path)));
        }
        if (assetsToFetch.length) {
            return forkJoin(assetsToFetch);
        }
        return of('No assets to fetch');
    };
    /**
     * Appends environment assets path if not full url.
     *
     * @param {string} assetsUrl
     * @param {string} path
     *
     * @returns {string}
     */
    /**
     * Appends environment assets path if not full url.
     *
     *
     * @param {?} assetsUrl
     * @param {?} path
     * @return {?}
     */
    UIThemeService.prototype.buildAssetPath = /**
     * Appends environment assets path if not full url.
     *
     *
     * @param {?} assetsUrl
     * @param {?} path
     * @return {?}
     */
    function (assetsUrl, path) {
        return path.indexOf('http') === 0 ? path : assetsUrl + '/' + path;
    };
    /**
     * Checks if CSS file exists and sets contents into style tag.
     *
     * @param {string} path
     *
     * @returns {Observable<boolean>}
     */
    /**
     * Checks if CSS file exists and sets contents into style tag.
     *
     *
     * @param {?} path
     * @return {?}
     */
    UIThemeService.prototype.setCSS = /**
     * Checks if CSS file exists and sets contents into style tag.
     *
     *
     * @param {?} path
     * @return {?}
     */
    function (path) {
        return this.uiHttpService.get(path, { observe: 'response', responseType: 'text' }).pipe(map(function (response) {
            if (response.ok) {
                /** @type {?} */
                var style$$1 = document.querySelector('#themeCSS');
                /** @type {?} */
                var exists = !!style$$1;
                if (!exists) {
                    style$$1 = document.createElement('style');
                    style$$1.setAttribute('id', 'themeCSS');
                    style$$1.setAttribute('type', 'text/css');
                }
                while (style$$1.firstChild) {
                    style$$1.removeChild(style$$1.firstChild);
                }
                style$$1.appendChild(document.createTextNode(response.body));
                if (!exists) {
                    /** @type {?} */
                    var head = document.querySelector('head');
                    head.appendChild(style$$1);
                }
            }
            return true;
        })).pipe(catchError(function () {
            return of(false);
        }));
    };
    /**
     * Attempts to set favicon from path.
     *
     * @param {string} path
     *
     * @returns {Observable<boolean>}
     */
    /**
     * Attempts to set favicon from path.
     *
     *
     * @param {?} path
     * @return {?}
     */
    UIThemeService.prototype.setFavicon = /**
     * Attempts to set favicon from path.
     *
     *
     * @param {?} path
     * @return {?}
     */
    function (path) {
        return this.uiHttpService.get(path, { observe: 'response', responseType: 'blob' }).pipe(map(function (response) {
            if (response.ok) {
                /** @type {?} */
                var faviconLink = document.querySelector('#favicon');
                faviconLink.setAttribute('href', path);
            }
            return true;
        })).pipe(catchError(function () {
            return of(false);
        }));
    };
    /**
     * Builds CSS Class for themed element.
     *
     * @param {"primary" | "positive" | "warning" | "negative" | "accent"} theme
     * @param {"color" | "background" | "border" | "br" | "bb" | "bl" | "bt"} property
     * @param {"foreground" | "highlight" | "mix" | null} themeDerivative
     * @param {"hover" | "focus" | "active" | null} pseudoClass
     * @param {"before" | "after" | null} pseudoElement
     *
     * @returns {string}
     */
    /**
     * Builds CSS Class for themed element.
     *
     *
     * @param {?} theme
     * @param {?} property
     * @param {?=} themeDerivative
     * @param {?=} pseudoClass
     * @param {?=} pseudoElement
     * @return {?}
     */
    UIThemeService.prototype.buildCssClass = /**
     * Builds CSS Class for themed element.
     *
     *
     * @param {?} theme
     * @param {?} property
     * @param {?=} themeDerivative
     * @param {?=} pseudoClass
     * @param {?=} pseudoElement
     * @return {?}
     */
    function (theme, property, themeDerivative, pseudoClass, pseudoElement) {
        if (themeDerivative === void 0) { themeDerivative = null; }
        if (pseudoClass === void 0) { pseudoClass = null; }
        if (pseudoElement === void 0) { pseudoElement = null; }
        /** @type {?} */
        var cssClass = '';
        // THEME
        if (theme === 'warning') {
            cssClass = 'warn-';
        }
        else {
            cssClass = theme.substr(0, 3) + '-';
        }
        // THEME DERIVATIVE
        switch (themeDerivative) {
            case 'foreground':
                cssClass += 'fg-';
                break;
            case 'highlight':
                cssClass += 'hl-';
                break;
            case 'mix':
                cssClass += 'mix-';
                break;
            default:
                cssClass += themeDerivative ? themeDerivative + '-' : '';
                break;
        }
        // PSEUDO CLASS
        if (pseudoClass) {
            cssClass += pseudoClass.substr(0, 3);
        }
        // PSEUDO ELEMENT
        if (pseudoElement) {
            cssClass += pseudoElement.substr(0, 3);
        }
        // PROPERTY
        switch (property) {
            case 'color':
                cssClass += 'col';
                break;
            case 'background':
                cssClass += 'bg';
                break;
            case 'border':
                cssClass += 'bd';
                break;
            default:
                cssClass += property;
                break;
        }
        return cssClass;
    };
    UIThemeService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIThemeService.ctorParameters = function () { return [
        { type: UIHttpService },
        { type: UISessionService },
        { type: DomSanitizer }
    ]; };
    return UIThemeService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIHttpService$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {HttpClient} httpClient
     */
    function UIHttpService(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Handles incoming requests and directs them accordingly.
     *
     * @param {string} requestType
     * @param {string} source
     * @param body
     * @param options
     *
     * @return {Observable<any>}
     */
    /**
     * Handles incoming requests and directs them accordingly.
     *
     * @param {?} requestType
     * @param {?} source
     * @param {?=} body
     * @param {?=} options
     *
     * @return {?}
     */
    UIHttpService.prototype.request = /**
     * Handles incoming requests and directs them accordingly.
     *
     * @param {?} requestType
     * @param {?} source
     * @param {?=} body
     * @param {?=} options
     *
     * @return {?}
     */
    function (requestType, source, body, options) {
        if (body === void 0) { body = null; }
        if (options === void 0) { options = null; }
        if (requestType === 'get') {
            return this.get(source, options);
        }
        if (requestType === 'delete') {
            return this.get(source, options);
        }
        if (requestType === 'post') {
            return this.post(source, body, options);
        }
        if (requestType === 'put') {
            return this.put(source, body, options);
        }
        if (requestType === 'patch') {
            return this.patch(source, body, options);
        }
    };
    /**
     * Http GET Method.
     *
     * @param {string} source
     * @param options
     *
     * @returns {Observable<any>}
     */
    /**
     * Http GET Method.
     *
     * @param {?} source
     * @param {?} options
     *
     * @return {?}
     */
    UIHttpService.prototype.get = /**
     * Http GET Method.
     *
     * @param {?} source
     * @param {?} options
     *
     * @return {?}
     */
    function (source, options) {
        return this.httpClient.get(source, options);
    };
    /**
     * Http DELETE Method.
     *
     * @param {string} source
     * @param options
     *
     * @returns {Observable<any>}
     */
    /**
     * Http DELETE Method.
     *
     * @param {?} source
     * @param {?} options
     *
     * @return {?}
     */
    UIHttpService.prototype.delete = /**
     * Http DELETE Method.
     *
     * @param {?} source
     * @param {?} options
     *
     * @return {?}
     */
    function (source, options) {
        return this.httpClient.delete(source, options);
    };
    /**
     * Http POST Method.
     *
     * @param {string} source
     * @param body
     * @param options
     *
     * @returns {Observable<any>}
     */
    /**
     * Http POST Method.
     *
     * @param {?} source
     * @param {?} body
     * @param {?} options
     *
     * @return {?}
     */
    UIHttpService.prototype.post = /**
     * Http POST Method.
     *
     * @param {?} source
     * @param {?} body
     * @param {?} options
     *
     * @return {?}
     */
    function (source, body, options) {
        return this.httpClient.post(source, body, options);
    };
    /**
     * Http PUT Method.
     *
     * @param {string} source
     * @param body
     * @param options
     *
     * @returns {Observable<any>}
     */
    /**
     * Http PUT Method.
     *
     * @param {?} source
     * @param {?} body
     * @param {?} options
     *
     * @return {?}
     */
    UIHttpService.prototype.put = /**
     * Http PUT Method.
     *
     * @param {?} source
     * @param {?} body
     * @param {?} options
     *
     * @return {?}
     */
    function (source, body, options) {
        return this.httpClient.put(source, body, options);
    };
    /**
     * Http PATCH Method.
     *
     * @param {string} source
     * @param body
     * @param options
     *
     * @returns {Observable<any>}
     */
    /**
     * Http PATCH Method.
     *
     * @param {?} source
     * @param {?} body
     * @param {?} options
     *
     * @return {?}
     */
    UIHttpService.prototype.patch = /**
     * Http PATCH Method.
     *
     * @param {?} source
     * @param {?} body
     * @param {?} options
     *
     * @return {?}
     */
    function (source, body, options) {
        return this.httpClient.patch(source, body, options);
    };
    UIHttpService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIHttpService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    return UIHttpService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIRestService$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIHttpService} uiHttpService
     * @param {UISessionService} uiSessionService
     * @param {UIToastService} uiToastService
     * @param {UIStorageService} uiStorageService
     * @param {Router} router
     */
    function UIRestService(uiHttpService, uiSessionService, uiToastService, uiStorageService, router) {
        var _this = this;
        this.uiHttpService = uiHttpService;
        this.uiSessionService = uiSessionService;
        this.uiToastService = uiToastService;
        this.uiStorageService = uiStorageService;
        this.router = router;
        if (this.uiSessionService.itemExists('uiApp')) {
            this.apiUrl = this.uiSessionService.getItem('uiApp').environment.apiUrl + '/';
        }
        this.uiSessionService.getSubject('uiApp').subscribe(function (uiApp) {
            _this.apiUrl = uiApp.environment.apiUrl + '/';
        });
    }
    /**
     * Returns one instance of requested objects.
     *
     * @param {(string|number)[]} uriParts
     * @param {UIRestOptions} options
     *
     * @returns {Observable<UIDataItem>}
     */
    /**
     * Returns one instance of requested objects.
     *
     *
     * @param {?} uriParts
     * @param {?=} options
     * @return {?}
     */
    UIRestService.prototype.one = /**
     * Returns one instance of requested objects.
     *
     *
     * @param {?} uriParts
     * @param {?=} options
     * @return {?}
     */
    function (uriParts, options) {
        return this.sendRequest('get', uriParts, null, options).pipe(map(function (response) {
            if (options && options.returnRawResponse) {
                return response;
            }
            if (response.ok) {
                return response.body['data'];
            }
            return null;
        }));
    };
    /**
     * Returns an array of requested objects.
     *
     * @param {(string|number)[]} uriParts
     * @param {{include: string[]}} options
     *
     * @returns {Observable<{ data: UIDataItem[], meta: any }>}
     */
    /**
     * Returns an array of requested objects.
     *
     *
     * @param {?} uriParts
     * @param {?=} options
     * @return {?}
     */
    UIRestService.prototype.list = /**
     * Returns an array of requested objects.
     *
     *
     * @param {?} uriParts
     * @param {?=} options
     * @return {?}
     */
    function (uriParts, options) {
        return this.sendRequest('get', uriParts, null, options).pipe(map(function (response) {
            if (options && options.returnRawResponse) {
                return response;
            }
            if (response.body) {
                return response.body;
            }
            return [];
        }));
    };
    /**
     * Posts object and return its instance
     *
     * @param {(string|number)[]} uriParts
     * @param {any} body
     * @param {UIRestOptions} options
     *
     * @returns {Observable<UIDataItem>}
     */
    /**
     * Posts object and return its instance
     *
     *
     * @param {?} uriParts
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    UIRestService.prototype.post = /**
     * Posts object and return its instance
     *
     *
     * @param {?} uriParts
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    function (uriParts, body, options) {
        return this.sendRequest('post', uriParts, body, options).pipe(map(function (response) {
            if (options && options.returnRawResponse) {
                return response;
            }
            if (response.body) {
                return response.body['data'] || null;
            }
            return null;
        }));
    };
    /**
     * Updates object and returns its instance.
     *
     * @param {(string|number)[]} uriParts
     * @param body
     * @param {UIRestOptions} options
     *
     * @returns {Observable<UIDataItem>}
     */
    /**
     * Updates object and returns its instance.
     *
     * @param {?} uriParts
     * @param {?} body
     *
     * @param {?=} options
     * @return {?}
     */
    UIRestService.prototype.put = /**
     * Updates object and returns its instance.
     *
     * @param {?} uriParts
     * @param {?} body
     *
     * @param {?=} options
     * @return {?}
     */
    function (uriParts, body, options) {
        return this.sendRequest('put', uriParts, body, options).pipe(map(function (response) {
            if (response.body) {
                return response.body['data'] || null;
            }
            return null;
        }));
    };
    /**
     * Updates object and returns its instance.
     *
     * @param {(string|number)[]} uriParts
     * @param body
     * @param {{include: string[]}} options
     *
     * @returns {Observable<UIDataItem>}
     */
    /**
     * Updates object and returns its instance.
     *
     * @param {?} uriParts
     * @param {?} body
     *
     * @param {?=} options
     * @return {?}
     */
    UIRestService.prototype.patch = /**
     * Updates object and returns its instance.
     *
     * @param {?} uriParts
     * @param {?} body
     *
     * @param {?=} options
     * @return {?}
     */
    function (uriParts, body, options) {
        return this.sendRequest('patch', uriParts, body, options).pipe(map(function (response) {
            if (options && options.returnRawResponse) {
                return response;
            }
            if (response.body) {
                return response.body['data'] || null;
            }
            return null;
        }));
    };
    /**
     * Deletes object and returns empty observable.
     *
     * @param {(string|number)[]} uriParts
     * @param {UIRestOptions} options
     *
     * @returns {Observable<any>}
     */
    /**
     * Deletes object and returns empty observable.
     *
     *
     * @param {?} uriParts
     * @param {?=} options
     * @return {?}
     */
    UIRestService.prototype.delete = /**
     * Deletes object and returns empty observable.
     *
     *
     * @param {?} uriParts
     * @param {?=} options
     * @return {?}
     */
    function (uriParts, options) {
        return this.sendRequest('delete', uriParts, null, options).pipe(map(function (response) {
            if (options && options.returnRawResponse) {
                return response;
            }
            return null;
        }));
    };
    /**
     * Builds request and calls http service to send.
     *
     * @param {string} requestType
     * @param {(string | number)[]} uriParts
     * @param body
     * @param {UIRestOptions} options
     *
     * @return {Observable<UIDataItem | {data: UIDataItem[]; meta: any} | any>}
     */
    /**
     * Builds request and calls http service to send.
     *
     * @param {?} requestType
     * @param {?} uriParts
     * @param {?=} body
     *
     * @param {?=} options
     * @return {?}
     */
    UIRestService.prototype.sendRequest = /**
     * Builds request and calls http service to send.
     *
     * @param {?} requestType
     * @param {?} uriParts
     * @param {?=} body
     *
     * @param {?=} options
     * @return {?}
     */
    function (requestType, uriParts, body, options) {
        var _this = this;
        if (body === void 0) { body = null; }
        /** @type {?} */
        var requestSource = this.getRequestSource(uriParts);
        /** @type {?} */
        var requestOptions = this.getRequestOptions(options);
        return this.uiHttpService.request(requestType, requestSource, body, requestOptions).pipe(catchError(function (error) {
            if (options && options.returnRawResponse) {
                return of(error);
            }
            _this.uiSessionService.setItem('httpErrorRequest', { source: requestSource, options: requestOptions });
            return _this.handleError(error);
        }));
    };
    /**
     * Gets request source from API url and uriParts array.
     *
     * @param {string[]} uriParts
     *
     * @returns {string}
     */
    /**
     * Gets request source from API url and uriParts array.
     *
     *
     * @param {?} uriParts
     * @return {?}
     */
    UIRestService.prototype.getRequestSource = /**
     * Gets request source from API url and uriParts array.
     *
     *
     * @param {?} uriParts
     * @return {?}
     */
    function (uriParts) {
        if (uriParts[0].toString().startsWith('/')) {
            uriParts[0] = uriParts[0].toString().substring(1);
        }
        return this.apiUrl + uriParts.join('/');
    };
    /**
     * Gets request options from passes options.
     *
     * @param {UIRestOptions} options
     *
     * @returns {any}
     */
    /**
     * Gets request options from passes options.
     *
     *
     * @param {?} options
     * @return {?}
     */
    UIRestService.prototype.getRequestOptions = /**
     * Gets request options from passes options.
     *
     *
     * @param {?} options
     * @return {?}
     */
    function (options) {
        options = new UIRestOptions(options);
        /** @type {?} */
        var params = new HttpParams();
        if (options.include && options.include.length) {
            params = params.append('include', options.include.join(','));
        }
        /** @type {?} */
        var headers = new HttpHeaders();
        if (options.requiresAuthorization) {
            /** @type {?} */
            var token = this.uiStorageService.getItem('token');
            if (token) {
                headers = headers.append('Authorization', "Bearer " + token);
            }
        }
        return {
            observe: 'response',
            params: params,
            headers: headers
        };
    };
    /**
     * Handle error.
     *
     * @param {HttpErrorResponse} error
     *
     * @returns {ErrorObservable}
     */
    /**
     * Handle error.
     *
     *
     * @param {?} error
     * @return {?}
     */
    UIRestService.prototype.handleError = /**
     * Handle error.
     *
     *
     * @param {?} error
     * @return {?}
     */
    function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            this.uiToastService.error('An error occurred');
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // store error data in session and pass to error component
            this.uiSessionService.setItem('httpErrorResponse', error);
            this.uiSessionService.setItem('httpErrorLocation', (/** @type {?} */ (window)).location);
            this.router.navigate(['/error', error.status], { skipLocationChange: true });
        }
        // return an ErrorObservable with a user-facing error message
        return EMPTY;
    };
    UIRestService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIRestService.ctorParameters = function () { return [
        { type: UIHttpService },
        { type: UISessionService },
        { type: UIToastService },
        { type: UIStorageService },
        { type: Router }
    ]; };
    return UIRestService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIDealerResolver = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UISessionService} uiSessionService
     * @param {UIRestService} uiRestService
     * @param {UIHelperService} uiHelperService
     * @param {DomSanitizer} domSanitizer
     */
    function UIDealerResolver(uiSessionService, uiRestService, uiHelperService, domSanitizer) {
        this.uiSessionService = uiSessionService;
        this.uiRestService = uiRestService;
        this.uiHelperService = uiHelperService;
        this.domSanitizer = domSanitizer;
    }
    /**
     * Gets dealer from session if already present, if not gets dealer from rest service.
     *
     * @param {ActivatedRouteSnapshot} activatedRouteSnapshot
     *
     * @returns {Observable<any>}
     */
    /**
     * Gets dealer from session if already present, if not gets dealer from rest service.
     *
     *
     * @param {?} activatedRouteSnapshot
     * @return {?}
     */
    UIDealerResolver.prototype.resolve = /**
     * Gets dealer from session if already present, if not gets dealer from rest service.
     *
     *
     * @param {?} activatedRouteSnapshot
     * @return {?}
     */
    function (activatedRouteSnapshot) {
        var _this = this;
        if (this.uiSessionService.itemExists('dealer')) {
            return of(this.uiSessionService.getItem('dealer'));
        }
        if (this.uiSessionService.itemExists('uiApp')) {
            /** @type {?} */
            var uiApp = this.uiSessionService.getItem('uiApp');
            return this.uiRestService.one(['dealers', uiApp.environment.subDomain]).pipe(map(function (dealer) {
                if (dealer["primary_addresses"] && dealer["primary_addresses"][0]) {
                    dealer["address"] = _this.buildAddress(dealer["primary_addresses"][0]);
                    dealer["map_link"] = _this.buildMapLink(dealer, false);
                    dealer["map_embed_link"] = _this.buildMapLink(dealer, true);
                }
                _this.uiSessionService.setItem('dealer', dealer);
                return dealer;
            }));
        }
        return EMPTY;
    };
    /**
     * Builds Address from object.
     *
     * @param address
     *
     * @returns {string}
     */
    /**
     * Builds Address from object.
     *
     * @param {?} address
     *
     * @return {?}
     */
    UIDealerResolver.prototype.buildAddress = /**
     * Builds Address from object.
     *
     * @param {?} address
     *
     * @return {?}
     */
    function (address) {
        return this.uiHelperService.buildAddress([address.line1, address.line2, address.line3, address.city, address.county, address.postal_code]);
    };
    /**
     * Builds map links.
     *
     * @param {UIDataItem} dealer
     * @param {boolean} embed
     *
     * @returns {SafeResourceUrl}
     */
    /**
     * Builds map links.
     *
     *
     * @param {?} dealer
     * @param {?} embed
     * @return {?}
     */
    UIDealerResolver.prototype.buildMapLink = /**
     * Builds map links.
     *
     *
     * @param {?} dealer
     * @param {?} embed
     * @return {?}
     */
    function (dealer, embed) {
        /** @type {?} */
        var location = (dealer["name"] + ',' + dealer["primary_addresses"][0].postal_code).replace(/ /g, '+');
        return this.domSanitizer.bypassSecurityTrustResourceUrl('https://maps.google.co.uk/maps?q=' + location + ((embed) ? '&output=embed' : ''));
    };
    UIDealerResolver.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIDealerResolver.ctorParameters = function () { return [
        { type: UISessionService },
        { type: UIRestService },
        { type: UIHelperService },
        { type: DomSanitizer }
    ]; };
    return UIDealerResolver;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIMaxNumberPipe = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {DecimalPipe} decimalPipe
     */
    function UIMaxNumberPipe(decimalPipe) {
        this.decimalPipe = decimalPipe;
    }
    /**
     * Limits number and appends '+' if greater than maximum.
     *
     * @param {number} value
     * @param {number} maxValue
     * @param {string} valueDigitsInfo
     *
     * @returns {string}
     */
    /**
     * Limits number and appends '+' if greater than maximum.
     *
     *
     * @param {?} value
     * @param {?} maxValue
     * @param {?=} valueDigitsInfo
     * @return {?}
     */
    UIMaxNumberPipe.prototype.transform = /**
     * Limits number and appends '+' if greater than maximum.
     *
     *
     * @param {?} value
     * @param {?} maxValue
     * @param {?=} valueDigitsInfo
     * @return {?}
     */
    function (value, maxValue, valueDigitsInfo) {
        if (valueDigitsInfo === void 0) { valueDigitsInfo = '1.0-0'; }
        if (value > maxValue) {
            return this.decimalPipe.transform(maxValue, valueDigitsInfo) + '+';
        }
        return this.decimalPipe.transform(value, valueDigitsInfo);
    };
    UIMaxNumberPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'uiMaxNumber'
                },] },
    ];
    /** @nocollapse */
    UIMaxNumberPipe.ctorParameters = function () { return [
        { type: DecimalPipe }
    ]; };
    return UIMaxNumberPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIMaxNumberModule = /** @class */ (function () {
    function UIMaxNumberModule() {
    }
    /**
     * @return {?}
     */
    UIMaxNumberModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: UIMaxNumberModule,
            providers: [
                UIMaxNumberPipe
            ]
        };
    };
    UIMaxNumberModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIMaxNumberPipe
                    ],
                    imports: [],
                    providers: [
                        DecimalPipe$1
                    ],
                    exports: [
                        UIMaxNumberPipe
                    ]
                },] },
    ];
    return UIMaxNumberModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UINavListComponent = /** @class */ (function () {
    function UINavListComponent() {
        this.navigation = new EventEmitter();
    }
    /**
     * Emits navigation event to parent.
     */
    /**
     * Emits navigation event to parent.
     * @return {?}
     */
    UINavListComponent.prototype.onNavigation = /**
     * Emits navigation event to parent.
     * @return {?}
     */
    function () {
        this.navigation.emit();
    };
    UINavListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-nav-list',
                    template: "\n      <ul>\n\n          <!--  PARENT LOOP  -->\n\n          <li *ngFor=\"let navItem of navItems\" [class.parent]=\"navItem.children\" [class.expanded]=\"navItem.expanded\" [routerLinkActive]=\"'active'\">\n\n              <!--  ITEM WITH NO CHILDREN  -->\n\n              <a *ngIf=\"!navItem.children\" class=\"pri-hl-col\" [class.has-prefix]=\"navItem.prefix\" [routerLink]=\"['/' + parentPath, navItem.path]\" [routerLinkActive]=\"'acc-hl-br'\" (click)=\"onNavigation()\">\n                  <span class=\"prefix\">{{ navItem.prefix }}</span>{{ navItem.name }}\n              </a>\n\n              <!--  END ITEM WITH NO CHILDREN  -->\n\n              <!--  PARENT WITH ACTIVE CHILD - NOT EXPANDED  -->\n\n              <a *ngIf=\"navItem.children\" class=\"is-active pri-hl-col acc-hl-br\" [class.has-prefix]=\"navItem.prefix\" (click)=\"navItem.expanded = !navItem.expanded\">\n                  <i class=\"fas fa-chevron-right acc-hl-col\"></i>\n                  <span class=\"prefix\">{{ navItem.prefix }}</span>{{ navItem.name }}\n              </a>\n\n              <!-- END PARENT WITH ACTIVE CHILD - NOT EXPANDED  -->\n\n              <!--  PARENT WITH ACTIVE CHILD - EXPANDED  -->\n\n              <a *ngIf=\"navItem.children\" class=\"is-inactive pri-hl-col\" [class.has-prefix]=\"navItem.prefix\" (click)=\"navItem.expanded = !navItem.expanded\">\n                  <i class=\"fas fa-chevron-right acc-hl-col\"></i>\n                  <span class=\"prefix\">{{ navItem.prefix }}</span>{{ navItem.name }}\n              </a>\n\n              <!--  END PARENT WITH ACTIVE CHILD - EXPANDED  -->\n\n              <!--  CHILD ITEMS  -->\n\n              <ul *ngIf=\"navItem.children\">\n\n                  <!--  CHILD ITEM LOOP  -->\n\n                  <li *ngFor=\"let subNavItem of navItem.children\" [routerLinkActive]=\"'active'\">\n                      <a class=\"pri-hl-mix-col\" [routerLink]=\"['/' +  parentPath, navItem.path, subNavItem.path]\" [routerLinkActive]=\"'acc-hl-br pri-hl-col'\" (click)=\"onNavigation()\">\n                          {{ subNavItem.name }}\n                      </a>\n                  </li>\n\n                  <!--  END CHILD ITEM LOOP  -->\n\n              </ul>\n\n              <!--  END CHILD ITEMS  -->\n\n          </li>\n\n          <!--  END PARENT LOOP  -->\n\n      </ul>\n    ",
                    styles: ["\n      :host>ul{font-size:13px}:host>ul>li{-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s}:host>ul>li a{display:block;line-height:1.45em;padding:10px 16px 10px 32px;cursor:pointer;position:relative;-webkit-transition:inherit;-o-transition:inherit;transition:inherit;overflow:hidden;border-right:5px solid #f2f2f2;z-index:1;background:#f2f2f2;color:#222}:host>ul>li a .prefix{display:none}:host>ul>li a.has-prefix{padding-left:56px}:host>ul>li a.has-prefix .prefix{display:inline-block;position:absolute;width:24px;left:32px}:host>ul>li a:hover{background:#FFF;border-right-color:#dedede}:host>ul>li>ul{overflow:hidden;max-height:0;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;opacity:0;padding:0}:host>ul>li>ul>li{-webkit-transition:inherit;-o-transition:inherit;transition:inherit}:host>ul>li>ul>li>a{padding:10px 16px 10px 56px;color:#646464}:host>ul>li.active>a{background:#FFF}:host>ul>li.active:not(.parent)>a{border-right-color:#222}:host>ul>li.parent>a .fa-chevron-right{font-size:10px;position:absolute;left:-10px;display:block;width:10px;height:10px;line-height:10px;-webkit-transform-origin:center;-ms-transform-origin:center;transform-origin:center;margin:-5px 0 0;top:50%;opacity:0;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;-webkit-transform:rotate(0);-ms-transform:rotate(0);transform:rotate(0);text-align:center}:host>ul>li.parent>a.is-active{display:none}:host>ul>li.parent>a.is-inactive{display:block}:host>ul>li.parent:hover>a .fa-chevron-right{left:12.8px;opacity:1}:host>ul>li.parent.expanded>a .fa-chevron-right{left:12.8px;opacity:1;-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}:host>ul>li.parent.expanded>ul{max-height:100vh;opacity:1}:host>ul>li.parent.active>a{background:#f2f2f2}:host>ul>li.parent.active>a:hover{background:#FFF}:host>ul>li.parent.active>ul>li.active>a{background:#FFF;border-right-color:#222}:host>ul>li.parent.active:not(.expanded)>a.is-active{display:block;background:#FFF;border-right-color:#222}:host>ul>li.parent.active:not(.expanded)>a.is-inactive{display:none}@media screen and (max-width:1174px){:host>ul>li a{padding:8px 16px 8px 24px}:host>ul>li a.has-prefix{padding-left:48px}:host>ul>li a.has-prefix .prefix{left:24px}:host>ul>li>ul>li>a{padding:8px 16px 8px 32px}:host>ul>li.parent:hover>a .fa-chevron-right{left:8px}:host>ul>li.parent.expanded>a .fa-chevron-right{left:8px}}\n    "]
                },] },
    ];
    UINavListComponent.propDecorators = {
        navItems: [{ type: Input }],
        parentPath: [{ type: Input }],
        navigation: [{ type: Output }]
    };
    return UINavListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UINavListModule = /** @class */ (function () {
    function UINavListModule() {
    }
    UINavListModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UINavListComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule
                    ],
                    providers: [],
                    exports: [
                        UINavListComponent
                    ]
                },] },
    ];
    return UINavListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UICoreModule = /** @class */ (function () {
    function UICoreModule() {
    }
    /**
     * @return {?}
     */
    UICoreModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: UICoreModule,
            providers: [
                PageScrollService$1,
                UICookieStorageService$1,
                UINotificationsService,
                UIScriptLoaderService$1,
                UILocalStorageService$1,
                UILayoutConfigService$1,
                UINavigationService$1,
                UIResponsiveService$1,
                UIStorageService$1,
                UISessionService$1,
                UIHelperService$1,
                UIScrollService$1,
                UIModalService$1,
                UIToastService$1,
                UIThemeService$1,
                UIHttpService$1,
                UIRestService$1,
                UIDealerResolver
            ]
        };
    };
    UICoreModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIHttpErrorComponent,
                        UIFooterComponent,
                        UIErrorComponent,
                        UIStartComponent,
                        UINavComponent,
                        UIAppModuleSwitcherModalComponent,
                        UISearchModalComponent,
                        UIModalComponent
                    ],
                    imports: [
                        HttpClientModule,
                        CommonModule,
                        RouterModule,
                        NgxPageScrollModule,
                        UIMaxNumberModule.forRoot(),
                        UITooltipModule,
                        UINavListModule,
                        UILoadingModule,
                        UITabBarModule
                    ],
                    exports: [
                        UIHttpErrorComponent,
                        UIFooterComponent,
                        UIErrorComponent,
                        UIStartComponent,
                        UINavComponent,
                        UIAppModuleSwitcherModalComponent,
                        UISearchModalComponent,
                        UIModalComponent
                    ]
                },] },
    ];
    return UICoreModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIKeyValueListComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIResponsiveService} uiResponsiveService
     */
    function UIKeyValueListComponent(uiResponsiveService) {
        this.uiResponsiveService = uiResponsiveService;
        this.align = 'right';
        this.style = 'plain';
        this.size = 'default';
        this.adjacentAt = 'sm1';
        this.keyCols = 15;
    }
    /**
     * Lifecycle hook: Sets CSS classes.
     */
    /**
     * Lifecycle hook: Sets CSS classes.
     * @return {?}
     */
    UIKeyValueListComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Sets CSS classes.
     * @return {?}
     */
    function () {
        this.items = this.getMappedItems();
        this.keyContainerCssClass = this.getKeyContainerCssClass();
        this.valueContainerCssClass = this.getValueContainerCssClass();
    };
    /**
     * Lifecycle hook: Detects changes from inputs and updates component properties.
     *
     * @param {SimpleChanges} simpleChanges
     */
    /**
     * Lifecycle hook: Detects changes from inputs and updates component properties.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    UIKeyValueListComponent.prototype.ngOnChanges = /**
     * Lifecycle hook: Detects changes from inputs and updates component properties.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    function (simpleChanges) {
        if (simpleChanges['adjacentAt'] || simpleChanges['keyCols'] || simpleChanges['align']) {
            this.keyContainerCssClass = this.getKeyContainerCssClass();
            this.valueContainerCssClass = this.getValueContainerCssClass();
        }
        if (simpleChanges['items']) {
            this.items = this.getMappedItems();
        }
    };
    /**
     * Ensures string values are replaced with objects.
     *
     * @returns {UIKeyValueItem[]}
     */
    /**
     * Ensures string values are replaced with objects.
     *
     * @return {?}
     */
    UIKeyValueListComponent.prototype.getMappedItems = /**
     * Ensures string values are replaced with objects.
     *
     * @return {?}
     */
    function () {
        return this.items.map(function (item) {
            if (typeof (item.value) === 'string') {
                item.value = {
                    type: 'text',
                    text: item.value
                };
            }
            return item;
        });
    };
    /**
     * Returns css classes for key container.
     *
     * @returns {string}
     */
    /**
     * Returns css classes for key container.
     *
     * @return {?}
     */
    UIKeyValueListComponent.prototype.getKeyContainerCssClass = /**
     * Returns css classes for key container.
     *
     * @return {?}
     */
    function () {
        if (this.adjacentAt === null || this.adjacentAt === 'sm1') {
            return "col-sm1-" + this.keyCols;
        }
        return "col-sm1-30 col-" + this.adjacentAt + "-" + this.keyCols;
    };
    /**
     * Returns css classes for value container.
     *
     * @returns {string}
     */
    /**
     * Returns css classes for value container.
     *
     * @return {?}
     */
    UIKeyValueListComponent.prototype.getValueContainerCssClass = /**
     * Returns css classes for value container.
     *
     * @return {?}
     */
    function () {
        if (this.adjacentAt === null || this.adjacentAt === 'sm1') {
            return "col-sm1-" + (30 - this.keyCols) + " value-align-" + this.align;
        }
        return "col-sm1-30 col-" + this.adjacentAt + "-" + (30 - this.keyCols) + " value-align-" + this.align;
    };
    /**
     * Handles click events from buttons.
     *
     * @param {UIActionButton} uiActionButton
     */
    /**
     * Handles click events from buttons.
     *
     * @param {?} uiActionButton
     * @return {?}
     */
    UIKeyValueListComponent.prototype.onButtonClick = /**
     * Handles click events from buttons.
     *
     * @param {?} uiActionButton
     * @return {?}
     */
    function (uiActionButton) {
        uiActionButton.working = uiActionButton.showWorking;
        uiActionButton.click(uiActionButton);
    };
    /**
     * Handles click events from link buttons.
     *
     * @param {UIActionLinkButton} uiActionLinkButton
     */
    /**
     * Handles click events from link buttons.
     *
     * @param {?} uiActionLinkButton
     * @return {?}
     */
    UIKeyValueListComponent.prototype.onLinkButtonClick = /**
     * Handles click events from link buttons.
     *
     * @param {?} uiActionLinkButton
     * @return {?}
     */
    function (uiActionLinkButton) {
        uiActionLinkButton.click(uiActionLinkButton);
    };
    UIKeyValueListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-key-value-list',
                    template: "\n      <!--  KEY VALUE LIST  -->\n\n      <ul class=\"key-value-list\" [ngClass]=\"'style-' + style + ' size-' + size\" [class.stacked]=\"uiResponsiveService.screenIsLT(adjacentAt)\">\n\n          <!--  ITEM LOOP  -->\n\n          <li *ngFor=\"let item of items\" class=\"row middle-sm1\" [class.has-icon]=\"!!item.icon\" [class.has-description]=\"!!item.description\">\n\n              <!--  KEY CONTAINER  -->\n\n              <div class=\"key-container\" [ngClass]=\"keyContainerCssClass\">\n\n                  <!--  ICON  -->\n\n                  <i *ngIf=\"item.icon\" class=\"pri-hl-col\" [ngClass]=\"item.icon\"></i>\n\n                  <!--  END ICON  -->\n\n                  <!--  KEY  -->\n\n                  <p class=\"key\">{{ item.key }}</p>\n\n                  <!--  END KEY  -->\n\n                  <!--  DESCRIPTION  -->\n\n                  <p *ngIf=\"item.description\" class=\"description\">{{ item.description }}</p>\n\n                  <!--  END DESCRIPTION  -->\n\n              </div>\n\n              <!--  END KEY CONTAINER  -->\n\n              <!--  VALUE CONTAINER  -->\n\n              <div *ngIf=\"item.value\" class=\"value-container\" [ngClass]=\"valueContainerCssClass\">\n\n                  <!--  BUTTON  -->\n\n                  <a *ngIf=\"item.value.type === 'button'\"\n                     class=\"button\"\n                     [ngClass]=\"item.value.theme + '-button'\"\n                     [uiLoading]=\"item.value.showWorking && item.value.working\"\n                     (click)=\"onButtonClick(item.value)\">\n                      {{ item.value.text }}\n                  </a>\n\n                  <!--  END BUTTON  -->\n\n                  <!--  ANCHOR LINK  -->\n\n                  <p *ngIf=\"item.value.type === 'anchorLink'\" class=\"link\"><a class=\"pri-hl-col pri-hl-mix-hov-col\" [attr.href]=\"item.value.href\" [attr.target]=\"item.value.target\">{{ item.value.text }}</a>\n                  </p>\n\n                  <!--  END ANCHOR LINK  -->\n\n                  <!--  LINK BUTTON  -->\n\n                  <p *ngIf=\"item.value.type === 'linkButton'\" class=\"link\"><a class=\"pri-hl-col pri-hl-mix-hov-col\" (click)=\"onLinkButtonClick(item.value)\">{{ item.value.text }}</a></p>\n\n                  <!--  END LINK BUTTON -->\n\n                  <!--  ROUTER LINK -->\n\n                  <p *ngIf=\"item.value.type === 'routerLink'\" class=\"link\"><a class=\"pri-hl-col pri-hl-mix-hov-col\" [routerLink]=\"item.value.navigateTo\">{{ item.value.text }}</a></p>\n\n                  <!--  END ROUTER LINK -->\n\n                  <!--  TEXT  -->\n\n                  <p *ngIf=\"item.value.type === 'text'\" class=\"text\">{{ item.value.text }}</p>\n\n                  <!--  END TEXT  -->\n\n              </div>\n\n              <!--  END VALUE CONTAINER  -->\n\n          </li>\n\n          <!--  END ITEM LOOP  -->\n\n      </ul>\n\n      <!--  END KEY VALUE LIST  -->\n    ",
                    styles: ["\n      :host .key-value-list>li{padding-bottom:16px}:host .key-value-list>li .key-container{padding-right:16px}:host .key-value-list>li .key-container .key{font-size:13px;font-weight:500;color:#222}:host .key-value-list>li .value-container{padding-left:16px}:host .key-value-list>li .value-container .link{font-size:13px;overflow-wrap:break-word}:host .key-value-list>li .value-container .text{font-size:13px;overflow-wrap:break-word}:host .key-value-list>li .value-container.value-align-left{text-align:left}:host .key-value-list>li .value-container.value-align-right{text-align:right}:host .key-value-list>li.has-icon .key-container{padding-left:32px;position:relative}:host .key-value-list>li.has-icon .key-container>i{position:absolute;top:1px;left:0;height:16px;line-height:16px;width:16px;font-size:16px;text-align:center}:host .key-value-list>li:last-child{padding-bottom:0}:host .key-value-list.style-separated>li{padding:16px 0;border-bottom:5px solid #f2f2f2}:host .key-value-list.style-separated>li:first-child{padding-top:0}:host .key-value-list.style-separated>li:last-child{padding-bottom:0;border-bottom:none}:host .key-value-list.style-striped>li{padding:16px;background:#f2f2f2;border-bottom:1px solid #d3d3d3}:host .key-value-list.style-striped>li:nth-child(even){background:#f8f8f8}:host .key-value-list.style-striped>li:first-child{border-radius:3px 3px 0 0}:host .key-value-list.style-striped>li:last-child{border-bottom:none;border-radius:0 0 3px 3px}:host .key-value-list.stacked>li .key-container{padding-right:0}:host .key-value-list.stacked>li .value-container,:host .key-value-list.stacked>li .value-container.value-align-right{padding-top:8px;padding-left:0;text-align:left}:host .key-value-list.stacked>li .value-container .button,:host .key-value-list.stacked>li .value-container.value-align-right .button{margin-top:8px}:host .key-value-list.stacked>li.has-icon .value-container{padding-left:32px}:host .key-value-list.size-large>li{padding-bottom:24px}:host .key-value-list.size-large>li .key-container .key{font-size:16px}:host .key-value-list.size-large>li .value-container .link,:host .key-value-list.size-large>li .value-container .text{font-size:16px}:host .key-value-list.size-large>li.has-icon .key-container{padding-left:48px}:host .key-value-list.size-large>li.has-icon .key-container>i{top:0;height:24px;line-height:24px;width:24px;font-size:24px}:host .key-value-list.size-large.style-separated>li{padding:24px 0}:host .key-value-list.size-large.style-separated>li:first-child{padding-top:0}:host .key-value-list.size-large.style-separated>li:last-child{padding-bottom:0}:host .key-value-list.size-large.style-striped>li{padding:24px}:host .key-value-list.size-large.stacked>li.has-icon .value-container{padding-left:48px}@media screen and (max-width:1174px){:host .key-value-list.size-large>li{padding-bottom:16px}:host .key-value-list.size-large>li .key-container .key{font-size:13px}:host .key-value-list.size-large>li .value-container .link,:host .key-value-list.size-large>li .value-container .text{font-size:13px}:host .key-value-list.size-large>li.has-icon .key-container{padding-left:32px}:host .key-value-list.size-large>li.has-icon .key-container>i{top:1px;height:16px;line-height:16px;width:16px;font-size:16px}:host .key-value-list.size-large.style-separated>li{padding:16px 0}:host .key-value-list.size-large.style-striped>li{padding:16px}:host .key-value-list.size-large.stacked>li.has-icon .value-container{padding-left:32px}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIKeyValueListComponent.ctorParameters = function () { return [
        { type: UIResponsiveService }
    ]; };
    UIKeyValueListComponent.propDecorators = {
        items: [{ type: Input }],
        align: [{ type: Input }],
        style: [{ type: Input }],
        size: [{ type: Input }],
        adjacentAt: [{ type: Input }],
        keyCols: [{ type: Input }]
    };
    return UIKeyValueListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIKeyValueItem = /** @class */ (function () {
    function UIKeyValueItem() {
    }
    return UIKeyValueItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIKeyValueListModule = /** @class */ (function () {
    function UIKeyValueListModule() {
    }
    UIKeyValueListModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIKeyValueListComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        UILoadingModule
                    ],
                    providers: [],
                    exports: [
                        UIKeyValueListComponent
                    ]
                },] },
    ];
    return UIKeyValueListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISideNavSectionComponent = /** @class */ (function () {
    function UISideNavSectionComponent() {
        this.showHeading = true;
    }
    UISideNavSectionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-side-nav-section',
                    template: "\n      <!--  SECTION  -->\n\n      <section [attr.id]=\"id\" class=\"section written-content padded\" [class.last-child]=\"lastChild\">\n\n          <!--  HEADING  -->\n\n          <h3 *ngIf=\"showHeading\">{{ title }}</h3>\n\n          <!--  END HEADING  -->\n\n          <!--  SECTION CONTENT  -->\n\n          <ng-content></ng-content>\n\n          <!--  END SECTION CONTENT  -->\n\n      </section>\n\n      <!--  END SIDE NAV SECTION  -->\n    "
                },] },
    ];
    UISideNavSectionComponent.propDecorators = {
        title: [{ type: Input }],
        linkText: [{ type: Input }],
        showHeading: [{ type: Input }],
        id: [{ type: Input }],
        lastChild: [{ type: Input }]
    };
    return UISideNavSectionComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISideNavItem = /** @class */ (function () {
    function UISideNavItem(uiSideNavItem) {
        Object.assign(/** @type {?} */ (this), uiSideNavItem);
    }
    return UISideNavItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISideNavContainerComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIHelperService} uiHelperService
     */
    function UISideNavContainerComponent(uiHelperService) {
        this.uiHelperService = uiHelperService;
        this.navPosition = 'right';
        this.sideNavHash = this.uiHelperService.generateRandomString(20);
        this.sideNavItems = [];
    }
    /**
     * Lifecycle hook: Set section IDs and create side nav bar
     */
    /**
     * Lifecycle hook: Set section IDs and create side nav bar
     * @return {?}
     */
    UISideNavContainerComponent.prototype.ngAfterContentInit = /**
     * Lifecycle hook: Set section IDs and create side nav bar
     * @return {?}
     */
    function () {
        this.buildSideNav();
    };
    /**
     * Builds side nav.
     */
    /**
     * Builds side nav.
     * @return {?}
     */
    UISideNavContainerComponent.prototype.buildSideNav = /**
     * Builds side nav.
     * @return {?}
     */
    function () {
        this.sideNavItems = [];
        /** @type {?} */
        var sectionsArray = this.sections.toArray();
        for (var i = 0; i < sectionsArray.length; i++) {
            /** @type {?} */
            var section = sectionsArray[i];
            /** @type {?} */
            var id = "section_" + this.sideNavHash + "_" + (i + 1);
            section.id = id;
            section.lastChild = i === sectionsArray.length - 1;
            this.sideNavItems.push(new UISideNavItem({
                id: id,
                name: section.linkText ? section.linkText : section.title
            }));
        }
    };
    UISideNavContainerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-side-nav-container',
                    template: "\n      <!--  SIDE NAV CONTAINER  -->\n\n      <div class=\"side-nav-container\">\n\n          <!--  CONTENT CONTAINER  -->\n\n          <div class=\"side-nav-content-container\">\n\n              <!--  SECTIONS  -->\n\n              <ng-content></ng-content>\n\n              <!--  END SECTIONS  -->\n\n          </div>\n\n          <!--  END CONTENT CONTAINER  -->\n\n          <!--  BAR CONTAINER  -->\n\n          <div class=\"side-nav-bar-container\">\n\n              <!--  SIDE NAV BAR  -->\n\n              <ui-side-nav-bar [uiSideNavItems]=\"sideNavItems\"></ui-side-nav-bar>\n\n              <!--  END SIDE NAV BAR  -->\n\n          </div>\n\n          <!--  END BAR CONTAINER  -->\n\n      </div>\n\n      <!--  END SIDE NAV CONTAINER  -->\n    ",
                    styles: ["\n      :host .side-nav-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch}:host .side-nav-container .side-nav-content-container{width:calc(100% - 256px)}:host .side-nav-container .side-nav-bar-container{width:256px;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-left:48px}@media screen and (max-width:1174px){:host .side-nav-container .side-nav-content-container{width:calc(100% - 200px)}:host .side-nav-container .side-nav-bar-container{padding-left:32px;width:208px}}@media screen and (max-width:974px){:host .side-nav-container .side-nav-content-container{width:100%}:host .side-nav-container .side-nav-bar-container{display:none}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UISideNavContainerComponent.ctorParameters = function () { return [
        { type: UIHelperService }
    ]; };
    UISideNavContainerComponent.propDecorators = {
        navPosition: [{ type: Input }],
        sections: [{ type: ContentChildren, args: [UISideNavSectionComponent,] }]
    };
    return UISideNavContainerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISideNavBarComponent = /** @class */ (function () {
    /**
     * Construct component and inject dependencies
     *
     * @param {UIScrollService} uiScrollService
     * @param {UIResponsiveService} uiResponsiveService
     * @param {UISessionService} uiSessionService
     */
    function UISideNavBarComponent(uiScrollService, uiResponsiveService, uiSessionService) {
        var _this = this;
        this.uiScrollService = uiScrollService;
        this.uiResponsiveService = uiResponsiveService;
        this.uiSessionService = uiSessionService;
        this.uiSideNavItems = [];
        this.uiApp = this.uiSessionService.getItem('uiApp');
        this.showBack = false;
        this.selectedItem = { height: 0, top: 0 };
        this.highlightStatic = false;
        this.destroyed$ = new Subject();
        this.uiSessionService.getSubject('uiApp').pipe(takeUntil(this.destroyed$)).subscribe(function (uiApp) {
            _this.uiApp = uiApp;
        });
    }
    /**
     * Lifecycle hook: Waits for component to render, then activates transition
     * and checks current scroll position.
     */
    /**
     * Lifecycle hook: Waits for component to render, then activates transition
     * and checks current scroll position.
     * @return {?}
     */
    UISideNavBarComponent.prototype.ngAfterContentInit = /**
     * Lifecycle hook: Waits for component to render, then activates transition
     * and checks current scroll position.
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout(function () {
            _this.highlightStatic = false;
            _this.checkScrollPosition();
        }, 200);
    };
    /**
     * Handles click event of item and builds config required for smooth scroll
     *
     * @param {string} id
     * @param {number} index
     */
    /**
     * Handles click event of item and builds config required for smooth scroll
     *
     * @param {?} id
     * @param {?} index
     * @return {?}
     */
    UISideNavBarComponent.prototype.onItemClick = /**
     * Handles click event of item and builds config required for smooth scroll
     *
     * @param {?} id
     * @param {?} index
     * @return {?}
     */
    function (id, index) {
        if (index === 0) {
            this.onBackToTopClick();
            return;
        }
        this.uiScrollService.smoothScrollTo('#' + id);
    };
    /**
     * Handles click event of back to top item.
     */
    /**
     * Handles click event of back to top item.
     * @return {?}
     */
    UISideNavBarComponent.prototype.onBackToTopClick = /**
     * Handles click event of back to top item.
     * @return {?}
     */
    function () {
        this.uiScrollService.smoothScrollTo('#app', 0);
    };
    /**
     * Checks scroll position and moves highlight item in to place depending on the active item.
     * Triggered by window:resize and window:scroll events:
     */
    /**
     * Checks scroll position and moves highlight item in to place depending on the active item.
     * Triggered by window:resize and window:scroll events:
     * @return {?}
     */
    UISideNavBarComponent.prototype.checkScrollPosition = /**
     * Checks scroll position and moves highlight item in to place depending on the active item.
     * Triggered by window:resize and window:scroll events:
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var hasActive = false;
        this.uiSideNavItems.forEach(function (item, index) {
            item.active = false;
            /** @type {?} */
            var sectionOffset = _this.uiScrollService.getScrollOffset();
            /** @type {?} */
            var section = document.getElementById(item.id);
            /** @type {?} */
            var sectionTop = section.offsetTop - window.pageYOffset;
            /** @type {?} */
            var sectionBottom = section.offsetTop + section.offsetHeight - window.pageYOffset;
            if (index === 0) {
                item.active = sectionBottom > sectionOffset;
            }
            else {
                item.active = sectionTop <= sectionOffset && sectionBottom > sectionOffset;
            }
            if (item.active) {
                hasActive = true;
                /** @type {?} */
                var link = document.getElementById('sidebarLink' + item.id);
                _this.selectedItem.top = link.offsetTop;
                _this.selectedItem.height = link.offsetHeight;
            }
        });
        if (!hasActive) {
            this.selectedItem = { height: 0, top: 0 };
        }
        this.showBack = window.pageYOffset > 0;
    };
    /**
     * Destroys component and any active subscriptions.
     */
    /**
     * Destroys component and any active subscriptions.
     * @return {?}
     */
    UISideNavBarComponent.prototype.ngOnDestroy = /**
     * Destroys component and any active subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
    };
    UISideNavBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-side-nav-bar',
                    template: "\n      <!--  SIDE NAV BAR  -->\n\n      <ul class=\"side-nav-bar\" [class.top-nav]=\"uiApp.navPosition === 'top'\" [class.consumer]=\"uiApp.audience === 'consumer'\">\n\n          <!--  SIDE NAV ITEM  -->\n\n          <li *ngFor=\"let item of uiSideNavItems; let index = index\">\n              <a [attr.id]=\"'sidebarLink' + item.id\"\n                 [class.active]=\"item.active\"\n                 (click)=\"onItemClick(item.id, index)\">\n                  {{ item.name }}\n              </a>\n          </li>\n\n          <!-- END SIDE NAV ITEM  -->\n\n          <!--  BACK TO TOP ITEM  -->\n\n          <li class=\"back-to-top\" [class.show]=\"showBack\">\n              <a (click)=\"onBackToTopClick()\">Back to top</a>\n          </li>\n\n          <!--  END BACK TO TOP ITEM  -->\n\n          <!--  HIGHLIGHT ITEM  -->\n\n          <li class=\"highlight acc-hl-bl\"\n              [class.static]=\"highlightStatic\"\n              [style.top]=\"selectedItem.top + 'px'\"\n              [style.height]=\"selectedItem.height + 'px'\">\n          </li>\n\n          <!--  END HIGHLIGHT ITEM  -->\n\n      </ul>\n\n      <!--  END SIDE NAV BAR  -->\n    ",
                    styles: ["\n      :host .side-nav-bar{position:-webkit-sticky;position:sticky;top:106px}:host .side-nav-bar li{border-left:5px solid #f2f2f2}:host .side-nav-bar li a{display:block;padding:10px 16px 10px 24px;font-size:13px;font-weight:500;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;cursor:pointer;position:relative;z-index:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#646464}:host .side-nav-bar li a:hover{background:#f2f2f2}:host .side-nav-bar li a.active{color:#222}:host .side-nav-bar li.highlight{display:block;position:absolute;background:#f2f2f2;left:0;right:0;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;z-index:0;border-left-color:#222}:host .side-nav-bar li.highlight.static{-webkit-transition:none;-o-transition:none;transition:none}:host .side-nav-bar li.back-to-top{margin-top:20px;opacity:0;visibility:hidden;-webkit-transition:opacity .2s linear 0s;-o-transition:opacity .2s linear 0s;transition:opacity .2s linear 0s}:host .side-nav-bar li.back-to-top.show{opacity:1;visibility:visible}@media screen and (min-width:1175px){:host .side-nav-bar.top-nav{top:154px}:host .side-nav-bar.top-nav.consumer{top:170px}}@media screen and (max-width:1174px){:host .side-nav-bar{top:130px}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UISideNavBarComponent.ctorParameters = function () { return [
        { type: UIScrollService },
        { type: UIResponsiveService },
        { type: UISessionService }
    ]; };
    UISideNavBarComponent.propDecorators = {
        uiSideNavItems: [{ type: Input }],
        checkScrollPosition: [{ type: HostListener, args: ['window:scroll',] }, { type: HostListener, args: ['window:resize',] }]
    };
    return UISideNavBarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISideNavModule = /** @class */ (function () {
    function UISideNavModule() {
    }
    UISideNavModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UISideNavContainerComponent,
                        UISideNavSectionComponent,
                        UISideNavBarComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UISideNavContainerComponent,
                        UISideNavSectionComponent,
                        UISideNavBarComponent
                    ]
                },] },
    ];
    return UISideNavModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISplitButtonComponent = /** @class */ (function () {
    /**
     * Construct component and inject dependencies
     *
     * @param {Router} router
     * @param {ElementRef} elementRef
     * @param {UIThemeService} uiThemeService
     */
    function UISplitButtonComponent(router, elementRef, uiThemeService) {
        this.router = router;
        this.elementRef = elementRef;
        this.uiThemeService = uiThemeService;
        this.items = [];
        this.size = 'default';
        this.theme = 'primary';
        this.popoverPosition = 'right';
        this.event = new EventEmitter;
        this.secondaryItemsPopover = this.getPopoverConfig();
        this.popoverExists = false;
        this.popoverDestroyed$ = new Subject();
    }
    /**
     * Lifecycle hook: Handles input change.
     */
    /**
     * Lifecycle hook: Handles input change.
     * @return {?}
     */
    UISplitButtonComponent.prototype.ngOnChanges = /**
     * Lifecycle hook: Handles input change.
     * @return {?}
     */
    function () {
        this.secondaryItemsPopover = this.getPopoverConfig();
    };
    /**
     * Sets popover config.
     *
     * @returns {UIPopover}
     */
    /**
     * Sets popover config.
     *
     * @return {?}
     */
    UISplitButtonComponent.prototype.getPopoverConfig = /**
     * Sets popover config.
     *
     * @return {?}
     */
    function () {
        return new UIPopover({
            face: 'bottom',
            position: this.popoverPosition,
            minWidth: 160,
            maxHeight: 220,
            hasArrow: false
        });
    };
    /**
     * Handles click event from user.
     *
     * @param {UISplitButtonItem} item
     * @param event
     */
    /**
     * Handles click event from user.
     *
     * @param {?} item
     * @param {?} event
     * @return {?}
     */
    UISplitButtonComponent.prototype.onClick = /**
     * Handles click event from user.
     *
     * @param {?} item
     * @param {?} event
     * @return {?}
     */
    function (item, event) {
        event.stopPropagation();
        if (typeof (item.event) !== 'undefined') {
            this.event.emit(item.event);
        }
        if (typeof (item.path) !== 'undefined') {
            this.router.navigate([item.path]);
        }
        this.setHide();
    };
    /**
     * Toggles visible state of secondary items popover
     */
    /**
     * Toggles visible state of secondary items popover
     * @return {?}
     */
    UISplitButtonComponent.prototype.onSplitClick = /**
     * Toggles visible state of secondary items popover
     * @return {?}
     */
    function () {
        if (this.popoverExists) {
            this.setHide();
            return;
        }
        this.setShow();
    };
    /**
     * Shows secondary items popover.
     */
    /**
     * Shows secondary items popover.
     * @return {?}
     */
    UISplitButtonComponent.prototype.setShow = /**
     * Shows secondary items popover.
     * @return {?}
     */
    function () {
        var _this = this;
        clearTimeout(this.popoverTimeout);
        this.popoverExists = true;
        this.popoverDestroyed$.next(false);
        this.popoverTimeout = setTimeout(function () {
            _this.secondaryItemsPopover.show = true;
        });
        // Popover exists and is visible, register listener to hide it when user clicks elsewhere.
        fromEvent(document, 'click').pipe(skip(1)).pipe(takeUntil(this.popoverDestroyed$)).subscribe(function (event) {
            if (!_this.elementRef.nativeElement.contains(event.target)) {
                _this.setHide();
            }
        });
    };
    /**
     * Hides secondary items popover.
     */
    /**
     * Hides secondary items popover.
     * @return {?}
     */
    UISplitButtonComponent.prototype.setHide = /**
     * Hides secondary items popover.
     * @return {?}
     */
    function () {
        var _this = this;
        clearTimeout(this.popoverTimeout);
        this.secondaryItemsPopover.show = false;
        this.popoverTimeout = setTimeout(function () {
            _this.popoverExists = false;
            _this.popoverDestroyed$.next(true);
        }, 200);
    };
    /**
     * Lifecycle hook: Destroys any active click listeners
     */
    /**
     * Lifecycle hook: Destroys any active click listeners
     * @return {?}
     */
    UISplitButtonComponent.prototype.ngOnDestroy = /**
     * Lifecycle hook: Destroys any active click listeners
     * @return {?}
     */
    function () {
        this.popoverDestroyed$.next(true);
    };
    UISplitButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-split-button',
                    template: "\n      <!--  SPLIT BUTTON  -->\n\n      <div class=\"split-button\" [ngClass]=\"[size + '-split-button', theme + '-split-button']\">\n\n          <!--  PRIMARY BUTTON - ROUTE ITEM  -->\n\n          <a *ngIf=\"items[0].path\"\n             class=\"button\"\n             [routerLink]=\"[items[0].path]\"\n             [ngClass]=\"size + '-button'\">\n              {{items[0].name}}\n          </a>\n\n          <!--  END PRIMARY BUTTON - ROUTE ITEM  -->\n\n          <!--  PRIMARY BUTTON - EVENT ITEM  -->\n\n          <a *ngIf=\"!items[0].path\"\n             class=\"button\"\n             [ngClass]=\"size + '-button'\"\n             (click)=\"onClick(items[0], $event)\">\n              {{items[0].name}}\n          </a>\n\n          <!--  END PRIMARY BUTTON - EVENT ITEM  -->\n\n          <!-- EXPAND ICON  -->\n\n          <a class=\"split-button-more\"\n             [class.active]=\"secondaryItemsPopover.show\"\n             (click)=\"onSplitClick()\">\n              <i class=\"fas fa-chevron-down\"></i>\n          </a>\n\n          <!--  END EXPAND ICON  -->\n\n          <!--  SECONDARY ITEMS POPOVER  -->\n\n          <ui-popover *ngIf=\"popoverExists\" [uiPopover]=\"secondaryItemsPopover\">\n\n              <!--  SECONDARY ITEMS  -->\n\n              <ul class=\"link-list\">\n                  <li *ngFor=\"let item of items | slice:1\" [class.separator]=\"item.separator\">\n\n                      <!--  ROUTE ITEM  -->\n\n                      <a *ngIf=\"item.path && !item.separator\" [ngClass]=\"item.theme && uiThemeService.buildCssClass(item.theme, 'color')\" [routerLink]=\"[item.path]\">{{item.name}}</a>\n\n                      <!--  END ROUTE ITEM  -->\n\n                      <!--  EVENT ITEM  -->\n\n                      <a *ngIf=\"!item.path && !item.separator\" [ngClass]=\"item.theme && uiThemeService.buildCssClass(item.theme, 'color')\" (click)=\"onClick(item, $event)\">{{item.name}}</a>\n\n                      <!--  END EVENT ITEM  -->\n\n                  </li>\n              </ul>\n\n              <!--  END SECONDARY ITEMS  -->\n\n          </ui-popover>\n\n          <!--  END SECONDARY ITEMS POPOVER  -->\n\n      </div>\n\n      <!--  END SPLIT BUTTON  -->\n    ",
                    styles: ["\n      :host .split-button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;position:relative;height:32px}:host .split-button>.button{border-top-right-radius:0;border-bottom-right-radius:0}:host .split-button>.split-button-more{display:inline-block;height:32px;background:#4e4e4e;color:#FFF;line-height:32px;width:32px;text-align:center;font-size:12px;margin-left:1px;border-top-right-radius:3px;border-bottom-right-radius:3px;cursor:pointer;-webkit-transition:background .2s linear 0s;-o-transition:background .2s linear 0s;transition:background .2s linear 0s}:host .split-button>.split-button-more.active,:host .split-button>.split-button-more:active,:host .split-button>.split-button-more:hover{background:#727272}:host .split-button.small-split-button{height:26px}:host .split-button.small-split-button>.split-button-more{height:26px;line-height:26px;width:26px;font-size:8px}:host .split-button.large-split-button{height:36px}:host .split-button.large-split-button>.split-button-more{height:36px;line-height:36px;width:36px;font-size:12px}\n    "]
                },] },
    ];
    /** @nocollapse */
    UISplitButtonComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ElementRef },
        { type: UIThemeService }
    ]; };
    UISplitButtonComponent.propDecorators = {
        items: [{ type: Input }],
        size: [{ type: Input }],
        theme: [{ type: Input }],
        popoverPosition: [{ type: Input }],
        event: [{ type: Output }]
    };
    return UISplitButtonComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISplitButtonItem = /** @class */ (function () {
    function UISplitButtonItem(uiSplitButtonItem) {
        Object.assign(/** @type {?} */ (this), uiSplitButtonItem);
    }
    return UISplitButtonItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISplitButtonModule = /** @class */ (function () {
    function UISplitButtonModule() {
    }
    UISplitButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UISplitButtonComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        UIPopoverModule
                    ],
                    providers: [],
                    exports: [
                        UISplitButtonComponent
                    ]
                },] },
    ];
    return UISplitButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UITab = /** @class */ (function () {
    function UITab(uiTab) {
        Object.assign(/** @type {?} */ (this), uiTab);
    }
    /**
     * @return {?}
     */
    UITab.prototype.click = /**
     * @return {?}
     */
    function () {
    };
    return UITab;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIViewHeaderComponent = /** @class */ (function () {
    /**
     * Constructs component and injects dependencies
     *
     * @param {UISessionService} uiSessionService
     * @param {UILayoutConfigService} uiLayoutConfigService
     * * @param {Title} titleTag
     */
    function UIViewHeaderComponent(uiSessionService, uiLayoutConfigService, titleTag) {
        this.uiSessionService = uiSessionService;
        this.uiLayoutConfigService = uiLayoutConfigService;
        this.titleTag = titleTag;
        this.hasKeyFunctions = false;
        this.uiApp = this.uiSessionService.getItem('uiApp');
        this.uiAppModule = this.uiSessionService.getItem('uiAppModule');
        this.uiLayoutConfig = this.uiSessionService.getItem('uiLayoutConfig');
        this.destroyed$ = new Subject();
    }
    /**
     * Lifecycle hook: Uses UISessionService to set page <title> tag.
     */
    /**
     * Lifecycle hook: Uses UISessionService to set page <title> tag.
     * @return {?}
     */
    UIViewHeaderComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Uses UISessionService to set page <title> tag.
     * @return {?}
     */
    function () {
        var _this = this;
        this.setTitle();
        this.uiSessionService.getSubject('uiAppModule').pipe(takeUntil(this.destroyed$)).subscribe(function (uiAppModule) {
            _this.uiAppModule = uiAppModule;
        });
        this.uiSessionService.getSubject('uiLayoutConfig').pipe(takeUntil(this.destroyed$)).subscribe(function (uiLayoutConfig) {
            _this.uiLayoutConfig = uiLayoutConfig;
        });
    };
    /**
     * Lifecycle hook: Updates title when input change.
     */
    /**
     * Lifecycle hook: Updates title when input change.
     * @return {?}
     */
    UIViewHeaderComponent.prototype.ngOnChanges = /**
     * Lifecycle hook: Updates title when input change.
     * @return {?}
     */
    function () {
        this.setTitle();
    };
    /**
     * Sets title tag
     */
    /**
     * Sets title tag
     * @return {?}
     */
    UIViewHeaderComponent.prototype.setTitle = /**
     * Sets title tag
     * @return {?}
     */
    function () {
        this.titleTag.setTitle(this.title + ' | ' + this.uiAppModule.name + ' | ' + this.uiApp.name);
        this.uiSessionService.setItem('title', this.title + ((this.suffixes) ? ' / ' + this.suffixes.join(' / ') : ''));
        this.uiLayoutConfigService.setProperty('hasKeyFunctions', this.hasKeyFunctions);
    };
    /**
     * Destroys component and any active subscriptions.
     */
    /**
     * Destroys component and any active subscriptions.
     * @return {?}
     */
    UIViewHeaderComponent.prototype.ngOnDestroy = /**
     * Destroys component and any active subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
        this.uiLayoutConfigService.setProperty('hasViewHeader', null);
    };
    UIViewHeaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-view-header',
                    template: "\n      <!--  VIEW HEADER  -->\n\n      <div *ngIf=\"uiLayoutConfig?.hasViewHeader !== false\"\n           class=\"view-header\"\n           [class.top-nav]=\"uiApp.navPosition === 'top'\"\n           [class.consumer]=\"uiApp.audience === 'consumer'\"\n           [class.has-key-functions]=\"hasKeyFunctions\"\n           [class.has-module-nav]=\"uiAppModule?.hasModuleNav !== false\">\n\n          <!--  TITLE  -->\n\n          <div class=\"title-container\">\n              <h2>{{title}}<span *ngFor=\"let suffix of suffixes\" class=\"acc-hl-col\">{{ suffix }}</span></h2>\n          </div>\n\n          <!--  END TITLE  -->\n\n          <!--  KEY FUNCTIONS  -->\n\n          <div *ngIf=\"hasKeyFunctions\" class=\"key-functions-container\">\n              <ng-content></ng-content>\n          </div>\n\n          <!--  END KEY FUNCTIONS  -->\n\n      </div>\n\n      <!--  END VIEW HEADER  -->\n    ",
                    styles: ["\n      :host .view-header{height:74px;padding:0 32px;background:#FFF;position:fixed;right:0;top:0;left:288px;z-index:8000;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;border-top:5px solid #f2f2f2;border-bottom:5px solid #f2f2f2}:host .view-header .title-container{position:relative}:host .view-header .title-container h2{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;line-height:32px;padding:0 1px 0 0;margin:0;font-size:18px}:host .view-header .title-container h2 span::before{content:'/';color:#919191;margin:0 8px}:host .view-header:not(.has-module-nav){left:48px}@media screen and (min-width:1175px){:host .view-header.top-nav{top:48px;left:240px}:host .view-header.top-nav.consumer{top:64px}:host .view-header.top-nav:not(.has-module-nav){left:0}}@media screen and (max-width:1174px){:host .view-header{top:48px;left:192px;height:58px;padding:0 20px 0 24px}:host .view-header .title-container h2{font-size:16px}:host .view-header.consumer{top:64px}:host .view-header:not(.has-module-nav){left:0}}@media screen and (max-width:774px){:host .view-header{display:none}:host .view-header.has-key-functions{display:-webkit-box;display:-ms-flexbox;display:flex;top:auto;left:0;padding:0 16px;bottom:0;border-bottom:none;border-top:5px solid #f2f2f2;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}:host .view-header.has-key-functions .title-container{display:none}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIViewHeaderComponent.ctorParameters = function () { return [
        { type: UISessionService },
        { type: UILayoutConfigService },
        { type: Title }
    ]; };
    UIViewHeaderComponent.propDecorators = {
        title: [{ type: Input }],
        hasKeyFunctions: [{ type: Input }],
        suffixes: [{ type: Input }]
    };
    return UIViewHeaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIViewHeaderModule = /** @class */ (function () {
    function UIViewHeaderModule() {
    }
    UIViewHeaderModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIViewHeaderComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UIViewHeaderComponent
                    ]
                },] },
    ];
    return UIViewHeaderModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIViewTakeoverComponent = /** @class */ (function () {
    /**
     * Constructs component and injects dependencies
     *
     * @param {UISessionService} uiSessionService
     * @param {UILayoutConfigService} uiLayoutConfigService
     */
    function UIViewTakeoverComponent(uiSessionService, uiLayoutConfigService) {
        this.uiSessionService = uiSessionService;
        this.uiLayoutConfigService = uiLayoutConfigService;
        this.backText = 'Back';
        this.navItems = [];
        this.uiApp = this.uiSessionService.getItem('uiApp');
        this.uiAppModule = this.uiSessionService.getItem('uiAppModule');
        this.uiLayoutConfig = this.uiSessionService.getItem('uiLayoutConfig');
        this.destroyed$ = new Subject();
    }
    /**
     * Lifecycle hook: Uses UISessionService to set page <title> tag.
     */
    /**
     * Lifecycle hook: Uses UISessionService to set page <title> tag.
     * @return {?}
     */
    UIViewTakeoverComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Uses UISessionService to set page <title> tag.
     * @return {?}
     */
    function () {
        var _this = this;
        this.uiLayoutConfigService.setProperty(['hasViewTakeover', 'viewTakeoverBackPath'], [true, this.backPath]);
        this.uiSessionService.getSubject('uiAppModule').pipe(takeUntil(this.destroyed$)).subscribe(function (uiAppModule) {
            _this.uiAppModule = uiAppModule;
        });
        this.uiSessionService.getSubject('uiLayoutConfig').pipe(takeUntil(this.destroyed$)).subscribe(function (uiLayoutConfig) {
            _this.uiLayoutConfig = uiLayoutConfig;
        });
    };
    /**
     * Handles when nav is collapsed.
     */
    /**
     * Handles when nav is collapsed.
     * @return {?}
     */
    UIViewTakeoverComponent.prototype.onCollapseNav = /**
     * Handles when nav is collapsed.
     * @return {?}
     */
    function () {
        this.uiLayoutConfigService.setProperty('navExpanded', false);
    };
    /**
     * Destroys component and any active subscriptions.
     */
    /**
     * Destroys component and any active subscriptions.
     * @return {?}
     */
    UIViewTakeoverComponent.prototype.ngOnDestroy = /**
     * Destroys component and any active subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
        this.uiLayoutConfigService.setProperty(['hasViewTakeover', 'viewTakeoverBackPath'], [false, null]);
    };
    UIViewTakeoverComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-view-takeover',
                    template: "\n      <!--  VIEW TAKEOVER  -->\n\n      <div class=\"view-takeover\" [class.top-nav]=\"uiApp.navPosition === 'top'\" [class.consumer]=\"uiApp.audience === 'consumer'\" [class.nav-expanded]=\"uiLayoutConfig.navExpanded\">\n\n          <!--  HEADING  -->\n\n          <div class=\"view-takeover-header\">\n              <a *ngIf=\"!!backPath\" class=\"icon-button alt back-button\" [routerLink]=\"backPath\" [uiTooltipText]=\"backText\" [uiTooltipConfig]=\"{placement:'right', size:'large'}\">\n                  <i class=\"fas fa-arrow-left acc-hl-col\"></i>\n              </a>\n              <h1>{{ title }}</h1>\n              <a class=\"icon-button close-button\" (click)=\"onCollapseNav()\">\n                  <i class=\"far fa-times\"></i>\n              </a>\n          </div>\n\n          <!--  END HEADING  -->\n\n          <!--  CONTENT  -->\n\n          <div *ngIf=\"hasContent\" class=\"view-takeover-content\">\n              <ng-content></ng-content>\n          </div>\n\n          <!--  END CONTENT  -->\n\n          <!--  NAVIGATION  -->\n\n          <ui-nav-list [navItems]=\"navItems\" [parentPath]=\"navParentPath\" (navigation)=\"onCollapseNav()\"></ui-nav-list>\n\n          <!--  END NAVIGATION  -->\n      </div>\n\n      <!--  END VIEW TAKEOVER  -->\n    ",
                    styles: ["\n      :host .view-takeover{position:fixed;z-index:8000;left:48px;top:0;bottom:0;width:240px;background:#f2f2f2;overflow:auto}:host .view-takeover .view-takeover-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:0 32px 0 16px}:host .view-takeover .view-takeover-header>h1{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-weight:500;letter-spacing:-.04em;font-size:20px;height:74px;line-height:64px;padding:5px 0 5px 16px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}:host .view-takeover .view-takeover-header>.icon-button:hover{background:#dedede}:host .view-takeover .view-takeover-header>.icon-button.back-button{background:#FFF}:host .view-takeover .view-takeover-header>.icon-button.close-button{display:none}:host .view-takeover .view-takeover-content{padding:0 24px 24px;border-bottom:5px solid #e9e9e9;margin-bottom:24px}@media screen and (min-width:1175px){:host .view-takeover.top-nav{top:48px;left:0}:host .view-takeover.top-nav.consumer{top:64px}}@media screen and (max-width:1174px){:host .view-takeover{top:48px;left:0;width:192px}:host .view-takeover .view-takeover-header{padding:0 16px}:host .view-takeover .view-takeover-header>h1{font-size:16px;height:58px;line-height:48px}:host .view-takeover .view-takeover-content{padding:0 16px 16px;margin-bottom:16px}:host .view-takeover.consumer{top:64px}}@media screen and (max-width:774px){:host .view-takeover{top:0;left:-320px;width:320px;padding-left:48px;z-index:9000;-webkit-transition:all .2s ease-in-out 0s,opacity 0s linear 0s;-o-transition:all .2s ease-in-out 0s,opacity 0s linear 0s;transition:all .2s ease-in-out 0s,opacity 0s linear 0s;opacity:0}:host .view-takeover .view-takeover-header>h1{height:48px;padding-top:0;padding-bottom:0}:host .view-takeover .view-takeover-header>.icon-button.back-button{background:#f2f2f2;margin-right:-8px;position:relative}:host .view-takeover .view-takeover-header>.icon-button.back-button:hover{background:#dedede}:host .view-takeover .view-takeover-header>.icon-button.close-button{display:block;margin-right:-8px}:host .view-takeover.nav-expanded{left:0;opacity:1}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIViewTakeoverComponent.ctorParameters = function () { return [
        { type: UISessionService },
        { type: UILayoutConfigService }
    ]; };
    UIViewTakeoverComponent.propDecorators = {
        title: [{ type: Input }],
        backPath: [{ type: Input }],
        backText: [{ type: Input }],
        navItems: [{ type: Input }],
        navParentPath: [{ type: Input }],
        hasContent: [{ type: Input }]
    };
    return UIViewTakeoverComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIViewTakeoverModule = /** @class */ (function () {
    function UIViewTakeoverModule() {
    }
    UIViewTakeoverModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIViewTakeoverComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        UITooltipModule,
                        UINavListModule
                    ],
                    providers: [],
                    exports: [
                        UIViewTakeoverComponent
                    ]
                },] },
    ];
    return UIViewTakeoverModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIShortNumberPipe$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {DecimalPipe} decimalPipe
     */
    function UIShortNumberPipe(decimalPipe) {
        this.decimalPipe = decimalPipe;
        this.denominators = {
            T: 1000000000000,
            B: 1000000000,
            M: 1000000,
            K: 1000
        };
    }
    /**
     * Transforms number in shortened number.
     *
     * @param {number} value
     * @param {string} digitsInfo
     *
     * @returns {string}
     */
    /**
     * Transforms number in shortened number.
     *
     *
     * @param {?} value
     * @param {?=} digitsInfo
     * @return {?}
     */
    UIShortNumberPipe.prototype.transform = /**
     * Transforms number in shortened number.
     *
     *
     * @param {?} value
     * @param {?=} digitsInfo
     * @return {?}
     */
    function (value, digitsInfo) {
        if (digitsInfo === void 0) { digitsInfo = '1.0-1'; }
        for (var suffix in this.denominators) {
            if (this.shouldShorten(value, this.denominators[suffix])) {
                return this.getShortenedNumber(value, digitsInfo, suffix);
            }
        }
        return this.decimalPipe.transform(value, digitsInfo);
    };
    /**
     * Checks if number requires shortening.
     *
     * @param value
     * @param number
     *
     * @returns {boolean}
     */
    /**
     * Checks if number requires shortening.
     *
     * @param {?} value
     * @param {?} number
     *
     * @return {?}
     */
    UIShortNumberPipe.prototype.shouldShorten = /**
     * Checks if number requires shortening.
     *
     * @param {?} value
     * @param {?} number
     *
     * @return {?}
     */
    function (value, number) {
        return Math.abs(value) >= number;
    };
    /**
     * Gets shortened number.
     *
     * @param {number} value
     * @param {string} digitsInfo
     * @param {string} suffix
     *
     * @returns {string}
     */
    /**
     * Gets shortened number.
     *
     *
     * @param {?} value
     * @param {?} digitsInfo
     * @param {?} suffix
     * @return {?}
     */
    UIShortNumberPipe.prototype.getShortenedNumber = /**
     * Gets shortened number.
     *
     *
     * @param {?} value
     * @param {?} digitsInfo
     * @param {?} suffix
     * @return {?}
     */
    function (value, digitsInfo, suffix) {
        return this.decimalPipe.transform(value / this.denominators[suffix], digitsInfo) + suffix;
    };
    UIShortNumberPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'uiShortNumber'
                },] },
    ];
    /** @nocollapse */
    UIShortNumberPipe.ctorParameters = function () { return [
        { type: DecimalPipe }
    ]; };
    return UIShortNumberPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIShortNumberModule = /** @class */ (function () {
    function UIShortNumberModule() {
    }
    /**
     * @return {?}
     */
    UIShortNumberModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: UIShortNumberModule,
            providers: [
                UIShortNumberPipe$1
            ]
        };
    };
    UIShortNumberModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIShortNumberPipe$1
                    ],
                    imports: [],
                    providers: [],
                    exports: [
                        UIShortNumberPipe$1
                    ]
                },] },
    ];
    return UIShortNumberModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIDateTimePipe = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {DatePipe} datePipe
     */
    function UIDateTimePipe(datePipe) {
        this.datePipe = datePipe;
    }
    /**
     * Transforms date into common format.
     *
     * @param {string} value
     * @param {boolean} includeTime
     *
     * @returns {string}
     */
    /**
     * Transforms date into common format.
     *
     *
     * @param {?} value
     * @param {?=} includeTime
     * @return {?}
     */
    UIDateTimePipe.prototype.transform = /**
     * Transforms date into common format.
     *
     *
     * @param {?} value
     * @param {?=} includeTime
     * @return {?}
     */
    function (value, includeTime) {
        if (includeTime === void 0) { includeTime = true; }
        try {
            /** @type {?} */
            var date = new Date(value).toISOString();
            /** @type {?} */
            var dateTime = this.datePipe.transform(date, 'dd/MM/yyyy');
            if (includeTime) {
                dateTime += ' at ' + this.datePipe.transform(date, 'HH:mm');
            }
            return dateTime;
        }
        catch (_a) {
            return value;
        }
    };
    UIDateTimePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'uiDateTime'
                },] },
    ];
    /** @nocollapse */
    UIDateTimePipe.ctorParameters = function () { return [
        { type: DatePipe }
    ]; };
    return UIDateTimePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIDateTimeModule = /** @class */ (function () {
    function UIDateTimeModule() {
    }
    /**
     * @return {?}
     */
    UIDateTimeModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: UIDateTimeModule,
            providers: [
                UIDateTimePipe
            ]
        };
    };
    UIDateTimeModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIDateTimePipe
                    ],
                    imports: [],
                    providers: [
                        DatePipe$1
                    ],
                    exports: [
                        UIDateTimePipe
                    ]
                },] },
    ];
    return UIDateTimeModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIPluralPipe = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {DecimalPipe} decimalPipe
     */
    function UIPluralPipe(decimalPipe) {
        this.decimalPipe = decimalPipe;
    }
    /**
     * Transforms nouns into their plural format.
     *
     * @param {number} value
     * @param {string} singular
     * @param {string} plural
     * @param {boolean} includeValue
     * @param {string} valueDigitsInfo
     *
     * @returns {string}
     */
    /**
     * Transforms nouns into their plural format.
     *
     *
     * @param {?} value
     * @param {?} singular
     * @param {?=} plural
     * @param {?=} includeValue
     * @param {?=} valueDigitsInfo
     * @return {?}
     */
    UIPluralPipe.prototype.transform = /**
     * Transforms nouns into their plural format.
     *
     *
     * @param {?} value
     * @param {?} singular
     * @param {?=} plural
     * @param {?=} includeValue
     * @param {?=} valueDigitsInfo
     * @return {?}
     */
    function (value, singular, plural, includeValue, valueDigitsInfo) {
        if (plural === void 0) { plural = ''; }
        if (includeValue === void 0) { includeValue = true; }
        if (valueDigitsInfo === void 0) { valueDigitsInfo = '1.0-2'; }
        value = value.toString();
        /** @type {?} */
        var pluralWord = plural.startsWith('+') ? singular + plural.slice(1) : plural;
        return (includeValue ? this.decimalPipe.transform(value, valueDigitsInfo) + ' ' : '') + ((value === '1' || plural === '') ? singular : pluralWord);
    };
    UIPluralPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'uiPlural'
                },] },
    ];
    /** @nocollapse */
    UIPluralPipe.ctorParameters = function () { return [
        { type: DecimalPipe }
    ]; };
    return UIPluralPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIPluralModule = /** @class */ (function () {
    function UIPluralModule() {
    }
    /**
     * @return {?}
     */
    UIPluralModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: UIPluralModule,
            providers: [
                UIPluralPipe
            ]
        };
    };
    UIPluralModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIPluralPipe
                    ],
                    imports: [],
                    providers: [],
                    exports: [
                        UIPluralPipe
                    ]
                },] },
    ];
    return UIPluralModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIMoneyPipe$1 = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {CurrencyPipe} currencyPipe
     */
    function UIMoneyPipe(currencyPipe) {
        this.currencyPipe = currencyPipe;
    }
    /**
     * Transforms currency values into a consistent format. Allows zero to be presented as 'FREE'.
     *
     * @param {number} value
     * @param {number} decimalPlaces
     * @param {boolean} freeWhenZero
     * @returns {string}
     */
    /**
     * Transforms currency values into a consistent format. Allows zero to be presented as 'FREE'.
     *
     * @param {?} value
     * @param {?=} decimalPlaces
     * @param {?=} freeWhenZero
     * @return {?}
     */
    UIMoneyPipe.prototype.transform = /**
     * Transforms currency values into a consistent format. Allows zero to be presented as 'FREE'.
     *
     * @param {?} value
     * @param {?=} decimalPlaces
     * @param {?=} freeWhenZero
     * @return {?}
     */
    function (value, decimalPlaces, freeWhenZero) {
        if (decimalPlaces === void 0) { decimalPlaces = 2; }
        if (freeWhenZero === void 0) { freeWhenZero = false; }
        if (value !== null && typeof (value) !== 'undefined') {
            if (freeWhenZero && value === 0) {
                return 'FREE';
            }
            else {
                /** @type {?} */
                var returnValue = this.currencyPipe.transform(value, 'GBP', 'symbol', '1.' + decimalPlaces + '-' + decimalPlaces);
                return returnValue.charAt(0) === '(' ? '-' + returnValue.substring(1, returnValue.length - 1) : returnValue;
            }
        }
        else {
            return value.toString();
        }
    };
    UIMoneyPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'uiMoney'
                },] },
    ];
    /** @nocollapse */
    UIMoneyPipe.ctorParameters = function () { return [
        { type: CurrencyPipe }
    ]; };
    return UIMoneyPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIMoneyModule = /** @class */ (function () {
    function UIMoneyModule() {
    }
    /**
     * @return {?}
     */
    UIMoneyModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: UIMoneyModule,
            providers: [
                UIMoneyPipe$1
            ]
        };
    };
    UIMoneyModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIMoneyPipe$1
                    ],
                    imports: [],
                    providers: [
                        CurrencyPipe$1
                    ],
                    exports: [
                        UIMoneyPipe$1
                    ]
                },] },
    ];
    return UIMoneyModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

var __extends$9 = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UISelectControl = /** @class */ (function (_super) {
    __extends$9(UISelectControl, _super);
    function UISelectControl(uiSelectControl) {
        var _this = _super.call(this, uiSelectControl) || this;
        _this.type = 'select';
        Object.assign(/** @type {?} */ (_this), uiSelectControl);
        return _this;
    }
    return UISelectControl;
}(UIFormControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISelectControlOption = /** @class */ (function () {
    function UISelectControlOption(uiSelectControlOption) {
        Object.assign(/** @type {?} */ (this), uiSelectControlOption);
    }
    return UISelectControlOption;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIPaginatorComponent = /** @class */ (function () {
    function UIPaginatorComponent() {
        this.showCount = false;
    }
    /**
     * @return {?}
     */
    UIPaginatorComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        this.paginationForm = [new UIFormGroup({
                name: 'pagination',
                controls: [
                    new UISelectControl({
                        name: 'page',
                        label: 'Page',
                        options: this.getPaginationOptions(),
                        value: this.pagination.current_page,
                        prefixes: ['*|i.fas fa-arrow-left|prev'],
                        suffixes: ['*|i.fas fa-arrow-right|next']
                    }),
                ]
            })];
    };
    /**
     * Gets starting item count of current page.
     *
     * @returns {number}
     */
    /**
     * Gets starting item count of current page.
     *
     * @return {?}
     */
    UIPaginatorComponent.prototype.getStartCount = /**
     * Gets starting item count of current page.
     *
     * @return {?}
     */
    function () {
        if (this.pagination.current_page === 1) {
            return 1;
        }
        return (this.pagination.count * this.pagination.current_page) - this.pagination.per_page;
    };
    /**
     * Gets ending item count of current page.
     *
     * @returns {number}
     */
    /**
     * Gets ending item count of current page.
     *
     * @return {?}
     */
    UIPaginatorComponent.prototype.getEndCount = /**
     * Gets ending item count of current page.
     *
     * @return {?}
     */
    function () {
        if (this.pagination.current_page === this.pagination.total_pages) {
            return this.pagination.total;
        }
        return this.pagination.current_page * this.pagination.per_page;
    };
    /**
     * Gets total count.
     *
     * @returns {number}
     */
    /**
     * Gets total count.
     *
     * @return {?}
     */
    UIPaginatorComponent.prototype.getTotalCount = /**
     * Gets total count.
     *
     * @return {?}
     */
    function () {
        return this.pagination.total;
    };
    /**
     * Gets options for page dropdown.
     */
    /**
     * Gets options for page dropdown.
     * @return {?}
     */
    UIPaginatorComponent.prototype.getPaginationOptions = /**
     * Gets options for page dropdown.
     * @return {?}
     */
    function () {
        /** @type {?} */
        var paginationOptions = [];
        for (var i = 1; i <= this.pagination.total_pages; i++) {
            paginationOptions.push(new UISelectControlOption({ name: "Page " + i + " of " + this.pagination.total_pages, value: i }));
        }
        return paginationOptions;
    };
    UIPaginatorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-paginator',
                    template: "\n      <div class=\"paginator\">\n          <p *ngIf=\"showCount\">\n              Showing\n              <strong>{{ getStartCount() | number:'1.0-0' }}</strong>\n              -\n              <strong>{{ getEndCount() | number:'1.0-0' }}</strong>\n              of\n              <strong>{{ getTotalCount() | uiPlural:'dealer':'+s'}}</strong>\n          </p>\n          <div>\n              <ui-form #form [uiFormGroups]=\"paginationForm\" [style]=\"'plain'\"></ui-form>\n          </div>\n\n      </div>\n    ",
                    styles: ["\n      :host .paginator{margin-top:32px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}:host .paginator>p{line-height:32px}\n    "]
                },] },
    ];
    UIPaginatorComponent.propDecorators = {
        pagination: [{ type: Input }],
        showCount: [{ type: Input }]
    };
    return UIPaginatorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIRefineModalComponent = /** @class */ (function () {
    function UIRefineModalComponent(uiModalService, uiHelperService) {
        var _this = this;
        this.uiModalService = uiModalService;
        this.uiHelperService = uiHelperService;
        this.refineItems = this.uiHelperService.copy(this.uiModalService.data);
        this.uiModalService.setConfig({
            title: 'Refine',
            width: 'sm1',
            height: 'full',
            position: 'right',
            baseTheme: 'light',
            actions: [
                new UIActionButton({
                    type: 'button',
                    text: 'Clear',
                    theme: 'minor',
                    click: function () {
                        _this.clearAll();
                    }
                }),
                new UIActionButton({
                    type: 'button',
                    text: 'Apply',
                    theme: 'positive',
                    showWorking: true,
                    click: function () {
                        setTimeout(function () {
                            _this.uiModalService.close();
                        }, 500);
                    }
                })
            ],
            actionsPosition: 'justify'
        });
        // this.refineItems.map((refineItem) => {
        //     refineItem.selectedOptions = this.getSelected(refineItem.options);
        // });
    }
    /**
     * Clears all selected options of a refine item.
     *
     * @param refineItem
     */
    /**
     * Clears all selected options of a refine item.
     *
     * @param {?} refineItem
     * @return {?}
     */
    UIRefineModalComponent.prototype.clearItem = /**
     * Clears all selected options of a refine item.
     *
     * @param {?} refineItem
     * @return {?}
     */
    function (refineItem) {
        for (var _i = 0, _a = refineItem.options; _i < _a.length; _i++) {
            var option = _a[_i];
            option.selected = false;
        }
        refineItem.selectedOptions = [];
        refineItem.selectedOptionsString = null;
    };
    /**
     * @return {?}
     */
    UIRefineModalComponent.prototype.clearAll = /**
     * @return {?}
     */
    function () {
        for (var _i = 0, _a = this.refineItems; _i < _a.length; _i++) {
            var refineItem = _a[_i];
            this.clearItem(refineItem);
        }
    };
    /**
     * @param {?} options
     * @return {?}
     */
    UIRefineModalComponent.prototype.getSelected = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        return options.filter(function (option) {
            return option.selected;
        }).map(function (option) {
            return option.name;
        }).join(', ');
    };
    /**
     * @param {?} refineItem
     * @return {?}
     */
    UIRefineModalComponent.prototype.chooseOptions = /**
     * @param {?} refineItem
     * @return {?}
     */
    function (refineItem) {
        console.log(refineItem);
    };
    UIRefineModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-refine-modal',
                    template: "\n      <!--  REFINE ITEMS CONTAINER  -->\n\n      <div class=\"refine-items-container\">\n\n          <!--  REFINE ITEMS LOOP  -->\n\n          <div *ngFor=\"let refineItem of refineItems\" class=\"refine-item\">\n\n              <!--  REFINE ITEM HEADER  -->\n\n              <div class=\"refine-item-header\">\n                  <h3>{{ refineItem.name }}<span *ngIf=\"refineItem.selectedOptions.length > 0\" class=\"acc-hl-col selected-count\">({{ refineItem.selectedOptions.length | number:'1.0-0' }})</span></h3>\n                  <a *ngIf=\"refineItem.selectedOptions.length > 0\" class=\"button tiny-button minor-button\" (click)=\"clearItem(refineItem)\">Clear</a>\n              </div>\n\n              <!--  END REFINE ITEM HEADER  -->\n\n              <!--  REFINE ITEM OPTIONS  -->\n\n              <a class=\"refine-item-options acc-hov-bg acc-hov-bd acc-fg-hov-col\" (click)=\"chooseOptions(refineItem)\">\n                  <span *ngIf=\"refineItem.selectedOptions.length > 0\"><strong>{{ refineItem.selectedOptionsString }}</strong></span>\n                  <span *ngIf=\"refineItem.selectedOptions.length < 1\" class=\"all\">All</span>\n                  <i class=\"fas fa-chevron-right acc-hl-col\"></i>\n              </a>\n\n              <!--  END REFINE ITEM OPTIONS  -->\n\n          </div>\n\n          <!--  END REFINE ITEMS LOOP  -->\n\n      </div>\n\n      <!--  END REFINE ITEMS CONTAINER  -->\n\n      <!--  OPTIONS SELECTOR CONTAINER  -->\n\n      <div class=\"options-selector-container\">\n\n      </div>\n\n      <!--  END OPTIONS SELECTOR CONTAINER  -->\n    ",
                    styles: ["\n      :host .refine-item .refine-item-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}:host .refine-item .refine-item-header>h3 .selected-count{margin-left:8px}:host .refine-item>.refine-item-options{display:block;border:1px solid #d3d3d3;border-radius:3px;height:40px;line-height:40px;padding:0 48px 0 12px;background:#FFF;margin:8px 0 24px;position:relative;color:#4e4e4e;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host .refine-item>.refine-item-options>span{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;display:block;font-size:13px}:host .refine-item>.refine-item-options>span>strong{color:inherit}:host .refine-item>.refine-item-options>span.all{opacity:.6}:host .refine-item>.refine-item-options>i{font-size:12px;height:24px;width:24px;line-height:24px;text-align:center;position:absolute;right:8px;top:7px;border-radius:100%;background:#FFF}:host .refine-item>.refine-item-options:hover>span.all{opacity:1}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIRefineModalComponent.ctorParameters = function () { return [
        { type: UIModalService },
        { type: UIHelperService }
    ]; };
    return UIRefineModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIDataModule = /** @class */ (function () {
    function UIDataModule() {
    }
    UIDataModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIPaginatorComponent,
                        UIRefineModalComponent
                    ],
                    imports: [
                        CommonModule,
                        UIPluralModule.forRoot(),
                        UIFormsModule
                    ],
                    providers: [],
                    exports: [
                        UIPaginatorComponent
                    ]
                },] },
    ];
    return UIDataModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

var __extends$a = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UICheckboxControl = /** @class */ (function (_super) {
    __extends$a(UICheckboxControl, _super);
    function UICheckboxControl(uiCheckboxControl) {
        var _this = _super.call(this, uiCheckboxControl) || this;
        _this.type = 'checkbox';
        _this.text = null;
        Object.assign(/** @type {?} */ (_this), uiCheckboxControl);
        return _this;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    UICheckboxControl.prototype.onCta = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
    };
    return UICheckboxControl;
}(UIFormControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIFormEvent = /** @class */ (function () {
    function UIFormEvent() {
    }
    return UIFormEvent;
}());

var __extends$b = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UITextareaControl = /** @class */ (function (_super) {
    __extends$b(UITextareaControl, _super);
    function UITextareaControl(uiTextareaControl) {
        var _this = _super.call(this, uiTextareaControl) || this;
        _this.type = 'textarea';
        _this.rows = 5;
        _this.defaultFocus = false;
        Object.assign(/** @type {?} */ (_this), uiTextareaControl);
        return _this;
    }
    return UITextareaControl;
}(UIFormControl));

var __extends$c = (undefined && undefined.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var UISliderControl = /** @class */ (function (_super) {
    __extends$c(UISliderControl, _super);
    function UISliderControl(uiSliderControl) {
        var _this = _super.call(this, uiSliderControl) || this;
        _this.type = 'range';
        _this.step = 1;
        _this.invert = false;
        _this.thumbLabel = true;
        _this.tickInterval = 'auto';
        _this.textInput = false;
        _this.defaultFocus = false;
        Object.assign(/** @type {?} */ (_this), uiSliderControl);
        return _this;
    }
    return UISliderControl;
}(UIFormControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIAffix = /** @class */ (function () {
    function UIAffix() {
    }
    return UIAffix;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UINotificationPreferencesComponent = /** @class */ (function () {
    function UINotificationPreferencesComponent() {
    }
    UINotificationPreferencesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-notification-preferences',
                    template: "\n      <!--  VIEW HEADER  -->\n\n      <ui-view-header [title]=\"'Notification Preferences'\" [hasKeyFunctions]=\"true\">\n          <a class=\"button positive-button\">Save Preferences</a>\n      </ui-view-header>\n\n      <!--  END VIEW HEADER  -->\n\n      <!--  CONTENT CONTAINER  -->\n\n      <div class=\"content-container\">\n\n          <p>Notification Preferences here...</p>\n\n      </div>\n\n      <!--  END CONTENT CONTAINER  -->\n    "
                },] },
    ];
    return UINotificationPreferencesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIChangePasswordComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIResponsiveService} uiResponsiveService
     * @param {UIUserAccountService} uiUserAccountService
     * @param {UIToastService} uiToastService
     */
    function UIChangePasswordComponent(uiResponsiveService, uiUserAccountService, uiToastService) {
        this.uiResponsiveService = uiResponsiveService;
        this.uiUserAccountService = uiUserAccountService;
        this.uiToastService = uiToastService;
        this.changePasswordFormGroups = this.getChangePasswordFormGroups();
    }
    /**
     * Gets change password form groups.
     *
     * @return {UIFormGroup[]}
     */
    /**
     * Gets change password form groups.
     *
     * @return {?}
     */
    UIChangePasswordComponent.prototype.getChangePasswordFormGroups = /**
     * Gets change password form groups.
     *
     * @return {?}
     */
    function () {
        return [
            new UIFormGroup({
                name: 'password',
                heading: 'Your New Password',
                description: 'The password you will use to log in and verify your identity.',
                controls: [
                    new UIInputControl({
                        name: 'new',
                        label: 'New Password',
                        inputType: 'password',
                        validators: [Validators.required, Validators.minLength(6)],
                        showPasswordStrength: true
                    }),
                    new UIInputControl({
                        name: 'confirm',
                        label: 'Confirm New Password',
                        inputType: 'password',
                        validators: [Validators.required, Validators.minLength(6), UIValidators.fieldMatch(['password', 'new'], 'New Password')]
                    })
                ]
            }),
            new UIFormGroup({
                name: 'confirmIdentity',
                heading: 'Confirm your Identify',
                description: 'Enter your current password so we know you\'re you!',
                controls: [
                    new UIInputControl({
                        name: 'password',
                        label: 'Your Password',
                        inputType: 'password',
                        validators: [Validators.required]
                    })
                ]
            })
        ];
    };
    /**
     * Handles form submission.
     *
     * @param {FormGroup} form
     */
    /**
     * Handles form submission.
     *
     * @param {?} form
     * @return {?}
     */
    UIChangePasswordComponent.prototype.onFormSubmit = /**
     * Handles form submission.
     *
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        if (form.valid) {
            /** @type {?} */
            var body = {
                password: form.value['password']['new'],
                password_confirmation: form.value['password']['confirm'],
                password_current: form.value['confirmIdentity']['password']
            };
            this.uiUserAccountService.updateMe(body).subscribe(function (success) {
                if (!success) {
                    _this.uiToastService.error('Password update failed, please check your current password.');
                    return;
                }
                _this.uiToastService.success('Your password was updated!');
            });
            form.reset();
        }
    };
    UIChangePasswordComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-change-password',
                    template: "\n      <!--  VIEW HEADER  -->\n\n      <ui-view-header [title]=\"'Change Password'\" [hasKeyFunctions]=\"true\">\n          <a class=\"button positive-button\" (click)=\"form.onSubmit()\">Save New Password</a>\n      </ui-view-header>\n\n      <!--  END VIEW HEADER  -->\n\n      <!--  CONTENT CONTAINER  -->\n\n      <div class=\"content-container\">\n\n          <!--  CHANGE PASSWORD FORM  -->\n\n          <ui-form\n              #form\n              [uiFormGroups]=\"changePasswordFormGroups\"\n              [showSubmit]=\"uiResponsiveService.screenIsGTE('md1')\"\n              [submitText]=\"'Save New Password'\"\n              (formSubmit)=\"onFormSubmit($event)\">\n          </ui-form>\n\n          <!--  END CHANGE PASSWORD FORM  -->\n\n      </div>\n\n      <!--  END CONTENT CONTAINER  -->\n    "
                },] },
    ];
    /** @nocollapse */
    UIChangePasswordComponent.ctorParameters = function () { return [
        { type: UIResponsiveService },
        { type: UIUserAccountService },
        { type: UIToastService }
    ]; };
    return UIChangePasswordComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIManageAccountComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIResponsiveService} uiResponsiveService
     * @param {UIUserAccountService} uiUserAccountService
     * @param {UIToastService} uiToastService
     * @param {UISessionService} uiSessionService
     */
    function UIManageAccountComponent(uiResponsiveService, uiUserAccountService, uiToastService, uiSessionService) {
        var _this = this;
        this.uiResponsiveService = uiResponsiveService;
        this.uiUserAccountService = uiUserAccountService;
        this.uiToastService = uiToastService;
        this.uiSessionService = uiSessionService;
        this.me = this.uiSessionService.getItem('me');
        this.accountFormGroups = this.getAccountFormGroups();
        this.destroyed$ = new Subject();
        this.uiSessionService.getSubject('me').pipe(takeUntil(this.destroyed$)).subscribe(function (me) {
            _this.me = me;
        });
    }
    /**
     * Gets account form groups.
     *
     * @return {UIFormGroup[]}
     */
    /**
     * Gets account form groups.
     *
     * @return {?}
     */
    UIManageAccountComponent.prototype.getAccountFormGroups = /**
     * Gets account form groups.
     *
     * @return {?}
     */
    function () {
        return [
            new UIFormGroup({
                name: 'basicDetails',
                heading: 'Basic Details',
                description: 'Your basic details and forms of contact.',
                controls: [
                    new UIInputControl({
                        name: 'firstName',
                        label: 'First Name',
                        inputType: 'text',
                        validators: [Validators.required],
                        value: this.me.first_name
                    }),
                    new UIInputControl({
                        name: 'lastName',
                        label: 'Last Name',
                        inputType: 'text',
                        validators: [Validators.required],
                        value: this.me.last_name
                    }),
                    new UIInputControl({
                        name: 'email',
                        label: 'Email Address',
                        inputType: 'text',
                        validators: [Validators.required, Validators.email],
                        value: this.me.email
                    }),
                    new UIInputControl({
                        name: 'phoneNumber',
                        label: 'Phone Number',
                        inputType: 'text',
                        validators: [Validators.required],
                        value: this.me.phone_number
                    }),
                ]
            }),
            new UIFormGroup({
                name: 'avatar',
                heading: 'Your Avatar',
                description: 'A photo or picture that represents your user.',
                controls: [
                    new UIInputControl({
                        name: 'path',
                        label: 'Avatar Path',
                        inputType: 'text',
                        value: this.me.avatar_path
                    })
                ]
            }),
            new UIFormGroup({
                name: 'confirmIdentity',
                heading: 'Confirm your Identify',
                description: 'Enter your current password so we know you\'re you!',
                controls: [
                    new UIInputControl({
                        name: 'password',
                        label: 'Your Password',
                        inputType: 'password',
                        validators: [Validators.required]
                    })
                ]
            })
        ];
    };
    /**
     * Handles form submission.
     *
     * @param {FormGroup} form
     */
    /**
     * Handles form submission.
     *
     * @param {?} form
     * @return {?}
     */
    UIManageAccountComponent.prototype.onFormSubmit = /**
     * Handles form submission.
     *
     * @param {?} form
     * @return {?}
     */
    function (form) {
        var _this = this;
        if (form.valid) {
            /** @type {?} */
            var body = {
                first_name: form.value['basicDetails']['firstName'],
                last_name: form.value['basicDetails']['lastName'],
                email: form.value['basicDetails']['email'],
                phone_number: form.value['basicDetails']['phoneNumber'],
                avatar_path: form.value['avatar']['path'],
                password_current: form.value['confirmIdentity']['password']
            };
            this.uiUserAccountService.updateMe(body).subscribe(function (success) {
                if (!success) {
                    _this.uiToastService.error('Your details were not updated.');
                    return;
                }
                _this.uiToastService.success('Your details were updated!');
            });
        }
    };
    /**
     * Lifecycle hook: destroys component and any active subscriptions.
     */
    /**
     * Lifecycle hook: destroys component and any active subscriptions.
     * @return {?}
     */
    UIManageAccountComponent.prototype.ngOnDestroy = /**
     * Lifecycle hook: destroys component and any active subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
    };
    UIManageAccountComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-manage-account',
                    template: "\n      <!--  VIEW HEADER  -->\n\n      <ui-view-header [title]=\"'Manage Account'\" [hasKeyFunctions]=\"true\">\n          <a class=\"button positive-button\" (click)=\"form.onSubmit()\">Save Details</a>\n      </ui-view-header>\n\n      <!--  END VIEW HEADER  -->\n\n      <!--  CONTENT CONTAINER  -->\n\n      <div class=\"content-container\">\n\n          <!--  MANAGE ACCOUNT FORM  -->\n\n          <ui-form\n              #form\n              [uiFormGroups]=\"accountFormGroups\"\n              [showSubmit]=\"uiResponsiveService.screenIsGTE('md1')\"\n              [submitText]=\"'Save Details'\"\n              (formSubmit)=\"onFormSubmit($event)\">\n          </ui-form>\n\n          <!--  END MANAGE ACCOUNT FORM  -->\n\n      </div>\n\n      <!--  END CONTENT CONTAINER  -->\n    "
                },] },
    ];
    /** @nocollapse */
    UIManageAccountComponent.ctorParameters = function () { return [
        { type: UIResponsiveService },
        { type: UIUserAccountService },
        { type: UIToastService },
        { type: UISessionService }
    ]; };
    return UIManageAccountComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIDealerSwitcherModalComponent = /** @class */ (function () {
    function UIDealerSwitcherModalComponent(uiModalService, uiSessionService, uiResponsiveService) {
        this.uiModalService = uiModalService;
        this.uiSessionService = uiSessionService;
        this.uiResponsiveService = uiResponsiveService;
        this.me = this.uiSessionService.getItem('me');
        this.dealers = [
            {
                id: 1,
                brand_name: 'Dace Motor Company'
            },
            {
                id: 2,
                brand_name: 'Chris W Roads'
            },
            {
                id: 3,
                brand_name: 'Click Motors'
            },
            {
                id: 4,
                brand_name: 'Ron Skinner & Sons'
            },
            {
                id: 5,
                brand_name: 'Some dealer with a long ass name'
            }
        ];
        this.uiModalService.setConfig({
            title: 'Switch Dealer...',
            position: this.uiResponsiveService.screenIsLTE('sm3') ? 'left' : 'right',
            width: 'sm3',
            baseTheme: 'light'
        });
    }
    /**
     * @param {?} dealer
     * @return {?}
     */
    UIDealerSwitcherModalComponent.prototype.onSwitchDealer = /**
     * @param {?} dealer
     * @return {?}
     */
    function (dealer) {
        this.me["current_dealer"] = dealer;
        this.uiSessionService.setItem('me', this.me);
        this.uiModalService.close();
    };
    UIDealerSwitcherModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-dealer-switcher-modal',
                    template: "\n\n          <div class=\"row padded grid-view\">\n              <div *ngFor=\"let dealer of dealers\" class=\"col-sm1-30 col-sm2-15 col-sm3-10\">\n                  <div class=\"panel panel-alt\" (click)=\"onSwitchDealer(dealer)\">\n                      {{ dealer.brand_name }}\n                  </div>\n              </div>\n          </div>\n    ",
                    styles: ["\n      .grid-view .panel{-webkit-box-shadow:0 2px 3px rgba(0,0,0,.3);box-shadow:0 2px 3px rgba(0,0,0,.3)}\n    "],
                },] },
    ];
    /** @nocollapse */
    UIDealerSwitcherModalComponent.ctorParameters = function () { return [
        { type: UIModalService },
        { type: UISessionService },
        { type: UIResponsiveService }
    ]; };
    return UIDealerSwitcherModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIUserAccountModalComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Router} router
     * @param {UIModalService} uiModalService
     * @param {UIStorageService} uiStorageService
     * @param {UIToastService} uiToastService
     * @param {UIResponsiveService} uiResponsiveService
     * @param {UIAuthService} uiAuthService
     * @param {UISessionService} uiSessionService
     */
    function UIUserAccountModalComponent(router, uiModalService, uiStorageService, uiToastService, uiResponsiveService, uiAuthService, uiSessionService) {
        this.router = router;
        this.uiModalService = uiModalService;
        this.uiStorageService = uiStorageService;
        this.uiToastService = uiToastService;
        this.uiResponsiveService = uiResponsiveService;
        this.uiAuthService = uiAuthService;
        this.uiSessionService = uiSessionService;
        this.uiApp = this.uiSessionService.getItem('uiApp');
        this.me = this.uiSessionService.getItem('me');
        this.destroyed$ = new Subject();
        this.uiModalService.setConfig({
            title: 'User Account',
            position: this.uiResponsiveService.screenIsLTE('sm3') ? 'left' : 'right',
            width: 'sm1',
            baseTheme: 'light'
        });
    }
    /**
     * Shows dealer switcher modal.
     */
    /**
     * Shows dealer switcher modal.
     * @return {?}
     */
    UIUserAccountModalComponent.prototype.onSwitchDealerClick = /**
     * Shows dealer switcher modal.
     * @return {?}
     */
    function () {
        this.uiModalService.show(['user-account', 'dealer-switcher'], null, false);
    };
    /**
     * Handles link navigation.
     *
     * @param {string[]} route
     */
    /**
     * Handles link navigation.
     *
     * @param {?} route
     * @return {?}
     */
    UIUserAccountModalComponent.prototype.navigateAndClose = /**
     * Handles link navigation.
     *
     * @param {?} route
     * @return {?}
     */
    function (route) {
        var _this = this;
        this.router.navigate(route).then(function () {
            _this.uiModalService.close();
        });
    };
    /**
     * Removes token and redirects to login page.
     */
    /**
     * Removes token and redirects to login page.
     * @return {?}
     */
    UIUserAccountModalComponent.prototype.onLogOut = /**
     * Removes token and redirects to login page.
     * @return {?}
     */
    function () {
        var _this = this;
        this.uiAuthService.logOut().subscribe(function () {
            _this.uiModalService.close();
        });
    };
    /**
     * Destroys component and any active subscriptions.
     */
    /**
     * Destroys component and any active subscriptions.
     * @return {?}
     */
    UIUserAccountModalComponent.prototype.ngOnDestroy = /**
     * Destroys component and any active subscriptions.
     * @return {?}
     */
    function () {
        this.destroyed$.next(true);
    };
    UIUserAccountModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-user-account-modal',
                    template: "\n      <!--  USER ACCOUNT  -->\n\n      <div class=\"user-account\">\n\n          <!--  CURRENT USER  -->\n\n          <div class=\"current-user\">\n\n              <!--  AVATAR  -->\n\n              <div class=\"avatar\">\n\n                  <img *ngIf=\"me.avatar_path\" [src]=\"me.avatar_path\">\n\n                  <i *ngIf=\"!me.avatar_path\" class=\"fas fa-user pri-bg pri-fg-col\"></i>\n\n              </div>\n\n              <!--  END AVATAR  -->\n\n              <h2 class=\"user-name\">{{ me.full_name }}</h2>\n              <h3 class=\"dealer-name color-orange\">{{ me.current_dealer.brand_name }}</h3>\n\n          </div>\n\n          <!--  END CURRENT USER  -->\n\n          <!--  USER NAV  -->\n\n          <ul class=\"nav-list\">\n              <li>\n                  <a *ngIf=\"uiApp.audience === 'dealer' && me.multi_dealer\" (click)=\"onSwitchDealerClick()\">\n                      <i class=\"fa-fw fa-sm fas fa-sync pri-bg pri-fg-col\"></i>\n                      Switch Dealer\n                  </a>\n              </li>\n\n              <li>\n                  <a (click)=\"navigateAndClose(['/user-account', 'manage-account'])\">\n                      <i class=\"fa-fw fa-sm fas fa-cog pri-bg pri-fg-col\"></i>\n                      Manage Account\n                  </a>\n              </li>\n              <li>\n                  <a (click)=\"navigateAndClose(['/user-account', 'change-password'])\">\n                      <i class=\"fa-fw fa-sm fas fa-lock-alt pri-bg pri-fg-col\"></i>\n                      Change Password\n                  </a>\n              </li>\n              <li>\n                  <a *ngIf=\"uiApp.audience !== 'consumer'\" (click)=\"navigateAndClose(['/user-account', 'notification-preferences'])\">\n                      <i class=\"fa-fw fa-sm fas fa-bell pri-bg pri-fg-col\"></i>\n                      Notification Preferences\n                  </a>\n              </li>\n              <li>\n                  <a (click)=\"onLogOut()\">\n                      <i class=\"fa-fw fa-sm fas fa-sign-out fa-rotate-180 neg-bg neg-fg-col\"></i>\n                      Log Out\n                  </a>\n              </li>\n\n          </ul>\n\n          <!--  END USER NAV  -->\n\n      </div>\n\n      <!--  END USER ACCOUNT  -->\n    ",
                    styles: ["\n      :host .user-account .current-user{background:#FFF;margin:-24px -24px 24px;padding:24px;border-bottom:5px solid #e9e9e9}:host .user-account .current-user .avatar{width:100px;height:100px;margin:0 auto 24px;border-radius:100%;overflow:hidden;display:block}:host .user-account .current-user .avatar>img{height:100px;width:100px;-o-object-fit:cover;object-fit:cover}:host .user-account .current-user .avatar>i{font-size:56px;height:100px;line-height:100px;text-align:center}:host .user-account .current-user .user-name{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;text-align:center}:host .user-account .current-user .dealer-name{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;text-align:center;text-transform:uppercase;letter-spacing:0;font-size:12px}@media screen and (max-width:774px){:host .user-account .current-user{margin:-16px -16px 16px;padding:16px}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIUserAccountModalComponent.ctorParameters = function () { return [
        { type: Router },
        { type: UIModalService },
        { type: UIStorageService },
        { type: UIToastService },
        { type: UIResponsiveService },
        { type: UIAuthService },
        { type: UISessionService }
    ]; };
    return UIUserAccountModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIUserAccountService$1 = /** @class */ (function () {
    function UIUserAccountService(uiRestService, uiSessionService) {
        this.uiRestService = uiRestService;
        this.uiSessionService = uiSessionService;
        this.uiApp = this.uiSessionService.getItem('uiApp');
    }
    /**
     * Gets current user.
     *
     * @return {Observable<boolean>}
     */
    /**
     * Gets current user.
     *
     * @return {?}
     */
    UIUserAccountService.prototype.getMe = /**
     * Gets current user.
     *
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var options = new UIRestOptions({
            returnRawResponse: true
        });
        return this.uiRestService.one(['me'], options).pipe(map(function (response) {
            if (response.ok) {
                response.body.data.multi_dealer = true;
                response.body.data.current_dealer = {
                    brand_name: 'Click Motors'
                };
                _this.uiSessionService.setItem('me', new UIUser(response.body.data));
                return true;
            }
            return response.ok;
        }));
    };
    /**
     * @param {?} body
     * @return {?}
     */
    UIUserAccountService.prototype.updateMe = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        if (this.uiApp.audience === 'consumer') {
            body.audience = 'consumer';
        }
        /** @type {?} */
        var options = new UIRestOptions({
            returnRawResponse: true
        });
        return this.uiRestService.patch(['me'], body, options).pipe(flatMap(function (response) {
            if (response.ok) {
                return _this.getMe();
            }
            return of(response.ok);
        }));
    };
    UIUserAccountService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIUserAccountService.ctorParameters = function () { return [
        { type: UIRestService },
        { type: UISessionService }
    ]; };
    return UIUserAccountService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIUserResolver = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {Router} router
     * @param {UISessionService} uiSessionService
     * @param {UIAuthService} uiAuthService
     * @param {UIUserAccountService} uiUserAccountService
     */
    function UIUserResolver(router, uiSessionService, uiAuthService, uiUserAccountService) {
        this.router = router;
        this.uiSessionService = uiSessionService;
        this.uiAuthService = uiAuthService;
        this.uiUserAccountService = uiUserAccountService;
    }
    /**
     * Gets me from session if already present, if not gets me from auth service.
     *
     * @param {ActivatedRouteSnapshot} activatedRouteSnapshot
     *
     * @returns {Observable<UIApp>}
     */
    /**
     * Gets me from session if already present, if not gets me from auth service.
     *
     *
     * @param {?} activatedRouteSnapshot
     * @return {?}
     */
    UIUserResolver.prototype.resolve = /**
     * Gets me from session if already present, if not gets me from auth service.
     *
     *
     * @param {?} activatedRouteSnapshot
     * @return {?}
     */
    function (activatedRouteSnapshot) {
        var _this = this;
        if (this.uiSessionService.itemExists('me')) {
            return true;
        }
        return this.uiUserAccountService.getMe().pipe(map(function (success) {
            if (!success) {
                _this.uiAuthService.logOut().subscribe();
            }
            return success;
        }));
    };
    UIUserResolver.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UIUserResolver.ctorParameters = function () { return [
        { type: Router },
        { type: UISessionService },
        { type: UIAuthService },
        { type: UIUserAccountService }
    ]; };
    return UIUserResolver;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIUserAccountModule = /** @class */ (function () {
    function UIUserAccountModule() {
    }
    UIUserAccountModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UINotificationPreferencesComponent,
                        UIChangePasswordComponent,
                        UIManageAccountComponent,
                        UIDealerSwitcherModalComponent,
                        UIUserAccountModalComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        UIViewHeaderModule,
                        UIFormsModule
                    ],
                    providers: [
                        UIFormsService$1
                    ],
                    exports: [
                        UINotificationPreferencesComponent,
                        UIChangePasswordComponent,
                        UIManageAccountComponent,
                        UIDealerSwitcherModalComponent,
                        UIUserAccountModalComponent
                    ]
                },] },
    ];
    return UIUserAccountModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIBigValueComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIThemeService} uiThemeService
     */
    function UIBigValueComponent(uiThemeService) {
        this.uiThemeService = uiThemeService;
        this.baseTheme = 'light';
        this.useFixedColor = false;
        this.fixedColor = 'blue';
    }
    /**
     * Handles when theme changes from parent.
     *
     * @param {SimpleChanges} simpleChanges
     */
    /**
     * Handles when theme changes from parent.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    UIBigValueComponent.prototype.ngOnChanges = /**
     * Handles when theme changes from parent.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    function (simpleChanges) {
        if (simpleChanges['theme'] && this.theme && !this.useFixedColor) {
            this.themeClass = this.uiThemeService.buildCssClass(this.theme, 'color');
        }
    };
    UIBigValueComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-big-value',
                    template: "\n      <!-- BIG VALUE  -->\n\n      <div class=\"panel\" [class.panel-dark]=\"baseTheme === 'dark'\" [class.panel-alt]=\"baseTheme === 'white'\" [class.panel-fixed-color]=\"useFixedColor\" [ngClass]=\"useFixedColor ? 'bg-' + fixedColor : ''\">\n\n          <!--  VALUE  -->\n\n          <div class=\"value\" [ngClass]=\"themeClass\">{{ value }}</div>\n\n          <!--  END VALUE  -->\n\n          <!--  LABEL  -->\n\n          <span class=\"label\">{{ label }}</span>\n\n          <!--  END LABEL  -->\n\n      </div>\n\n      <!--  END BIG VALUE  -->\n    ",
                    styles: ["\n      :host .panel .value{font-weight:500;font-size:26px;color:#4e4e4e;margin-bottom:8px}:host .panel .label{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;text-transform:uppercase;font-size:12px;font-weight:500;color:#919191;width:100%;display:inline-block;margin-bottom:-8px}:host .panel.panel-dark .value{color:#FFF}:host .panel.panel-dark .label{color:#bdbdbd}:host .panel.panel-fixed-color .label,:host .panel.panel-fixed-color .value{color:#FFF}:host .panel.panel-fixed-color .label{opacity:.7}@media screen and (max-width:1174px){:host .panel .value{font-size:22px}:host .panel .label{font-size:11px;margin-bottom:-4px}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIBigValueComponent.ctorParameters = function () { return [
        { type: UIThemeService }
    ]; };
    UIBigValueComponent.propDecorators = {
        value: [{ type: Input }],
        label: [{ type: Input }],
        theme: [{ type: Input }],
        baseTheme: [{ type: Input }],
        useFixedColor: [{ type: Input }],
        fixedColor: [{ type: Input }]
    };
    return UIBigValueComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIBigValueModule = /** @class */ (function () {
    function UIBigValueModule() {
    }
    UIBigValueModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIBigValueComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UIBigValueComponent
                    ]
                },] },
    ];
    return UIBigValueModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIChartKeyComponent = /** @class */ (function () {
    function UIChartKeyComponent() {
        this.onItemClick = new EventEmitter();
    }
    /**
     * Handled click of key item.
     *
     * @param {UIChartKeyItem} uiChartKeyItem
     */
    /**
     * Handled click of key item.
     *
     * @param {?} uiChartKeyItem
     * @return {?}
     */
    UIChartKeyComponent.prototype.onClick = /**
     * Handled click of key item.
     *
     * @param {?} uiChartKeyItem
     * @return {?}
     */
    function (uiChartKeyItem) {
        uiChartKeyItem.enabled = !uiChartKeyItem.enabled;
        this.onItemClick.emit(uiChartKeyItem);
    };
    UIChartKeyComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-chart-key',
                    template: "\n      <!--  KEY  -->\n\n      <ul class=\"key\">\n\n          <!--  LINE LOOP  -->\n\n          <li *ngFor=\"let item of items\" [ngClass]=\"item.color\" [class.disabled]=\"!item.enabled\" (click)=\"onClick(item)\">{{ item.name }}</li>\n\n          <!--  END LINE LOOP  -->\n\n      </ul>\n\n      <!--  END KEY  -->\n    ",
                    styles: ["\n      :host ul.key{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-24px;margin-bottom:4px}:host ul.key>li{font-size:13px;color:#4e4e4e;margin:0 24px 4px 0;padding-left:16px;position:relative;cursor:pointer;-webkit-transition:all .2s linear 0s;-o-transition:all .2s linear 0s;transition:all .2s linear 0s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host ul.key>li::before{content:'';display:block;width:8px;height:8px;border-radius:100%;position:absolute;left:0;top:50%;margin-top:-4px;-webkit-transition:inherit;-o-transition:inherit;transition:inherit}:host ul.key>li.green::after,:host ul.key>li.green::before{background:#2B9F57}:host ul.key>li.teal::after,:host ul.key>li.teal::before{background:#35B4A7}:host ul.key>li.light-blue::after,:host ul.key>li.light-blue::before{background:#4EB0DD}:host ul.key>li.blue::after,:host ul.key>li.blue::before{background:#2156A0}:host ul.key>li.purple::after,:host ul.key>li.purple::before{background:#8935B4}:host ul.key>li.pink::after,:host ul.key>li.pink::before{background:#D0497C}:host ul.key>li.red::after,:host ul.key>li.red::before{background:#D63535}:host ul.key>li.orange::after,:host ul.key>li.orange::before{background:#F57F15}:host ul.key>li.yellow::after,:host ul.key>li.yellow::before{background:#F2B521}:host ul.key>li.dark-blue::after,:host ul.key>li.dark-blue::before{background:#202839}:host ul.key>li.grey::after,:host ul.key>li.grey::before{background:#777}:host ul.key>li.black::after,:host ul.key>li.black::before{background:#000}:host ul.key>li.disabled{color:#d3d3d3}:host ul.key>li.disabled::after,:host ul.key>li.disabled::before{background:#d3d3d3}\n    "]
                },] },
    ];
    UIChartKeyComponent.propDecorators = {
        items: [{ type: Input }],
        onItemClick: [{ type: Output }]
    };
    return UIChartKeyComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIChartKeyItem = /** @class */ (function () {
    function UIChartKeyItem(uiChartKeyItem) {
        this.color = 'blue';
        this.enabled = true;
        Object.assign(/** @type {?} */ (this), uiChartKeyItem);
    }
    return UIChartKeyItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIChartKeyModule = /** @class */ (function () {
    function UIChartKeyModule() {
    }
    UIChartKeyModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIChartKeyComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UIChartKeyComponent
                    ]
                },] },
    ];
    return UIChartKeyModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILineChartXLabelComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {ElementRef} elementRef
     */
    function UILineChartXLabelComponent(elementRef) {
        this.elementRef = elementRef;
        this.popover = this.getPopoverConfig();
        this.popoverExists = false;
        this.popoverDestroyed$ = new Subject();
    }
    /**
     * Gets influence popover config.
     *
     * @returns {UIPopover}
     */
    /**
     * Gets influence popover config.
     *
     * @return {?}
     */
    UILineChartXLabelComponent.prototype.getPopoverConfig = /**
     * Gets influence popover config.
     *
     * @return {?}
     */
    function () {
        /** @type {?} */
        var coordinates = this.elementRef.nativeElement.getBoundingClientRect();
        /** @type {?} */
        var x = coordinates.x + (coordinates.width * 0.5);
        /** @type {?} */
        var position = 'center';
        /** @type {?} */
        var offset = 0;
        if (x < 130) {
            position = 'left';
            offset = coordinates.width * 0.5 - 18;
        }
        if (x > (window.innerWidth - 130)) {
            position = 'right';
            offset = -(coordinates.width * 0.5 - 18);
        }
        return new UIPopover({
            face: 'top',
            position: position,
            minWidth: 220,
            maxHeight: 220,
            hasArrow: true,
            offset: offset
        });
    };
    /**
     * Shows secondary items popover.
     */
    /**
     * Shows secondary items popover.
     * @return {?}
     */
    UILineChartXLabelComponent.prototype.setShow = /**
     * Shows secondary items popover.
     * @return {?}
     */
    function () {
        var _this = this;
        this.xLabel.hovered = true;
        if (this.showInfluences && this.xLabel.influences.length > 0) {
            clearTimeout(this.popoverTimeout);
            this.popover = this.getPopoverConfig();
            this.popoverExists = true;
            this.popoverDestroyed$.next(false);
            this.popoverTimeout = setTimeout(function () {
                _this.popover.show = true;
            }, 200);
            // Popover exists and is visible, register listener to hide it when user clicks elsewhere.
            fromEvent(document, 'click').pipe(skip(1)).pipe(takeUntil(this.popoverDestroyed$)).subscribe(function (event) {
                if (!_this.elementRef.nativeElement.contains(event.target)) {
                    _this.setHide();
                }
            });
        }
    };
    /**
     * Hides secondary items popover.
     */
    /**
     * Hides secondary items popover.
     * @return {?}
     */
    UILineChartXLabelComponent.prototype.setHide = /**
     * Hides secondary items popover.
     * @return {?}
     */
    function () {
        var _this = this;
        this.xLabel.hovered = false;
        if (this.showInfluences && this.xLabel.influences.length > 0) {
            clearTimeout(this.popoverTimeout);
            this.popover.show = false;
            this.popoverTimeout = setTimeout(function () {
                _this.popoverExists = false;
                _this.popoverDestroyed$.next(true);
            }, 200);
        }
    };
    /**
     * Lifecycle hook: Destroys any active click listeners
     */
    /**
     * Lifecycle hook: Destroys any active click listeners
     * @return {?}
     */
    UILineChartXLabelComponent.prototype.ngOnDestroy = /**
     * Lifecycle hook: Destroys any active click listeners
     * @return {?}
     */
    function () {
        this.popoverDestroyed$.next(true);
    };
    UILineChartXLabelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-line-chart-x-label',
                    template: "\n      <!--  X LABEL  -->\n\n      <div class=\"x-axis-label acc-aft-bg\" [class.show-influences]=\"showInfluences\" [class.has-influences]=\"xLabel.influences.length > 0\" [class.hovered]=\"xLabel.hovered\" (mouseenter)=\"setShow()\" (mouseleave)=\"setHide()\">\n\n          <!--  LABEL  -->\n\n          <span>{{ xLabel.name }}</span>\n\n          <!--  END LABEL  -->\n\n          <!--  INFLUENCES POPOVER  -->\n\n          <ui-popover *ngIf=\"popoverExists\" [uiPopover]=\"popover\">\n\n              <!--  INFLUENCE LIST  -->\n\n              <ul class=\"influence-list\">\n\n                  <!--  INFLUENCE LOOP  -->\n\n                  <li *ngFor=\"let influence of xLabel.influences\">\n\n                      <!--  INFLUENCE LABEL  -->\n\n                      <div class=\"label\">\n                          <i class=\"fa-fw\" [ngClass]=\"[influence.icon, 'color-' + influence.color]\"></i>{{ influence.name }}\n                      </div>\n\n                      <!--  END INFLUENCE LABEL  -->\n\n                      <!--  INFLUENCE VALUE  -->\n\n                      <div class=\"value\" [ngClass]=\"'color-' + influence.color\">{{ influence.value | number:'1.0-2' }}</div>\n\n                      <!--  END INFLUENCE VALUE  -->\n\n                  </li>\n\n                  <!--  END INFLUENCE LOOP  -->\n\n              </ul>\n\n              <!--  END INFLUENCE LIST  -->\n\n          </ui-popover>\n\n          <!--  END INFLUENCES POPOVER  -->\n\n      </div>\n\n      <!--  END X LABEL  -->\n    ",
                    styles: ["\n      :host{display:block}:host .x-axis-label{height:37px;position:absolute;left:0;right:0;bottom:0;border-top:5px solid #dedede;background:#FFF;border-radius:0 0 3px 3px;-webkit-transition:all .1s linear 0s;-o-transition:all .1s linear 0s;transition:all .1s linear 0s;cursor:pointer}:host .x-axis-label>span{display:block;padding:0 8px;text-align:center;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;overflow:hidden;line-height:32px;font-size:12px;font-weight:500;text-transform:uppercase;color:#919191}:host .x-axis-label .influence-list{padding:4px 16px}:host .x-axis-label .influence-list>li{border-bottom:3px solid #f2f2f2;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:8px 0}:host .x-axis-label .influence-list>li>.label{font-size:12px;font-weight:500;text-transform:uppercase;color:#919191;position:relative;padding-left:28px;line-height:18px}:host .x-axis-label .influence-list>li>.label>i{position:absolute;top:0;left:0;font-size:14px;line-height:18px}:host .x-axis-label .influence-list>li .value{font-size:14px;font-weight:500;color:#4e4e4e;padding-left:16px;line-height:18px}:host .x-axis-label .influence-list>li:last-child{border-bottom:none}:host .x-axis-label.show-influences{height:53px}:host .x-axis-label.show-influences.has-influences::after{content:'';display:block;width:6px;height:6px;border-radius:100%;position:absolute;bottom:13px;left:0;right:0;margin:auto}:host .x-axis-label.hovered{background:#e9e9e9}:host .x-axis-label.hovered>span{color:#4e4e4e}\n    "]
                },] },
    ];
    /** @nocollapse */
    UILineChartXLabelComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    UILineChartXLabelComponent.propDecorators = {
        xLabel: [{ type: Input }],
        showInfluences: [{ type: Input }]
    };
    return UILineChartXLabelComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILineChartComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIScriptLoaderService} uiScriptLoaderService
     * @param {UIHelperService} uiHelperService
     * @param {UIMoneyPipe} uiMoneyPipe
     * @param {UIShortNumberPipe} uiShortNumberPipe
     * @param {DecimalPipe} decimalPipe
     */
    function UILineChartComponent(uiScriptLoaderService, uiHelperService, uiMoneyPipe, uiShortNumberPipe, decimalPipe) {
        this.uiScriptLoaderService = uiScriptLoaderService;
        this.uiHelperService = uiHelperService;
        this.uiMoneyPipe = uiMoneyPipe;
        this.uiShortNumberPipe = uiShortNumberPipe;
        this.decimalPipe = decimalPipe;
        this.height = 200;
        this.showInfluences = false;
        this.showYAxis = true;
        this.sharedYAxis = true;
        this.showKey = true;
        this.tooltipConfig = this.getTooltipConfig();
        this.initialized = false;
        this.pointHoverTimeout = null;
    }
    /**
     * Lifecycle hook: Builds chart.
     */
    /**
     * Lifecycle hook: Builds chart.
     * @return {?}
     */
    UILineChartComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Builds chart.
     * @return {?}
     */
    function () {
        this.buildChart();
        this.initialized = true;
    };
    /**
     * Lifecycle hook: Handles when inputs change and determines whether to re-build the chart.
     *
     * @param {SimpleChanges} simpleChanges
     */
    /**
     * Lifecycle hook: Handles when inputs change and determines whether to re-build the chart.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    UILineChartComponent.prototype.ngOnChanges = /**
     * Lifecycle hook: Handles when inputs change and determines whether to re-build the chart.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    function (simpleChanges) {
        if (this.initialized) {
            /** @type {?} */
            var rebuildTriggers = ['sharedYAxis', 'thresholdLines'];
            for (var _i = 0, _a = Object.keys(simpleChanges); _i < _a.length; _i++) {
                var trigger$$1 = _a[_i];
                if (rebuildTriggers.indexOf(trigger$$1) !== -1) {
                    this.buildChart();
                    return;
                }
            }
        }
    };
    /**
     * Gets tooltip config.
     *
     * @returns {UITooltip}
     */
    /**
     * Gets tooltip config.
     *
     * @return {?}
     */
    UILineChartComponent.prototype.getTooltipConfig = /**
     * Gets tooltip config.
     *
     * @return {?}
     */
    function () {
        return new UITooltip({
            delay: 150,
            size: 'large'
        });
    };
    /**
     * Builds chart.
     */
    /**
     * Builds chart.
     * @return {?}
     */
    UILineChartComponent.prototype.buildChart = /**
     * Builds chart.
     * @return {?}
     */
    function () {
        var _this = this;
        this.checkConfig();
        this.barWidth = 100 / this.xLabels.length;
        this.allLineMaxValue = this.getAllLineMaxValue();
        this.lines = this.lines.map(function (uiLineChartLine) {
            uiLineChartLine.enabled = true;
            uiLineChartLine.points = _this.getLinePoints(uiLineChartLine);
            uiLineChartLine.solidPoints = _this.getSolidPoints(uiLineChartLine);
            uiLineChartLine.dashedPoints = _this.getDashedPoints(uiLineChartLine);
            uiLineChartLine.displayValues = _this.getDisplayValues(uiLineChartLine);
            return uiLineChartLine;
        });
        this.thresholdLines = this.thresholdLines.map(function (uiLineChartThresholdLine) {
            uiLineChartThresholdLine.top = _this.getThresholdLineTopValue(uiLineChartThresholdLine);
            return uiLineChartThresholdLine;
        });
        this.chartKeyItems = this.getChartKeyItems();
        this.yLabels = this.getYLabels();
    };
    /**
     * Checks if line chart inputs are configured
     */
    /**
     * Checks if line chart inputs are configured
     * @return {?}
     */
    UILineChartComponent.prototype.checkConfig = /**
     * Checks if line chart inputs are configured
     * @return {?}
     */
    function () {
        if (this.showYAxis) {
            if (!this.sharedYAxis) {
                console.warn('Line Chart: When showing the Y axis, the Y axis needs to be shared.');
            }
            if (!this.linesShareValueType()) {
                console.warn('Line Chart: When showing the Y axis, all lines should share a common valueType.');
            }
        }
        if (this.sharedYAxis) {
            if (!this.linesShareValueType()) {
                console.warn('Line Chart: When sharing the Y axis, all lines should share a common valueType.');
            }
        }
        if (this.thresholdLines.length > 0) {
            if (!this.sharedYAxis) {
                console.warn('Line Chart: When showing threshold lines, the Y axis needs to be shared.');
            }
            if (!this.linesShareValueType()) {
                console.warn('Line Chart: When showing threshold lines, all lines should share a common valueType.');
            }
        }
    };
    /**
     * Checks if lines share a value type.
     *
     * @returns {boolean}
     */
    /**
     * Checks if lines share a value type.
     *
     * @return {?}
     */
    UILineChartComponent.prototype.linesShareValueType = /**
     * Checks if lines share a value type.
     *
     * @return {?}
     */
    function () {
        /** @type {?} */
        var lineValueTypes = this.lines.map(function (uiLineChartLine) {
            return uiLineChartLine.valueType;
        });
        return this.uiHelperService.getDistinctArray(lineValueTypes).length === 1;
    };
    /**
     * Gets max value across all lines.
     *
     * @returns {number}
     */
    /**
     * Gets max value across all lines.
     *
     * @return {?}
     */
    UILineChartComponent.prototype.getAllLineMaxValue = /**
     * Gets max value across all lines.
     *
     * @return {?}
     */
    function () {
        /** @type {?} */
        var allValues = [];
        for (var _i = 0, _a = this.lines; _i < _a.length; _i++) {
            var line = _a[_i];
            allValues.push.apply(allValues, line.values);
        }
        return Math.max.apply(Math, allValues);
    };
    /**
     * Gets chart key items.
     *
     * @returns {UIChartKeyItem[]}
     */
    /**
     * Gets chart key items.
     *
     * @return {?}
     */
    UILineChartComponent.prototype.getChartKeyItems = /**
     * Gets chart key items.
     *
     * @return {?}
     */
    function () {
        return this.lines.map(function (uiLineChartLine) {
            return {
                color: uiLineChartLine.color,
                name: uiLineChartLine.name,
                enabled: uiLineChartLine.enabled && uiLineChartLine.visible
            };
        });
    };
    /**
     * Gets points for line.
     *
     * @param {UILineChartLine} uiLineChartLine
     *
     * @returns {[number][]}
     */
    /**
     * Gets points for line.
     *
     *
     * @param {?} uiLineChartLine
     * @return {?}
     */
    UILineChartComponent.prototype.getLinePoints = /**
     * Gets points for line.
     *
     *
     * @param {?} uiLineChartLine
     * @return {?}
     */
    function (uiLineChartLine) {
        /** @type {?} */
        var maxValue = (this.sharedYAxis || this.showYAxis) ? this.allLineMaxValue : Math.max.apply(Math, uiLineChartLine.values);
        /** @type {?} */
        var points = [];
        /** @type {?} */
        var offset = uiLineChartLine.startIndex < 0 ? 0 : uiLineChartLine.startIndex;
        for (var i = 0; i < uiLineChartLine.values.length + offset; i++) {
            if (uiLineChartLine.startIndex <= i) {
                /** @type {?} */
                var left = this.barWidth * (i + ((uiLineChartLine.startIndex < 0) ? -0.5 : 0.5));
                /** @type {?} */
                var top_1 = 100 - (uiLineChartLine.values[i - offset] / maxValue) * 100;
                points.push([left, top_1]);
            }
        }
        return points;
    };
    /**
     * Gets display values for line points.
     *
     * @param {UILineChartLine} uiLineChartLine
     *
     * @returns {string[]}
     */
    /**
     * Gets display values for line points.
     *
     *
     * @param {?} uiLineChartLine
     * @return {?}
     */
    UILineChartComponent.prototype.getDisplayValues = /**
     * Gets display values for line points.
     *
     *
     * @param {?} uiLineChartLine
     * @return {?}
     */
    function (uiLineChartLine) {
        /** @type {?} */
        var displayValues = [];
        for (var _i = 0, _a = uiLineChartLine.values; _i < _a.length; _i++) {
            var value = _a[_i];
            if (uiLineChartLine.valueType === 'number' || uiLineChartLine.valueType === 'percentage') {
                displayValues.push(this.decimalPipe.transform(value) + (uiLineChartLine.valueType === 'percentage' ? '%' : ''));
                continue;
            }
            if (uiLineChartLine.valueType === 'currency') {
                displayValues.push(this.uiMoneyPipe.transform(value, 0, false));
                continue;
            }
            displayValues.push(value.toString());
        }
        return displayValues;
    };
    /**
     * Gets top value for threshold lines.
     *
     * @param {UILineChartThresholdLine} uiLineChartThresholdLine
     *
     * @returns {number}
     */
    /**
     * Gets top value for threshold lines.
     *
     *
     * @param {?} uiLineChartThresholdLine
     * @return {?}
     */
    UILineChartComponent.prototype.getThresholdLineTopValue = /**
     * Gets top value for threshold lines.
     *
     *
     * @param {?} uiLineChartThresholdLine
     * @return {?}
     */
    function (uiLineChartThresholdLine) {
        return 100 - (uiLineChartThresholdLine.value / this.allLineMaxValue) * 100;
    };
    /**
     * Gets all points for solid part of line.
     *
     * @param {UILineChartLine} uiLineChartLine
     *
     * @returns {[number][]}
     */
    /**
     * Gets all points for solid part of line.
     *
     *
     * @param {?} uiLineChartLine
     * @return {?}
     */
    UILineChartComponent.prototype.getSolidPoints = /**
     * Gets all points for solid part of line.
     *
     *
     * @param {?} uiLineChartLine
     * @return {?}
     */
    function (uiLineChartLine) {
        if (uiLineChartLine.trailingDashedSections === 0) {
            return uiLineChartLine.points;
        }
        if (uiLineChartLine.trailingDashedSections >= uiLineChartLine.points.length || uiLineChartLine.trailingDashedSections === 'all') {
            return [];
        }
        return uiLineChartLine.points.slice(0, uiLineChartLine.points.length - uiLineChartLine.trailingDashedSections);
    };
    /**
     * Gets all points for dashed part of line.
     *
     * @param {UILineChartLine} uiLineChartLine
     *
     * @returns {[number][]}
     */
    /**
     * Gets all points for dashed part of line.
     *
     *
     * @param {?} uiLineChartLine
     * @return {?}
     */
    UILineChartComponent.prototype.getDashedPoints = /**
     * Gets all points for dashed part of line.
     *
     *
     * @param {?} uiLineChartLine
     * @return {?}
     */
    function (uiLineChartLine) {
        if (uiLineChartLine.trailingDashedSections === 0) {
            return [];
        }
        if (uiLineChartLine.trailingDashedSections >= uiLineChartLine.points.length || uiLineChartLine.trailingDashedSections === 'all') {
            return uiLineChartLine.points;
        }
        return uiLineChartLine.points.slice((uiLineChartLine.points.length - uiLineChartLine.trailingDashedSections) - 1, uiLineChartLine.points.length);
    };
    /**
     * Gets Y Axis labels.
     *
     * @returns {UILineChartYLabel[]}
     */
    /**
     * Gets Y Axis labels.
     *
     * @return {?}
     */
    UILineChartComponent.prototype.getYLabels = /**
     * Gets Y Axis labels.
     *
     * @return {?}
     */
    function () {
        /** @type {?} */
        var yLabels = [];
        /** @type {?} */
        var markers = [1, 0.75, 0.5, 0.25, 0];
        for (var _i = 0, markers_1 = markers; _i < markers_1.length; _i++) {
            var marker = markers_1[_i];
            /** @type {?} */
            var prefix = this.lines[0].valueType === 'currency' ? '£' : '';
            /** @type {?} */
            var suffix = this.lines[0].valueType === 'percentage' ? '%' : '';
            yLabels.push({
                name: prefix + this.uiShortNumberPipe.transform(this.allLineMaxValue * marker) + suffix,
                top: 100 - (100 * marker)
            });
        }
        return yLabels;
    };
    /**
     * Hides all lines apart from hovered line.
     *
     * @param {UILineChartLine} uiLineChartLine
     */
    /**
     * Hides all lines apart from hovered line.
     *
     * @param {?} uiLineChartLine
     * @return {?}
     */
    UILineChartComponent.prototype.onPointMouseEnter = /**
     * Hides all lines apart from hovered line.
     *
     * @param {?} uiLineChartLine
     * @return {?}
     */
    function (uiLineChartLine) {
        var _this = this;
        clearTimeout(this.pointHoverTimeout);
        this.pointHoverTimeout = setTimeout(function () {
            _this.lines.map(function (line) {
                if (line !== uiLineChartLine) {
                    line.visible = false;
                }
            });
            _this.chartKeyItems = _this.getChartKeyItems();
        }, 250);
    };
    /**
     * Sets lines back to state previous to point hover.
     */
    /**
     * Sets lines back to state previous to point hover.
     * @return {?}
     */
    UILineChartComponent.prototype.onPointMouseLeave = /**
     * Sets lines back to state previous to point hover.
     * @return {?}
     */
    function () {
        var _this = this;
        clearTimeout(this.pointHoverTimeout);
        this.pointHoverTimeout = setTimeout(function () {
            _this.lines.map(function (line) {
                line.visible = true;
            });
            _this.chartKeyItems = _this.getChartKeyItems();
        }, 400);
    };
    /**
     * Handles key item click.
     *
     * @param {UIChartKeyItem} uiChartKeyItem
     */
    /**
     * Handles key item click.
     *
     * @param {?} uiChartKeyItem
     * @return {?}
     */
    UILineChartComponent.prototype.onKeyItemClick = /**
     * Handles key item click.
     *
     * @param {?} uiChartKeyItem
     * @return {?}
     */
    function (uiChartKeyItem) {
        /** @type {?} */
        var uiLineChartItem = this.lines.find(function (uiLineChartLine) {
            return uiLineChartLine.name === uiChartKeyItem.name;
        });
        uiLineChartItem.enabled = uiChartKeyItem.enabled;
    };
    UILineChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-line-chart',
                    template: "\n      <!--  LINE CHART HEADER  -->\n\n      <div *ngIf=\"!!title || showKey\" class=\"line-chart-header\">\n\n          <!--  CHART TITLE  -->\n\n          <h3>{{ title }}</h3>\n\n          <!--  END CHART TITLE  -->\n\n          <!--  KEY  -->\n\n          <ui-chart-key *ngIf=\"showKey\" [items]=\"chartKeyItems\" (onItemClick)=\"onKeyItemClick($event)\"></ui-chart-key>\n\n          <!--  END KEY  -->\n\n\n      </div>\n\n      <!--  END LINE CHART HEADER  -->\n\n\n      <!--  LINE CHART CONTAINER  -->\n\n      <div class=\"line-chart-container\" [style.height]=\"this.height + 'px'\" [class.has-y-axis]=\"showYAxis\" [class.has-influences]=\"showInfluences\" [class.has-threshold-lines]=\"thresholdLines.length > 0\">\n\n          <!--  THRESHOLD LINES CONTAINER  -->\n\n          <div *ngIf=\"thresholdLines\" class=\"threshold-line-container\">\n\n              <!--  THRESHOLD LINE LOOP  -->\n\n              <div *ngFor=\"let thresholdLine of thresholdLines\" class=\"threshold-line\" [class.hidden]=\"thresholdLine.top < 0\" [style.top]=\"thresholdLine.top + '%'\">\n                  <span>{{ thresholdLine.name }}</span>\n              </div>\n\n              <!--  END THRESHOLD LINE LOOP  -->\n\n          </div>\n\n          <!--  END THRESHOLD LINES CONTAINER  -->\n\n          <!--  SVG CONTAINER  -->\n\n          <div class=\"svg-container\">\n\n              <!--  SVG  -->\n\n              <svg width=\"100%\" height=\"100%\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"none\">\n\n                  <!--  LINES GROUP  -->\n\n                  <g class=\"lines-group\">\n\n                      <!--  POLYLINE LOOP  -->\n\n\n                      <g *ngFor=\"let line of lines\">\n\n                          <polyline class=\"solid\" [ngClass]=\"'stroke-' + line.color\" [class.disabled]=\"!line.enabled || !line.visible\" [attr.points]=\"getSolidPoints(line)\"></polyline>\n                          <polyline *ngIf=\"line.trailingDashedSections !== null\" class=\"dashed\" [ngClass]=\"'stroke-' + line.color\" [class.disabled]=\"!line.enabled || !line.visible\" [attr.points]=\"getDashedPoints(line)\"></polyline>\n\n                      </g>\n\n\n                      <!--  END POLYLINE GROUP  -->\n\n                  </g>\n\n                  <!--  END LINES GROUP  -->\n              </svg>\n\n              <!--  END SVG  -->\n\n          </div>\n\n          <!--  END SVG CONTAINER  -->\n\n          <!--  POINTS CONTAINER  -->\n\n          <div class=\"points-container\">\n\n              <!--  LINE LOOP  -->\n\n              <div *ngFor=\"let line of lines\" [class.disabled]=\"!line.enabled || !line.visible\">\n\n                  <!--  POINT LOOP  -->\n\n                  <div *ngFor=\"let point of line.points; let index = index\"\n                       class=\"point\"\n                       [class.hidden]=\"point[0] < 0 || point[0] > 100 || !line.displayValues[index]\"\n                       [style.left]=\"point[0] + '%'\"\n                       [style.top]=\"point[1] + '%'\"\n                       [uiTooltipText]=\"line.displayValues[index]\"\n                       [uiTooltipConfig]=\"tooltipConfig\"\n                       (mouseenter)=\"onPointMouseEnter(line)\"\n                       (mouseleave)=\"onPointMouseLeave()\">\n                      <div class=\"inner\" [ngClass]=\"'bg-' + line.color\"></div>\n                  </div>\n\n                  <!--  END POINT LOOP  -->\n\n              </div>\n\n              <!--  END LINE LOOP  -->\n          </div>\n\n          <!--  END POINTS CONTAINER  -->\n\n          <!--  BAR CONTAINER  -->\n\n          <div class=\"bar-container\">\n\n              <!--  BAR LOOP  -->\n\n              <div *ngFor=\"let xLabel of xLabels\" class=\"bar acc-hl-aft-bg\" [class.hovered]=\"xLabel.hovered\" [style.width]=\"barWidth + '%'\">\n\n                  <!--  X AXIS LABEL  -->\n\n                  <ui-line-chart-x-label [xLabel]=\"xLabel\" [showInfluences]=\"showInfluences\"></ui-line-chart-x-label>\n\n                  <!--  END X AXIS LABEL  -->\n\n              </div>\n\n              <!--  END BAR LOOP  -->\n\n          </div>\n\n          <!--  END BAR CONTAINER  -->\n\n          <!--  Y AXIS  -->\n\n          <div *ngIf=\"showYAxis\" class=\"y-axis-container\">\n\n              <div class=\"inner\">\n\n                  <!--  Y AXIS LABEL LOOP  -->\n\n                  <div *ngFor=\"let yLabel of yLabels\" [style.top]=\"yLabel.top + '%'\">{{ yLabel.name }}</div>\n\n                  <!--  END Y AXIS LABEL LOOP  -->\n\n              </div>\n\n          </div>\n\n          <!--  END Y AXIS  -->\n\n      </div>\n\n      <!--  END LINE CHART CONTAINER  -->\n    ",
                    styles: ["\n      :host .line-chart-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-bottom:16px}:host .line-chart-header>h3{-ms-flex-negative:0;flex-shrink:0;margin-right:24px;margin-bottom:8px}:host .line-chart-container{position:relative}:host .line-chart-container>.svg-container{position:absolute;top:0;left:0;right:0;bottom:42px;z-index:2;pointer-events:none}:host .line-chart-container>.svg-container>svg{shape-rendering:geometricPrecision;padding:16px 0}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline{fill:none;stroke:#2156A0;stroke-width:2px;stroke-linejoin:round;stroke-linecap:round;vector-effect:non-scaling-stroke;pointer-events:auto;-webkit-transition:opacity .2s linear 0s;-o-transition:opacity .2s linear 0s;transition:opacity .2s linear 0s}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-green{stroke:#2B9F57}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-teal{stroke:#35B4A7}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-light-blue{stroke:#4EB0DD}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-blue{stroke:#2156A0}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-purple{stroke:#8935B4}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-pink{stroke:#D0497C}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-red{stroke:#D63535}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-orange{stroke:#F57F15}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-yellow{stroke:#F2B521}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-dark-blue{stroke:#202839}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-grey{stroke:#777}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.stroke-black{stroke:#000}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.disabled{opacity:0;pointer-events:none}:host .line-chart-container>.svg-container>svg>.lines-group>g>polyline.dashed{stroke-dasharray:8px}:host .line-chart-container>.points-container{position:absolute;top:16px;left:0;right:0;bottom:58px;z-index:3;pointer-events:none}:host .line-chart-container>.points-container>div{-webkit-transition:opacity .2s linear 0s;-o-transition:opacity .2s linear 0s;transition:opacity .2s linear 0s}:host .line-chart-container>.points-container>div>.point{position:absolute;pointer-events:auto;width:32px;height:32px;margin:-16px 0 0 -16px;border-radius:100%;-webkit-transition:height .1s linear 0s,width .1s linear 0s;-o-transition:height .1s linear 0s,width .1s linear 0s;transition:height .1s linear 0s,width .1s linear 0s;cursor:pointer}:host .line-chart-container>.points-container>div>.point>.inner{width:16px;height:16px;position:absolute;left:0;right:0;top:0;bottom:0;margin:auto;border-radius:100%;border:2px solid #FFF;-webkit-transition:inherit;-o-transition:inherit;transition:inherit}:host .line-chart-container>.points-container>div>.point>.inner::after{content:'';position:absolute;width:0;height:0;left:0;right:0;top:0;bottom:0;margin:auto;background:#FFF;border-radius:100%;-webkit-transition:inherit;-o-transition:inherit;transition:inherit}:host .line-chart-container>.points-container>div>.point:hover .inner{width:32px;height:32px}:host .line-chart-container>.points-container>div>.point:hover .inner::after{width:16px;height:16px}:host .line-chart-container>.points-container>div.disabled{opacity:0;pointer-events:none}:host .line-chart-container>.points-container>div.disabled>.point{pointer-events:none}:host .line-chart-container>.threshold-line-container{position:absolute;top:15px;left:0;right:0;bottom:58px;z-index:1;pointer-events:none}:host .line-chart-container>.threshold-line-container>.threshold-line{position:absolute;left:0;right:0;height:1px}:host .line-chart-container>.threshold-line-container>.threshold-line>span{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;position:absolute;height:15px;color:#FFF;text-transform:uppercase;font-size:9px;display:block;padding:0 3px;line-height:15px;border-radius:2px;width:48px;text-align:center;background:#c8c8c8;right:0;top:-7px}:host .line-chart-container>.threshold-line-container>.threshold-line::after{content:'';display:block;position:absolute;height:1px;background:#dedede;right:48px;left:0}:host .line-chart-container>.bar-container{position:absolute;top:0;left:0;right:0;bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex}:host .line-chart-container>.bar-container>.bar{-ms-flex-negative:0;flex-shrink:0;background:#FFF;border-radius:3px;position:relative;-webkit-transition:all .1s linear 0s;-o-transition:all .1s linear 0s;transition:all .1s linear 0s}:host .line-chart-container>.bar-container>.bar:nth-child(odd){background:#f8f8f8}:host .line-chart-container>.bar-container>.bar::after{content:'';display:block;position:absolute;bottom:32px;left:0;right:0;background:#4e4e4e;height:5px;z-index:1;opacity:0;-webkit-transition:all .1s linear 0s;-o-transition:all .1s linear 0s;transition:all .1s linear 0s}:host .line-chart-container>.bar-container>.bar.hovered{background:#e9e9e9}:host .line-chart-container>.bar-container>.bar.hovered::after{opacity:1}:host .line-chart-container>.bar-container::after,:host .line-chart-container>.bar-container::before{content:'';display:block;position:absolute;bottom:37px;left:0;right:0;background:#FFF;height:5px;z-index:2;pointer-events:none}:host .line-chart-container>.bar-container::after{position:absolute;bottom:32px;background:#dedede;z-index:0}:host .line-chart-container>.y-axis-container{position:absolute;top:0;left:0;bottom:32px;width:64px;border-right:5px solid #dedede}:host .line-chart-container>.y-axis-container .inner{position:absolute;left:0;right:0;top:16px;bottom:26px}:host .line-chart-container>.y-axis-container .inner>div{height:12px;line-height:12px;margin-top:-6px;text-align:right;font-size:10px;font-weight:500;color:#919191;position:absolute;right:0;padding-right:10px}:host .line-chart-container>.y-axis-container .inner>div::after{content:'';display:block;position:absolute;width:5px;height:2px;background:#dedede;right:0;top:5px}:host .line-chart-container.has-y-axis>.points-container,:host .line-chart-container.has-y-axis>.svg-container,:host .line-chart-container.has-y-axis>.threshold-line-container{left:69px}:host .line-chart-container.has-y-axis>.bar-container{left:64px;padding-left:5px}:host .line-chart-container.has-influences>.svg-container{bottom:58px}:host .line-chart-container.has-influences>.points-container{bottom:74px}:host .line-chart-container.has-influences>.bar-container>.bar::after{bottom:48px}:host .line-chart-container.has-influences>.bar-container::before{bottom:53px}:host .line-chart-container.has-influences>.bar-container::after{bottom:48px}:host .line-chart-container.has-influences>.y-axis-container{bottom:48px}:host .line-chart-container.has-threshold-lines>.points-container,:host .line-chart-container.has-threshold-lines>.svg-container{right:48px}:host .line-chart-container.has-threshold-lines>.bar-container{padding-right:48px}@media screen and (max-width:1174px){:host .line-chart-header{margin-bottom:8px}}@media screen and (max-width:974px){:host .line-chart-container>.points-container>div>.point{width:24px;height:24px;margin:-12px 0 0 -12px}:host .line-chart-container>.points-container>div>.point>.inner{width:12px;height:12px}:host .line-chart-container>.points-container>div>.point:hover .inner{width:24px;height:24px}:host .line-chart-container>.points-container>div>.point:hover .inner::after{width:12px;height:12px}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UILineChartComponent.ctorParameters = function () { return [
        { type: UIScriptLoaderService },
        { type: UIHelperService },
        { type: UIMoneyPipe },
        { type: UIShortNumberPipe },
        { type: DecimalPipe }
    ]; };
    UILineChartComponent.propDecorators = {
        title: [{ type: Input }],
        lines: [{ type: Input }],
        height: [{ type: Input }],
        xLabels: [{ type: Input }],
        showInfluences: [{ type: Input }],
        showYAxis: [{ type: Input }],
        sharedYAxis: [{ type: Input }],
        showKey: [{ type: Input }],
        thresholdLines: [{ type: Input }]
    };
    return UILineChartComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILineChartThresholdLine = /** @class */ (function () {
    function UILineChartThresholdLine(uiLineChartThresholdLine) {
        Object.assign(/** @type {?} */ (this), uiLineChartThresholdLine);
    }
    return UILineChartThresholdLine;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILineChartXLabel = /** @class */ (function () {
    function UILineChartXLabel(uiLineChartXLabel) {
        this.influences = [];
        //  PROCESSED
        this.hovered = false;
        Object.assign(/** @type {?} */ (this), uiLineChartXLabel);
    }
    return UILineChartXLabel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILineChartYLabel = /** @class */ (function () {
    function UILineChartYLabel(uiLineChartYLabel) {
        Object.assign(/** @type {?} */ (this), uiLineChartYLabel);
    }
    return UILineChartYLabel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILineChartLine = /** @class */ (function () {
    function UILineChartLine(uiLineChartLine) {
        this.valueType = 'number';
        this.color = 'blue';
        this.startIndex = 0;
        this.trailingDashedSections = 0;
        // PROCESSED
        this.enabled = true;
        this.visible = true;
        this.displayValues = [];
        this.points = [];
        this.solidPoints = [];
        this.dashedPoints = [];
        Object.assign(/** @type {?} */ (this), uiLineChartLine);
    }
    return UILineChartLine;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UILineChartModule = /** @class */ (function () {
    function UILineChartModule() {
    }
    UILineChartModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UILineChartComponent,
                        UILineChartXLabelComponent
                    ],
                    imports: [
                        CommonModule,
                        UIShortNumberModule.forRoot(),
                        UIMoneyModule.forRoot(),
                        UIChartKeyModule,
                        UITooltipModule,
                        UIPopoverModule
                    ],
                    providers: [
                        DecimalPipe$1
                    ],
                    exports: [
                        UILineChartComponent,
                        UILineChartXLabelComponent
                    ]
                },] },
    ];
    return UILineChartModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIProgressBarComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param uiThemeService
     */
    function UIProgressBarComponent(uiThemeService) {
        this.uiThemeService = uiThemeService;
        this.size = 'medium';
        this.theme = 'primary';
        this.animated = false;
    }
    /**
     * Re-builds when inputs change.
     *
     * @param simpleChanges
     */
    /**
     * Re-builds when inputs change.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    UIProgressBarComponent.prototype.ngOnChanges = /**
     * Re-builds when inputs change.
     *
     * @param {?} simpleChanges
     * @return {?}
     */
    function (simpleChanges) {
        if (simpleChanges['theme']) {
            this.themeClass = this.uiThemeService.buildCssClass(this.theme, 'background');
        }
    };
    UIProgressBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-progress-bar',
                    template: "\n      <!--  PROGRESS BAR  -->\n\n      <div class=\"progress-bar\" [ngClass]=\"'size-' + size\" [class.animated]=\"animated\">\n\n          <!--  OUTER  -->\n\n          <div class=\"outer\"></div>\n\n          <!--  END OUTER  -->\n\n          <!--  INNER  -->\n\n          <div class=\"inner\" [style.width]=\"value + '%'\" [ngClass]=\"themeClass\">\n\n              <!--  STRIPES  -->\n\n              <div class=\"stripes progress\"></div>\n\n              <!--  END STRIPES  -->\n\n          </div>\n\n          <!--  END INNER  -->\n\n      </div>\n\n      <!--  END PROGRESS BAR  -->\n    ",
                    styles: ["\n      :host .progress-bar{position:relative;height:16px;-webkit-transition:all .2s ease-in-out 0s;-o-transition:all .2s ease-in-out 0s;transition:all .2s ease-in-out 0s;border-radius:8px;overflow:hidden}:host .progress-bar>div{position:absolute;border-radius:8px;top:0;left:0;bottom:0;-webkit-transition:inherit;-o-transition:inherit;transition:inherit}:host .progress-bar>.outer{z-index:0;right:0;background:#e9e9e9}:host .progress-bar>.inner{background:#4e4e4e;overflow:hidden}:host .progress-bar>.inner .stripes{opacity:0;position:absolute;top:0;left:0;bottom:0;width:3200px;background-image:-o-repeating-linear-gradient(26deg,transparent,transparent 16px,rgba(255,255,255,.2) 16px,rgba(255,255,255,.2) 32px);background-image:repeating-linear-gradient(64deg,transparent,transparent 16px,rgba(255,255,255,.2) 16px,rgba(255,255,255,.2) 32px);-webkit-transition:opacity .2s linear 0s;-o-transition:opacity .2s linear 0s;transition:opacity .2s linear 0s}:host .progress-bar.size-small{height:8px;border-radius:4px}:host .progress-bar.size-small>div{border-radius:4px}:host .progress-bar.size-large{height:24px;border-radius:12px}:host .progress-bar.size-large>div{border-radius:12px}:host .progress-bar.animated>.inner>.stripes{opacity:1}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIProgressBarComponent.ctorParameters = function () { return [
        { type: UIThemeService }
    ]; };
    UIProgressBarComponent.propDecorators = {
        value: [{ type: Input }],
        size: [{ type: Input }],
        theme: [{ type: Input }],
        animated: [{ type: Input }]
    };
    return UIProgressBarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIProgressBarModule = /** @class */ (function () {
    function UIProgressBarModule() {
    }
    UIProgressBarModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIProgressBarComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UIProgressBarComponent
                    ]
                },] },
    ];
    return UIProgressBarModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIRadarChartComponent = /** @class */ (function () {
    /**
     * Constructs class and injects dependencies.
     *
     * @param {UIHelperService} uiHelperService
     */
    function UIRadarChartComponent(uiHelperService) {
        this.uiHelperService = uiHelperService;
        this.size = 400;
        this.segments = [];
        this.baseTheme = 'light';
        this.showLabels = true;
        this.clipPathName = this.uiHelperService.generateRandomString(30);
    }
    /**
     * Lifecycle hook: Initialises chart build.
     */
    /**
     * Lifecycle hook: Initialises chart build.
     * @return {?}
     */
    UIRadarChartComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Initialises chart build.
     * @return {?}
     */
    function () {
        this.setChartSize();
        this.buildSegments();
        this.createSegmentClip();
    };
    /**
     * Lifecycle hook: Initialises chart build.
     */
    /**
     * Lifecycle hook: Initialises chart build.
     * @param {?} simpleChanges
     * @return {?}
     */
    UIRadarChartComponent.prototype.ngOnChanges = /**
     * Lifecycle hook: Initialises chart build.
     * @param {?} simpleChanges
     * @return {?}
     */
    function (simpleChanges) {
        if (simpleChanges['size']) {
            this.setChartSize();
        }
        if (simpleChanges['segments'] || simpleChanges['size']) {
            this.buildSegments();
            this.createSegmentClip();
        }
    };
    /**
     * Sets chart size settings based on passed size.
     */
    /**
     * Sets chart size settings based on passed size.
     * @return {?}
     */
    UIRadarChartComponent.prototype.setChartSize = /**
     * Sets chart size settings based on passed size.
     * @return {?}
     */
    function () {
        if (this.size <= 150) {
            this.sizeSettings = { name: 'xs', padding: 4, strokeWidth: 2 };
            return;
        }
        if (this.size <= 250) {
            this.sizeSettings = { name: 'sm', padding: this.showLabels ? 32 : 8, strokeWidth: 4 };
            return;
        }
        if (this.size <= 350) {
            this.sizeSettings = { name: 'md', padding: this.showLabels ? 48 : 12, strokeWidth: 6 };
            return;
        }
        this.sizeSettings = { name: 'lg', padding: this.showLabels ? 64 : 16, strokeWidth: 8 };
    };
    /**
     * Creates clip for segments.
     */
    /**
     * Creates clip for segments.
     * @return {?}
     */
    UIRadarChartComponent.prototype.createSegmentClip = /**
     * Creates clip for segments.
     * @return {?}
     */
    function () {
        if (this.segments.length === 1) {
            this.clipPolygonPoints = ["0,0", this.size + ",0", this.size + "," + this.size, "0," + this.size].join(' ');
            return;
        }
        if (this.segments.length === 2) {
            this.clipPolygonPoints = ["0," + this.size / 2, this.size + "," + this.size / 2, this.size + "," + this.size, "0," + this.size].join(' ');
            return;
        }
        /** @type {?} */
        var multiplier = 1;
        switch (this.segments.length) {
            case 3:
                multiplier = 4.76;
                break;
            case 4:
                multiplier = 2;
                break;
            case 5:
                multiplier = 1.51;
                break;
            case 6:
                multiplier = 1.27;
                break;
            case 7:
                multiplier = 1.11;
                break;
        }
        this.clipPolygonPoints = [this.size / 2 + "," + this.size / 2, this.size + "," + this.size / 2, this.size + "," + this.size, this.size / multiplier + "," + this.size].join(' ');
    };
    /**
     * Appends additional properties to segments.
     */
    /**
     * Appends additional properties to segments.
     * @return {?}
     */
    UIRadarChartComponent.prototype.buildSegments = /**
     * Appends additional properties to segments.
     * @return {?}
     */
    function () {
        var _this = this;
        this.segments = this.uiHelperService.copy(this.segments);
        this.segments.map(function (segment, index) {
            segment.segmentRotateValue = (-90 + ((360 / _this.segments.length) * index)).toString() + ' ' + (_this.size / 2).toString() + ' ' + (_this.size / 2).toString();
            segment.labelRotateValue = -90 + ((360 / _this.segments.length) * index) + (360 / (_this.segments.length * 2));
            /** @type {?} */
            var valueToCalculateWith = segment.value > 100 ? 100 : segment.value;
            segment.radius = ((_this.size / 2) - _this.sizeSettings.padding) * (valueToCalculateWith / 100);
            /** @type {?} */
            var innerRadius = segment.radius - ((_this.sizeSettings.strokeWidth / 2) + 1.5);
            segment.innerRadius = innerRadius < 0 ? 0 : innerRadius;
            if (segment.labelRotateValue > 0 && segment.labelRotateValue < 180) {
                segment.labelFlipped = true;
                segment.labelRotateValue += 180;
            }
            return segment;
        });
    };
    UIRadarChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-radar-chart',
                    template: "\n      <!--  RADAR CHART CONTAINER  -->\n\n      <div class=\"radar-chart-container\" [style.width]=\"size +'px'\" [style.height]=\"size + 'px'\" [ngClass]=\"[baseTheme + '-base-theme', 'size-' + sizeSettings.name]\">\n\n\n          <!--  RADAR CHART SVG  -->\n\n          <svg [attr.width]=\"size\" [attr.height]=\"size\" class=\"radar-chart\">\n\n              <!--  DEFS  -->\n\n              <defs>\n\n                  <clipPath [attr.id]=\"clipPathName\">\n                      <polygon [attr.points]=\"clipPolygonPoints\"></polygon>\n                  </clipPath>\n\n              </defs>\n\n              <!--  END DEFS  -->\n\n              <!--  BACKDROP CIRCLE  -->\n\n              <circle class=\"backdrop\" [attr.cx]=\"size / 2\"\n                      [attr.cy]=\"size / 2\"\n                      [attr.r]=\"(size / 2)\">\n              </circle>\n\n              <!--  END BACKDROP CIRCLE  -->\n\n              <!--  SEGMENTS LOOP  -->\n\n              <circle *ngFor=\"let segment of segments\"\n                      class=\"segment\"\n                      [class.glow]=\"segment.glow\"\n                      [ngClass]=\"segment.color\"\n                      [style.stroke-width]=\"sizeSettings.strokeWidth\"\n                      [attr.transform]=\"'rotate(' + segment.segmentRotateValue + ')'\"\n                      [attr.cx]=\"size / 2\"\n                      [attr.cy]=\"size / 2\"\n                      [attr.r]=\"segment.radius\"\n                      [attr.clip-path]=\"'url(#' + clipPathName + ')'\">\n              </circle>\n\n              <!--  END SEGMENTS LOOP  -->\n\n              <!--  INNER SEGMENTS LOOP  -->\n\n              <circle *ngFor=\"let segment of segments\"\n                      class=\"inner-segment\"\n                      [attr.transform]=\"'rotate(' + segment.segmentRotateValue + ')'\"\n                      [attr.cx]=\"size / 2\"\n                      [attr.cy]=\"size / 2\"\n                      [attr.r]=\"segment.innerRadius\"\n                      [attr.clip-path]=\"'url(#' + clipPathName + ')'\">\n              </circle>\n\n              <!--  END INNER SEGMENTS LOOP  -->\n\n              <!--  SEGMENT LINES LOOP  -->\n\n              <g *ngIf=\"segments.length > 1\">\n\n                  <line *ngFor=\"let segment of segments\"\n                        [attr.x1]=\"size / 2\"\n                        [attr.y1]=\"size / 2\"\n                        [attr.x2]=\"size\"\n                        [attr.y2]=\"size / 2\"\n                        [attr.transform]=\"'rotate(' + segment.segmentRotateValue + ')'\">\n                  </line>\n\n              </g>\n\n              <!--  END SEGMENT LINES GROUP  -->\n\n          </svg>\n\n          <!--  END RADAR CHART SVG  -->\n\n          <!--  RADAR CHART OVERLAY  -->\n\n          <div class=\"radar-chart-overlay\">\n\n              <!--  LABELS  -->\n\n              <div *ngIf=\"showLabels && sizeSettings.name !=='xs'\" class=\"labels\">\n                  <span *ngFor=\"let segment of segments\" [style.transform]=\"'rotate(' + segment.labelRotateValue + 'deg)'\" [class.flipped]=\"segment.labelFlipped\">\n                     <span>\n                         {{ segment.label }}<br>\n                         <span [ngClass]=\"'color-' + segment.color\">{{ segment.value | number:'1.1-1' }}</span>\n                      </span>\n                  </span>\n              </div>\n\n              <!--  END LABELS LOOP  -->\n\n          </div>\n\n          <!--  END RADAR CHART OVERLAY  -->\n\n      </div>\n\n      <!--  END RADAR CHART CONTAINER  -->\n    ",
                    styles: ["\n      :host{display:block}:host .radar-chart-container{position:relative;margin:0 auto}:host .radar-chart-container .radar-chart{position:absolute;top:0;left:0;z-index:0}:host .radar-chart-container .radar-chart .backdrop{fill:#f2f2f2}:host .radar-chart-container .radar-chart .segment{fill-opacity:.2}:host .radar-chart-container .radar-chart .segment.blue{fill:#2156A0;stroke:#2156A0}:host .radar-chart-container .radar-chart .segment.light-blue{fill:#4EB0DD;stroke:#4EB0DD}:host .radar-chart-container .radar-chart .segment.green{fill:#2B9F57;stroke:#2B9F57}:host .radar-chart-container .radar-chart .segment.red{fill:#D63535;stroke:#D63535}:host .radar-chart-container .radar-chart .segment.pink{fill:#D0497C;stroke:#D0497C}:host .radar-chart-container .radar-chart .segment.purple{fill:#8935B4;stroke:#8935B4}:host .radar-chart-container .radar-chart .segment.teal{fill:#35B4A7;stroke:#35B4A7}:host .radar-chart-container .radar-chart .segment.orange{fill:#F57F15;stroke:#F57F15}:host .radar-chart-container .radar-chart .segment.yellow{fill:#F2B521;stroke:#F2B521}:host .radar-chart-container .radar-chart .inner-segment{stroke-width:3;stroke:#f2f2f2;fill:none;pointer-events:none}:host .radar-chart-container .radar-chart line{stroke-width:3;stroke:#f2f2f2}:host .radar-chart-container .radar-chart-overlay{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1}:host .radar-chart-container .radar-chart-overlay .labels{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg);position:absolute;top:0;left:0;right:0;bottom:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host .radar-chart-container .radar-chart-overlay .labels>span{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;position:absolute;left:37.5%;right:37.5%;top:16px;bottom:16px;color:#7a7a7a;font-size:12px;line-height:16px;text-transform:uppercase;font-weight:500;-ms-flex-pack:distribute;justify-content:space-around;pointer-events:none;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;text-align:center}:host .radar-chart-container .radar-chart-overlay .labels>span>span{-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding-right:1px;display:inline-block;pointer-events:initial}:host .radar-chart-container .radar-chart-overlay .labels>span.flipped{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}:host .radar-chart-container.white-base-theme .radar-chart .backdrop{fill:#FFF}:host .radar-chart-container.white-base-theme .radar-chart .inner-segment{stroke:#FFF}:host .radar-chart-container.white-base-theme .radar-chart line{stroke:#FFF}:host .radar-chart-container.dark-base-theme .radar-chart .backdrop{fill:#1a1a1a}:host .radar-chart-container.dark-base-theme .radar-chart .inner-segment{stroke:#1a1a1a}:host .radar-chart-container.dark-base-theme .radar-chart line{stroke:#1a1a1a}:host .radar-chart-container.size-sm .radar-chart-overlay .labels>span{font-size:9px;top:6px;bottom:6px;line-height:10px}:host .radar-chart-container.size-md .radar-chart-overlay .labels>span{font-size:10px;top:12px;bottom:12px;line-height:12px}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIRadarChartComponent.ctorParameters = function () { return [
        { type: UIHelperService }
    ]; };
    UIRadarChartComponent.propDecorators = {
        size: [{ type: Input }],
        segments: [{ type: Input }],
        baseTheme: [{ type: Input }],
        showLabels: [{ type: Input }]
    };
    return UIRadarChartComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIRadarChartSegment = /** @class */ (function () {
    function UIRadarChartSegment(uiRadarChartSegment) {
        this.glow = false;
        this.labelFlipped = false;
        Object.assign(/** @type {?} */ (this), uiRadarChartSegment);
    }
    return UIRadarChartSegment;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIRadarChartModule = /** @class */ (function () {
    function UIRadarChartModule() {
    }
    UIRadarChartModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIRadarChartComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UIRadarChartComponent
                    ]
                },] },
    ];
    return UIRadarChartModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIChartInfluence = /** @class */ (function () {
    function UIChartInfluence(uiChartInfluence) {
        this.color = 'blue';
        Object.assign(/** @type {?} */ (this), uiChartInfluence);
    }
    return UIChartInfluence;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISpeedoChartLabel = /** @class */ (function () {
    function UISpeedoChartLabel(uiSpeedoChartLabel) {
        this.name = '';
        this.x = 0;
        this.y = 0;
        Object.assign(/** @type {?} */ (this), uiSpeedoChartLabel);
    }
    return UISpeedoChartLabel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISpeedoChartComponent = /** @class */ (function () {
    /**
     * Constructs component and injects dependencies.
     *
     * @param {CurrencyPipe} currencyPipe
     * @param {DecimalPipe} decimalPipe
     * @param {UIHelperService} uiHelperService
     */
    function UISpeedoChartComponent(currencyPipe, decimalPipe, uiHelperService) {
        this.currencyPipe = currencyPipe;
        this.decimalPipe = decimalPipe;
        this.uiHelperService = uiHelperService;
        this.segments = [];
        this.segmentDashArray = '';
        this.clipPolygonPoints = '';
        this.averageMinimumLabel = new UISpeedoChartLabel({});
        this.averageMaximumLabel = new UISpeedoChartLabel({});
        // minimumLabel: UISpeedoChartLabel = new UISpeedoChartLabel({});
        // maximumLabel: UISpeedoChartLabel = new UISpeedoChartLabel({});
        this.needlePolygonPoints = '';
        this.needleRotateValue = '';
        this.ghostNeedleRotateValue = '';
        this.finalDisplayValue = '';
        this.finalDisplayValueSuffix = null;
        this.outcomeClass = '';
        this.outcomeLabel = '';
        this.clipPathName = this.uiHelperService.generateRandomString(30);
    }
    /**
     * Lifecycle hook: Initialises chart when component first loaded .
     */
    /**
     * Lifecycle hook: Initialises chart when component first loaded .
     * @return {?}
     */
    UISpeedoChartComponent.prototype.ngOnInit = /**
     * Lifecycle hook: Initialises chart when component first loaded .
     * @return {?}
     */
    function () {
        this.initChart();
    };
    /**
     * Lifecycle hook: Initialises chart when inputs are updated.
     */
    /**
     * Lifecycle hook: Initialises chart when inputs are updated.
     * @return {?}
     */
    UISpeedoChartComponent.prototype.ngOnChanges = /**
     * Lifecycle hook: Initialises chart when inputs are updated.
     * @return {?}
     */
    function () {
        this.initChart();
    };
    /**
     * Initialises speedo chart.
     */
    /**
     * Initialises speedo chart.
     * @return {?}
     */
    UISpeedoChartComponent.prototype.initChart = /**
     * Initialises speedo chart.
     * @return {?}
     */
    function () {
        this.createSegments();
        this.createSegmentDashArray();
        this.createSegmentClip();
        this.createSegmentLabels();
        this.createNeedle();
        this.setChartValues();
    };
    /**
     * Creates chart segments
     */
    /**
     * Creates chart segments
     * @return {?}
     */
    UISpeedoChartComponent.prototype.createSegments = /**
     * Creates chart segments
     * @return {?}
     */
    function () {
        this.segments = [{
                className: 'below-average',
                rotateValue: '-165 ' + (this.uiSpeedoChart.size / 2).toString() + ' ' + (this.uiSpeedoChart.size / 2).toString()
            }, {
                className: 'average',
                rotateValue: '-115 ' + (this.uiSpeedoChart.size / 2).toString() + ' ' + (this.uiSpeedoChart.size / 2).toString()
            }, {
                className: 'above-average',
                rotateValue: '-65 ' + (this.uiSpeedoChart.size / 2).toString() + ' ' + (this.uiSpeedoChart.size / 2).toString()
            }];
    };
    /**
     * Creates dash array for segments.
     */
    /**
     * Creates dash array for segments.
     * @return {?}
     */
    UISpeedoChartComponent.prototype.createSegmentDashArray = /**
     * Creates dash array for segments.
     * @return {?}
     */
    function () {
        /** @type {?} */
        var circumference = (this.uiSpeedoChart.size - 60) * Math.PI;
        /** @type {?} */
        var segmentSize = Math.ceil(circumference * (50 / 360));
        this.segmentDashArray = segmentSize.toString() + ' ' + Math.ceil(circumference - segmentSize).toString();
    };
    /**
     * Creates clip for segments.
     */
    /**
     * Creates clip for segments.
     * @return {?}
     */
    UISpeedoChartComponent.prototype.createSegmentClip = /**
     * Creates clip for segments.
     * @return {?}
     */
    function () {
        /** @type {?} */
        var points = [
            (this.uiSpeedoChart.size / 2).toString() + ',' + (this.uiSpeedoChart.size / 2).toString(),
            (this.uiSpeedoChart.size).toString() + ',' + (this.uiSpeedoChart.size / 2).toString(),
            (this.uiSpeedoChart.size).toString() + ',' + (this.uiSpeedoChart.size).toString(),
            (this.uiSpeedoChart.size - ((this.uiSpeedoChart.size * 0.08) + 4)).toString() + ',' + (this.uiSpeedoChart.size).toString()
        ];
        this.clipPolygonPoints = points.join(' ');
    };
    /**
     * Creates threshold labels.
     */
    /**
     * Creates threshold labels.
     * @return {?}
     */
    UISpeedoChartComponent.prototype.createSegmentLabels = /**
     * Creates threshold labels.
     * @return {?}
     */
    function () {
        switch (this.uiSpeedoChart.unitType) {
            case 'currency':
                this.averageMinimumLabel.name = this.currencyPipe.transform(this.uiSpeedoChart.averageMinimum, 'GBP', 'symbol', '1.' + this.uiSpeedoChart.decimalPlaces + '-' + this.uiSpeedoChart.decimalPlaces);
                this.averageMaximumLabel.name = this.currencyPipe.transform(this.uiSpeedoChart.averageMaximum, 'GBP', 'symbol', '1.' + this.uiSpeedoChart.decimalPlaces + '-' + this.uiSpeedoChart.decimalPlaces);
                // this.minimumLabel.name = this.currencyPipe.transform(this.uiSpeedoChart.minimum, 'GBP', 'symbol', '1.' + this.uiSpeedoChart.decimalPlaces + '-' + this.uiSpeedoChart.decimalPlaces);
                // this.maximumLabel.name = this.currencyPipe.transform(this.uiSpeedoChart.maximum, 'GBP', 'symbol', '1.' + this.uiSpeedoChart.decimalPlaces + '-' + this.uiSpeedoChart.decimalPlaces);
                break;
            case 'percentage':
            case 'number':
                this.averageMinimumLabel.name = this.decimalPipe.transform(this.uiSpeedoChart.averageMinimum, '1.' + this.uiSpeedoChart.decimalPlaces + '-' + this.uiSpeedoChart.decimalPlaces);
                this.averageMaximumLabel.name = this.decimalPipe.transform(this.uiSpeedoChart.averageMaximum, '1.' + this.uiSpeedoChart.decimalPlaces + '-' + this.uiSpeedoChart.decimalPlaces);
                // this.minimumLabel.name = this.decimalPipe.transform(this.uiSpeedoChart.minimum, '1.' + this.uiSpeedoChart.decimalPlaces + '-' + this.uiSpeedoChart.decimalPlaces);
                // this.maximumLabel.name = this.decimalPipe.transform(this.uiSpeedoChart.maximum, '1.' + this.uiSpeedoChart.decimalPlaces + '-' + this.uiSpeedoChart.decimalPlaces);
                if (this.uiSpeedoChart.unitType === 'percentage') {
                    this.averageMinimumLabel.name += '%';
                    this.averageMaximumLabel.name += '%';
                    // this.minimumLabel.name += '%';
                    // this.maximumLabel.name += '%';
                }
                break;
            default:
                this.averageMinimumLabel.name = this.uiSpeedoChart.averageMinimum.toString();
                this.averageMaximumLabel.name = this.uiSpeedoChart.averageMaximum.toString();
                // this.minimumLabel.name = this.uiSpeedoChart.minimum.toString();
                // this.maximumLabel.name = this.uiSpeedoChart.maximum.toString();
                break;
        }
        this.averageMinimumLabel.y = this.uiSpeedoChart.size * 0.06;
        this.averageMinimumLabel.x = this.uiSpeedoChart.size * 0.3;
        this.averageMaximumLabel.y = this.uiSpeedoChart.size * 0.06;
        this.averageMaximumLabel.x = this.uiSpeedoChart.size * 0.69;
        // this.minimumLabel.y = this.uiSpeedoChart.size * 0.4;
        // this.minimumLabel.x = this.uiSpeedoChart.size * 0.05;
        // this.maximumLabel.y = this.uiSpeedoChart.size * 0.4;
        // this.maximumLabel.x = this.uiSpeedoChart.size * 0.9;
    };
    /**
     * Creates needle element.
     */
    /**
     * Creates needle element.
     * @return {?}
     */
    UISpeedoChartComponent.prototype.createNeedle = /**
     * Creates needle element.
     * @return {?}
     */
    function () {
        /** @type {?} */
        var points = [
            (this.uiSpeedoChart.size / 2).toString() + ',' + ((this.uiSpeedoChart.size / 2) - 6).toString(),
            (this.uiSpeedoChart.size - 50).toString() + ',' + (this.uiSpeedoChart.size / 2).toString(),
            (this.uiSpeedoChart.size / 2).toString() + ',' + ((this.uiSpeedoChart.size / 2) + 6).toString()
        ];
        this.needlePolygonPoints = points.join(' ');
        this.needleRotateValue = '-100 ' + (this.uiSpeedoChart.size / 2) + ' ' + (this.uiSpeedoChart.size / 2);
    };
    /**
     * Sets values.
     */
    /**
     * Sets values.
     * @return {?}
     */
    UISpeedoChartComponent.prototype.setChartValues = /**
     * Sets values.
     * @return {?}
     */
    function () {
        this.needleRotateValue = this.setNeedleRotateValue(this.uiSpeedoChart.value);
        if (this.uiSpeedoChart.ghostValue) {
            this.ghostNeedleRotateValue = this.setNeedleRotateValue(this.uiSpeedoChart.ghostValue);
        }
        this.setFinalDisplayValue();
        this.setOutcome();
    };
    /**
     * Rotates needles to match values.
     *
     * @param value
     * @returns {string}
     */
    /**
     * Rotates needles to match values.
     *
     * @param {?} value
     * @return {?}
     */
    UISpeedoChartComponent.prototype.setNeedleRotateValue = /**
     * Rotates needles to match values.
     *
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var rotateValue = 0;
        if (this.uiSpeedoChart.reverseNeedle) {
            /** @type {?} */
            var interval = this.uiSpeedoChart.averageMinimum - this.uiSpeedoChart.averageMaximum;
            /** @type {?} */
            var intervalDegree = 50 / interval;
            if (value <= ((this.uiSpeedoChart.averageMaximum - interval) < 0 ? 0 : (this.uiSpeedoChart.averageMaximum - interval))) {
                rotateValue = -15;
            }
            else if ((value > (this.uiSpeedoChart.averageMaximum - interval)) && (value <= (this.uiSpeedoChart.averageMinimum + interval))) {
                rotateValue = -(((value - (this.uiSpeedoChart.averageMaximum - interval)) * intervalDegree) + 15);
            }
            else {
                rotateValue = -165;
            }
        }
        else {
            /** @type {?} */
            var interval = this.uiSpeedoChart.averageMaximum - this.uiSpeedoChart.averageMinimum;
            /** @type {?} */
            var intervalDegree = 50 / interval;
            if (value <= ((this.uiSpeedoChart.averageMinimum - interval) < 0 ? 0 : (this.uiSpeedoChart.averageMinimum - interval))) {
                rotateValue = -165;
            }
            else if ((value > (this.uiSpeedoChart.averageMinimum - interval)) && (value <= (this.uiSpeedoChart.averageMaximum + interval))) {
                rotateValue = (((value - (this.uiSpeedoChart.averageMinimum - interval)) * intervalDegree) - 165);
            }
            else {
                rotateValue = -15;
            }
        }
        return rotateValue.toString() + ' ' + (this.uiSpeedoChart.size / 2).toString() + ' ' + (this.uiSpeedoChart.size / 2).toString();
    };
    /**
     * Sets display value on chart overlay.
     */
    /**
     * Sets display value on chart overlay.
     * @return {?}
     */
    UISpeedoChartComponent.prototype.setFinalDisplayValue = /**
     * Sets display value on chart overlay.
     * @return {?}
     */
    function () {
        /** @type {?} */
        var finalDisplayValue = null;
        switch (this.uiSpeedoChart.unitType) {
            case 'currency':
                finalDisplayValue = this.currencyPipe.transform(this.uiSpeedoChart.value, 'GBP', 'symbol', '1.' + this.uiSpeedoChart.decimalPlaces + '-' + this.uiSpeedoChart.decimalPlaces);
                break;
            case 'percentage':
            case 'number':
                finalDisplayValue = this.decimalPipe.transform(this.uiSpeedoChart.value, '1.' + this.uiSpeedoChart.decimalPlaces + '-' + this.uiSpeedoChart.decimalPlaces);
                if (this.uiSpeedoChart.unitType === 'percentage') {
                    this.finalDisplayValueSuffix = '%';
                }
                break;
            default:
                finalDisplayValue = this.uiSpeedoChart.value;
                break;
        }
        this.finalDisplayValue = finalDisplayValue;
    };
    /**
     * Sets outcome label / classes.
     */
    /**
     * Sets outcome label / classes.
     * @return {?}
     */
    UISpeedoChartComponent.prototype.setOutcome = /**
     * Sets outcome label / classes.
     * @return {?}
     */
    function () {
        if (this.uiSpeedoChart.reverseNeedle) {
            if (this.uiSpeedoChart.value > this.uiSpeedoChart.averageMinimum) {
                this.outcomeClass = 'neg-col';
                this.outcomeLabel = 'Needs Improvement';
            }
            else if (this.uiSpeedoChart.value <= this.uiSpeedoChart.averageMinimum && this.uiSpeedoChart.value > this.uiSpeedoChart.averageMaximum) {
                this.outcomeClass = 'warn-col';
                this.outcomeLabel = 'Average';
            }
            else {
                this.outcomeClass = 'pos-col';
                this.outcomeLabel = 'Good';
            }
        }
        else {
            if (this.uiSpeedoChart.value < this.uiSpeedoChart.averageMinimum) {
                this.outcomeClass = 'neg-col';
                this.outcomeLabel = 'Needs Improvement';
            }
            else if (this.uiSpeedoChart.value >= this.uiSpeedoChart.averageMinimum && this.uiSpeedoChart.value < this.uiSpeedoChart.averageMaximum) {
                this.outcomeClass = 'warn-col';
                this.outcomeLabel = 'Average';
            }
            else {
                this.outcomeClass = 'pos-col';
                this.outcomeLabel = 'Good';
            }
        }
    };
    UISpeedoChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-speedo-chart',
                    template: "\n      <!--  SPEEDO CHART  -->\n\n      <svg [attr.width]=\"uiSpeedoChart.size\" [attr.height]=\"uiSpeedoChart.size\" class=\"speedo-chart\">\n\n          <!--  CLIP PATH  -->\n\n      \t<defs>\n      \t\t<clipPath [attr.id]=\"clipPathName\">\n      \t\t\t<polygon [attr.points]=\"clipPolygonPoints\"></polygon>\n      \t\t</clipPath>\n      \t</defs>\n\n          <!--  END CLIP PATH  -->\n\n          <!--  SEGMENTS -->\n\n          <circle *ngFor=\"let s of segments\"\n                  [ngClass]=\"s.className\"\n                  [attr.transform]=\"'rotate(' + s.rotateValue + ')'\"\n                  [attr.cx]=\"uiSpeedoChart.size / 2\"\n                  [attr.cy]=\"uiSpeedoChart.size / 2\"\n                  [attr.r]=\"(uiSpeedoChart.size / 2) - 30\"\n                  [attr.stroke-dasharray]=\"segmentDashArray\"\n                  [attr.clip-path]=\"'url(#' + clipPathName + ')'\">\n          </circle>\n\n          <!--  END SEGMENTS  -->\n\n          <!--  INNER STROKE  -->\n\n          <circle class=\"inner-stroke\" [attr.cx]=\"uiSpeedoChart.size / 2\" [attr.cy]=\"uiSpeedoChart.size / 2\" [attr.r]=\"(uiSpeedoChart.size / 2) - 36\"></circle>\n\n          <!--  END INNER STROKE  -->\n\n          <!--  SEGMENT SEPARATOR LINE  -->\n\n      \t<line *ngFor=\"let s of segments | slice:1:3\" [attr.x1]=\"uiSpeedoChart.size / 2\" [attr.y1]=\"uiSpeedoChart.size / 2\" [attr.x2]=\"uiSpeedoChart.size\" [attr.y2]=\"uiSpeedoChart.size / 2\" [attr.transform]=\"'rotate(' + s.rotateValue + ')'\"></line>\n\n          <!--  END SEGMENT SEPARATOR LINE  -->\n\n          <!--  GHOST NEEDLE  -->\n\n          <g *ngIf=\"uiSpeedoChart.ghostValue\" class=\"needle ghost\" [attr.transform]=\"'rotate(' + ghostNeedleRotateValue + ')'\">\n      \t\t<circle [attr.cx]=\"uiSpeedoChart.size / 2\" [attr.cy]=\"uiSpeedoChart.size / 2\" r=\"6\"></circle>\n      \t\t<polygon [attr.points]=\"needlePolygonPoints\"></polygon>\n      \t</g>\n\n          <!--  END GHOST NEEDLE  -->\n\n          <!-- MAIN NEEDLE  -->\n\n          <g class=\"needle\" [attr.transform]=\"'rotate(' + needleRotateValue + ')'\">\n      \t\t<circle [attr.cx]=\"uiSpeedoChart.size / 2\" [attr.cy]=\"uiSpeedoChart.size / 2\" r=\"6\"></circle>\n      \t\t<polygon [attr.points]=\"needlePolygonPoints\"></polygon>\n      \t</g>\n\n          <!--  END MAIN NEEDLE  -->\n\n          <!--  THRESHOLD LABELS  -->\n\n      \t<text *ngIf=\"uiSpeedoChart.showThresholds\" [attr.x]=\"averageMinimumLabel.x\" [attr.y]=\"averageMinimumLabel.y\" text-anchor=\"middle\">{{ averageMinimumLabel.name }}</text>\n      \t<text *ngIf=\"uiSpeedoChart.showThresholds\" [attr.x]=\"averageMaximumLabel.x\" [attr.y]=\"averageMaximumLabel.y\" text-anchor=\"middle\">{{ averageMaximumLabel.name }}</text>\n      \t<!--<text *ngIf=\"uiSpeedoChart.showThresholds\" [attr.x]=\"minimumLabel.x\" [attr.y]=\"minimumLabel.y\" text-anchor=\"end\">{{ minimumLabel.name }}</text>-->\n      \t<!--<text *ngIf=\"uiSpeedoChart.showThresholds\" [attr.x]=\"maximumLabel.x\" [attr.y]=\"maximumLabel.y\" text-anchor=\"start\">{{ maximumLabel.name }}</text>-->\n\n          <!--  END THRESHOLD LABELS -->\n\n      </svg>\n\n      <!--  END SPEEDO CHART  -->\n\n      <!--  CHART OVERLAY  -->\n\n      <div class=\"chart-overlay\">\n\n          <!--  DISPLAY VALUE  -->\n\n      \t<p class=\"speedo-chart-value\">\n      \t\t{{ finalDisplayValue }}<span *ngIf=\"finalDisplayValueSuffix\" class=\"suffix\">{{ finalDisplayValueSuffix }}</span>\n              <!--<span *ngIf=\"display_value_bolt_on\" class=\"suffix bolt-on\">{{ display_value_bolt_on }}</span>-->\n      \t</p>\n\n          <!--  END DISPLAY VALUE  -->\n\n          <!--  LABEL  -->\n\n          <span class=\"speedo-chart-label\">{{uiSpeedoChart.label}}</span>\n\n          <!--  END LABEL  -->\n\n          <!--  OUTCOME  -->\n\n          <span *ngIf=\"uiSpeedoChart.showOutcome\" class=\"speedo-chart-outcome\" [ngClass]=\"outcomeClass\">{{outcomeLabel}}</span>\n\n          <!--  END OUTCOME  -->\n\n      </div>\n\n      <!--  END CHART OVERLAY  -->\n    ",
                    styles: ["\n      :host{position:relative;display:block}:host .speedo-chart{margin:0 auto;display:block}:host .speedo-chart circle{stroke-width:8;fill-opacity:.2}:host .speedo-chart circle.below-average{fill:#D63535;stroke:#D63535}:host .speedo-chart circle.average{fill:#F57F15;stroke:#F57F15}:host .speedo-chart circle.above-average{fill:#2B9F57;stroke:#2B9F57}:host .speedo-chart circle.inner-stroke{stroke:#f2f2f2;stroke-width:3;fill:none}:host .speedo-chart line{stroke:#f2f2f2;stroke-width:3}:host .speedo-chart .needle{fill:#4e4e4e}:host .speedo-chart .needle circle{fill-opacity:1}:host .speedo-chart .needle.ghost{opacity:.3}:host .speedo-chart text{font-size:10px;fill:#919191}:host .chart-overlay{position:absolute;top:72%;left:0;right:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);text-align:center}:host .chart-overlay .speedo-chart-value{position:relative;font-weight:500;font-size:28px;text-align:center;padding-bottom:0;color:#4e4e4e}:host .chart-overlay .speedo-chart-value .suffix{font-size:18px;margin-left:2px}:host .chart-overlay .speedo-chart-value .suffix.bolt-on{position:absolute;bottom:3px;margin-left:15px;color:#bdbdbd}:host .chart-overlay .speedo-chart-label{text-transform:uppercase;font-size:14px;font-weight:500;color:#919191;margin-top:10px;display:block}:host .chart-overlay .speedo-chart-outcome{text-transform:uppercase;font-weight:500;font-size:12px;display:block;padding-top:12px}@supports (-ms-ime-align:auto){:host .speedo-chart circle{fill-opacity:0}}\n    "]
                },] },
    ];
    /** @nocollapse */
    UISpeedoChartComponent.ctorParameters = function () { return [
        { type: CurrencyPipe },
        { type: DecimalPipe },
        { type: UIHelperService }
    ]; };
    UISpeedoChartComponent.propDecorators = {
        uiSpeedoChart: [{ type: Input }]
    };
    return UISpeedoChartComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISpeedoChart = /** @class */ (function () {
    function UISpeedoChart(uiSpeedoChart) {
        // this.minimum = this.averageMinimum - (this.averageMaximum - this.averageMinimum);
        // this.maximum = this.averageMaximum + (this.averageMaximum - this.averageMinimum);
        //
        // if (this.reverseNeedle) {
        //     const temp: number = this.minimum;
        //     this.minimum = this.maximum;
        //     this.maximum = temp;
        // }
        // minimum?: number;
        // maximum?: number;
        this.value = 0;
        this.size = 300;
        this.unitType = 'number';
        this.decimalPlaces = 0;
        this.valueBoltOn = null;
        this.showOutcome = true;
        this.averageMinimum = 20;
        this.averageMaximum = 30;
        this.showThresholds = true;
        this.reverseNeedle = false;
        Object.assign(/** @type {?} */ (this), uiSpeedoChart);
    }
    return UISpeedoChart;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UISpeedoChartModule = /** @class */ (function () {
    function UISpeedoChartModule() {
    }
    UISpeedoChartModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UISpeedoChartComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [
                        CurrencyPipe$1
                    ],
                    exports: [
                        UISpeedoChartComponent
                    ]
                },] },
    ];
    return UISpeedoChartModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIKanbanBoardComponent = /** @class */ (function () {
    function UIKanbanBoardComponent() {
    }
    UIKanbanBoardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-kanban-board',
                    template: "\n      <div class=\"board\">\n          <ui-kanban-list *ngFor=\"let list of lists\" [name]=\"list.name\" [cards]=\"list.cards\"></ui-kanban-list>\n      </div>\n    ",
                    styles: ["\n      :host .board{display:-webkit-box;display:-ms-flexbox;display:flex;overflow-x:scroll;overflow-y:hidden;padding-bottom:32px;height:calc(100vh - 186px)}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIKanbanBoardComponent.ctorParameters = function () { return []; };
    UIKanbanBoardComponent.propDecorators = {
        lists: [{ type: Input }]
    };
    return UIKanbanBoardComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIKanbanListComponent = /** @class */ (function () {
    function UIKanbanListComponent() {
    }
    UIKanbanListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-kanban-list',
                    template: "\n      <div class=\"list\">\n          <div class=\"list-header\">\n              <h3>{{ name }}</h3>\n              <i class=\"far fa-ellipsis-h icon-button alt\"></i>\n          </div>\n          <div class=\"list-cards\">\n              <ui-kanban-card *ngFor=\"let card of cards\" [name]=\"card.name\"></ui-kanban-card>\n          </div>\n      </div>\n    ",
                    styles: ["\n      :host .list{background:#f2f2f2;width:256px;margin-right:24px;-ms-flex-negative:0;flex-shrink:0;height:100%;border-radius:3px}:host .list .list-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:8px 8px 8px 16px}:host .list .list-header h3{line-height:32px}:host .list .list-cards{padding:0 8px}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIKanbanListComponent.ctorParameters = function () { return []; };
    UIKanbanListComponent.propDecorators = {
        name: [{ type: Input }],
        cards: [{ type: Input }]
    };
    return UIKanbanListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIKanbanCardComponent = /** @class */ (function () {
    function UIKanbanCardComponent() {
    }
    UIKanbanCardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ui-kanban-card',
                    template: "\n      <div class=\"card\">\n          {{ name }}\n      </div>\n    ",
                    styles: ["\n      :host .card{background:#FFF;border-bottom:1px solid #dedede;border-radius:2px;padding:8px;font-size:13px;color:#7a7a7a;margin-bottom:8px;line-height:1.5em}\n    "]
                },] },
    ];
    /** @nocollapse */
    UIKanbanCardComponent.ctorParameters = function () { return []; };
    UIKanbanCardComponent.propDecorators = {
        name: [{ type: Input }]
    };
    return UIKanbanCardComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIKanbanList = /** @class */ (function () {
    function UIKanbanList(uiKanbanList) {
        this.cards = [];
        Object.assign(/** @type {?} */ (this), uiKanbanList);
    }
    return UIKanbanList;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIKanbanCard = /** @class */ (function () {
    function UIKanbanCard(uiKanbanCard) {
        Object.assign(/** @type {?} */ (this), uiKanbanCard);
    }
    return UIKanbanCard;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UIKanbanModule = /** @class */ (function () {
    function UIKanbanModule() {
    }
    UIKanbanModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        UIKanbanBoardComponent,
                        UIKanbanListComponent,
                        UIKanbanCardComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    providers: [],
                    exports: [
                        UIKanbanBoardComponent,
                        UIKanbanListComponent,
                        UIKanbanCardComponent
                    ]
                },] },
    ];
    return UIKanbanModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { UIForgottenPasswordComponent, UIResetPasswordComponent, UILoginComponent, UIAuthComponent, UIAuthService$1 as UIAuthService, UIAuthGuard, UIResetPasswordResolver, UIAuthInterceptor, UIUser, UIAuthModule, UICodePanelComponent, UICodePanel, UICodePanelModule, UIHttpErrorComponent, UIFooterComponent, UIErrorComponent, UIStartComponent, UINavComponent, UIAppModuleSwitcherModalComponent, UISearchModalComponent, UIModalComponent, UIActionAnchorButton, UIActionRouterButton, UIActionAnchorLink, UIActionLinkButton, UIActionRouterLink, UILayoutConfig, UIActionButton, UIMainNavItem, UIRestOptions, UIAppModule, UIDataItem, UINavItem, UIAction, UIFooter, UICache, UIModal, UIError, UIBadge, UIApp, UICookieStorageService$1 as UICookieStorageService, UINotificationsService, UILocalStorageService$1 as UILocalStorageService, UIScriptLoaderService$1 as UIScriptLoaderService, UILayoutConfigService$1 as UILayoutConfigService, UIResponsiveService$1 as UIResponsiveService, UINavigationService$1 as UINavigationService, UISessionService$1 as UISessionService, UIStorageService$1 as UIStorageService, UIHelperService$1 as UIHelperService, UIScrollService$1 as UIScrollService, UIModalService$1 as UIModalService, UIToastService$1 as UIToastService, UIThemeService$1 as UIThemeService, UIHttpService$1 as UIHttpService, UIRestService$1 as UIRestService, UIDealerResolver, UICoreModule, UIKeyValueListComponent, UIKeyValueItem, UIKeyValueListModule, UINavListComponent, UINavListModule, UIPopoverComponent, UIPopover, UIPopoverModule, UISideNavContainerComponent, UISideNavSectionComponent, UISideNavBarComponent, UISideNavItem, UISideNavModule, UISplitButtonComponent, UISplitButtonItem, UISplitButtonModule, UITabBarComponent, UITabBar, UITab, UITabBarModule, UIToastComponent, UIToast, UIToastModule, UIViewHeaderComponent, UIViewHeaderModule, UIViewTakeoverComponent, UIViewTakeoverModule, UILoadingDirective, UILoadingModule, UITooltipDirective, UITooltip, UITooltipModule, UIShortNumberPipe$1 as UIShortNumberPipe, UIShortNumberModule, UIMaxNumberPipe, UIMaxNumberModule, UIDateTimePipe, UIDateTimeModule, UIPluralPipe, UIPluralModule, UIMoneyPipe$1 as UIMoneyPipe, UIMoneyModule, UIPaginatorComponent, UIRefineModalComponent, UIDataModule, UIFormComponent, UIControlSelectorComponent, UICheckboxControlComponent, UIInputControlComponent, UITextareaControlComponent, UISelectControlComponent, UISliderControlComponent, UIMultiControlComponent, UIFormGroup, UIFormControl, UICheckboxControl, UIFormEvent, UIInputControl, UITextareaControl, UISelectControl, UISelectControlOption, UISliderControl, UIMultiControl, UIAffix, UIFormsService$1 as UIFormsService, UIFormsModule, UINotificationPreferencesComponent, UIChangePasswordComponent, UIManageAccountComponent, UIDealerSwitcherModalComponent, UIUserAccountModalComponent, UIUserAccountService$1 as UIUserAccountService, UIUserResolver, UIUserAccountModule, UIBigValueComponent, UIBigValueModule, UIChartKeyComponent, UIChartKeyItem, UIChartKeyModule, UILineChartXLabelComponent, UILineChartComponent, UILineChartThresholdLine, UILineChartXLabel, UILineChartYLabel, UILineChartLine, UILineChartModule, UIProgressBarComponent, UIProgressBarModule, UIRadarChartComponent, UIRadarChartSegment, UIRadarChartModule, UIChartInfluence, UISpeedoChartComponent, UISpeedoChart, UISpeedoChartModule, UIKanbanBoardComponent, UIKanbanListComponent, UIKanbanCardComponent, UIKanbanList, UIKanbanCard, UIKanbanModule };
